{
	"type": "FeatureCollection",
	"features": [
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[14.627338533463659, 50.84305418140996],
						[14.617878910417216, 50.839996305342694],
						[14.614385607210707, 50.83858110732497],
						[14.609726904163466, 50.835731490737146],
						[14.604643819003414, 50.831165288185346],
						[14.596917152342941, 50.82644271792317],
						[14.594170571022792, 50.82524490968053],
						[14.587250705909598, 50.82360836427352],
						[14.583998682497393, 50.822547935063106],
						[14.576386455548134, 50.817886388649505],
						[14.574415205624074, 50.816078173905275],
						[14.570496561697977, 50.80936815767013],
						[14.5672302264454, 50.806091325936706],
						[14.56647777411864, 50.80491255339122],
						[14.565542224280815, 50.802253753490064],
						[14.564008716361323, 50.794281039822465],
						[14.561938283109471, 50.79039761833938],
						[14.559435840603163, 50.78787609303476],
						[14.55475139428565, 50.78453825112499],
						[14.55113506044686, 50.782638524014736],
						[14.547042848562139, 50.78115465039439],
						[14.542499542961403, 50.78029633255135],
						[14.535482408273072, 50.77982713362199],
						[14.52619171472003, 50.77997210765598],
						[14.519743919918467, 50.780654912406256],
						[14.51607513471742, 50.781612400415575],
						[14.509702685077624, 50.784484887794754],
						[14.50262832972621, 50.78612902923692],
						[14.49930381502915, 50.78720090189967],
						[14.494611738349603, 50.78984449619346],
						[14.475730893196076, 50.79758450706454],
						[14.470184327593483, 50.800537122897936],
						[14.46688080234482, 50.80110172267295],
						[14.465071678926375, 50.801059730177215],
						[14.461553572922188, 50.80029677691662],
						[14.4586057678465, 50.79882813975643],
						[14.456456188232568, 50.797130621333125],
						[14.45475769396547, 50.795051608382956],
						[14.452642437926391, 50.790508242924496],
						[14.451699260335301, 50.78694156108639],
						[14.451752659119068, 50.78439709150987],
						[14.453912736683424, 50.776527420970844],
						[14.454543116823514, 50.77164843667981],
						[14.454410555614274, 50.76523592601302],
						[14.453126910917023, 50.760902438823265],
						[14.452301982946794, 50.759658850508636],
						[14.44809627736165, 50.755374927841736],
						[14.444553371333473, 50.74981685718908],
						[14.442598343570893, 50.74808121372573],
						[14.43945312532508, 50.746070864920924],
						[14.432954792277798, 50.74106220321294],
						[14.431391714759066, 50.73915480377569],
						[14.430950163276602, 50.73798750379051],
						[14.430785182470082, 50.735557588016405],
						[14.431484221549242, 50.73322676786995],
						[14.432916644823791, 50.73138812636004],
						[14.435441970312326, 50.72914504514374],
						[14.436269758572156, 50.72802732883439],
						[14.43736457749388, 50.72544478649778],
						[14.43776226040667, 50.721229552931916],
						[14.43704605235249, 50.71846772509652],
						[14.436250685246529, 50.71717451664387],
						[14.435050965735662, 50.716003431174],
						[14.43192863287423, 50.714450819246714],
						[14.423787117354268, 50.712360385430976],
						[14.420191764959508, 50.71104049805144],
						[14.41732216176744, 50.71045306175287],
						[14.412594795637906, 50.71060562527558],
						[14.404244424564963, 50.712612167946126],
						[14.401061058017467, 50.712783813216724],
						[14.399486544543752, 50.71264269649696],
						[14.397976874229798, 50.7123222247886],
						[14.395483017407315, 50.71126938287959],
						[14.389273646130226, 50.707271601243875],
						[14.388315197469106, 50.70616909637507],
						[14.387037278906554, 50.70369722077343],
						[14.384128574108866, 50.69475940303608],
						[14.383262637007016, 50.689895656123916],
						[14.382767678455412, 50.679874431209235],
						[14.382129667765142, 50.67495726168758],
						[14.37856578634721, 50.664455395317695],
						[14.377256393333697, 50.66199493313006],
						[14.375357631842732, 50.660076179630444],
						[14.368513108781888, 50.65498734948799],
						[14.363946911493077, 50.652481048443576],
						[14.359752654192683, 50.64958571580715],
						[14.353676795610065, 50.64651488920661],
						[14.348133087792366, 50.642921453876475],
						[14.351184844731005, 50.63943862683551],
						[14.35473346664599, 50.63462447679804],
						[14.359429361369255, 50.630294818466346],
						[14.360277176662054, 50.62918473022398],
						[14.372135160423257, 50.60164640470035],
						[14.377283095972672, 50.59628295569343],
						[14.379820825234495, 50.59169770798186],
						[14.381380080578262, 50.58955764192657],
						[14.385800360722744, 50.5853843601068],
						[14.389891623410193, 50.5786323446919],
						[14.394295691330884, 50.574432362304655],
						[14.397542000367777, 50.56870270307063],
						[14.402783392685015, 50.56346129237297],
						[14.406027793286245, 50.55773543734233],
						[14.411256788805526, 50.55248640659525],
						[14.414465903257721, 50.546737661460014],
						[14.41970443576069, 50.54150389182248],
						[14.423087121417144, 50.535873426217655],
						[14.424963950959908, 50.53409957740168],
						[14.428048134050622, 50.53202057078265],
						[14.435503004176908, 50.525924665212415],
						[14.437000274285305, 50.523536678531954],
						[14.439361573841564, 50.51539231866789],
						[14.440956114228658, 50.5129890297771],
						[14.442976951369143, 50.51142883078906],
						[14.44947910334517, 50.507396700474104],
						[14.452761649470963, 50.50633239153667],
						[14.460000038893229, 50.50462723497415],
						[14.463054658325806, 50.503334058353985],
						[14.466141699052748, 50.50071714678545],
						[14.468014718374594, 50.497543347221466],
						[14.466083527643715, 50.49443055194175],
						[14.465262413019541, 50.491744995065545],
						[14.46521663850109, 50.489063280708876],
						[14.466004371292742, 50.48656463285386],
						[14.46761703305674, 50.48461912274006],
						[14.477843284344472, 50.476661679599694],
						[14.479349135363798, 50.474403371818944],
						[14.480137825865928, 50.471839913011685],
						[14.480294229155913, 50.46463014194935],
						[14.481199263562326, 50.45848464036405],
						[14.481163979780495, 50.45404435364935],
						[14.479890824815593, 50.449844374350384],
						[14.47762870713832, 50.447422020376514],
						[14.476029394933377, 50.446548451069546],
						[14.47238826881711, 50.44543839755787],
						[14.459107399909017, 50.44340516027667],
						[14.445817948821247, 50.442035688914444],
						[14.441970826512316, 50.44128419242906],
						[14.43554019951033, 50.43935394510264],
						[14.432691575971418, 50.43799974349299],
						[14.430500984349695, 50.43625641021966],
						[14.42095565727731, 50.42600249583183],
						[14.418772697379556, 50.424472808167074],
						[14.416048049706697, 50.42346572662407],
						[14.411480902798646, 50.42306136282636],
						[14.389740944352026, 50.4236869855091],
						[14.384860038199479, 50.42365264350328],
						[14.38021564330052, 50.42329786714479],
						[14.37593078528638, 50.422286979070286],
						[14.374040603825849, 50.42136764709354],
						[14.37255001034678, 50.42015456827969],
						[14.371526718527795, 50.41880035778162],
						[14.370421410875798, 50.41585923476251],
						[14.370024682226257, 50.41270829352],
						[14.370116235558232, 50.40606691140172],
						[14.37082195179835, 50.39940642315578],
						[14.371527671973015, 50.39626312410668],
						[14.37269687660877, 50.39341354450755],
						[14.376782418559953, 50.38877869882098],
						[14.378734588625532, 50.38467788698765],
						[14.379715919349549, 50.37822341777535],
						[14.37990665559281, 50.3697319151112],
						[14.379527092193479, 50.36478424280383],
						[14.378215791001155, 50.360294353803276],
						[14.377390860228775, 50.35898970306908],
						[14.374160766668819, 50.35569000309696],
						[14.37144756137207, 50.35160825880711],
						[14.369602204179952, 50.34955979185036],
						[14.366567610251561, 50.34793470881309],
						[14.364722252414198, 50.34745026144644],
						[14.360736846321403, 50.34699248679029],
						[14.354429243124772, 50.34723661502198],
						[14.341745378119787, 50.34874726841075],
						[14.325693129174702, 50.349342333281434],
						[14.304076194179913, 50.34940337562779],
						[14.296257017687438, 50.34900663953164],
						[14.291310310326368, 50.34835815392907],
						[14.28157806258793, 50.34576796132759],
						[14.27117252355518, 50.33987426813453],
						[14.262216568105911, 50.333503724253525],
						[14.259943960243243, 50.331268292296045],
						[14.256963730763214, 50.3275108426508],
						[14.252777098150956, 50.328968033729794],
						[14.244792939185094, 50.33111954674086],
						[14.234759331394526, 50.33423233668248],
						[14.230148316720804, 50.3350258000878],
						[14.21662235356466, 50.336471567138986],
						[14.213019371264577, 50.33731460800124],
						[14.208216668921558, 50.33914567764807],
						[14.206732750330552, 50.33941650777304],
						[14.203468322934155, 50.33951568781547],
						[14.19989108866137, 50.338947279027394],
						[14.196334837649927, 50.33781050432377],
						[14.188445089469877, 50.33492277294223],
						[14.182495117107473, 50.33166503826981],
						[14.180935860366834, 50.33105850899366],
						[14.172218322324829, 50.32883452943967],
						[14.1657619468084, 50.326030723039146],
						[14.162015915681735, 50.32510376734746],
						[14.155424118709302, 50.324455267850716],
						[14.148264885783728, 50.32423783177251],
						[14.130987167159951, 50.32419967454054],
						[14.12137985245472, 50.32444381872642],
						[14.11689186119722, 50.32479858632432],
						[14.112831114762807, 50.32548903463883],
						[14.111059188982756, 50.32602310319896],
						[14.10460090737142, 50.32882309954754],
						[14.097529412440013, 50.33045579122207],
						[14.094234465992386, 50.33144759573668],
						[14.090637207429769, 50.3331832925442],
						[14.087554931982472, 50.33426666600246],
						[14.083523749363396, 50.33498000160033],
						[14.074857712957566, 50.33589173525521],
						[14.070816992289778, 50.33655546675785],
						[14.069033624086106, 50.3370475903148],
						[14.063939093291957, 50.33913801851741],
						[14.060528756855009, 50.339893357701236],
						[14.052475927988077, 50.340438830068514],
						[14.030858994299033, 50.34104157262856],
						[14.019354819603755, 50.34098815269597],
						[14.01308822571206, 50.34040068972985],
						[14.011193276923967, 50.33999253793852],
						[14.008098601279228, 50.33877943928622],
						[14.002792359713931, 50.33544160254049],
						[14.000720024904922, 50.33381653630108],
						[13.999187468659203, 50.33138655790703],
						[13.998354911474868, 50.32723998692992],
						[13.998702049163414, 50.32141876128451],
						[13.99993801151683, 50.31731415143408],
						[14.001467705607535, 50.315010079174215],
						[14.005096434661017, 50.31187819545823],
						[14.005969047231003, 50.31073379200092],
						[14.007416725629545, 50.306747441246706],
						[14.007225989452673, 50.30255126107431],
						[14.0057611469636, 50.299915317918405],
						[14.00437164295352, 50.29876327401215],
						[14.002603531778144, 50.29791642133245],
						[13.998592377264545, 50.29703903756247],
						[13.994240761587049, 50.296768196350456],
						[13.978096007593724, 50.296821587127404],
						[13.973749161589277, 50.29647065036743],
						[13.969827652722104, 50.29552460466077],
						[13.968165398419204, 50.294693000966156],
						[13.96599101992899, 50.29240035735216],
						[13.964996338499628, 50.28981781619133],
						[13.963712691626636, 50.28452681856235],
						[13.962300299971423, 50.28215789163408],
						[13.955353736952498, 50.27706146315842],
						[13.952564239064754, 50.27578353440828],
						[13.942267417954826, 50.273178101061475],
						[13.935813904084347, 50.2703437833026],
						[13.925391198086265, 50.26777649816911],
						[13.9203605646087, 50.2655906618897],
						[13.9165611267834, 50.26473236159146],
						[13.912224769470528, 50.26432037230243],
						[13.891267776752175, 50.26396942405074],
						[13.88698291868232, 50.26342392876735],
						[13.883131027768199, 50.26215363103027],
						[13.880725859722684, 50.260383597101466],
						[13.879059791907776, 50.25835037579241],
						[13.877169608631846, 50.25509261640385],
						[13.876420974741473, 50.25247955332321],
						[13.876221656423983, 50.246070858004146],
						[13.877500533429966, 50.23623656588912],
						[13.861993788970512, 50.23639296771171],
						[13.857387542508535, 50.23670196313356],
						[13.853082657402496, 50.23735809877773],
						[13.849356650486286, 50.238571158648405],
						[13.842229843067008, 50.2436904899837],
						[13.837226867386114, 50.24624252024315],
						[13.833790779681497, 50.2473335323922],
						[13.826878546829494, 50.2489128027305],
						[13.823185921040876, 50.24935150478265],
						[13.819331169159168, 50.249328613594756],
						[13.81410026503986, 50.24848937515958],
						[13.807876586728028, 50.24668502617725],
						[13.793170928146829, 50.238197318401575],
						[13.789752006025607, 50.23714827974866],
						[13.781752585686277, 50.23572158119415],
						[13.777731894896684, 50.234680170152224],
						[13.76763534454826, 50.23060606977489],
						[13.765200615694493, 50.22904969045575],
						[13.76345157636761, 50.22665786881111],
						[13.761675834600386, 50.2201194757512],
						[13.76030922023067, 50.21765519080788],
						[13.759072304708582, 50.21655655867518],
						[13.757414818513272, 50.21567917591272],
						[13.755513191756148, 50.215065007907604],
						[13.751273155816017, 50.214370733732856],
						[13.744264602396301, 50.21404647555152],
						[13.708682060329862, 50.21427154631739],
						[13.698816299836869, 50.21455383711041],
						[13.694229125998238, 50.214931488259246],
						[13.690135002865182, 50.21563339984502],
						[13.688394546953669, 50.21615982514064],
						[13.683629990031502, 50.218265537647426],
						[13.68198585508867, 50.21869277939797],
						[13.676425933483852, 50.219131466073726],
						[13.672719002414832, 50.218746191955425],
						[13.671026229032021, 50.21831893068184],
						[13.664791106616999, 50.21568679230514],
						[13.656128883788192, 50.21354294263661],
						[13.653324126682113, 50.212268824020356],
						[13.645655632744164, 50.207370765555225],
						[13.639543533206378, 50.201282499989745],
						[13.631249428459505, 50.194400794232614],
						[13.625757216835263, 50.189338678152346],
						[13.624537467336499, 50.18850325895319],
						[13.621610640575707, 50.18717955605723],
						[13.61510562955327, 50.18531799924299],
						[13.60879039790885, 50.184364321596014],
						[13.601597786337022, 50.18406677648331],
						[13.581920624090337, 50.184024814025825],
						[13.577090263609847, 50.183792116787814],
						[13.572394370252137, 50.18325804851504],
						[13.561545372157, 50.180847169507906],
						[13.557647704840479, 50.17950439205377],
						[13.553735733090516, 50.177639008174864],
						[13.530299186180551, 50.16320037291951],
						[13.526641845517211, 50.16130828663046],
						[13.519082069822502, 50.1580276533777],
						[13.510693550402966, 50.152267459122704],
						[13.509025573831002, 50.15013504133487],
						[13.506609916915549, 50.14555359126053],
						[13.502478599970278, 50.14126587356303],
						[13.501704215579867, 50.14009093794286],
						[13.500694275105136, 50.1374588033959],
						[13.498866081136017, 50.130512236481025],
						[13.497321128997159, 50.12810135047072],
						[13.493374824893884, 50.12514877707682],
						[13.489791869815258, 50.122035977052725],
						[13.485760688330707, 50.11919402602323],
						[13.480675696935748, 50.11153792924045],
						[13.472863197424836, 50.10562133892418],
						[13.465021133620544, 50.10113525598686],
						[13.462204932755421, 50.09992217584578],
						[13.45337676976581, 50.09788894385925],
						[13.445343970806956, 50.09452819354151],
						[13.438255310126742, 50.092830658677144],
						[13.434942245797966, 50.091667178613584],
						[13.428676605599476, 50.087570194390885],
						[13.4225826264778, 50.084728242392956],
						[13.416914939849304, 50.079441070228576],
						[13.406311035356236, 50.073505403728994],
						[13.403214454578917, 50.07245635909986],
						[13.40135669687701, 50.0721511819043],
						[13.395624160668921, 50.07219314471725],
						[13.393801689114836, 50.07253265345759],
						[13.39083480830971, 50.0736427302892],
						[13.383415222021096, 50.078109739653215],
						[13.378588676813894, 50.081760410325565],
						[13.372044563047645, 50.08568191267543],
						[13.369445800834374, 50.08686065730251],
						[13.36641406996013, 50.0876731854587],
						[13.361782073718159, 50.0884819003531],
						[13.349506378305632, 50.08855438372379],
						[13.343691825599748, 50.089225766204194],
						[13.340586662604636, 50.09018707607326],
						[13.335468291923194, 50.0924491849017],
						[13.32036590542598, 50.097564693690494],
						[13.309329033215203, 50.10226822237318],
						[13.308112144019796, 50.10651397225212],
						[13.306302071066245, 50.10966110707301],
						[13.303856849948033, 50.11264038381732],
						[13.301180839620201, 50.11427688685533],
						[13.291071891685103, 50.1171073902953],
						[13.28732204413899, 50.11867904413963],
						[13.283995628378754, 50.119636535877326],
						[13.279681206072308, 50.12015915261422],
						[13.26577758747573, 50.120548243859446],
						[13.261475562883456, 50.121044157162515],
						[13.259486198422067, 50.12157821651826],
						[13.257687568733548, 50.12244415356864],
						[13.256411552348995, 50.123527525998995],
						[13.255150795119048, 50.12596130516492],
						[13.255164146741635, 50.12844467503038],
						[13.256273269241689, 50.13076018847385],
						[13.260421753041287, 50.1346054089063],
						[13.263404845907107, 50.138759610003426],
						[13.265869140317886, 50.140655514299866],
						[13.269415855045368, 50.141754146524995],
						[13.27335071560285, 50.14210128747472],
						[13.277364731164191, 50.14198303573541],
						[13.284036636661414, 50.141227725457725],
						[13.28750896451451, 50.141239166003956],
						[13.290932655121285, 50.141864774341045],
						[13.293734550332827, 50.14311599578878],
						[13.295970916365986, 50.14503478597235],
						[13.299315452495197, 50.150772093869605],
						[13.30328083008084, 50.15502547896099],
						[13.303974151546992, 50.15620040825141],
						[13.304670334294856, 50.158809666462815],
						[13.304566383449435, 50.16159439179978],
						[13.303622246441547, 50.1643905709044],
						[13.301837920394991, 50.16695403258192],
						[13.296908378700465, 50.172412873370895],
						[13.294953346630102, 50.17420196934696],
						[13.29041099493191, 50.17696380028692],
						[13.286445616831363, 50.17996977861584],
						[13.280922888948075, 50.18358611250452],
						[13.273542404443575, 50.1909561185819],
						[13.269906997370892, 50.19500350622381],
						[13.266248703061986, 50.19809722963234],
						[13.264745712023146, 50.200061795358906],
						[13.264120102720659, 50.202468880499254],
						[13.264802933343033, 50.206043249832554],
						[13.26545333918239, 50.20709229110722],
						[13.268623352163942, 50.21016693235584],
						[13.26940918002361, 50.211292270419406],
						[13.27065754024356, 50.21538163162564],
						[13.270753859705385, 50.21839903968509],
						[13.270307541470757, 50.22147751467927],
						[13.269210814690489, 50.22447966743583],
						[13.2670545572904, 50.22776412421795],
						[13.2620468133629, 50.22902297333525],
						[13.254112243265089, 50.23034286087076],
						[13.250591277531125, 50.23136138336074],
						[13.249088286644414, 50.23220442970972],
						[13.24796485863724, 50.233283992626994],
						[13.246924401179097, 50.23567582080607],
						[13.246875762947882, 50.236892700283775],
						[13.247546196876536, 50.23921204562909],
						[13.24903392700871, 50.241016378272995],
						[13.25159835872475, 50.2431488097764],
						[13.253041268261585, 50.24546051946747],
						[13.25375747688674, 50.248176575557316],
						[13.253852844088, 50.25104522545239],
						[13.25327014883055, 50.25386046937742],
						[13.251792908380605, 50.25635910741715],
						[13.247837066682518, 50.25947189365079],
						[13.246029853144593, 50.26126479383737],
						[13.240099906379275, 50.26795577426515],
						[13.238714217250644, 50.2706146145707],
						[13.238259315550138, 50.273376465476],
						[13.238617896563934, 50.27602385975175],
						[13.239809035883315, 50.27835082613006],
						[13.243122101541601, 50.281524665761644],
						[13.243898392161968, 50.28261185157918],
						[13.244936942901395, 50.28515243367869],
						[13.245577813023315, 50.289455422614736],
						[13.245470047595486, 50.293991095218445],
						[13.244631766615468, 50.29845427768936],
						[13.243493080876833, 50.30121613331718],
						[13.24042224822811, 50.305953972992825],
						[13.23986720980467, 50.308189385895545],
						[13.240492820333714, 50.310188289148854],
						[13.24127483398479, 50.311054232978364],
						[13.242487908144074, 50.311820991679085],
						[13.249823570802748, 50.31398010838306],
						[13.252301215623161, 50.315395349899845],
						[13.253922462031628, 50.31719970245549],
						[13.255079270231068, 50.319126137858674],
						[13.255849838050226, 50.3222465493242],
						[13.25467109661872, 50.32830047413598],
						[13.253038405623347, 50.33214568298677],
						[13.251195908313676, 50.334167488104875],
						[13.24725723264432, 50.337348937757156],
						[13.243363381745029, 50.34146119555024],
						[13.23904132759102, 50.344802847551755],
						[13.234007834865867, 50.34779357356545],
						[13.230235099253106, 50.34940337562779],
						[13.226008413422749, 50.35042570113088],
						[13.221680642079727, 50.35073853499574],
						[13.217573165212391, 50.35048293344587],
						[13.215686796814733, 50.35015104841596],
						[13.212690354648268, 50.34915162464873],
						[13.209156038009212, 50.347473161865985],
						[13.205528259028915, 50.34652328227236],
						[13.201250075121067, 50.345966326645765],
						[13.196627615986293, 50.345664968500955],
						[13.187019348049422, 50.345558165491376],
						[13.177759170014854, 50.346126550887305],
						[13.173686028664488, 50.34684373159709],
						[13.171925546256984, 50.34737397857045],
						[13.16825199193392, 50.349056250948365],
						[13.16514110533507, 50.35007476469047],
						[13.158866881108723, 50.35079191819496],
						[13.152279852548203, 50.350589738624166],
						[13.148274422885615, 50.349926007606754],
						[13.146560669235972, 50.349395755053784],
						[13.141940116107829, 50.3471946633622],
						[13.13853931603716, 50.34640504816469],
						[13.134753226897859, 50.34619140266089],
						[13.13099002946163, 50.346611034490145],
						[13.127949713507606, 50.347732531624274],
						[13.121027944759042, 50.35272977905163],
						[13.119586944986075, 50.35517120795246],
						[13.117355348462373, 50.36324312207919],
						[13.115429878105132, 50.36553573469682],
						[13.112484932437194, 50.366996770389505],
						[13.104491234949712, 50.36944199810585],
						[13.100210190382404, 50.372032171549925],
						[13.090832708506605, 50.376819591763706],
						[13.089114188037785, 50.377372729814915],
						[13.085189820203588, 50.37806321119327],
						[13.069414137658265, 50.378871905550334],
						[13.062561989378876, 50.37953186623074],
						[13.058271407356045, 50.380451194613684],
						[13.048404692500752, 50.38334654577954],
						[13.03925323396205, 50.385265340660204],
						[13.032702446142917, 50.386142732421824],
						[13.01582813228053, 50.387195583404484],
						[13.010195732206737, 50.388320923820686],
						[13.004055021428615, 50.39038084037118],
						[13.001581191109889, 50.392150869142306],
						[12.997284890257635, 50.39868928118103],
						[12.992954253942486, 50.40298843159789],
						[12.988572121309774, 50.41279984213384],
						[12.988455773993628, 50.412788408277905],
						[12.986342431199153, 50.41941834663847],
						[12.983346938092097, 50.41921995998657],
						[12.980576514519225, 50.41903685792438],
						[12.980979920371231, 50.41950989779691],
						[12.98148822952094, 50.419815081539724],
						[12.981843949495449, 50.41977692868928],
						[12.982096671227083, 50.41948699055818],
						[12.982719422777866, 50.41941453524861],
						[12.9834508884025, 50.41971586858442],
						[12.983740806339048, 50.42010879257387],
						[12.98428916968922, 50.42032623697682],
						[12.984975813031522, 50.42062376004194],
						[12.98584556600393, 50.421005251264326],
						[12.9865045562146, 50.42162324576698],
						[12.987154959388343, 50.42206572146895],
						[12.98762989044025, 50.42259597776494],
						[12.988158226736601, 50.42327118698806],
						[12.988690374606806, 50.42403410062151],
						[12.98890018551679, 50.42459870337862],
						[12.989244462237819, 50.42519379930393],
						[12.989542961498438, 50.42575836588211],
						[12.989716530336956, 50.42649841836865],
						[12.990015985096672, 50.42708970746879],
						[12.990398406126872, 50.427539816231956],
						[12.990822791263096, 50.42795943363451],
						[12.99093627960659, 50.42841339444564],
						[12.991181372259462, 50.428810105243976],
						[12.991827966353524, 50.42919542095479],
						[12.99229049538696, 50.42947004677047],
						[12.992674828266242, 50.4298667982001],
						[12.993353843430112, 50.43044662197107],
						[12.993926046592302, 50.43112943742374],
						[12.99460983215526, 50.43206786454936],
						[12.994775833931456, 50.4322875755723],
						[12.996601604723502, 50.433666909534374],
						[12.996786270082154, 50.43418423959252],
						[12.997584344551822, 50.43473054693961],
						[12.99829292291392, 50.43504333431765],
						[12.99837875437346, 50.43508148958266],
						[12.998811722191844, 50.435279850384866],
						[12.999818803375344, 50.43565370259928],
						[13.000449180928866, 50.436107639000106],
						[13.000578880735157, 50.43625259856375],
						[13.00088310357622, 50.43658448511585],
						[13.001751900717169, 50.437026988264556],
						[13.002668382421428, 50.437557238558746],
						[13.00438785523052, 50.438076016070106],
						[13.006087302133146, 50.43848036614767],
						[13.007458688166487, 50.43909074313144],
						[13.008672714733484, 50.439647679930886],
						[13.00918578935372, 50.44002531173956],
						[13.009899140661988, 50.44043351570424],
						[13.010826110265274, 50.44115828850612],
						[13.011559486521923, 50.44169998311454],
						[13.012336731087442, 50.44225311419254],
						[13.013390540645945, 50.44271468653782],
						[13.014800073411264, 50.44324113757853],
						[13.015501021259478, 50.44343184266117],
						[13.016554831300283, 50.44388960548751],
						[13.017710686889657, 50.44467164330414],
						[13.018431664259703, 50.44549561347815],
						[13.019018173149604, 50.44617462085122],
						[13.019865036629666, 50.44673157402264],
						[13.020277977232277, 50.447357180335615],
						[13.020299912996176, 50.447753922310994],
						[13.020090104396928, 50.448017133744806],
						[13.020068169119368, 50.44844437159499],
						[13.020488737902738, 50.44878004789556],
						[13.020957947668526, 50.44916916849384],
						[13.021478653133688, 50.44970321847908],
						[13.021728515521717, 50.45018005260196],
						[13.022231101679134, 50.4513969388068],
						[13.022773742825107, 50.452133180311655],
						[13.022977829034977, 50.45261383116014],
						[13.023366926345892, 50.45317457224726],
						[13.023797035384352, 50.45368194759147],
						[13.023862837511402, 50.45407866108806],
						[13.023437500027322, 50.45449066191283],
						[13.02270316986849, 50.45499037722783],
						[13.022152900590543, 50.45557403451513],
						[13.022089004449127, 50.4560623161704],
						[13.02233600691315, 50.45648575631723],
						[13.022269250090291, 50.45691682117434],
						[13.021794320549114, 50.45724107332068],
						[13.021194459001284, 50.457740794344275],
						[13.020728112205887, 50.45823670440139],
						[13.020573615633838, 50.458698268480155],
						[13.020195007429123, 50.45913314931693],
						[13.020092964771509, 50.459735876784634],
						[13.019893645774761, 50.46019744373803],
						[13.019654274100796, 50.46074676635761],
						[13.019683839194263, 50.461288466126604],
						[13.01980018710401, 50.461799631732994],
						[13.019826887572494, 50.46228788711794],
						[13.019724845896022, 50.462886810408406],
						[13.019442557502373, 50.46346663585696],
						[13.019373892811819, 50.46386717757206],
						[13.01940154927884, 50.46438216075685],
						[13.019553185426737, 50.46469498664216],
						[13.01961707995765, 50.46506499460573],
						[13.019412039828149, 50.46541213043285],
						[13.019164086348725, 50.46578599052174],
						[13.019095421778811, 50.46619034822734],
						[13.018977166359528, 50.46647645262293],
						[13.018813134366244, 50.46676636949756],
						[13.018786429839524, 50.46708297172709],
						[13.018871306027206, 50.46785353171421],
						[13.01917934435852, 50.468589784657325],
						[13.019529344465166, 50.46926881826967],
						[13.01973915076074, 50.46983337144847],
						[13.019816397979525, 50.47043227462228],
						[13.01997661471845, 50.470916735321396],
						[13.02005004733797, 50.47145841908772],
						[13.020077705552195, 50.47196960630159],
						[13.020460127139065, 50.47241972113858],
						[13.020619392414664, 50.47287368795397],
						[13.020559310812159, 50.47341918837214],
						[13.020190240634264, 50.47405626191661],
						[13.020095826092613, 50.47480011947882],
						[13.020174026558161, 50.47542572095247],
						[13.0204315179469, 50.47605132405384],
						[13.020729065558696, 50.476585394796984],
						[13.02116107772901, 50.47711942782536],
						[13.02132129572521, 50.47760390199665],
						[13.021304132244548, 50.478118914593864],
						[13.021108627917553, 50.4786377017201],
						[13.02126693698387, 50.47909164137392],
						[13.021651269255422, 50.47956849483603],
						[13.02182483537587, 50.48030851819786],
						[13.022036553326515, 50.48090363510007],
						[13.022554396923386, 50.48137664088457],
						[13.022573472673296, 50.48171998788216],
						[13.022364616070945, 50.482009884233484],
						[13.022563935056379, 50.48237610645249],
						[13.0231208785456, 50.48273847793551],
						[13.023274421267498, 50.48310470126479],
						[13.023023605069245, 50.48342513741016],
						[13.022780419589768, 50.48391724911245],
						[13.0227642074151, 50.48443223633501],
						[13.022965430911583, 50.484855648623444],
						[13.022942542282419, 50.48525618706481],
						[13.023012160593638, 50.48571395165853],
						[13.023030279825722, 50.48605345350583],
						[13.022680283840415, 50.48620606804811],
						[13.022399903286159, 50.486541758138316],
						[13.022539140598594, 50.4869232370973],
						[13.023014068290442, 50.48742675446009],
						[13.0232162459539, 50.48785017202541],
						[13.023421288663735, 50.48833466782869],
						[13.02393436417935, 50.48869323581121],
						[13.024708746228134, 50.48932645953894],
						[13.02527332190075, 50.49026488017712],
						[13.025932312183258, 50.49085235779367],
						[13.026134490410351, 50.49127578139695],
						[13.026209829617017, 50.491844159898996],
						[13.026597022260455, 50.4923782268383],
						[13.0272092807515, 50.49293898284124],
						[13.027680395878523, 50.49335478500193],
						[13.027891159342904, 50.49395370788623],
						[13.027970314506012, 50.49457932032254],
						[13.028096200545232, 50.49526216214819],
						[13.02834606027143, 50.49574278249628],
						[13.028993608022995, 50.49682237274967],
						[13.029331983716048, 50.49722044127087],
						[13.034532102888205, 50.4965054201096],
						[13.04228357010022, 50.49278473007078],
						[13.051068564489452, 50.491131099910895],
						[13.060370320042766, 50.49061430878034],
						[13.069775430100744, 50.491079397405805],
						[13.07887048180525, 50.492681363263394],
						[13.078973834805256, 50.492681363263394],
						[13.079180542100525, 50.49278473007078],
						[13.107395872611065, 50.498985886229086],
						[13.160105833868457, 50.497022185013236],
						[13.17514093437015, 50.50419231071993],
						[13.17590713641203, 50.50385667376513],
						[13.176445959245582, 50.50362012916649],
						[13.178112984967719, 50.502883924500566],
						[13.17985820619467, 50.50308988884004],
						[13.18813705617403, 50.50392534177206],
						[13.191875456367837, 50.503387436426145],
						[13.193359376730111, 50.503173846398234],
						[13.195270539431892, 50.50326157779835],
						[13.19569492263566, 50.5035247721911],
						[13.196167947079594, 50.50386048649246],
						[13.19641590119543, 50.504035949826765],
						[13.196916580325034, 50.50463867319309],
						[13.197014806820643, 50.505363444988035],
						[13.19696807904262, 50.50592804408325],
						[13.1969480513898, 50.5061683648151],
						[13.196825982791406, 50.50674821689681],
						[13.196351050724102, 50.5072593624932],
						[13.19625472840582, 50.50736234651854],
						[13.19575405289711, 50.507987993902915],
						[13.195617676454043, 50.50855637306975],
						[13.195491792521464, 50.50908281266551],
						[13.195613862192657, 50.50972748973245],
						[13.195674897001219, 50.51005173532845],
						[13.19633770100173, 50.51052094679412],
						[13.196386336561309, 50.510879509010394],
						[13.196025849411644, 50.51148224956867],
						[13.195630073965198, 50.511978153825716],
						[13.195682525680622, 50.5123901372021],
						[13.19560241649138, 50.51296996541561],
						[13.195134163982221, 50.513423931071884],
						[13.194704054671323, 50.51404570356271],
						[13.194615362560409, 50.514713271366695],
						[13.194689750667136, 50.515258789017494],
						[13.195178033185417, 50.515895856847074],
						[13.19586467576545, 50.51654813917743],
						[13.196785927061022, 50.51709366100243],
						[13.197906494646132, 50.51742554244319],
						[13.19905185723211, 50.517940523745374],
						[13.200149536474214, 50.51836395623852],
						[13.201210974538919, 50.51865385793843],
						[13.201579093135686, 50.51881789319861],
						[13.202239991727655, 50.519107834355275],
						[13.203334808738315, 50.51947784833739],
						[13.203767776264323, 50.519664762031894],
						[13.204305649716494, 50.5198974705634],
						[13.20530891565637, 50.520404831194455],
						[13.20573425399267, 50.52067567038811],
						[13.206865312286569, 50.52118684566899],
						[13.207339286980508, 50.521572114895335],
						[13.207523347656434, 50.52206422700328],
						[13.207928657426487, 50.5227279651983],
						[13.208039285541604, 50.522949237610725],
						[13.208215711844058, 50.52330015343098],
						[13.208584785940843, 50.52405548601112],
						[13.208728790645525, 50.524509433749465],
						[13.208791732442347, 50.52470779054383],
						[13.209183691311551, 50.52537534912929],
						[13.20923709905286, 50.526058200804094],
						[13.209016800202976, 50.52688980393595],
						[13.209025384085617, 50.52751923756142],
						[13.208853720675087, 50.52822493512407],
						[13.2089757918359, 50.52886199850665],
						[13.209179876642395, 50.52946851959504],
						[13.209609033162621, 50.53005601540808],
						[13.210345266800697, 50.53080366515342],
						[13.210915563737949, 50.531391125330934],
						[13.211604117375181, 50.53205107618624],
						[13.212490081338546, 50.53272246841868],
						[13.213569641235257, 50.53329849371512],
						[13.213626860553788, 50.53332899928148],
						[13.21488857280847, 50.533893586421264],
						[13.214974404641872, 50.53396226303182],
						[13.215600014686489, 50.53446961453424],
						[13.215950966037408, 50.535396577570985],
						[13.216437340566154, 50.53598786225202],
						[13.216982841389466, 50.536624907370815],
						[13.217741968023677, 50.53729249916641],
						[13.218420983616811, 50.53803254495997],
						[13.218967436620783, 50.53893660316492],
						[13.219492913764427, 50.539707199330216],
						[13.219876290105596, 50.54047394575468],
						[13.22043323402807, 50.54106520406294],
						[13.221180916578405, 50.54176712821103],
						[13.221681595398161, 50.541881567062376],
						[13.221870423758263, 50.541965499297895],
						[13.221938131989448, 50.54215239162762],
						[13.221813201353237, 50.5426788272088],
						[13.221653937783005, 50.54333877026317],
						[13.221375464562964, 50.543903342095064],
						[13.221199034462183, 50.544025408700406],
						[13.221050261301288, 50.544136035263264],
						[13.221049307580603, 50.54436110191411],
						[13.221276283479176, 50.54487991559305],
						[13.221552847440869, 50.54549406512254],
						[13.22208976846326, 50.54621888266594],
						[13.222741126239415, 50.54673384805042],
						[13.224039077132325, 50.54719161328357],
						[13.225432397720047, 50.547580737767774],
						[13.22688388795773, 50.54799651797844],
						[13.228042602031124, 50.54847335281277],
						[13.22812461920787, 50.54855347392151],
						[13.228610993350836, 50.54901886952761],
						[13.229077340025716, 50.549736031920304],
						[13.22908592214853, 50.550609587648744],
						[13.228992462698102, 50.5509529170529],
						[13.229331017650713, 50.55142213081075],
						[13.229214667372464, 50.551856985152426],
						[13.228736879167508, 50.55263521101644],
						[13.228462217452387, 50.55325315505292],
						[13.22873401709682, 50.55379868266729],
						[13.22859859333726, 50.55437468086113],
						[13.228630067407593, 50.55491639749352],
						[13.228575707353935, 50.55519486390168],
						[13.228543280344383, 50.55526732125667],
						[13.228450775322386, 50.55547714418297],
						[13.2283964142483, 50.55553434742367],
						[13.228117944065865, 50.555828107682736],
						[13.227774620127711, 50.55599975661157],
						[13.227208138491033, 50.55622864798422],
						[13.226254465036618, 50.55659105328666],
						[13.225881577676036, 50.556747448485886],
						[13.225165366353895, 50.557079307062786],
						[13.224822999451053, 50.55726625011305],
						[13.224523544204839, 50.55745315439541],
						[13.224147798091076, 50.55779649362325],
						[13.223752976941354, 50.55806352261434],
						[13.223554610287215, 50.55828474986066],
						[13.223379134536222, 50.55867766707696],
						[13.223528863667363, 50.55954744185067],
						[13.223729134758754, 50.55984116812535],
						[13.223814965868275, 50.55996324286368],
						[13.224099160993012, 50.56037141734574],
						[13.22397232063198, 50.56085205157197],
						[13.224034308671268, 50.561443321331886],
						[13.223608017019698, 50.56212234551584],
						[13.223320960197329, 50.56229781262098],
						[13.223033903584435, 50.562465652534016],
						[13.222861288333917, 50.56290434062582],
						[13.223217963773882, 50.56343459664056],
						[13.223563192558643, 50.56377790554338],
						[13.224207879843105, 50.563934344359076],
						[13.224493982039762, 50.5642318897125],
						[13.224637031486719, 50.564743041272635],
						[13.224946974798513, 50.56522368428883],
						[13.225375174244888, 50.56553648608442],
						[13.225708008786274, 50.565898905496866],
						[13.225949285656775, 50.56616209090379],
						[13.226327896935748, 50.56636048222421],
						[13.226731302094885, 50.56647493284314],
						[13.22706699472014, 50.566658030598084],
						[13.227567672491572, 50.56701659906265],
						[13.228270531605437, 50.56743241306871],
						[13.228824617062243, 50.567714707800185],
						[13.229384424056585, 50.5678634827839],
						[13.229813575599678, 50.56794357147422],
						[13.230273247164877, 50.56807709160021],
						[13.230691910561553, 50.56821823930505],
						[13.23117351573156, 50.56823349431425],
						[13.232018470390358, 50.56842422092741],
						[13.232397078412342, 50.56861113393436],
						[13.233122824578423, 50.56892775392742],
						[13.233659744862832, 50.56917572651581],
						[13.234169961850114, 50.56944276821946],
						[13.234492303075232, 50.569633495797866],
						[13.234904287863078, 50.56990431287608],
						[13.23524379757365, 50.570156100261066],
						[13.235393525364678, 50.57027818026798],
						[13.23551177880971, 50.570373524913514],
						[13.235816003391578, 50.570755020624865],
						[13.235916138171469, 50.57096481823018],
						[13.235981940949987, 50.57116317462191],
						[13.236040116437986, 50.57143403235039],
						[13.236070631354385, 50.571720106701385],
						[13.235835073865239, 50.57205198606751],
						[13.23568725569403, 50.57266616647647],
						[13.235657693126853, 50.57311631478574],
						[13.2356004717597, 50.57332992829851],
						[13.235529897823817, 50.57359693572893],
						[13.235274314286155, 50.57406234117361],
						[13.234902383614378, 50.57447816744249],
						[13.234576224633717, 50.574943535687275],
						[13.234250069446569, 50.575408943755804],
						[13.234171868393547, 50.57575608373679],
						[13.23397350169711, 50.57623670999184],
						[13.233837125858752, 50.57680509556846],
						[13.233808516946404, 50.57729339064596],
						[13.233727456949904, 50.57754899972096],
						[13.233516692509493, 50.577857964831395],
						[13.233530043220448, 50.57808302431388],
						[13.233570099851061, 50.57853318283273],
						[13.233654022374244, 50.57876587079265],
						[13.233633042024739, 50.57912445743206],
						[13.234033583696617, 50.579204549898066],
						[13.234574317474076, 50.57918166633361],
						[13.235105515285145, 50.579311378812186],
						[13.23565196985092, 50.579547881463476],
						[13.23606872705369, 50.57966233840091],
						[13.236724853024052, 50.57976531466555],
						[13.237113000151957, 50.57987214383055],
						[13.237393380140267, 50.580081949444555],
						[13.237585069280648, 50.58044435200784],
						[13.23759937340028, 50.58069611158654],
						[13.237758637397393, 50.58147812857947],
						[13.237851010390042, 50.58170801731076],
						[13.25177982396005, 50.580893036098125],
						[13.26800622602992, 50.573658346312655],
						[13.28464603541477, 50.568955773416036],
						[13.305626669815304, 50.575777098953644],
						[13.307409665014955, 50.57916995212884],
						[13.307678222785892, 50.57915115491775],
						[13.30865478532984, 50.57895660581565],
						[13.309730530477886, 50.578929908351725],
						[13.310866355877959, 50.57915878277132],
						[13.312189103066364, 50.57949830033865],
						[13.313323975355372, 50.579700477753],
						[13.31499099609102, 50.57980345403407],
						[13.315871239323233, 50.579902655338564],
						[13.316437720631976, 50.579967492306004],
						[13.31757545289771, 50.58022687926962],
						[13.318494795852587, 50.58057402625451],
						[13.319184304770534, 50.58084489465607],
						[13.319681168305674, 50.580886848151515],
						[13.320402145305575, 50.580928801654316],
						[13.321355820086582, 50.58110428257294],
						[13.322895050063075, 50.58132553115381],
						[13.323595045397212, 50.581615431319726],
						[13.323678018165074, 50.58164979593517],
						[13.324467659944487, 50.582088480339344],
						[13.324950216542971, 50.5826453989797],
						[13.325026512486087, 50.58316040393524],
						[13.324734688931493, 50.58353806715843],
						[13.324450492832563, 50.584030151092215],
						[13.32413291849033, 50.5847244177095],
						[13.323853493246727, 50.58530426556747],
						[13.323843000688607, 50.58587644784692],
						[13.323968887047096, 50.58647155467797],
						[13.324228288385154, 50.587039964622],
						[13.324390413231292, 50.58749010111233],
						[13.324319839950286, 50.587810521284226],
						[13.323488233944767, 50.58817289666241],
						[13.322886465987295, 50.58861540713371],
						[13.322021485854583, 50.58918000809712],
						[13.321417807398902, 50.58959578285982],
						[13.321361539917396, 50.59013746260871],
						[13.321616174565358, 50.59064866962118],
						[13.321652412890604, 50.59124756355405],
						[13.321556090194381, 50.59187697202905],
						[13.321413041671223, 50.592483536244494],
						[13.32149696341848, 50.59313583288056],
						[13.321680069248044, 50.593933108369065],
						[13.32180881401822, 50.5945892231423],
						[13.322038650061291, 50.59540938860693],
						[13.32229518907056, 50.59594726736119],
						[13.32241439975825, 50.59643174848155],
						[13.322407723760232, 50.597061170635676],
						[13.322079657217987, 50.5975837573086],
						[13.321539880144057, 50.598312391461334],
						[13.321082116888709, 50.59892274736441],
						[13.320936202275883, 50.59946822362467],
						[13.32100963728291, 50.59995271189805],
						[13.321045874114118, 50.60055159027192],
						[13.320584059839426, 50.600945199786445],
						[13.321853066293716, 50.60239042522433],
						[13.333140449961409, 50.60748996298592],
						[13.335454885170527, 50.608535611345424],
						[13.348053879388988, 50.61422773208606],
						[13.359370159662314, 50.61934032925471],
						[13.365364623748615, 50.623474424391176],
						[13.36598474105786, 50.6270917775992],
						[13.368775269197505, 50.62833202341583],
						[13.375705989528505, 50.626716809065776],
						[13.380970905925558, 50.625489806228046],
						[13.386345254274708, 50.62161405712731],
						[13.400401244242403, 50.60657622615439],
						[13.40701582644702, 50.60130522092392],
						[13.429340048619776, 50.594328925405655],
						[13.447943564764769, 50.59727449421482],
						[13.45991782597182, 50.60421078654785],
						[13.46489343174359, 50.60709299535734],
						[13.482256713147814, 50.620890606519474],
						[13.492178587828901, 50.62445626696493],
						[13.495996660603046, 50.627451487924695],
						[13.498173056029907, 50.629158844575635],
						[13.498617184251392, 50.63204567614248],
						[13.49896240333129, 50.63214493811877],
						[13.500142098806696, 50.63231660304611],
						[13.501006128047012, 50.63246537941666],
						[13.501522062774796, 50.632793411789955],
						[13.501846314100328, 50.633644110406806],
						[13.50231838384349, 50.63400270176651],
						[13.503279684486573, 50.63426206969234],
						[13.504463194975528, 50.63449095832645],
						[13.505380630537728, 50.63478088424577],
						[13.50624465992821, 50.63492966215735],
						[13.5071029670163, 50.63499451409664],
						[13.508008004220473, 50.635082254983814],
						[13.508966447660534, 50.63531495923264],
						[13.509705542455212, 50.63561247689005],
						[13.51066398594594, 50.63584518165758],
						[13.511487007610095, 50.63605118278926],
						[13.512440682450178, 50.63619614665554],
						[13.513018608726801, 50.63609696084275],
						[13.513998031745505, 50.635955811872776],
						[13.51499652927291, 50.63610077568095],
						[13.51590728889792, 50.636280073144825],
						[13.516988755671168, 50.636306777033994],
						[13.51785945750999, 50.63656996231773],
						[13.518381118975308, 50.63698578086729],
						[13.519040106037144, 50.63745496924977],
						[13.51964473680975, 50.637752528511086],
						[13.5202951441207, 50.63808060710246],
						[13.521347044373908, 50.638366683595244],
						[13.522308349275102, 50.63862609520692],
						[13.523211479154694, 50.63869094815404],
						[13.523950578139132, 50.63898469407719],
						[13.524192808965752, 50.63926314187947],
						[13.524377821864585, 50.640029896865315],
						[13.52446460594055, 50.64068602185639],
						[13.524314881650207, 50.64114762662823],
						[13.524071693251551, 50.64155578440223],
						[13.523829458756245, 50.64199064740422],
						[13.523494721399219, 50.64237214098004],
						[13.523427008869241, 50.64271544679361],
						[13.523501394578094, 50.64316938667381],
						[13.52348804636454, 50.64365770098141],
						[13.523530958599176, 50.64431379705505],
						[13.52370548164519, 50.644939414025636],
						[13.523744582623822, 50.64498519379023],
						[13.52414512559915, 50.64546965791046],
						[13.524511338779975, 50.64626313791896],
						[13.524587632711743, 50.646743789634655],
						[13.524674414795793, 50.64739989422581],
						[13.524756431772675, 50.64797210891101],
						[13.525064469863624, 50.648563400163944],
						[13.525412557832691, 50.6490669078787],
						[13.52610969695327, 50.64942170744562],
						[13.525848388407843, 50.64964294163285],
						[13.52504062721498, 50.64933014621635],
						[13.524122238744736, 50.64931870106516],
						[13.5235595720625, 50.649024981302574],
						[13.522499084664629, 50.648849489270425],
						[13.520980835085442, 50.648841859184984],
						[13.52032566096503, 50.64885711935608],
						[13.519734383971386, 50.648979200759975],
						[13.51928043448855, 50.648921975094076],
						[13.51872062537782, 50.64866255224826],
						[13.518270492310712, 50.648365018261536],
						[13.517812727587113, 50.648242937173144],
						[13.516976356131531, 50.64834975812205],
						[13.51693248747755, 50.64882659901491],
						[13.51665592138764, 50.64919280443857],
						[13.516439437253222, 50.64960479108086],
						[13.515994070820012, 50.649959552521594],
						[13.51534938858351, 50.65013123031005],
						[13.515261650796656, 50.65015793575497],
						[13.51488971892492, 50.650276202761376],
						[13.51303291358423, 50.651691440622784],
						[13.512780190636764, 50.65214158255002],
						[13.512794491837163, 50.65322491645746],
						[13.51280312417709, 50.6535647731966],
						[13.523287802446715, 50.66218008980881],
						[13.52339951092087, 50.66256371808842],
						[13.52347087945716, 50.662590035618436],
						[13.524143215962749, 50.6628455805439],
						[13.524503709949338, 50.6631927701444],
						[13.525374414389924, 50.66419603337033],
						[13.525531765014014, 50.66432567537705],
						[13.525967599600994, 50.66468049773583],
						[13.526118277596701, 50.66500853564391],
						[13.526272770393593, 50.665340389312895],
						[13.52649402648477, 50.66557312319276],
						[13.527319907592638, 50.66600036058784],
						[13.527347564390501, 50.666015621861284],
						[13.528611186832382, 50.66673664028679],
						[13.528944014658109, 50.66692732900331],
						[13.529162408442792, 50.66707231170694],
						[13.529453274750031, 50.66727063137028],
						[13.529547690453981, 50.667388906898175],
						[13.52980136557728, 50.667713133203065],
						[13.530621526490497, 50.66822812757665],
						[13.53150272639192, 50.668514279302805],
						[13.532520290827742, 50.66860577006355],
						[13.533249858775507, 50.66857532504902],
						[13.533897401566724, 50.668453233572265],
						[13.536048892267326, 50.668087037383124],
						[13.537268637378581, 50.6678275936038],
						[13.53840160722659, 50.66765598088758],
						[13.539226535700571, 50.66766742692241],
						[13.539777753805357, 50.667785624783775],
						[13.54024410430664, 50.668010730359775],
						[13.540574072255808, 50.66959761003792],
						[13.540367126755292, 50.670566561806304],
						[13.53849124586505, 50.672874417779845],
						[13.539131165417428, 50.67389298370947],
						[13.53959655710875, 50.6746101327443],
						[13.540399551305851, 50.675407408792324],
						[13.541400905806109, 50.67599483608588],
						[13.542754172964344, 50.67653655684498],
						[13.543678281107075, 50.67679974777096],
						[13.54437256169768, 50.677448304408585],
						[13.544055935237612, 50.678230250067436],
						[13.543843269187839, 50.67910766437765],
						[13.543326376129322, 50.680095654841345],
						[13.542730330282247, 50.68116377621078],
						[13.54202175456453, 50.68203738579743],
						[13.541875841251676, 50.68265916978386],
						[13.542173383969434, 50.68349455101136],
						[13.541642189826527, 50.68425370080347],
						[13.541747096862895, 50.68565753862047],
						[13.541354177434217, 50.6863708297131],
						[13.541259766089718, 50.68709183213722],
						[13.541257859181426, 50.68772507638174],
						[13.540266990994542, 50.68861389500097],
						[13.540347098820476, 50.68918227655367],
						[13.54042625320372, 50.68975447516967],
						[13.540168761488577, 50.69006346922638],
						[13.539834978250212, 50.69046404075031],
						[13.539103504873653, 50.691429106302095],
						[13.537918093744082, 50.69194415217407],
						[13.537801739683616, 50.692012757552334],
						[13.536852833309696, 50.692565884273314],
						[13.535519597196659, 50.69343182648836],
						[13.53501033815593, 50.694099429602716],
						[13.534919741267872, 50.694454218632316],
						[13.53466320075268, 50.69465256119449],
						[13.534128187820599, 50.695140825688625],
						[13.533698081958049, 50.695728301877736],
						[13.533045772077129, 50.69638446404119],
						[13.532447815552354, 50.69655609754875],
						[13.531444550186968, 50.69682312651531],
						[13.531010653110588, 50.69691548481062],
						[13.556567420900867, 50.70672513760405],
						[13.596075574106482, 50.71144990533301],
						[13.601939332760924, 50.712151202883184],
						[13.607118410229706, 50.71213329075996],
						[13.691752966403008, 50.71184108970688],
						[13.711028278720239, 50.71426990510668],
						[13.749062133833117, 50.72320993932336],
						[13.770662882334246, 50.72460520735108],
						[13.81655155197875, 50.721349568797386],
						[13.834534955476096, 50.723675053712114],
						[13.839316768759579, 50.72557064574367],
						[13.860594613898927, 50.73400586021031],
						[13.863473755739616, 50.73514720436157],
						[13.869571575065448, 50.73525055960093],
						[13.875359334398611, 50.73654246496382],
						[13.877412335150009, 50.73840879662105],
						[13.877959251432143, 50.73818588285007],
						[13.879387852329227, 50.73811718619576],
						[13.88023185561904, 50.73781584022363],
						[13.881460193149154, 50.737922701558226],
						[13.883349417837442, 50.7383346477822],
						[13.88429737411095, 50.73908236823145],
						[13.885278701052384, 50.73949431647753],
						[13.886033056898427, 50.74030302695018],
						[13.886814118032131, 50.74050522447298],
						[13.8885860478592, 50.741054570157424],
						[13.890424724584967, 50.741550407725015],
						[13.892395971510593, 50.74191663965989],
						[13.89402484720543, 50.74207685657387],
						[13.894369125307765, 50.74211120547429],
						[13.894807812095745, 50.74268337632795],
						[13.895007133020481, 50.742744441200095],
						[13.89592647342238, 50.7430305272207],
						[13.896161082183465, 50.74312975779176],
						[13.896857258891028, 50.74333569640983],
						[13.898190497561782, 50.744483939908875],
						[13.898874280749839, 50.7455558569699],
						[13.899359700019707, 50.74631497222778],
						[13.899321555029324, 50.74774168867941],
						[13.899723053977276, 50.74915314711742],
						[13.900568960067648, 50.751792887578546],
						[13.901290894837654, 50.752151501986],
						[13.901808738484823, 50.752418515847424],
						[13.902751924867303, 50.75290682173294],
						[13.901581762625998, 50.75400541630342],
						[13.901024821910516, 50.754535709670236],
						[13.897920606421483, 50.75558851066699],
						[13.897014619316028, 50.756797804379175],
						[13.895468712810246, 50.75876999851212],
						[13.893115040976538, 50.76037976482757],
						[13.893074035788693, 50.760429383754776],
						[13.892782215215862, 50.7607727439011],
						[13.8923864354458, 50.76123808805496],
						[13.892135616227241, 50.76160045578206],
						[13.891874310119043, 50.76174923547008],
						[13.89159774566799, 50.76190564898147],
						[13.890797617527335, 50.76212313248244],
						[13.890107151515943, 50.762432065336064],
						[13.889587400137469, 50.762996651687345],
						[13.889130592843268, 50.763721470997275],
						[13.88881683698416, 50.76431277876013],
						[13.88860416718052, 50.76484301739955],
						[13.88851451927633, 50.76506805954473],
						[13.888570784254473, 50.76583861046166],
						[13.888607976113013, 50.766345950910456],
						[13.888629912770089, 50.76664733330907],
						[13.888615611726937, 50.766716038267504],
						[13.888517380660545, 50.76720047889975],
						[13.888338091524547, 50.768016840345226],
						[13.88821124837964, 50.768596630061644],
						[13.887887957262988, 50.76906206755112],
						[13.887532233244201, 50.769783010614354],
						[13.887531281586599, 50.77046204673983],
						[13.887631419370088, 50.771137267806864],
						[13.888189312231678, 50.7717971448091],
						[13.88878822120254, 50.77233121731348],
						[13.88896655822243, 50.77245710155726],
						[13.889487263735527, 50.77282712060854],
						[13.890532497322788, 50.77318576699701],
						[13.890847208393522, 50.7732887494014],
						[13.891525268888119, 50.773509982555446],
						[13.891839979251214, 50.773727398860885],
						[13.892383573387146, 50.774101236968576],
						[13.892420767896937, 50.774246207479926],
						[13.892524719931366, 50.77464676590669],
						[13.892568585993692, 50.774974800551234],
						[13.892639160601513, 50.775516514426144],
						[13.892790798017653, 50.776187932876695],
						[13.893300057341195, 50.776885995090105],
						[13.893499376913907, 50.77752688049858],
						[13.893657681293217, 50.77829739424105],
						[13.894023898483962, 50.779125245551704],
						[13.894376752310093, 50.77964398815363],
						[13.894602778724812, 50.77997210765598],
						[13.895259516375791, 50.78048267248171],
						[13.900990841025873, 50.780622427526204],
						[13.910706010655725, 50.77876207187936],
						[13.923315066105948, 50.77995068483505],
						[13.933546998413478, 50.784808261971015],
						[13.942073293078796, 50.7917214552538],
						[13.94884321712649, 50.79721055377228],
						[13.949380995540317, 50.79745362334465],
						[13.95959191883899, 50.80206817541184],
						[13.97912560809295, 50.804755332225255],
						[14.015712522152393, 50.801758099856286],
						[14.034936157198196, 50.80258494294305],
						[14.060862512797746, 50.81012389461944],
						[14.077862821933122, 50.81506725329169],
						[14.190792279110358, 50.84790519242846],
						[14.197027335370423, 50.85160394729901],
						[14.197429653831037, 50.85153958132763],
						[14.19842815235119, 50.8513908227519],
						[14.19937896923799, 50.85118104916382],
						[14.200160981429871, 50.851173412536],
						[14.201027871354711, 50.85133744423937],
						[14.202000618199815, 50.85157394620844],
						[14.20290375022019, 50.851844813336605],
						[14.203897478158044, 50.852165241137314],
						[14.204752920950265, 50.852542866485955],
						[14.2057180403592, 50.85304260150281],
						[14.20638275095645, 50.85352706417561],
						[14.207034110051879, 50.85384749427532],
						[14.207181932849942, 50.854286216158144],
						[14.207334517346359, 50.85457610033933],
						[14.207552908905257, 50.85482024232159],
						[14.207850454385282, 50.854972821448875],
						[14.208130839134274, 50.8550987499556],
						[14.208574295872475, 50.85548401679718],
						[14.20921039569177, 50.85579681279324],
						[14.210165021932557, 50.85634229759168],
						[14.211034778598117, 50.85672000759513],
						[14.212152481053606, 50.857162475338434],
						[14.21298408212209, 50.857772798541646],
						[14.214022640346453, 50.858478584135405],
						[14.21500587265053, 50.85921476355628],
						[14.215744019823068, 50.85972214970276],
						[14.216504093940445, 50.86023327748132],
						[14.217741965904647, 50.86049651768388],
						[14.218571659173335, 50.860542261349025],
						[14.219366074436218, 50.860507973081326],
						[14.219873429588185, 50.86027528056076],
						[14.220225335460894, 50.860038769812945],
						[14.220718385546332, 50.859806077758236],
						[14.221236227100134, 50.859691602080005],
						[14.222650528854329, 50.85940171157246],
						[14.222845081437013, 50.85935214968285],
						[14.223292351113768, 50.85923767422635],
						[14.223896979030968, 50.85985563974382],
						[14.226026538192283, 50.86194613643579],
						[14.227799414072969, 50.86431883303421],
						[14.229225160724573, 50.86613084847107],
						[14.229798314458854, 50.86670300936198],
						[14.230576511437922, 50.86753460118444],
						[14.232007028522608, 50.86903764601717],
						[14.232915877119815, 50.87060164271184],
						[14.234114648169188, 50.87258149405766],
						[14.235236171475501, 50.87432101827966],
						[14.235836032258824, 50.87594989052088],
						[14.236020089500368, 50.87644959753449],
						[14.236439704758244, 50.87812805043847],
						[14.236729625306175, 50.87925723509618],
						[14.236678518155179, 50.879976879813576],
						[14.26810021990926, 50.8841303501268],
						[14.34654504666485, 50.88020296748338],
						[14.375897257200245, 50.89596425590907],
						[14.376326650981662, 50.89774845788179],
						[14.377282144517887, 50.89761354330427],
						[14.377874376158372, 50.897884385761365],
						[14.378677365259273, 50.89811703773404],
						[14.3794021631568, 50.89809420119851],
						[14.380295753870314, 50.897872928534504],
						[14.380996708167277, 50.89790348114068],
						[14.381492615159313, 50.898212436800826],
						[14.38171863420431, 50.8985366692143],
						[14.382845879674807, 50.898895273904955],
						[14.38372516487586, 50.89900969081834],
						[14.384736062970608, 50.89883424637797],
						[14.385630605790903, 50.89880369365017],
						[14.386530878495266, 50.89883806546924],
						[14.387635231084698, 50.89908981386731],
						[14.388061526306426, 50.89958575121062],
						[14.388335227445529, 50.90029906730468],
						[14.388136865901176, 50.90065767469917],
						[14.388021465349228, 50.901145899169585],
						[14.387689593934484, 50.9016075465857],
						[14.387130737644371, 50.90191650714191],
						[14.386491776042385, 50.90211868790865],
						[14.386108401506132, 50.90247347894438],
						[14.386082648586731, 50.90284346920324],
						[14.386593820386569, 50.90299607963864],
						[14.387248994507384, 50.90332795701736],
						[14.387234690715971, 50.90367129237793],
						[14.387504580528992, 50.9043350495246],
						[14.38790416536772, 50.905025464959266],
						[14.388014795713637, 50.90552141489871],
						[14.388086319635915, 50.9058380190409],
						[14.388192178134092, 50.9067649966588],
						[14.388355256009648, 50.907352455916346],
						[14.3886089294726, 50.908172578634776],
						[14.388531684183828, 50.90877913769989],
						[14.388453484427334, 50.90937805981272],
						[14.388398170745752, 50.90956878923583],
						[14.387769699736447, 50.90989685667897],
						[14.387137415049509, 50.910167713373305],
						[14.387066837826556, 50.91051480012301],
						[14.387518883321984, 50.91080475396754],
						[14.387759206479592, 50.91130063823154],
						[14.387324335029522, 50.911720293388726],
						[14.386466981533436, 50.9120407252395],
						[14.38608360314663, 50.91222381821659],
						[14.386023518542594, 50.91252133486737],
						[14.386180875331714, 50.91304013871551],
						[14.386407848520546, 50.91354366638903],
						[14.386672977366334, 50.91398624160907],
						[14.38673210029952, 50.91452406750351],
						[14.386631008391749, 50.91501614030916],
						[14.386303902208759, 50.91536713157225],
						[14.386135097314124, 50.91590496064724],
						[14.385726931079299, 50.91614534726049],
						[14.385643002856565, 50.91648862351465],
						[14.385869025055504, 50.91681670067885],
						[14.386553761310736, 50.91699215862444],
						[14.387063977447465, 50.91661450719031],
						[14.387974737369944, 50.91643141077058],
						[14.388614658073019, 50.91640857244478],
						[14.389188768708854, 50.91646196580382],
						[14.389704707534717, 50.916660339777586],
						[14.389737133077313, 50.917045630063654],
						[14.389676094456096, 50.91733551407047],
						[14.389320372072683, 50.91751097240596],
						[14.389073369354898, 50.917629217835675],
						[14.388686177654288, 50.91794583839132],
						[14.3886070264949, 50.91835404725983],
						[14.388660430944663, 50.91865921055216],
						[14.388875963548779, 50.91886522523024],
						[14.389367099629366, 50.91875454006091],
						[14.389629366767343, 50.91874315975771],
						[14.389750482909882, 50.91873934034104],
						[14.390291211605613, 50.91838834400842],
						[14.3909549695109, 50.918140394219],
						[14.3914699584228, 50.91798785183559],
						[14.392146110824196, 50.91790390290163],
						[14.392756458431487, 50.91787334767967],
						[14.39364719243641, 50.91795347719881],
						[14.394148826280906, 50.91815185243988],
						[14.39450072927709, 50.918445557232054],
						[14.394592282695534, 50.918765998311905],
						[14.394530293356231, 50.91913983380308],
						[14.394064904531842, 50.91936112661214],
						[14.393980976977245, 50.91939160408132],
						[14.393538476594383, 50.919551864189344],
						[14.393023494487, 50.919693027245266],
						[14.392353058769112, 50.91986084848248],
						[14.391818049742843, 50.919940978683805],
						[14.391660689829584, 50.920101161221254],
						[14.39153289582577, 50.920276621635374],
						[14.391520497924484, 50.92046354051574],
						[14.391617776079645, 50.920677195682806],
						[14.391799923277077, 50.92082973982362],
						[14.39195823801211, 50.920928967619226],
						[14.392425539731509, 50.92100145927973],
						[14.392832759254002, 50.920818359419286],
						[14.393359180389291, 50.92063900120225],
						[14.393764492269923, 50.92070385387498],
						[14.394320490490255, 50.92087557323849],
						[14.394671440247835, 50.92098236201213],
						[14.394908902199644, 50.92127225090752],
						[14.395334240533773, 50.92158123747797],
						[14.395560261981963, 50.92189786339401],
						[14.39624405165058, 50.92206194469379],
						[14.396342281610513, 50.922073403107156],
						[14.3968782392228, 50.922141997702326],
						[14.397681238042201, 50.92236711283361],
						[14.39823817897972, 50.92288968009726],
						[14.398944857044661, 50.92299272825484],
						[14.39959621290321, 50.92327498066531],
						[14.400292397415843, 50.923416145972965],
						[14.400711060818425, 50.92348099941738],
						[14.4012899378524, 50.923580150391274],
						[14.40180111108178, 50.923732774378365],
						[14.402143475939251, 50.924072242286734],
						[14.402060506658287, 50.92444608627675],
						[14.402011871417129, 50.92470932082172],
						[14.401674273230197, 50.92509844391479],
						[14.401338579342172, 50.925525684981224],
						[14.400988580602839, 50.9257698230847],
						[14.400807379809692, 50.926486960753444],
						[14.400512698299389, 50.92688372591069],
						[14.400615688297245, 50.927261316011084],
						[14.400967599671759, 50.92754747109574],
						[14.401372913289629, 50.927623784374276],
						[14.401279451627053, 50.92803957135795],
						[14.40090656550072, 50.928348566889106],
						[14.400435448880398, 50.928520213927555],
						[14.400130270047843, 50.92861936704278],
						[14.400056837673185, 50.928745257261525],
						[14.399919508146775, 50.92898557914951],
						[14.399869919769998, 50.92924881881593],
						[14.400046347213316, 50.929656969504926],
						[14.39994620948777, 50.92982479790794],
						[14.399681093510845, 50.93022920795105],
						[14.399531367412182, 50.9304771705852],
						[14.399412155374131, 50.93075943204971],
						[14.39938926778288, 50.93082428753527],
						[14.39968776367106, 50.93115612652183],
						[14.399796484736637, 50.93159483756269],
						[14.39998245152785, 50.9317779458798],
						[14.400294303382388, 50.932262415790085],
						[14.400839806201029, 50.93281174274488],
						[14.400978086948431, 50.933277116528586],
						[14.400700569291418, 50.933708192235464],
						[14.400165559680845, 50.93395997823393],
						[14.39948654373083, 50.9340210149426],
						[14.399002078223473, 50.93402865427637],
						[14.3988704643463, 50.93415828913121],
						[14.398722650749963, 50.93426134226627],
						[14.39855861440276, 50.93434903880512],
						[14.398174283133057, 50.9345245099343],
						[14.397898676737409, 50.93498232572324],
						[14.397671702304697, 50.93516161701439],
						[14.397218701059396, 50.93553540082333],
						[14.397050857352514, 50.93609237488898],
						[14.396728512807156, 50.93648907843219],
						[14.39593982427389, 50.93678662602084],
						[14.39567279988808, 50.93699647642173],
						[14.395375248160821, 50.937194789901326],
						[14.394855498792024, 50.93745421911044],
						[14.394155500258266, 50.937442759941554],
						[14.393503191510153, 50.937652610932965],
						[14.393027305662002, 50.937931061351314],
						[14.392435075011715, 50.9381752124397],
						[14.391888618920724, 50.938465122700734],
						[14.391408920306642, 50.93869781511781],
						[14.391000746759914, 50.93892668801994],
						[14.390698435112613, 50.93924333748044],
						[14.390518189783705, 50.939472210918105],
						[14.389862057822587, 50.93997189791665],
						[14.389239315291944, 50.940372505786264],
						[14.38873386211202, 50.9409751728624],
						[14.388217926669006, 50.94145966188226],
						[14.387725833442406, 50.94165423732152],
						[14.387322427121036, 50.94181443477022],
						[14.38717842063564, 50.94162749877998],
						[14.386636733004526, 50.94092177389285],
						[14.385887147357472, 50.94052888258065],
						[14.383450506718825, 50.9402160511423],
						[14.379629137175051, 50.93971254386034],
						[14.378764154464013, 50.93959428723727],
						[14.378334047374791, 50.938888568505305],
						[14.377802852604821, 50.938842809505196],
						[14.376996993098704, 50.93892668801994],
						[14.37624931001552, 50.93885037104291],
						[14.375539782861752, 50.9387207335795],
						[14.375164982686774, 50.93849942240591],
						[14.374567033547226, 50.938179032174574],
						[14.373867033424746, 50.938156113766155],
						[14.373174669324104, 50.938240069987614],
						[14.372340205429873, 50.93848422139957],
						[14.371770854896479, 50.93884655129705],
						[14.3709764491847, 50.939235697975846],
						[14.370108607547946, 50.93942645180344],
						[14.369158748772879, 50.93949130969944],
						[14.369561191903236, 50.9406699803765],
						[14.369688036347755, 50.94164659773793],
						[14.369475367725034, 50.9421768477989],
						[14.367333413215874, 50.942104349557056],
						[14.366417881051907, 50.9420699713664],
						[14.363323208571874, 50.94143292336306],
						[14.361821172592409, 50.941440562939654],
						[14.360522269242198, 50.941448202516504],
						[14.360823632182834, 50.94216156859765],
						[14.361069676603103, 50.942718480538495],
						[14.360530853977163, 50.942916876841096],
						[14.355883599075547, 50.94465637919903],
						[14.349320415588265, 50.94514087587097],
						[14.347544669042685, 50.94631575524976],
						[14.34658718403799, 50.94691851565094],
						[14.347414013457186, 50.94802090391011],
						[14.346680637377764, 50.94818874553315],
						[14.345984456819044, 50.948486308057525],
						[14.345796586270833, 50.948566448094965],
						[14.343057632694935, 50.948959352957694],
						[14.342216493098533, 50.94908143424637],
						[14.339215279495013, 50.94987488622442],
						[14.337592121193518, 50.949558222318664],
						[14.335462566404027, 50.94950100146188],
						[14.33432197215946, 50.94898983429517],
						[14.333080295332566, 50.94909671390131],
						[14.331550596633381, 50.94963072287949],
						[14.328644748847239, 50.94967266407442],
						[14.325367930464049, 50.949718503158586],
						[14.323446270799632, 50.950359315789555],
						[14.321714398025902, 50.95064160132895],
						[14.319062230608539, 50.95161054261355],
						[14.317825320025065, 50.9519844307618],
						[14.317021370584147, 50.952083593857616],
						[14.316340449664986, 50.951988250723055],
						[14.31524943921034, 50.95256038807441],
						[14.311707495634083, 50.95376204480053],
						[14.31141090583588, 50.95423128041603],
						[14.310748099973912, 50.955280301021226],
						[14.311441420535582, 50.95572279953653],
						[14.312464716963127, 50.95619585913286],
						[14.313548087373778, 50.956672661768266],
						[14.313752170776219, 50.95676418678089],
						[14.314567567627233, 50.95713426315688],
						[14.315520286356683, 50.957454679453576],
						[14.31636905381776, 50.95771405326046],
						[14.317242625305571, 50.957920102450935],
						[14.317207338976162, 50.95819475702807],
						[14.317207338189661, 50.95968248144786],
						[14.316911698614126, 50.960670482905385],
						[14.315183638346454, 50.96081923311317],
						[14.313960075877043, 50.961105351442534],
						[14.313447954584404, 50.96122743909827],
						[14.310193063967533, 50.96199419158012],
						[14.309082033294155, 50.96248628662348],
						[14.306563377527748, 50.9628562941331],
						[14.305498124039188, 50.963516243669126],
						[14.302558902936264, 50.965332069586715],
						[14.304463389340278, 50.96646120844506],
						[14.305226325150162, 50.96724700126258],
						[14.307390216328224, 50.96808245965777],
						[14.308623313051314, 50.96816252847635],
						[14.309685703631372, 50.96916576893958],
						[14.311021803826057, 50.970413198613734],
						[14.31182479825806, 50.97116470025634],
						[14.312956806153176, 50.972259484771214],
						[14.316565511357744, 50.9732780241436],
						[14.320208549053493, 50.972122188125574],
						[14.323749543402771, 50.972663890523705],
						[14.325477597930222, 50.9721641333727],
						[14.327013969809515, 50.9724464453537],
						[14.328423500432606, 50.973506931033945],
						[14.329070088564857, 50.97454449955914],
						[14.32794189366138, 50.97545241479858],
						[14.326058388111205, 50.97782135348243],
						[14.326431271982127, 50.97988889282064],
						[14.326558114894391, 50.98059083744378],
						[14.329084399697273, 50.98153308233607],
						[14.329728129173901, 50.98220064780552],
						[14.328372955956395, 50.983013159123246],
						[14.327788351190067, 50.983409864654085],
						[14.32609939385391, 50.984077435513015],
						[14.324829104953414, 50.98436740294326],
						[14.323554037715505, 50.98536299432697],
						[14.322351453437848, 50.98530576466522],
						[14.317883488048167, 50.9852981236488],
						[14.317199709630795, 50.98497774697122],
						[14.316185954474959, 50.984622986259176],
						[14.315080645405192, 50.984722163265246],
						[14.313834186803867, 50.984836544346024],
						[14.31302547254389, 50.98489759439379],
						[14.311928747267318, 50.984745008289146],
						[14.311408044664487, 50.98466493376131],
						[14.310821535045328, 50.984306353034775],
						[14.309761050846362, 50.98390582548872],
						[14.309161189909243, 50.98354724593321],
						[14.308803560192315, 50.983020800064594],
						[14.307927132952392, 50.982604992877455],
						[14.307264330888275, 50.98235705269981],
						[14.306403158841698, 50.982124316641595],
						[14.30539226302484, 50.98180768682057],
						[14.304240227860694, 50.98167420498635],
						[14.303467754217175, 50.98148349450802],
						[14.302522659360966, 50.981098175613376],
						[14.301872251026593, 50.98082349399884],
						[14.300904270139847, 50.98050304552002],
						[14.29992294652985, 50.98003009244072],
						[14.29948615772689, 50.97957608645804],
						[14.298900602603482, 50.97921751358051],
						[14.297485351485976, 50.97901916430717],
						[14.296300884994254, 50.97884365964705],
						[14.295389171757348, 50.9786834367167],
						[14.294837953412213, 50.97840501552715],
						[14.29374409035216, 50.97846606388601],
						[14.292844774279548, 50.97845842309436],
						[14.291861531480729, 50.97848126750279],
						[14.291444779190925, 50.97845078230298],
						[14.291069028938246, 50.97838209315899],
						[14.290634157842549, 50.97830584121586],
						[14.289685246352601, 50.978218050154844],
						[14.288245199375504, 50.97806928882339],
						[14.287726398582915, 50.97800442018035],
						[14.287235263074637, 50.97757723878708],
						[14.286592480255912, 50.977222411400355],
						[14.285775187109207, 50.97699739919171],
						[14.28487587205368, 50.977520011041854],
						[14.282209398153588, 50.977725999803766],
						[14.2814311952838, 50.979209872764166],
						[14.279443744701167, 50.98091510647968],
						[14.276125909463989, 50.9827613980438],
						[14.269341468614847, 50.98444747736864],
						[14.26289558014685, 50.98539730094293],
						[14.263112066715266, 50.986434922529625],
						[14.261054996566488, 50.986774481847185],
						[14.260293962732469, 50.98717119379769],
						[14.258646968784833, 50.98753742003396],
						[14.258523943621743, 50.98798754304338],
						[14.258494379856876, 50.988445308044334],
						[14.25854301289855, 50.98933027615394],
						[14.258366584953308, 50.98994827438485],
						[14.258750914120899, 50.99049376094146],
						[14.25854397099103, 50.99213030626722],
						[14.260259627962883, 50.993164059310224],
						[14.262116431647188, 50.99426269011613],
						[14.262295720647792, 50.994800545474064],
						[14.262530330829806, 50.99573520662388],
						[14.263195988420915, 50.996486634186496],
						[14.263974189192634, 50.99704741890132],
						[14.26472950008135, 50.997695925382914],
						[14.265419008717327, 50.99810411813928],
						[14.265857694784975, 50.99847410436161],
						[14.266580585004785, 50.999195130838885],
						[14.268169403317062, 50.999225618760235],
						[14.268802639762626, 51.000041932393614],
						[14.267621994908337, 51.00016404049688],
						[14.267269137798513, 51.00047305381898],
						[14.267336844316695, 51.00083922305198],
						[14.264980315027145, 51.001720417604226],
						[14.264839171976973, 51.00177383053081],
						[14.264216425240035, 51.00232698643742],
						[14.26224136459442, 51.004074106911574],
						[14.26181792818319, 51.005451164627786],
						[14.260758397338435, 51.007198308615855],
						[14.260526653812029, 51.00757977195522],
						[14.260603903141838, 51.00840757762996],
						[14.260642048630514, 51.008830994823875],
						[14.265157696706199, 51.008159609908205],
						[14.267066956658848, 51.00890351386827],
						[14.26774978579865, 51.008941644858794],
						[14.26991653133815, 51.0100288096001],
						[14.272087099356726, 51.01068117327215],
						[14.27430534285454, 51.01176070427614],
						[14.280221939727824, 51.01409531251953],
						[14.281111717649006, 51.014850620513506],
						[14.281971929281962, 51.015590646939835],
						[14.280869485815249, 51.0164146601758],
						[14.279448509564633, 51.016735080232486],
						[14.279860493815216, 51.017890904324474],
						[14.277671813645274, 51.01884078674086],
						[14.27820873313769, 51.01935959371287],
						[14.280017856730414, 51.02087024644669],
						[14.280644418731953, 51.0213699524491],
						[14.28473377351983, 51.0247421383236],
						[14.286314960222837, 51.026962241404945],
						[14.28623390163469, 51.02981185585818],
						[14.285787583158298, 51.03099823724203],
						[14.285344122998596, 51.03221129567662],
						[14.28483486134619, 51.032394405273884],
						[14.284139634950364, 51.03245164654902],
						[14.283621790025583, 51.03281404497758],
						[14.283234597850573, 51.03317262267649],
						[14.282675746990693, 51.0335007084996],
						[14.282531751370092, 51.033623770047704],
						[14.287530560663923, 51.03683423341768],
						[14.319363238875683, 51.04001229829633],
						[14.356570269346015, 51.03233833379324],
						[14.364115032615802, 51.02799755333981],
						[14.369386030882376, 51.02244235885375],
						[14.375897257657368, 51.016990465238145],
						[14.38674930715059, 51.013269747943056],
						[14.397808063984119, 51.013114725849036],
						[14.419135427995426, 51.01907613297333],
						[14.42279242367072, 51.020098386825715],
						[14.425816690897872, 51.02094370503309],
						[14.46209354643623, 51.019651788681024],
						[14.473462365435978, 51.0233725303804],
						[14.474768244777442, 51.02545178292724],
						[14.482325557466671, 51.02452472236769],
						[14.485528941866363, 51.02355953211538],
						[14.489803786131736, 51.02352841713734],
						[14.49010217400557, 51.02270071346502],
						[14.493512816894535, 51.01670622759305],
						[14.502917925264452, 51.00851549825575],
						[14.515320270733389, 51.00303781008718],
						[14.54229536611307, 50.998748650894115],
						[14.55459435871037, 50.99265084689871],
						[14.566686641192712, 50.983400742290506],
						[14.574334757965973, 50.97549428267999],
						[14.57743534114391, 50.96572741959183],
						[14.575574994922228, 50.95068962342658],
						[14.56782353008169, 50.93864901595181],
						[14.555834593967171, 50.92428293869036],
						[14.550356896757252, 50.91208733637968],
						[14.561829058783568, 50.90635119613933],
						[14.617122843578843, 50.92087229942284],
						[14.629215127457536, 50.920717260920135],
						[14.634589477039869, 50.90940011800937],
						[14.628801716464977, 50.89611927798486],
						[14.611851848921043, 50.87095287904278],
						[14.608337852292959, 50.8530728365575],
						[14.61319543450865, 50.845579727379864],
						[14.627338533463659, 50.84305418140996]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ42",
				"name": " Ústecký kraj",
				"region": "ustecky"
			},
			"id": 1
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[13.582298267130613, 48.96982561673792],
						[13.57285882293542, 48.97871412631206],
						[13.569098474585118, 48.98277284894925],
						[13.564088815326162, 48.986705713345955],
						[13.562423707542875, 48.98886491498959],
						[13.559840191766934, 48.99339282855497],
						[13.555690763523128, 48.997417429587664],
						[13.554576881396404, 48.999694907707465],
						[13.554369913645761, 49.0021704223836],
						[13.555007929520388, 49.004577581379394],
						[13.555671683222466, 49.00566854511516],
						[13.558929449659258, 49.008792946200394],
						[13.56034756497585, 49.01113518791942],
						[13.562352182577825, 49.018077873293535],
						[13.563441279524756, 49.02071383870519],
						[13.564229010548829, 49.02188872211063],
						[13.567505828299423, 49.025215059363184],
						[13.568247784315044, 49.026378513570414],
						[13.569208132502045, 49.02899537568959],
						[13.570914273275871, 49.03593450051965],
						[13.571572296000701, 49.03720847218401],
						[13.573477747337842, 49.03921892752133],
						[13.579853068394563, 49.043304558394546],
						[13.582960136164802, 49.04450615358052],
						[13.586983690576336, 49.04519282602873],
						[13.59767342250609, 49.04616172106277],
						[13.599670404786837, 49.046527804001826],
						[13.60290525992852, 49.047592015827234],
						[13.60655784179889, 49.049430800632514],
						[13.612247456023834, 49.05170810144059],
						[13.615465162815322, 49.05350111424113],
						[13.618182175701422, 49.05574409918538],
						[13.620072370943914, 49.058506078744195],
						[13.62108136202184, 49.06308375516869],
						[13.620938288062682, 49.06612000602761],
						[13.620216366140966, 49.0689925768043],
						[13.61876011775698, 49.07151422546319],
						[13.615323063626189, 49.07476040344678],
						[13.614523880637131, 49.0758856965826],
						[13.613400445357, 49.078464356485476],
						[13.61122416891663, 49.085338531800645],
						[13.609573374893145, 49.08768856173416],
						[13.60554982188282, 49.09050379670345],
						[13.599372854213962, 49.095428362805755],
						[13.598064429026392, 49.09719474148835],
						[13.59778975983604, 49.09822077547955],
						[13.597989081955514, 49.10036849561023],
						[13.59852313154424, 49.101570037894774],
						[13.60248089046164, 49.10737230671784],
						[13.604356759265023, 49.11189262972581],
						[13.604878415774971, 49.11405934146266],
						[13.603586194325787, 49.12657925670379],
						[13.603135099317784, 49.13449849158645],
						[13.6034831966669, 49.13903041954931],
						[13.604522713778353, 49.141861056381806],
						[13.606642712184842, 49.14413821787112],
						[13.609540930187633, 49.145591636611265],
						[13.613179198397168, 49.14631262193588],
						[13.616875658460465, 49.146305192278945],
						[13.631736762339457, 49.14376457135631],
						[13.635131824894488, 49.14269626098046],
						[13.638549796751342, 49.14092246042516],
						[13.64144991887294, 49.13993062318157],
						[13.645129196453128, 49.13946906722446],
						[13.648929608559179, 49.13960279764062],
						[13.650748251792711, 49.139915454663175],
						[13.653682716329104, 49.14099892243876],
						[13.656732567194041, 49.14293679296221],
						[13.66132545672135, 49.1453743198212],
						[13.665546416456843, 49.14829634777622],
						[13.675694470160352, 49.15255360718624],
						[13.680413246053318, 49.157184599735054],
						[13.682611459641842, 49.158809599157586],
						[13.685850130189184, 49.16006836912383],
						[13.69443987775132, 49.162330516976965],
						[13.699200636452186, 49.164836951029386],
						[13.704793938900174, 49.167160129434414],
						[13.709327703511013, 49.170044007273816],
						[13.711583143965427, 49.172512123879685],
						[13.712861054366279, 49.175331043324164],
						[13.714287760034082, 49.186962150913445],
						[13.715263375653025, 49.18954095928766],
						[13.716091160031622, 49.1906853154863],
						[13.717232716993625, 49.19166960200791],
						[13.718655595195733, 49.19242105567935],
						[13.726696000829477, 49.19445404734143],
						[13.72821521171589, 49.195022519933524],
						[13.73028277090602, 49.19641862692364],
						[13.731377598453163, 49.19826122695758],
						[13.731217378219872, 49.20264809718113],
						[13.730577463015827, 49.20521157656234],
						[13.729414000026365, 49.207660823348256],
						[13.727636348446717, 49.20959484639095],
						[13.7247781792889, 49.211841625481476],
						[13.72311686798341, 49.21394722410948],
						[13.720333087413707, 49.21853624867841],
						[13.7156867928527, 49.222633305532895],
						[13.714818952674634, 49.2237319753803],
						[13.713238719718662, 49.22748569530807],
						[13.712553978617118, 49.23129273159525],
						[13.712835316688476, 49.23426061058183],
						[13.714221013388135, 49.23604215915573],
						[13.716354376640808, 49.23743445718928],
						[13.71992397649217, 49.23910144646678],
						[13.724404344153516, 49.24176035179069],
						[13.730081564645195, 49.24399192056541],
						[13.733315477668572, 49.245681868026146],
						[13.736051549743527, 49.247825518642685],
						[13.737105361695429, 49.24907294427832],
						[13.738292692466132, 49.251819593194114],
						[13.738462457262465, 49.25320825825442],
						[13.738042824221045, 49.25589363021658],
						[13.73654174478151, 49.258247340539135],
						[13.728463179393605, 49.26378638530791],
						[13.724102021828314, 49.26632692105114],
						[13.722493185957765, 49.26813903827666],
						[13.721487058235928, 49.27013792552629],
						[13.721013082201624, 49.27213682796839],
						[13.721592905229354, 49.274417899598035],
						[13.723464970231449, 49.27656178428188],
						[13.726071349205926, 49.278423218132545],
						[13.729091657221007, 49.280017991163604],
						[13.736437787045046, 49.28289783693764],
						[13.743864056604187, 49.287685363900835],
						[13.745550163948414, 49.289600461068474],
						[13.746225363977285, 49.29199226142563],
						[13.745963096570955, 49.29439926096524],
						[13.744865421244956, 49.296512643962465],
						[13.74191475241806, 49.29936603226636],
						[13.741423598813723, 49.30027762388864],
						[13.741131787161619, 49.3023529547202],
						[13.741349230540665, 49.303451647704264],
						[13.742656704200089, 49.305877647498306],
						[13.747968686562489, 49.312240737764355],
						[13.757537835386291, 49.31879418215204],
						[13.762331010362402, 49.32114411946662],
						[13.765551578540386, 49.323093536404286],
						[13.768215182279963, 49.32423785369361],
						[13.774831776773109, 49.32598500722495],
						[13.777858746050612, 49.3274270372286],
						[13.778985024263143, 49.32847596028373],
						[13.780312551886205, 49.33093657802713],
						[13.780886639877515, 49.33365620247053],
						[13.781756400105783, 49.34211729940481],
						[13.782781588130566, 49.34465394697287],
						[13.783653261438472, 49.345767997820595],
						[13.785682676965024, 49.34732817267226],
						[13.79209993835729, 49.35126861603121],
						[13.794832222900055, 49.35213081861321],
						[13.800705911094596, 49.353492751305616],
						[13.8034095668019, 49.35472859673795],
						[13.804656016324355, 49.355827199767425],
						[13.806088444850241, 49.358421296831814],
						[13.806465143426946, 49.362693728318504],
						[13.805808081844175, 49.36549392837876],
						[13.805179586684929, 49.366798302681495],
						[13.804310806160768, 49.36798866610759],
						[13.799796095935738, 49.372089295903606],
						[13.796420096424486, 49.37777327508684],
						[13.792089462624165, 49.38200760252379],
						[13.791278846023722, 49.38315589606211],
						[13.79018879137186, 49.385742208754294],
						[13.7886848521191, 49.39130409191215],
						[13.78747175775694, 49.39392457016472],
						[13.785594954366129, 49.39596191184587],
						[13.781903264877558, 49.39858243697395],
						[13.779341706888054, 49.40089807726637],
						[13.773489006606148, 49.40769204247899],
						[13.778238302477616, 49.41192251811985],
						[13.783023821624596, 49.41722093577605],
						[13.786994942676525, 49.42031487985269],
						[13.788637170264513, 49.422470188184384],
						[13.791206369330698, 49.42701731213578],
						[13.795488361584232, 49.431175274682545],
						[13.796309472408817, 49.432373060400536],
						[13.797287950609945, 49.435096842596636],
						[13.79761410688396, 49.43807230282772],
						[13.79741764514324, 49.44116215650893],
						[13.796004308454886, 49.445743699370375],
						[13.792433742288997, 49.45100406618065],
						[13.790949826840295, 49.45380025817943],
						[13.788628574167433, 49.46277232689926],
						[13.787521356226007, 49.46543877851004],
						[13.786690722589745, 49.46661006704976],
						[13.782401082618945, 49.470821356498035],
						[13.779050829172512, 49.476493858139904],
						[13.777172083879183, 49.47829813709452],
						[13.77304936336761, 49.48139962935018],
						[13.76613236913237, 49.489059600518175],
						[13.764659886004106, 49.49175267118262],
						[13.764281264856637, 49.493152533456716],
						[13.764177334096212, 49.495922212452996],
						[13.765008924651363, 49.498519879058556],
						[13.765868195727336, 49.49968728761988],
						[13.76791954350589, 49.501285585754495],
						[13.774497980140717, 49.505218445653185],
						[13.778005601259476, 49.50626374646898],
						[13.787839885653781, 49.508075673244505],
						[13.79296303229259, 49.5096703033301],
						[13.80214978498885, 49.51298917429596],
						[13.808320058622632, 49.51607527280399],
						[13.810035713751285, 49.516639795672376],
						[13.813888557032833, 49.517402725026926],
						[13.823797240405758, 49.5183374018149],
						[13.827144616269445, 49.51842110437909],
						[13.835602773627652, 49.51725020097705],
						[13.846370696604787, 49.51488112965468],
						[13.850197799093424, 49.514915540244374],
						[13.853811261566957, 49.51573178557879],
						[13.861652361715535, 49.518348562155225],
						[13.866310130552085, 49.52092754375212],
						[13.869224553559677, 49.52215581644519],
						[13.87501334428187, 49.523261948906615],
						[13.88430976704334, 49.52382276731833],
						[13.887812626418656, 49.523304111000165],
						[13.88952541103917, 49.522747013893905],
						[13.892626751058561, 49.52127444804137],
						[13.896595942294807, 49.518573629121526],
						[13.90067671565092, 49.51501071189929],
						[13.903432859415737, 49.5135385002292],
						[13.907084459456193, 49.512496889972645],
						[13.915163980680422, 49.51077638224152],
						[13.92668342083259, 49.507015175293645],
						[13.93671417421614, 49.50451662090888],
						[13.945637706638701, 49.507560768550476],
						[13.952054016286548, 49.51071159217454],
						[13.956584929112342, 49.51197050638917],
						[13.962930686604876, 49.51282890278531],
						[13.974510201887085, 49.51229104844346],
						[13.981321344041964, 49.512428379445474],
						[13.985565173254399, 49.51301180451727],
						[13.989185329131548, 49.51432033069102],
						[13.991409298223406, 49.51626964709529],
						[13.99414730230148, 49.52048112605068],
						[13.995963095331463, 49.5221710071335],
						[14.00324630479705, 49.52688977428104],
						[14.012797351724235, 49.529983479764056],
						[14.01537131658089, 49.531738218495576],
						[14.016966812674717, 49.53401939671782],
						[14.020255086598583, 49.54041287995403],
						[14.026052467838827, 49.547256395816504],
						[14.028168686221075, 49.54912193887015],
						[14.032422052696582, 49.551254137519535],
						[14.041425717862344, 49.554725780442624],
						[14.04592608165477, 49.55580507810787],
						[14.050876607407847, 49.55640782488309],
						[14.058385840212331, 49.55670919880068],
						[14.065624229734246, 49.55641929692906],
						[14.070053088444238, 49.5556791959865],
						[14.07204818031051, 49.555023121691434],
						[14.073787682927229, 49.5540923424116],
						[14.075049406632454, 49.552955692470896],
						[14.07588101131424, 49.55172355224715],
						[14.077910424931583, 49.54384996212339],
						[14.079275122589054, 49.54146948484889],
						[14.081158652855208, 49.539878998496334],
						[14.086274148770716, 49.536422747412196],
						[14.089468941227587, 49.535125580113075],
						[14.09607028640565, 49.53416821035088],
						[14.1133737493199, 49.533580707029046],
						[14.12359524539763, 49.532634813995266],
						[14.127471909304166, 49.532493441883496],
						[14.131340033194238, 49.532672947275536],
						[14.14151762940759, 49.53374471177927],
						[14.164311413733044, 49.53472905250324],
						[14.17966078838294, 49.53646460162841],
						[14.199981702408124, 49.53708280469604],
						[14.207206733483812, 49.53788764902827],
						[14.213682175989428, 49.539646162040114],
						[14.216602321623995, 49.540840109932034],
						[14.217849736325261, 49.541614582338674],
						[14.219836246793204, 49.54372036537264],
						[14.223133095709086, 49.5492096820459],
						[14.22685433559053, 49.55233776131882],
						[14.23162555482862, 49.55703351721772],
						[14.234711645029623, 49.558933237616664],
						[14.236506461227926, 49.559738150314814],
						[14.240577701830341, 49.56089405400711],
						[14.244955072378966, 49.56142053761593],
						[14.249364850424174, 49.561538671012016],
						[14.258644117255347, 49.561142102687235],
						[14.271863926683311, 49.56238545030441],
						[14.277200695273294, 49.56362911400165],
						[14.281947122820535, 49.56576143298319],
						[14.283604614133452, 49.56620017756027],
						[14.287280089617111, 49.56663520207514],
						[14.291074765933766, 49.566494121342785],
						[14.294578550108916, 49.565681435819485],
						[14.303372391902364, 49.560703366746985],
						[14.30718134670258, 49.557754398529944],
						[14.31629467948145, 49.5526276585886],
						[14.319680222585248, 49.55155953603954],
						[14.327436444077241, 49.549930541425056],
						[14.32936953987942, 49.549365945584995],
						[14.332891463961856, 49.54784393035289],
						[14.335888875733394, 49.54596723502904],
						[14.34094144286325, 49.54143538074991],
						[14.349951729535489, 49.53600296550128],
						[14.353721616849144, 49.53491972051151],
						[14.358046521765571, 49.534358877943916],
						[14.365052221269897, 49.53404233881398],
						[14.37464619955712, 49.534149298613585],
						[14.381530753175532, 49.53467169711371],
						[14.385670667003415, 49.53543095949383],
						[14.388852105385592, 49.536617137051806],
						[14.393760684096737, 49.539131194274376],
						[14.411451335035903, 49.54615016028866],
						[14.417689320518315, 49.54928967408384],
						[14.421336182988455, 49.55036553840627],
						[14.42956160081327, 49.55193314588965],
						[14.43527888167034, 49.55369175489792],
						[14.443927775812874, 49.54913341059108],
						[14.449283591460475, 49.54677954819237],
						[14.45687197137556, 49.54438385181826],
						[14.466569897423822, 49.54062649485441],
						[14.476574908482961, 49.53724681167674],
						[14.486244196099527, 49.54213327552969],
						[14.49218941228739, 49.54433827582545],
						[14.49897195273049, 49.545452254615256],
						[14.505986204605607, 49.545787720366796],
						[14.5151271878201, 49.545505581858905],
						[14.521246917296802, 49.54456336550109],
						[14.52429199774115, 49.54343419861598],
						[14.527804387869171, 49.54164899649887],
						[14.531036383277462, 49.5406227744192],
						[14.538004869662728, 49.53892130102541],
						[14.544297203717838, 49.53617844293765],
						[14.546029079987216, 49.535713086959305],
						[14.54994582419932, 49.535247731821926],
						[14.55415534941301, 49.53532027880332],
						[14.558377260560965, 49.53591150646082],
						[14.56820392840178, 49.53878023549628],
						[14.572820667331843, 49.53956989341982],
						[14.580114378939518, 49.5400048728866],
						[14.587453852968983, 49.53964244161908],
						[14.592164986136574, 49.53878395590486],
						[14.594241147561908, 49.53813939592305],
						[14.598074923063493, 49.53654489973636],
						[14.60708808508479, 49.532100638638155],
						[14.610919000388561, 49.53067018263209],
						[14.622804654873585, 49.5281106348797],
						[14.62446974446349, 49.52755724762954],
						[14.629347791569316, 49.5252150531281],
						[14.639157297668014, 49.522232079909855],
						[14.641492831085152, 49.52059924065901],
						[14.64483928382349, 49.51559445281807],
						[14.646016128694102, 49.51469047647054],
						[14.647365567800804, 49.5140571369046],
						[14.648881913435183, 49.51361848119065],
						[14.65216921685712, 49.51324833694942],
						[14.655527111528258, 49.51350780986687],
						[14.657140730922835, 49.513881674529486],
						[14.65992164897757, 49.515167264697936],
						[14.666755674953212, 49.52132032996624],
						[14.676649089464137, 49.52856822657927],
						[14.685507769665959, 49.534381820070315],
						[14.692818655655664, 49.53843702803734],
						[14.700583451946287, 49.54156869679887],
						[14.7041911999768, 49.54346458250353],
						[14.707183853153207, 49.54451003845269],
						[14.710841189992943, 49.54513942234455],
						[14.720615389706827, 49.54600909079731],
						[14.724267014410911, 49.546634757833836],
						[14.725916877597275, 49.54713454845267],
						[14.734037395149434, 49.5512504169307],
						[14.736151699906056, 49.55269245919948],
						[14.737503996695597, 49.55450812314588],
						[14.737726199961886, 49.55750263243977],
						[14.736435897657854, 49.5643425722579],
						[14.73313331638226, 49.573482516797945],
						[14.73251914217535, 49.57931511066761],
						[14.733196250515448, 49.58512489044638],
						[14.736559862730788, 49.59241862020466],
						[14.738998410623836, 49.596099829301444],
						[14.746975907404728, 49.604721154446544],
						[14.751376161829876, 49.607547856175344],
						[14.75515840889631, 49.610576477647655],
						[14.76274489229873, 49.614978679755495],
						[14.765740401362892, 49.61608893359652],
						[14.76950646281985, 49.61655815684958],
						[14.773358344388088, 49.61640929544676],
						[14.775195112654826, 49.616107851371325],
						[14.778183941098186, 49.61511234413885],
						[14.783082963135103, 49.61285401467438],
						[14.791870104123774, 49.61070238670902],
						[14.799816147156516, 49.60717788674705],
						[14.80689715963633, 49.605499230833814],
						[14.810191162256416, 49.60444267251965],
						[14.816262240154467, 49.601203869318326],
						[14.826396933855555, 49.59746924885696],
						[14.830446232544661, 49.59626759520785],
						[14.836855893857413, 49.595413261653256],
						[14.841185557463064, 49.59530627634524],
						[14.845387463399991, 49.59548954685667],
						[14.85101126461919, 49.59634388066554],
						[14.857164369565355, 49.59883867573057],
						[14.858613967072198, 49.599163047389105],
						[14.861875546989108, 49.59937298987647],
						[14.86360263663905, 49.59923933370879],
						[14.867369646277806, 49.598392432791016],
						[14.873910894056271, 49.595912837117446],
						[14.876626968230484, 49.59455489962865],
						[14.877799998425937, 49.59367762435909],
						[14.879466060697826, 49.59125141103901],
						[14.880083093417735, 49.58729180826758],
						[14.879517543340112, 49.58263767090374],
						[14.879660607233161, 49.580612190892815],
						[14.881340982939024, 49.57657244169928],
						[14.88281439254053, 49.57469925749804],
						[14.883788113156484, 49.57390980173854],
						[14.886912347842243, 49.57188035964091],
						[14.890684113378473, 49.56883607153317],
						[14.89517690048927, 49.566116459455905],
						[14.900244716986707, 49.56152347800002],
						[14.904676442334452, 49.55866627752879],
						[14.911952971621805, 49.555473319940496],
						[14.915451994174077, 49.55340185642853],
						[14.918251031010445, 49.55209344173449],
						[14.929289826146363, 49.54839333061624],
						[14.94103240320418, 49.54351418885828],
						[14.941249847098767, 49.53950881653287],
						[14.941899289333378, 49.53676595218609],
						[14.943174374027867, 49.5340996940633],
						[14.946581838455934, 49.52884290599792],
						[14.947794912300344, 49.52573774353026],
						[14.948718055886289, 49.519286962498704],
						[14.94834041653491, 49.51456833450467],
						[14.947321889109523, 49.511646244716246],
						[14.945247652059509, 49.50910951569337],
						[14.942714705713588, 49.507606648035996],
						[14.927456855471345, 49.501037594705075],
						[14.925073633834861, 49.49903879554237],
						[14.923578248311305, 49.496318680404265],
						[14.922645571060977, 49.4917412020146],
						[14.922442450502375, 49.486869951407606],
						[14.922670363174984, 49.47855757490741],
						[14.923277851348344, 49.472087825237175],
						[14.923927298042045, 49.469074160531065],
						[14.925024024306696, 49.4663695479864],
						[14.928968437934712, 49.461937032407974],
						[14.930148135951535, 49.45960628057674],
						[14.930621139872512, 49.456962514321674],
						[14.930455197510833, 49.45417775570833],
						[14.929717062190594, 49.45163725133014],
						[14.922211639508014, 49.4345359066183],
						[14.920699105507698, 49.43224320962485],
						[14.916379928991207, 49.42787170803857],
						[14.912630095267122, 49.42017759769898],
						[14.909111024072114, 49.41501237062016],
						[14.907670033276407, 49.41211712413398],
						[14.906562813026511, 49.40729911869958],
						[14.905376437435022, 49.39578250119312],
						[14.902645100379257, 49.385845079275946],
						[14.902042392578782, 49.37756351251966],
						[14.90287589398946, 49.36935037168817],
						[14.907405847661462, 49.35766596052389],
						[14.909057602953396, 49.355388501556845],
						[14.913949976179271, 49.351356602078816],
						[14.919705391361394, 49.34486771053275],
						[14.92153741283345, 49.34227003041971],
						[14.922669415984394, 49.33926778254663],
						[14.92307567525708, 49.33619307777125],
						[14.922640795866032, 49.331733658331174],
						[14.920807826763971, 49.32793415041948],
						[14.918359757105623, 49.32562256484251],
						[14.916986465909545, 49.32375336141012],
						[14.91628074583529, 49.32018660884906],
						[14.916834837474694, 49.317794861124405],
						[14.918207177895606, 49.3158417664006],
						[14.921454423053902, 49.312587673423224],
						[14.924114222740025, 49.30810542397066],
						[14.925867095720132, 49.30600371832571],
						[14.93774222195005, 49.297195323273264],
						[14.940413469444719, 49.29342264402729],
						[14.948513997223825, 49.291809205228155],
						[14.95770262888436, 49.288532180172346],
						[14.961745264481152, 49.281131767309176],
						[14.966830265777391, 49.273727536523616],
						[14.971347805842694, 49.269626588033],
						[14.97457599016429, 49.26439279158632],
						[14.97549437974828, 49.26338190876126],
						[14.976777065520372, 49.26247013542647],
						[14.978411686400756, 49.261776087257665],
						[14.982082365130566, 49.261119824742366],
						[14.985843671864174, 49.2612344150589],
						[14.987640383819594, 49.26155093235467],
						[14.99055576037086, 49.2626113609808],
						[14.995027555832545, 49.265167370790806],
						[15.004845604480415, 49.26907715684961],
						[15.008812896601658, 49.27036277806395],
						[15.015813825991193, 49.27140806614552],
						[15.022882469462504, 49.27147682301828],
						[15.027317045440718, 49.271022780218054],
						[15.031222331912211, 49.27002704789941],
						[15.037404057806453, 49.26691815737931],
						[15.049144749290448, 49.26227192425001],
						[15.068313591111199, 49.25645820907691],
						[15.075649273364032, 49.25556194457189],
						[15.092734330953526, 49.25494379018092],
						[15.09704875309105, 49.254295287084034],
						[15.098974238833259, 49.253700362772705],
						[15.101492870859381, 49.252399338287944],
						[15.10661315767139, 49.249046310997976],
						[15.10830496475529, 49.246986265890556],
						[15.108755096565774, 49.24572739177447],
						[15.10888863382194, 49.24308021435916],
						[15.108156214400466, 49.24041757957272],
						[15.106506357098471, 49.237876984060236],
						[15.103150366685435, 49.23446654248913],
						[15.101452820820615, 49.232097561088324],
						[15.101156220362752, 49.23073563866695],
						[15.101449981362187, 49.2293244863573],
						[15.10340214679596, 49.226825802217014],
						[15.106573108523701, 49.224842107252144],
						[15.10851192322777, 49.224090561399144],
						[15.110665309025018, 49.223556398465796],
						[15.114404686688433, 49.22328575632546],
						[15.118040096315394, 49.22366725653932],
						[15.125293721698322, 49.2258757572483],
						[15.129125597238621, 49.22676851453235],
						[15.133190165443008, 49.22710047361286],
						[15.135208121844949, 49.22703544428249],
						[15.139028558390633, 49.22629937531251],
						[15.140696527773786, 49.22553636782776],
						[15.142029764003945, 49.224472062776115],
						[15.142912873044503, 49.22328575632546],
						[15.143865586879597, 49.22072984297548],
						[15.14500904426689, 49.21541217328956],
						[15.145522122572332, 49.214145708610346],
						[15.14706612533658, 49.212066737945484],
						[15.149789808675997, 49.20965956178391],
						[15.15320588515862, 49.20595563737705],
						[15.155935278597633, 49.20386496495662],
						[15.159386631890598, 49.20211026198706],
						[15.163564688366181, 49.20095068436039],
						[15.165800099870628, 49.20065312734322],
						[15.170343399313468, 49.200511934952694],
						[15.174847605401332, 49.20091631511444],
						[15.177028651983521, 49.20133586792661],
						[15.180995002406325, 49.202556754915065],
						[15.190841671147467, 49.2063674572052],
						[15.195668215889466, 49.20898051541169],
						[15.198605522135386, 49.210189671245224],
						[15.202388752228279, 49.21105946179484],
						[15.216066356331494, 49.21324153705268],
						[15.225789065347696, 49.213970138069214],
						[15.251056685041975, 49.214130535842905],
						[15.260983457404718, 49.21456899820779],
						[15.265778536009147, 49.21515268687783],
						[15.27869319293624, 49.2176017161574],
						[15.292801844320818, 49.2198027344104],
						[15.32217310857838, 49.22000493917394],
						[15.333483692914932, 49.219703644843165],
						[15.338950148254167, 49.21902457265316],
						[15.341592782299513, 49.21841424523915],
						[15.345856651778819, 49.21680436249547],
						[15.349506362612173, 49.21470245688281],
						[15.352486623910838, 49.21219647960401],
						[15.35464094620196, 49.20917497082929],
						[15.355843558937865, 49.20587172529524],
						[15.35698223974709, 49.198757254230735],
						[15.356543535827262, 49.19542689170371],
						[15.354165083452468, 49.18830496107196],
						[15.35252855920551, 49.18570696860443],
						[15.349508290412498, 49.18251423765599],
						[15.348417272608506, 49.17990484649075],
						[15.348427785418941, 49.17710507389898],
						[15.349671374747844, 49.17445765497275],
						[15.356961239694087, 49.168578999603625],
						[15.374723442757505, 49.157951434763],
						[15.381615637662897, 49.15489958689683],
						[15.38610077733065, 49.1525879701599],
						[15.403015127506109, 49.14261236892479],
						[15.412184725970784, 49.13870630984085],
						[15.416979805614297, 49.13617721518322],
						[15.420563689494376, 49.13527671470562],
						[15.424650189097859, 49.134838073948245],
						[15.444824225764174, 49.1344567016266],
						[15.451080336178048, 49.13391126586398],
						[15.454625114608646, 49.133071755117086],
						[15.459570873292787, 49.13084019242229],
						[15.461161615548011, 49.13036348427245],
						[15.464790343455164, 49.12969207015209],
						[15.476485252063988, 49.12828826602194],
						[15.479739192146079, 49.12742617608772],
						[15.4831752929697, 49.125759270439154],
						[15.485896104248443, 49.12484735210254],
						[15.490846631769616, 49.1243743692131],
						[15.495764728913029, 49.12488171149442],
						[15.498449330335047, 49.12576298498052],
						[15.501928329591777, 49.12739181636722],
						[15.505526534734711, 49.128326340435336],
						[15.516183851393011, 49.1296806168139],
						[15.520203575359021, 49.13041672695849],
						[15.521971710419104, 49.130939558319575],
						[15.527025216500496, 49.133174836493055],
						[15.532755842323667, 49.134391695035454],
						[15.541708938936743, 49.13504021388271],
						[15.558691964454988, 49.13558565196131],
						[15.561785694536816, 49.13533398260665],
						[15.564605717968105, 49.13443379454028],
						[15.566860192335225, 49.13304513350698],
						[15.572280892403095, 49.12865074704044],
						[15.573900214081835, 49.12664023728573],
						[15.574797619319856, 49.122821703543046],
						[15.574269300124564, 49.116867116565544],
						[15.574474329453617, 49.11482233772072],
						[15.575839982665794, 49.11181246172967],
						[15.577303872365606, 49.10984788907078],
						[15.579492579716657, 49.10819254588478],
						[15.58707904420713, 49.104705773059706],
						[15.592073428375928, 49.10182941326655],
						[15.596527112684509, 49.09847271927143],
						[15.59881020635473, 49.095878700048154],
						[15.600213994033101, 49.0928343731898],
						[15.600837702881874, 49.08965297113015],
						[15.600920691191734, 49.08025754872621],
						[15.586670860651399, 49.07948289067701],
						[15.57060909395712, 49.077217113889866],
						[15.564684884049507, 49.07558456569426],
						[15.561999326408383, 49.07404332555727],
						[15.55904961637849, 49.07063684500935],
						[15.556086528947642, 49.063991439229994],
						[15.55192470988322, 49.057502788306266],
						[15.548371315346348, 49.04973221153096],
						[15.544220922081037, 49.045349099184236],
						[15.542936312832456, 49.043464543844784],
						[15.541168218391133, 49.03949742798793],
						[15.540200236100866, 49.03336336750229],
						[15.538192755791846, 49.02994162347481],
						[15.534256933362693, 49.02686308135908],
						[15.52360437738182, 49.02180084548091],
						[15.520765318593728, 49.02071012562382],
						[15.51402281203468, 49.01896653018038],
						[15.510867122007058, 49.017566711263925],
						[15.508599274787736, 49.015445646776506],
						[15.507206912039608, 49.01301951609767],
						[15.505615224211025, 49.008323572080016],
						[15.505315792559614, 49.00627529118566],
						[15.50586033738776, 49.004074180150795],
						[15.506547922116356, 49.0030478881269],
						[15.509019860327106, 49.001281821066556],
						[15.512375816651062, 49.00027070029995],
						[15.522804252129564, 48.99821845861377],
						[15.527276048068638, 48.99676522231701],
						[15.529904374354413, 48.99542244762344],
						[15.53203105675475, 48.99335477334371],
						[15.53493310485382, 48.988571307099726],
						[15.536869992115907, 48.98619832358379],
						[15.53944778964851, 48.984066059503505],
						[15.542466152041982, 48.98225773212134],
						[15.55165385605295, 48.97791284597359],
						[15.554735171741617, 48.97680652615045],
						[15.569961544822197, 48.97405621496134],
						[15.576540953967804, 48.97217185035599],
						[15.579462037430664, 48.970771656263544],
						[15.58173179698466, 48.968990332801766],
						[15.582797998779462, 48.96770090697875],
						[15.587309830339395, 48.95751564970305],
						[15.591567028005255, 48.951175580052634],
						[15.584994322715072, 48.945396486525055],
						[15.57802487787339, 48.94141782482768],
						[15.57393360573634, 48.93845753067808],
						[15.569383623576655, 48.93594362609951],
						[15.56552219322818, 48.932983391924374],
						[15.561072350656625, 48.93024064171343],
						[15.554747571846558, 48.92441931077042],
						[15.54528046883147, 48.91762935976842],
						[15.538476931106631, 48.91128527696999],
						[15.535946835511997, 48.909076589938266],
						[15.534773837667371, 48.909023391144956],
						[15.533529282024228, 48.90896988306688],
						[15.527981769648619, 48.9087258492495],
						[15.527821550133996, 48.91044244160518],
						[15.527562138774714, 48.913227055916416],
						[15.520772931304082, 48.912929509401856],
						[15.517578122350036, 48.912792180351545],
						[15.513991603660878, 48.91263629340591],
						[15.506777942281358, 48.91675619284693],
						[15.506770144933123, 48.91683970497051],
						[15.506663324626494, 48.917976400326125],
						[15.506345759741189, 48.92134104656265],
						[15.50350667089664, 48.92121515768473],
						[15.499555597662317, 48.92104349112739],
						[15.4991683897774, 48.92516320925552],
						[15.499132141245758, 48.92554459334709],
						[15.498869895814646, 48.92833709600976],
						[15.498708724794039, 48.93004607979733],
						[15.49828528396067, 48.934547331874846],
						[15.497860897252155, 48.93904865892401],
						[15.491066918458674, 48.93875108399909],
						[15.489340788639987, 48.93867498900854],
						[15.484274879211712, 48.93845381873088],
						[15.484045990002073, 48.94086845117341],
						[15.483848559761304, 48.9429549015348],
						[15.479434952792433, 48.94276033046383],
						[15.47705459119687, 48.94265361030158],
						[15.470259658317135, 48.942356031405296],
						[15.469871508904212, 48.946460607504214],
						[15.469834331458314, 48.94685748858274],
						[15.469756141030153, 48.94768156775959],
						[15.469408026580476, 48.951358711470725],
						[15.464301118731974, 48.951133818682464],
						[15.462612149687338, 48.95105741085895],
						[15.462681757293087, 48.950324886749925],
						[15.462845807985898, 48.94860463841312],
						[15.463040362429059, 48.94655619299512],
						[15.458154686106338, 48.946338728318956],
						[15.456244453966299, 48.94625458840587],
						[15.455367083812495, 48.946216539850866],
						[15.454483991612335, 48.9461784913012],
						[15.44944953133475, 48.94595329349106],
						[15.4492492551444, 48.94805896221642],
						[15.449240673310621, 48.94815052685265],
						[15.449021349663148, 48.950454810644494],
						[15.443551070333163, 48.950214451488726],
						[15.442442878674925, 48.95016464736609],
						[15.442227348116266, 48.95015320169945],
						[15.435433378703033, 48.94985190243345],
						[15.432152758388654, 48.94970713042115],
						[15.430796611273408, 48.94964588074701],
						[15.428973773661955, 48.94956545190309],
						[15.42165639923616, 48.951190737884886],
						[15.421533592671542, 48.95248039411806],
						[15.421412474160384, 48.953746855529474],
						[15.418760314721311, 48.953628685209836],
						[15.414617550639793, 48.953445552251324],
						[15.414388664164964, 48.9558296932446],
						[15.4141845814665, 48.957946885028896],
						[15.41052530893271, 48.95778261955447],
						[15.407387728690358, 48.957641555498085],
						[15.407221787486325, 48.959369595272356],
						[15.406954766765502, 48.96214295829779],
						[15.400158867181203, 48.96183762401645],
						[15.400060649328204, 48.96183391174767],
						[15.393362045977401, 48.96153259943624],
						[15.393096913262916, 48.964290516780416],
						[15.392929090769831, 48.96603406719142],
						[15.389872561795281, 48.965896711143024],
						[15.386133190736441, 48.96572872850331],
						[15.385909093248152, 48.96805203360099],
						[15.385698303423606, 48.970229956965895],
						[15.382390989632759, 48.97008146163187],
						[15.378900527554078, 48.96992492288919],
						[15.378673551886177, 48.97226713559178],
						[15.37846374014476, 48.97442622144596],
						[15.375256551335422, 48.974281436239295],
						[15.371666917449645, 48.974121182618326],
						[15.371436121124576, 48.97650148462715],
						[15.371230137291933, 48.978622551295594],
						[15.367863641804927, 48.9784697200874],
						[15.364433292686758, 48.97831348584482],
						[15.364254006126659, 48.98015984007441],
						[15.364218718768846, 48.980518407988946],
						[15.363995566095513, 48.98281492460153],
						[15.35719490629721, 48.982505854338214],
						[15.353143692934202, 48.98232270175704],
						[15.350396143345005, 48.98220049697912],
						[15.343597422916847, 48.98189173679996],
						[15.33679867058934, 48.98158266759657],
						[15.335692417719645, 48.981533167056405],
						[15.3299999183057, 48.98127359874796],
						[15.329437260395444, 48.981246992237054],
						[15.327658655707099, 48.98116686334213],
						[15.323201166066081, 48.980964530254184],
						[15.323232639844584, 48.98065174958715],
						[15.319873796578683, 48.98138033419611],
						[15.317706107153821, 48.98184966129195],
						[15.310396179093726, 48.981704562715485],
						[15.306057933567693, 48.981617008601646],
						[15.303835882508125, 48.982803477548416],
						[15.301595691149906, 48.98399737687285],
						[15.30073739670497, 48.98445526140817],
						[15.29557131354615, 48.98721681668336],
						[15.294060699799866, 48.99108879632395],
						[15.293034540967009, 48.99371707154886],
						[15.288539884019581, 48.995067572574634],
						[15.287137021052157, 48.99548711104374],
						[15.285729411120926, 48.995910672300774],
						[15.28197860343494, 48.9970359438336],
						[15.277053841159587, 48.99472816766964],
						[15.278093340158982, 48.992462179079446],
						[15.278982149048533, 48.99052416138362],
						[15.279458055087629, 48.98948678312723],
						[15.279728882494679, 48.985942772760936],
						[15.279915810142443, 48.9835014392988],
						[15.280023500392641, 48.982102114438696],
						[15.279614718125853, 48.982592789982014],
						[15.274550411349905, 48.98672675147869],
						[15.266902300258064, 48.986675084302696],
						[15.262871554112518, 48.982592789982014],
						[15.260391069989403, 48.96915677065358],
						[15.257083788496818, 48.96388587610416],
						[15.253173246747389, 48.96079231302068],
						[15.251133910001132, 48.96159354245359],
						[15.250613207633037, 48.96179957326398],
						[15.246829977898885, 48.96328726887803],
						[15.244646082827122, 48.96262369807976],
						[15.241410268716972, 48.961643348686096],
						[15.237996116839158, 48.9606057723013],
						[15.22832489419415, 48.961715737885186],
						[15.226055133018773, 48.96197497799687],
						[15.222830788151931, 48.96234527725214],
						[15.210682878697787, 48.9584885596468],
						[15.199984556767236, 48.95375830134852],
						[15.198666561298184, 48.95260227607651],
						[15.197196961713113, 48.9513092164806],
						[15.196488383290005, 48.95068743644054],
						[15.194100364270511, 48.94858917138554],
						[15.193230624190006, 48.94782633868557],
						[15.19255541500926, 48.94723116981971],
						[15.190004358491402, 48.94732675558343],
						[15.184745800836975, 48.94752132994489],
						[15.18267060379495, 48.94818888502034],
						[15.177580845134953, 48.94982158692019],
						[15.177071558641014, 48.94957720688648],
						[15.176170361979299, 48.94914258218335],
						[15.17609787159017, 48.94985963598328],
						[15.176072115440522, 48.95011515259494],
						[15.175928130884778, 48.95153441875893],
						[15.170491208878449, 48.95127859146002],
						[15.16973018673219, 48.951240542196864],
						[15.169134150407142, 48.95121393865016],
						[15.168678289271991, 48.955715234197264],
						[15.16822529681419, 48.96021660484776],
						[15.16795446021798, 48.962886960704516],
						[15.16911601418516, 48.96342462359691],
						[15.16933726859011, 48.96352763968201],
						[15.170396819341374, 48.96914687100155],
						[15.167223928510836, 48.971782666203744],
						[15.163991934686951, 48.974468295794146],
						[15.163636194894865, 48.97719943004152],
						[15.16322899051473, 48.98032380981213],
						[15.160918242332764, 48.98132712115581],
						[15.158534062508421, 48.982364777339],
						[15.159149162212628, 48.98239509651242],
						[15.158755305003412, 48.986286188571675],
						[15.15874576038741, 48.986381478802244],
						[15.158735272829173, 48.98648450366739],
						[15.158693322637186, 48.98689660352243],
						[15.15858267432044, 48.987979760880506],
						[15.158234598167848, 48.99139787644526],
						[15.157856950968, 48.99512109772638],
						[15.157779706478337, 48.99589551195209],
						[15.156426430069974, 48.995830539038835],
						[15.155545238263555, 48.9962692612057],
						[15.154840462983065, 48.996620115696324],
						[15.151674261962171, 48.998195563197136],
						[15.145369539573835, 48.99909219867386],
						[15.142023090934412, 48.99956898224843],
						[15.13884735971696, 49.00001915830101],
						[15.135432231224968, 49.0000265838917],
						[15.129234323354385, 49.00004205387295],
						[15.126997936329822, 49.00004947946431],
						[15.114356037583805, 48.99965282941482],
						[15.113428100985061, 48.999622198897136],
						[15.110922817045758, 48.99954608671676],
						[15.109588612578836, 48.999435321874856],
						[15.10281373420719, 48.99888242654485],
						[15.102886201304743, 48.998180402719626],
						[15.102923382868244, 48.99781407633899],
						[15.098115934776438, 48.9975854320014],
						[15.096121777784115, 48.997489828404994],
						[15.089321126413651, 48.99716558086207],
						[15.082522382431302, 48.99684133371014],
						[15.081240652693213, 48.996780382714746],
						[15.075723648832621, 48.9965133742023],
						[15.074109161996866, 48.9964354065291],
						[15.068870020439718, 48.99671726596251],
						[15.06846045317598, 49.00068653408377],
						[15.06830118854983, 49.002227661775265],
						[15.067995076439837, 49.00518803785303],
						[15.06797504530843, 49.005374918875404],
						[15.069659229988478, 49.0070457152487],
						[15.071179388298855, 49.008552534963115],
						[15.071309094600016, 49.0090256224033],
						[15.072386745172766, 49.01295856143242],
						[15.067399968738254, 49.01643361827403],
						[15.059225094985463, 49.0162049580895],
						[15.05680466576412, 49.01447686272209],
						[15.055622098469025, 49.01363370474045],
						[15.054288857351356, 49.012683801488734],
						[15.051318170452415, 49.012634295222455],
						[15.044463155180743, 49.01251981201666],
						[15.043046003728506, 49.01302725146227],
						[15.039856921527193, 49.01287471011348],
						[15.033056247241094, 49.01254642162231],
						[15.032994280732687, 49.01314173488439],
						[15.032821644951275, 49.01479710874104],
						[15.032587054865987, 49.01704410169645],
						[15.025786411389792, 49.016716117526016],
						[15.01898479325729, 49.01638411131634],
						[15.019186970300662, 49.01443478211417],
						[15.01945207941692, 49.01188644229789],
						[15.012653354212384, 49.011554751473035],
						[15.008818623023462, 49.01137157910351],
						[15.007738128900398, 49.01131836012769],
						[15.006375315488395, 49.01125338348544],
						[15.005851757727013, 49.011226774007945],
						[14.999051093973867, 49.010894774585644],
						[14.9992104257098, 49.00936999592988],
						[14.982061818093822, 49.00791422406047],
						[14.978857865133504, 49.00626043965916],
						[14.977307580075534, 49.0029015405031],
						[14.977307577500023, 48.998250635959394],
						[14.978237740006517, 48.99282447608224],
						[14.964595171009288, 48.97174059227502],
						[14.964181774337058, 48.94326701980948],
						[14.968315864774496, 48.91267433723556],
						[14.968212514169291, 48.885027469979335],
						[14.94702520120093, 48.822395874143],
						[14.939790500201454, 48.8097868142675],
						[14.938136854670097, 48.80281051103799],
						[14.940100550756965, 48.79650589670819],
						[14.944441367890759, 48.788599363952265],
						[14.948885547212226, 48.78213988334206],
						[14.951055942003661, 48.78033104587375],
						[14.94021224398225, 48.76377259227456],
						[14.936415660928677, 48.76358402277714],
						[14.93617152806241, 48.76590343661181],
						[14.936038027566068, 48.767177685113815],
						[14.936015127800532, 48.76739500659244],
						[14.9359417095396, 48.76808561397166],
						[14.933384884575034, 48.76795948680023],
						[14.932809841106906, 48.76792919155692],
						[14.929175387533618, 48.76774989324673],
						[14.928997994255134, 48.76774216487392],
						[14.922409065570942, 48.767414172933115],
						[14.922196402453796, 48.769432210626775],
						[14.922166834017188, 48.76971445268388],
						[14.922130596759054, 48.77006161390428],
						[14.921935069338378, 48.771911499098785],
						[14.915167793205551, 48.771575773685406],
						[14.911980642224181, 48.77141965841695],
						[14.91087149120255, 48.77136215855835],
						[14.908400547860287, 48.77124035782238],
						[14.908211710492521, 48.77123262935112],
						[14.901634205186692, 48.7709006144314],
						[14.901436800571796, 48.77277369083491],
						[14.901392930797725, 48.77318948523813],
						[14.901324274216146, 48.773838063939195],
						[14.89764498942973, 48.77381889714907],
						[14.897165301683815, 48.77381518744793],
						[14.892359748395771, 48.77378860125776],
						[14.891951561953222, 48.77487183602601],
						[14.887623784973826, 48.77472684801901],
						[14.887365340813936, 48.77715301138514],
						[14.887144078663852, 48.779224294267564],
						[14.882982264425054, 48.77901469209306],
						[14.880376812064958, 48.77888485011853],
						[14.880252849391352, 48.78004848372542],
						[14.880065926591067, 48.78180321793432],
						[14.879912377824477, 48.78324510097598],
						[14.875082009961373, 48.78253930693416],
						[14.874578478090816, 48.782367727842896],
						[14.87128736054857, 48.78125014774563],
						[14.866909041807185, 48.77976623101727],
						[14.866671575791532, 48.77978910800581],
						[14.856713285682376, 48.78068533099262],
						[14.85333634831591, 48.78190245535307],
						[14.852845187461366, 48.78207774396569],
						[14.852192886260909, 48.782039718384084],
						[14.846057885675668, 48.78168481321073],
						[14.845893852511535, 48.78321449488911],
						[14.84582519825668, 48.78386309734135],
						[14.844892496537158, 48.78382105252188],
						[14.84481049093473, 48.78381734268519],
						[14.84177683861566, 48.78368749843227],
						[14.839051253728861, 48.78355796339374],
						[14.839101779591983, 48.78309237972807],
						[14.839116111427801, 48.782959135146186],
						[14.83914280545365, 48.782714905106474],
						[14.839290629143152, 48.781341656207246],
						[14.833060269414375, 48.78102879632316],
						[14.832524285329306, 48.78100190028261],
						[14.83232498180455, 48.78284072992248],
						[14.832282057920496, 48.78323737216584],
						[14.83086013275474, 48.78316874034139],
						[14.824539173744599, 48.78372181440742],
						[14.823254599653417, 48.78383651017536],
						[14.818698885974976, 48.78299716085549],
						[14.818716059680927, 48.78283702009907],
						[14.818795198590733, 48.782100621147386],
						[14.818987834517836, 48.780315279269146],
						[14.816830533544811, 48.78020614965841],
						[14.815456984067136, 48.78033104587375],
						[14.814495447726703, 48.780087436476904],
						[14.810063691032195, 48.77896430103374],
						[14.800367486529563, 48.776507207135786],
						[14.794476368810995, 48.76699869642942],
						[14.790445596856292, 48.754854633541406],
						[14.780420369029258, 48.743124075142696],
						[14.775356066757062, 48.72400368055528],
						[14.73688154607577, 48.70162957050395],
						[14.735870406474753, 48.701041737997315],
						[14.722749481517067, 48.69341146440892],
						[14.70383590448442, 48.67310259559456],
						[14.700218549211343, 48.64610161590579],
						[14.70073531428324, 48.61553501793899],
						[14.695671029966423, 48.58954183037791],
						[14.692011973824327, 48.58711329969759],
						[14.687151918911724, 48.586460216703024],
						[14.68599416107193, 48.58634961907239],
						[14.675586708422195, 48.58535393344453],
						[14.674123769532036, 48.585289057992036],
						[14.668670647199866, 48.585052417184116],
						[14.663348187393332, 48.58482349983169],
						[14.662228583487066, 48.58672713407087],
						[14.660782810829938, 48.58918377446457],
						[14.659864414210656, 48.59074390066819],
						[14.65725326874487, 48.59494022018651],
						[14.65557669755137, 48.597633275512116],
						[14.65542220730519, 48.599025691430306],
						[14.655321106272279, 48.5999410997943],
						[14.65482425732909, 48.60443878618586],
						[14.652100569313923, 48.60429388774902],
						[14.651917465095423, 48.6042824565323],
						[14.648082742344213, 48.60408410954906],
						[14.647644989017547, 48.60801307454231],
						[14.647581091130666, 48.608585261546764],
						[14.647556290536759, 48.60881790595213],
						[14.646399511963343, 48.60957732291093],
						[14.644710555746952, 48.61068741010344],
						[14.643832210122797, 48.61126331013397],
						[14.643638598313824, 48.61122499915065],
						[14.641975415362372, 48.61089719329168],
						[14.64057540126427, 48.61061851227204],
						[14.639122955916884, 48.61033241652739],
						[14.637270929645256, 48.609966300912696],
						[14.63650322808334, 48.60953530466853],
						[14.635736480259956, 48.609104309093375],
						[14.633502960701568, 48.60784531151345],
						[14.630850787680199, 48.6077041187666],
						[14.628204336713532, 48.607562926091525],
						[14.627355571514082, 48.60751720068918],
						[14.624511730765617, 48.60736859318353],
						[14.623142235674555, 48.61201470081126],
						[14.62267588313417, 48.613952507207664],
						[14.621804233046346, 48.617580369270314],
						[14.620861066123291, 48.61933530508926],
						[14.619064317838486, 48.622680527760835],
						[14.618835442100957, 48.62310783674923],
						[14.618796355818303, 48.623455122341184],
						[14.618606560699725, 48.625156333668336],
						[14.61741639135391, 48.62509546559299],
						[14.617355336613677, 48.625091448918454],
						[14.612039561032242, 48.62839502890593],
						[14.611417766562107, 48.62878032554377],
						[14.611360543924219, 48.6292991018949],
						[14.609253878477238, 48.62918848720137],
						[14.60904788597361, 48.62917705495901],
						[14.60415839679466, 48.62968439978935],
						[14.603927605318098, 48.629707264316366],
						[14.60258007969656, 48.62984476049833],
						[14.600911140069453, 48.62874602886865],
						[14.598063467763508, 48.62687300427972],
						[14.597897519283155, 48.626766098276164],
						[14.597832667171438, 48.6266897810098],
						[14.59548662897659, 48.62393557599012],
						[14.59541892627815, 48.62385555181975],
						[14.594944967176705, 48.623298781976374],
						[14.593811998992667, 48.62196742066207],
						[14.593411454826176, 48.62187967277484],
						[14.591875079360618, 48.62155154535813],
						[14.591914377904338, 48.62120117244338],
						[14.578778918629016, 48.620495793393914],
						[14.552247243289692, 48.6120332384359],
						[14.552186005851992, 48.612575464504694],
						[14.549329747531452, 48.61242283780048],
						[14.548468584463127, 48.612377111597716],
						[14.54544352701018, 48.61221305345931],
						[14.545216569470103, 48.61421975994857],
						[14.545100222040814, 48.61525355158686],
						[14.544936166584007, 48.6167143372515],
						[14.538191809662028, 48.616352229766704],
						[14.537232408939884, 48.6162987787872],
						[14.535667418284342, 48.616214740273804],
						[14.524453149816116, 48.61785874831353],
						[14.524357804630004, 48.618698212668725],
						[14.524251930075508, 48.61962882536797],
						[14.524195661831182, 48.620124720860126],
						[14.51951216341919, 48.61987291088883],
						[14.517337800582684, 48.620792404602234],
						[14.51669503598071, 48.62106337157704],
						[14.51051043717956, 48.621169966411635],
						[14.508843421260456, 48.62120055450214],
						[14.508366588790093, 48.6211548268529],
						[14.507836341430089, 48.62110137494814],
						[14.503779422211075, 48.62070094944585],
						[14.50142858935942, 48.62046798610942],
						[14.500130659475206, 48.62171560901796],
						[14.498514181782479, 48.623268193654454],
						[14.497728336914525, 48.6240233245278],
						[14.4963970224758, 48.62593464287509],
						[14.496198652716046, 48.627666458218876],
						[14.496157658371772, 48.62802518171481],
						[14.495685574947126, 48.6321639760389],
						[14.49340724913241, 48.632041927841456],
						[14.492446894831307, 48.634811353712294],
						[14.488055243046688, 48.63665785899674],
						[14.484899533214767, 48.63800443135391],
						[14.481266023678337, 48.63955309035491],
						[14.481167780490974, 48.6404303174417],
						[14.479657168035454, 48.64035028850809],
						[14.473866459675117, 48.64492031755979],
						[14.473728182914217, 48.64612200980065],
						[14.473388668225617, 48.64906307237312],
						[14.47068977344025, 48.64891815061282],
						[14.470261575792488, 48.64889528449978],
						[14.469483366724976, 48.64976110809832],
						[14.468504905944018, 48.64912796273813],
						[14.467948927238245, 48.6487695209119],
						[14.464897145813865, 48.646789447189164],
						[14.45729159368736, 48.64519872406621],
						[14.451523781385996, 48.645725256115746],
						[14.450299263091447, 48.64583587741307],
						[14.449676521259034, 48.64575584691702],
						[14.444084162877868, 48.645042371432154],
						[14.442954052125566, 48.641036869532044],
						[14.445013987620566, 48.638465752852305],
						[14.446282397489538, 48.63853465760289],
						[14.447441115432682, 48.63859954550027],
						[14.447476411011719, 48.6382917916076],
						[14.443593395465523, 48.63651572461863],
						[14.421165826631903, 48.59706080212057],
						[14.412934919912411, 48.59145229353465],
						[14.412184707938927, 48.591411513782965],
						[14.411971094880295, 48.593261746567116],
						[14.411797536814372, 48.59476103422582],
						[14.411466601570881, 48.5947647415204],
						[14.405785550883039, 48.59479131046625],
						[14.397141452068826, 48.59483332647882],
						[14.394351010905936, 48.59456640133045],
						[14.392811767558701, 48.59441749181043],
						[14.389377583391532, 48.59408939684241],
						[14.389334673019485, 48.5939559345933],
						[14.38816832633721, 48.59019461167191],
						[14.3886461333866, 48.58717354158369],
						[14.388827324176926, 48.58602524080041],
						[14.390040175966915, 48.58190999462254],
						[14.366608351917934, 48.57521346592877],
						[14.355463174560663, 48.57202852402245],
						[14.353366341425799, 48.57142922767704],
						[14.333212533230864, 48.56070636578243],
						[14.325357703226485, 48.55863919173729],
						[14.315745889452854, 48.5579157462221],
						[14.314372568176914, 48.55823762055344],
						[14.312327473114793, 48.558717034833656],
						[14.300431267281946, 48.56150519117941],
						[14.296732281021418, 48.56237197801625],
						[14.293460844119211, 48.563138681947976],
						[14.2933406852661, 48.56415560274519],
						[14.293041230032937, 48.566692360590665],
						[14.28960132074818, 48.56649774732244],
						[14.289138801627011, 48.566471181077326],
						[14.288834572056123, 48.566452028669616],
						[14.286306378801477, 48.56631085693089],
						[14.285775174981012, 48.570808308596675],
						[14.285702701822785, 48.57141872455668],
						[14.28541183507916, 48.57387924577352],
						[14.285328861473932, 48.574581108415536],
						[14.285242070677883, 48.57530583287675],
						[14.283864964097168, 48.5752295297436],
						[14.281855585619619, 48.575115229542796],
						[14.281324382837745, 48.57508464652405],
						[14.278507237362305, 48.5749283333696],
						[14.278385174412328, 48.57595456481275],
						[14.278208718516893, 48.577442020172086],
						[14.27817154796457, 48.577751251245616],
						[14.278134355775748, 48.57807932694587],
						[14.277974139352743, 48.57942592419542],
						[14.275116920292458, 48.579265592591454],
						[14.274783126738603, 48.57924643930391],
						[14.27195168609561, 48.579086416727144],
						[14.271239286470058, 48.57904440309288],
						[14.271227831861742, 48.579135844540254],
						[14.271153441595226, 48.57976141605856],
						[14.271018034834713, 48.58090598388337],
						[14.270954135637398, 48.581443824262735],
						[14.270706165546672, 48.58354175149582],
						[14.263969423817587, 48.58316424081941],
						[14.262223247669548, 48.583065074842864],
						[14.25723361678478, 48.582782714592305],
						[14.251727117357168, 48.58247007972569],
						[14.250931729020266, 48.582424049523006],
						[14.250508306724619, 48.582344037309646],
						[14.244743347544864, 48.58206940096847],
						[14.24376202187631, 48.582023679759146],
						[14.23725032715999, 48.5816535853817],
						[14.236988072164385, 48.58194737478461],
						[14.236781121420794, 48.58369065519315],
						[14.236744867160422, 48.5839918610486],
						[14.236489293512033, 48.586135838302056],
						[14.233362195708422, 48.58596036519136],
						[14.232652657020765, 48.58591835051933],
						[14.22975157875868, 48.58575430800024],
						[14.229566586515737, 48.58730329338268],
						[14.229282369497195, 48.58967961560629],
						[14.229213728851164, 48.59025207379956],
						[14.228413572052165, 48.59020604230926],
						[14.224096296073307, 48.58996198285712],
						[14.22247696723418, 48.589870537851716],
						[14.217070582577437, 48.5895653094703],
						[14.208769790992175, 48.59106056101564],
						[14.20645047662093, 48.59148040685179],
						[14.204750070382396, 48.591877082970335],
						[14.204086315648228, 48.59202969838786],
						[14.199535362239843, 48.593089976232676],
						[14.198531149458134, 48.59303282245785],
						[14.1949911127755, 48.59283448350346],
						[14.19482897551285, 48.594188566749544],
						[14.194757465809781, 48.59475331069564],
						[14.194432244739627, 48.59732803860831],
						[14.1891794097515, 48.59703052563296],
						[14.187712677418427, 48.59694680189359],
						[14.181533801863461, 48.596591825876494],
						[14.180974017698823, 48.596561549439976],
						[14.17633914107876, 48.59629431368917],
						[14.174237265375153, 48.59617629752032],
						[14.167499540503904, 48.59578702988401],
						[14.161628709517261, 48.595451209750024],
						[14.160764695632627, 48.59540177903779],
						[14.157209410069761, 48.59519973109293],
						[14.156292925191417, 48.595146284184054],
						[14.155792225190016, 48.59542834804455],
						[14.153842911788223, 48.59652694780227],
						[14.153787617234542, 48.596981094639894],
						[14.153719903811353, 48.59754182798352],
						[14.153480522866575, 48.59951011910553],
						[14.148104664887777, 48.59920117278656],
						[14.147556295772494, 48.59917058711963],
						[14.146743770162793, 48.59912486309865],
						[14.140008934913922, 48.59873590027828],
						[14.135826116205658, 48.59849554068206],
						[14.133269302397807, 48.59834662905709],
						[14.129031180668635, 48.59810256245842],
						[14.128649713400636, 48.59807970053486],
						[14.12653159616712, 48.59796137466313],
						[14.124809261370174, 48.59786220340998],
						[14.122067464609218, 48.59636320796798],
						[14.117794996402248, 48.59402853557734],
						[14.117055894618677, 48.593624132890575],
						[14.114322668768674, 48.593315193113696],
						[14.113540655754209, 48.59322745427963],
						[14.10792826436472, 48.592597836275665],
						[14.10620690345017, 48.59240351383325],
						[14.10468673551902, 48.592769606306085],
						[14.103114133130548, 48.5931511462317],
						[14.099886891193927, 48.59393307301078],
						[14.099734303634357, 48.59517285316635],
						[14.09958362517304, 48.59640120795865],
						[14.097954740477723, 48.5963057445773],
						[14.096456517965215, 48.59621800479941],
						[14.09483335965253, 48.598140562686936],
						[14.094034204403826, 48.599086862735554],
						[14.092407218712932, 48.59960929094674],
						[14.092296602823348, 48.60050585542918],
						[14.090023047834926, 48.600372390098975],
						[14.087812413081767, 48.601081734348256],
						[14.08518696834001, 48.60124980224062],
						[14.084873188241493, 48.601268648095164],
						[14.078583721357923, 48.601669354518535],
						[14.078440672197633, 48.60283285848034],
						[14.078270916590125, 48.60421757666237],
						[14.0731916496077, 48.60392005631012],
						[14.0717973573583, 48.60383972895915],
						[14.07153415445543, 48.60382459034563],
						[14.065171230303887, 48.60345446694877],
						[14.064794531356155, 48.603431604584856],
						[14.06452560533902, 48.605625164289876],
						[14.06424332762898, 48.60792934749314],
						[14.057581895285884, 48.607540063389415],
						[14.057503703984352, 48.607536355924374],
						[14.055810932767116, 48.60743718125317],
						[14.050765034072992, 48.60714336491178],
						[14.050498965355235, 48.60930636715069],
						[14.050212863459068, 48.6116371514585],
						[14.047622680448269, 48.61148452527015],
						[14.047072403900708, 48.6114539382506],
						[14.046993250771099, 48.61171717210495],
						[14.043238652832638, 48.61314024583248],
						[14.043148036845986, 48.613872485916794],
						[14.042948736925487, 48.61549392568755],
						[14.042918213877613, 48.615738007570954],
						[14.042361249106648, 48.62023533193818],
						[14.04207228363846, 48.622581347677624],
						[14.043669703622434, 48.624668153541954],
						[14.04377174877654, 48.62484365110867],
						[14.046020519308698, 48.624973420507615],
						[14.048546788013489, 48.62512203744149],
						[14.047990791083274, 48.62961951397973],
						[14.04509067406591, 48.62945173788526],
						[14.041249286022332, 48.62922680066562],
						[14.041022307113437, 48.63106925197652],
						[14.040933603970107, 48.63179010704702],
						[14.0406951838202, 48.63372032700628],
						[14.037324917260463, 48.633525975772535],
						[14.033953678210732, 48.63332760788125],
						[14.032572736642422, 48.6332472720155],
						[14.031767839870902, 48.63320154237923],
						[14.027212153825682, 48.63293087252461],
						[14.021224981521017, 48.63257986726211],
						[14.020469675819626, 48.632534137735995],
						[14.020400060664317, 48.63310637532259],
						[14.020218839790827, 48.63455953040106],
						[14.01991175399363, 48.63703142556871],
						[14.016938223502624, 48.636856229272475],
						[14.014982219468306, 48.63674159471888],
						[14.013468740314071, 48.63877103501653],
						[14.013326634671925, 48.63896168204483],
						[14.012791623810758, 48.639678849756095],
						[14.012612352168052, 48.64112864039191],
						[14.012323722855651, 48.64345227633926],
						[14.013748827199795, 48.6438020593966],
						[14.013764189948914, 48.643823380109616],
						[14.020466765792328, 48.653155521178284],
						[14.023463983070627, 48.65460229232936],
						[14.02454072881776, 48.65446478385308],
						[14.028321562373387, 48.6539821141921],
						[14.032869111408711, 48.654912536423524],
						[14.033168120309606, 48.65591743302995],
						[14.037913310737691, 48.656196468620905],
						[14.040961276594256, 48.65637600329726],
						[14.044658662860856, 48.65658952920005],
						[14.051403051430212, 48.65698629846444],
						[14.051071161046206, 48.65966790503859],
						[14.050847055065752, 48.661479966427706],
						[14.053510663635773, 48.66163632835252],
						[14.05588625458634, 48.66177353137917],
						[14.05717563528657, 48.66184615012578],
						[14.057593332730725, 48.66187272550167],
						[14.057280551781215, 48.664409758614006],
						[14.058775895623057, 48.66724007675178],
						[14.057370188889102, 48.676002534948765],
						[14.048702236634968, 48.67883297188019],
						[14.048622135456984, 48.6794624768655],
						[14.046976081954165, 48.67936698485342],
						[14.045329084704308, 48.679267784448655],
						[14.043607700861784, 48.67916858407956],
						[14.041875836524607, 48.67906567532311],
						[14.037325858459777, 48.67879866899883],
						[14.035129556567252, 48.67867289180362],
						[14.034873962906165, 48.68071747366078],
						[14.034775719741736, 48.681510773027334],
						[14.034714693520323, 48.68200677943849],
						[14.034570703263727, 48.68316660351681],
						[14.032687195552832, 48.68305596727664],
						[14.032390594726436, 48.683036806814954],
						[14.02942468107019, 48.68286528983832],
						[14.027727126600567, 48.683536524451995],
						[14.027602184176986, 48.6845396709376],
						[14.027472508895922, 48.685585159896185],
						[14.027305607826444, 48.686931661563335],
						[14.027263639505664, 48.687267283612634],
						[14.027168263053547, 48.6872595575019],
						[14.026926984332968, 48.687248122858485],
						[14.024956711910189, 48.68713006791882],
						[14.02436257545541, 48.68709576400603],
						[14.020516385864049, 48.68687047084698],
						[14.019987098271956, 48.69112387604507],
						[14.019956581439507, 48.69136802466857],
						[14.019724843100157, 48.69322201601627],
						[14.019566524657842, 48.694492218985175],
						[14.019396793744267, 48.69586194319743],
						[14.018889431662428, 48.69583134684671],
						[14.01716995461356, 48.69573214052078],
						[14.015651702000872, 48.69564436922165],
						[14.012647631596403, 48.69546511806384],
						[14.012536996907206, 48.69635766636314],
						[14.012248999264003, 48.69867713105039],
						[14.01208972866214, 48.699958794328424],
						[14.011065496483841, 48.69989790977934],
						[14.010226247486166, 48.69984815135074],
						[14.010367398989159, 48.700668393922975],
						[14.004693986302712, 48.70474244577834],
						[14.000041957929133, 48.70808406629098],
						[13.998641026534587, 48.70909132001276],
						[13.997021661457383, 48.709190222080395],
						[13.993106850344232, 48.70942696904907],
						[13.989904398836517, 48.70975489175314],
						[13.980833995903824, 48.710681793195796],
						[13.976252559893135, 48.71143345414291],
						[13.969714162478125, 48.71250531631321],
						[13.969566339894008, 48.71367639541052],
						[13.969330780364334, 48.715549390547515],
						[13.962579736991373, 48.715152846123985],
						[13.962538710102743, 48.71514882813977],
						[13.95975209437122, 48.714985018063835],
						[13.959090787289663, 48.71494576547519],
						[13.955644139226727, 48.71620030570362],
						[13.937701760474075, 48.72273241419311],
						[13.934254220628938, 48.72398760810171],
						[13.933996187058417, 48.7260359262486],
						[13.933870324982058, 48.7270318093937],
						[13.933706287773946, 48.728328750145174],
						[13.933301922106763, 48.73152538286223],
						[13.929672241286848, 48.73131179891389],
						[13.929111482909489, 48.73127748949627],
						[13.928346638935336, 48.731231743612746],
						[13.928205486050144, 48.73122401626833],
						[13.926547042986659, 48.731124797185096],
						[13.926303852499123, 48.73304736648394],
						[13.926202771473788, 48.73384854402712],
						[13.923386561868343, 48.735896935659085],
						[13.920851699868892, 48.73773948115236],
						[13.918825158218489, 48.73972329919281],
						[13.9186544511899, 48.73971186236967],
						[13.918628699636566, 48.7399140160168],
						[13.918424595720904, 48.74151981365251],
						[13.918275821156252, 48.742694725628766],
						[13.918085085214958, 48.74420533412844],
						[13.915523534317558, 48.74405294373911],
						[13.914685238333874, 48.74400317732203],
						[13.914299001551036, 48.743980303319645],
						[13.91371535985688, 48.74435803371084],
						[13.913181311238962, 48.74470145352735],
						[13.911435117170015, 48.745826612371324],
						[13.911033641166922, 48.74613201342477],
						[13.910964955279026, 48.746677284976386],
						[13.910759929378571, 48.74829486846383],
						[13.908239376491538, 48.748146185157985],
						[13.907878888882218, 48.74812331081039],
						[13.907676710568293, 48.74811187363731],
						[13.904004104079643, 48.74789054897636],
						[13.90372179758197, 48.75011431352893],
						[13.90367412163229, 48.75049205236183],
						[13.90356159682294, 48.75137334195534],
						[13.903431889506143, 48.75238415462014],
						[13.902367582961329, 48.75231923993346],
						[13.901081070928372, 48.75224288791684],
						[13.90008639174356, 48.752185701197675],
						[13.896677007572379, 48.75198353851303],
						[13.896374707243599, 48.75453191205861],
						[13.89630221428692, 48.75514211564182],
						[13.896137239984077, 48.75653841739813],
						[13.88875674526377, 48.76053230625834],
						[13.88846494125576, 48.76069274310208],
						[13.887659063988325, 48.76112737594809],
						[13.88113498029665, 48.76463692231971],
						[13.878171910583779, 48.76623142674439],
						[13.876919755126995, 48.766426180731756],
						[13.874357222054229, 48.766822799200646],
						[13.874241821054163, 48.76772299851029],
						[13.874111174814121, 48.76874159985338],
						[13.870982159476007, 48.76855457261582],
						[13.867353439373817, 48.76833725021752],
						[13.867025374180338, 48.77090834289331],
						[13.866779319873267, 48.772830881849195],
						[13.865225798483834, 48.772735666545536],
						[13.860018732564605, 48.77242281649502],
						[13.853259089271171, 48.772018461425596],
						[13.846499455733687, 48.77161039728175],
						[13.844351768356491, 48.77148055881803],
						[13.843806268294603, 48.77144624437719],
						[13.842494969953547, 48.77136617736525],
						[13.839738840027982, 48.771202024607035],
						[13.839625367657527, 48.77208338077723],
						[13.835868846858594, 48.77183545076469],
						[13.835860243647133, 48.7714613921929],
						[13.835046754008195, 48.77098068130725],
						[13.834974285227634, 48.77076335698439],
						[13.833542831425541, 48.770725332974074],
						[13.831069948961716, 48.770828276038586],
						[13.827132230425526, 48.77196127058091],
						[13.824213018062148, 48.77228153946484],
						[13.820948587610596, 48.77235016856012],
						[13.816654207842348, 48.77342226855137],
						[13.813168530282073, 48.77398305147569],
						[13.810274117091984, 48.77688590977801],
						[13.808775906862452, 48.77848821418256],
						[13.803902635596938, 48.78112803346111],
						[13.80411435585589, 48.781238709190106],
						[13.804353713348863, 48.781356804570386],
						[13.807363510743002, 48.782829291300466],
						[13.807890890722161, 48.78308866990123],
						[13.80917740887168, 48.7847825202297],
						[13.809648516061701, 48.78540422992556],
						[13.809869779372562, 48.78714384979394],
						[13.809985167559697, 48.787517620638894],
						[13.81026839857821, 48.78843303675123],
						[13.81051732123732, 48.7892380860768],
						[13.811357494551949, 48.791168173661184],
						[13.81208325822004, 48.792827756898596],
						[13.812990200892544, 48.79333509424644],
						[13.81391716111968, 48.79408265337032],
						[13.814602847789786, 48.79587550510728],
						[13.815318100998562, 48.79690163126616],
						[13.811842930912698, 48.80008329610018],
						[13.8070564280928, 48.80443955650504],
						[13.805042257742725, 48.80628194474177],
						[13.802142134880649, 48.808921723200875],
						[13.799767505483382, 48.81108105498366],
						[13.797015197556275, 48.813701710254335],
						[13.795725824772122, 48.814991022517695],
						[13.796211239833656, 48.8154334713671],
						[13.796891207536904, 48.81578440090864],
						[13.797479622922932, 48.81612389088575],
						[13.797957427264878, 48.81658180107762],
						[13.798132890645494, 48.816970762532804],
						[13.798192013953022, 48.81740177452261],
						[13.798097617228182, 48.8177567260842],
						[13.797946928935012, 48.81799696795192],
						[13.797508233298428, 48.81846230190093],
						[13.797296519897857, 48.81868739395641],
						[13.79661369300536, 48.819160458908975],
						[13.79624463156659, 48.81942760183281],
						[13.795881279679358, 48.81978997667996],
						[13.79561805931988, 48.82028963425516],
						[13.79508303331638, 48.82075868245274],
						[13.7945013097825, 48.821407374037754],
						[13.794177045626824, 48.8218878644141],
						[13.793469421252658, 48.82244101686704],
						[13.793110855244674, 48.82286461676496],
						[13.792688366353005, 48.82323070654977],
						[13.792267793779192, 48.82361596710732],
						[13.79150677467274, 48.82381447235826],
						[13.790852534512842, 48.82383333345658],
						[13.790234568984847, 48.823951756448075],
						[13.789925569882739, 48.82423776519048],
						[13.789679540784961, 48.82455840453723],
						[13.789458276670745, 48.8246307571517],
						[13.789009101228537, 48.82477577163765],
						[13.788389200572155, 48.82487100507333],
						[13.787993445014205, 48.82518020476913],
						[13.787963877130098, 48.825634110557665],
						[13.788408287137646, 48.82603081494114],
						[13.78906344860203, 48.82646555166254],
						[13.789626115003752, 48.82683937632496],
						[13.789688112110037, 48.82688142776656],
						[13.790436741730929, 48.82736965784607],
						[13.791083333242023, 48.82768628124022],
						[13.791785249821071, 48.8279191109824],
						[13.792250644258838, 48.82820141344648],
						[13.79230119006744, 48.828495156736956],
						[13.792234432657118, 48.82883466253432],
						[13.792330747743723, 48.829380098962936],
						[13.792693139355228, 48.82987977410929],
						[13.79309271923244, 48.8302229920981],
						[13.792569151069127, 48.830257313920754],
						[13.792093286166043, 48.83027277420264],
						[13.79161643971756, 48.83026504406158],
						[13.791109094592011, 48.830261333593974],
						[13.790764803419975, 48.83044809386058],
						[13.790633198615279, 48.83070751768826],
						[13.790232657994844, 48.83095550112504],
						[13.789944636513486, 48.83103929607801],
						[13.789764409695922, 48.83108907833164],
						[13.78921032015348, 48.83126068803337],
						[13.78849793377831, 48.83130274015692],
						[13.78769302304732, 48.83130645063872],
						[13.787136085505228, 48.8310089938411],
						[13.786972994036216, 48.83079904272095],
						[13.786581035807094, 48.83073039894356],
						[13.785845767975921, 48.83087170619787],
						[13.78535174037389, 48.831062177361154],
						[13.784756666176449, 48.831077637688665],
						[13.784043317151754, 48.83110051897504],
						[13.783844959323103, 48.83121121495511],
						[13.783784876889127, 48.83124553690218],
						[13.783720970265584, 48.83162307860534],
						[13.783350937379995, 48.83188621404103],
						[13.782784454836401, 48.83188621404103],
						[13.782121663939344, 48.831768096810514],
						[13.781504644865272, 48.831470639509114],
						[13.780960090709256, 48.83134850276936],
						[13.780487047776509, 48.83140168635564],
						[13.780121800555976, 48.83172604461516],
						[13.77963352135337, 48.83199691034021],
						[13.778974540630834, 48.83238991348616],
						[13.778494834100437, 48.832347861194826],
						[13.777911183025806, 48.832088435805886],
						[13.777420036809392, 48.83188621404103],
						[13.777391421704058, 48.831718314432884],
						[13.777370444339615, 48.831592467096414],
						[13.777414310398306, 48.831355923734286],
						[13.777131075468366, 48.83112711074268],
						[13.776448262587916, 48.83116545236573],
						[13.776100167340166, 48.83131418080934],
						[13.775813116223167, 48.83148208016854],
						[13.775337232422654, 48.83149352082847],
						[13.773933411496413, 48.83057023019684],
						[13.773354535676521, 48.83074956972649],
						[13.77249241986795, 48.83088314683216],
						[13.771844872461372, 48.83097467192382],
						[13.770165451432405, 48.83133706211555],
						[13.769049639540553, 48.83180612931634],
						[13.768290523296534, 48.83218769149764],
						[13.767636305360393, 48.83278662770075],
						[13.767251968711713, 48.833354953513236],
						[13.766758920669407, 48.83364870235754],
						[13.766070365660891, 48.833728787623706],
						[13.76532172855922, 48.83383175442906],
						[13.764746670801816, 48.834247641771604],
						[13.764503472587961, 48.834670950804025],
						[13.764509208875795, 48.8352089778425],
						[13.764720922136293, 48.83566290033109],
						[13.765147201408018, 48.83616629754477],
						[13.765515334505402, 48.83669288665738],
						[13.765593526836607, 48.83740995238803],
						[13.765291200682794, 48.83785614818729],
						[13.76474667007651, 48.83829121298633],
						[13.763927473185586, 48.83867278424908],
						[13.763484949807255, 48.83903116487647],
						[13.763440126254242, 48.839065487808575],
						[13.76310729264124, 48.839496534729584],
						[13.763112067116271, 48.8400153998621],
						[13.763145452474163, 48.84051138390445],
						[13.762972823146916, 48.84109487750956],
						[13.762588488093822, 48.84166322065428],
						[13.762438786376148, 48.84180082295418],
						[13.762048725044068, 48.842155497067964],
						[13.761472714782673, 48.84257139711848],
						[13.760963440454299, 48.84308624824677],
						[13.760363567155895, 48.8436011003485],
						[13.760008815909433, 48.844150586218134],
						[13.759752271156753, 48.84483334792073],
						[13.759393696292575, 48.8457832800944],
						[13.759125702384425, 48.84628669601455],
						[13.75860212847401, 48.84658416949584],
						[13.758188253041922, 48.846996365615816],
						[13.75732898590945, 48.84901808375616],
						[13.75599671239391, 48.85215768285614],
						[13.754883778521101, 48.85477842391982],
						[13.754450806920625, 48.85543832895233],
						[13.75379847877974, 48.85571663989586],
						[13.753344526034514, 48.85591114849098],
						[13.752544403583787, 48.856361394675645],
						[13.751750936059388, 48.856910597074716],
						[13.75085544266639, 48.85755535468475],
						[13.750146867880751, 48.85829164809826],
						[13.750108719000213, 48.85839462419443],
						[13.749657618196593, 48.85961518768001],
						[13.74931336561763, 48.86093533205855],
						[13.749380121133767, 48.86157236818112],
						[13.74941348481068, 48.861885011212564],
						[13.749793066578567, 48.862411650089236],
						[13.749970436336474, 48.86265564225754],
						[13.750559794846192, 48.863376487319066],
						[13.750755313938003, 48.864131969630165],
						[13.75073433005019, 48.864894875920356],
						[13.750762953409524, 48.86584487815308],
						[13.750764850475342, 48.865894357527],
						[13.750606545874705, 48.86675653706376],
						[13.75031662512339, 48.86699682216378],
						[13.749648090909398, 48.86754604604731],
						[13.74848556618005, 48.868511210752665],
						[13.747768403382356, 48.869125380145576],
						[13.74734307392795, 48.869781608996746],
						[13.74720191192292, 48.87038031869978],
						[13.74719143499658, 48.87076193497381],
						[13.746973028161607, 48.871177569515766],
						[13.746743196059178, 48.87160866732414],
						[13.746030810713847, 48.872299229299365],
						[13.745091434293437, 48.87282557910429],
						[13.744261730206109, 48.87337481477075],
						[13.743762015401602, 48.87400816899012],
						[13.74372862929019, 48.874580291991116],
						[13.743771564822362, 48.8752213804398],
						[13.743698125202638, 48.87574773590765],
						[13.743112563853566, 48.876171109524265],
						[13.7424812185023, 48.87644944169903],
						[13.74141787750288, 48.87674323708189],
						[13.740721690355244, 48.87714372708949],
						[13.740542406344003, 48.87736886767743],
						[13.740388871968905, 48.87755968065705],
						[13.739878660141661, 48.878025116445315],
						[13.739317905796849, 48.87830747090371],
						[13.737711899402761, 48.87911216725798],
						[13.737243638924143, 48.87967285832595],
						[13.737244614903148, 48.88022241710429],
						[13.73703004128223, 48.88080228477618],
						[13.736965174974292, 48.881446789818035],
						[13.736864097644744, 48.88209160565477],
						[13.73690319211532, 48.88268663131585],
						[13.73698043344772, 48.88330454396004],
						[13.737347591788259, 48.88393390087712],
						[13.737828255786294, 48.88463593709635],
						[13.737897862511309, 48.884845620513204],
						[13.738054279599512, 48.88531880050055],
						[13.737929333844276, 48.88584888677348],
						[13.737430560811175, 48.885997645126004],
						[13.737051962471794, 48.885902390287995],
						[13.736834526310137, 48.88573074610255],
						[13.736459734215783, 48.88552477322337],
						[13.735853196286385, 48.8856392025814],
						[13.73547459457059, 48.88591012201059],
						[13.735268589823624, 48.88608547753878],
						[13.735211376910655, 48.886299182577275],
						[13.73478700012188, 48.886432786970516],
						[13.734266284319888, 48.8864479411767],
						[13.734037392550624, 48.88649742430475],
						[13.73371791974065, 48.886653914756636],
						[13.733258256814098, 48.8868104052988],
						[13.732810020364548, 48.88681411653805],
						[13.732470512308025, 48.88681411653805],
						[13.731952677386154, 48.88673030439739],
						[13.731486330339742, 48.886764633352236],
						[13.731141079071259, 48.88701235864176],
						[13.730533587727168, 48.88710390262621],
						[13.730052002746378, 48.88692483519901],
						[13.729674340434398, 48.88667680071962],
						[13.729105000571629, 48.886264853681325],
						[13.728791235649053, 48.8858909473389],
						[13.72879983194387, 48.88548673320423],
						[13.728884693356871, 48.88512798206649],
						[13.728678703295968, 48.884750366079565],
						[13.728366864620742, 48.884403368068384],
						[13.728096004861829, 48.884124718471504],
						[13.727996826679545, 48.8837242181647],
						[13.727714543543087, 48.88327794709053],
						[13.727333076827932, 48.88298043344872],
						[13.72710990821713, 48.8829154876867],
						[13.726743688928657, 48.88280477066159],
						[13.72611808033865, 48.882633128435366],
						[13.725625987943818, 48.882289844308595],
						[13.725382795668152, 48.88189305788138],
						[13.725217832201643, 48.88158812342191],
						[13.724735256156857, 48.8813895760168],
						[13.72404097296316, 48.881278859614135],
						[13.72316933950507, 48.88073362837916],
						[13.722687727974925, 48.88041694324123],
						[13.72239493511276, 48.88004675610201],
						[13.72202970009498, 48.87975326640639],
						[13.721473682775647, 48.879466890043965],
						[13.720882426345463, 48.87923061430934],
						[13.720218670857124, 48.87907041700416],
						[13.719477658503598, 48.8788910456163],
						[13.718628879770169, 48.878814658181916],
						[13.71796512430465, 48.87865446112216],
						[13.717404358570063, 48.8782920078918],
						[13.716819776729974, 48.87815871676578],
						[13.716054929388044, 48.87820448726108],
						[13.715340605740183, 48.87842931946823],
						[13.714699744111353, 48.878597247909426],
						[13.714240063443048, 48.878612401678126],
						[13.713673598200199, 48.87875373380637],
						[13.713274004702306, 48.87909701346141],
						[13.712599744699911, 48.879341020615264],
						[13.711733824459062, 48.879596779933316],
						[13.710945142475442, 48.87984480794232],
						[13.710380546464817, 48.88001242799689],
						[13.709765445552014, 48.88000500570444],
						[13.709187509789139, 48.87997438875033],
						[13.708536140593477, 48.87998954259587],
						[13.707589149467315, 48.88016891470952],
						[13.706794727352076, 48.8803442665283],
						[13.705789561109109, 48.88061518067202],
						[13.704391478224332, 48.88114927818343],
						[13.703858383047912, 48.881214223522825],
						[13.70322036309576, 48.88143534705682],
						[13.702584278657774, 48.881679665576584],
						[13.701931946538952, 48.881675645143496],
						[13.701313975692056, 48.88161472012583],
						[13.700586321945746, 48.88163760566386],
						[13.700036034929683, 48.88145050098393],
						[13.699243545128828, 48.881069178952906],
						[13.698342335379406, 48.88079084204213],
						[13.697338107945459, 48.880691568613024],
						[13.696376804484327, 48.88066868315475],
						[13.695720677180285, 48.88061146951756],
						[13.69505308879944, 48.88037859467539],
						[13.694682123306665, 48.87998583144994],
						[13.694499957395934, 48.87955843148335],
						[13.694060316523037, 48.87929524992837],
						[13.69347571377671, 48.8793295779428],
						[13.692780495090563, 48.879291538791925],
						[13.692274085704668, 48.87919226591109],
						[13.691670422248478, 48.87893681623504],
						[13.691241262215591, 48.87868878905558],
						[13.690539368479753, 48.87859353678254],
						[13.689813614292548, 48.8784713788839],
						[13.689132701531353, 48.878364684055356],
						[13.68839264089811, 48.87835695254765],
						[13.687706947327369, 48.878505706794186],
						[13.687138554114949, 48.8787917728819],
						[13.686362258359347, 48.87921515124487],
						[13.685597417801219, 48.879497506940844],
						[13.684548363850583, 48.87974151445467],
						[13.68372630531265, 48.879806459457285],
						[13.68281175088417, 48.87977615178746],
						[13.68188666038177, 48.8796042022146],
						[13.681194314921035, 48.87932215566904],
						[13.680723176970432, 48.87884125461412],
						[13.678302771197629, 48.87877661910319],
						[13.67623804811886, 48.87871538547546],
						[13.673913965704958, 48.87927638498533],
						[13.671602240796673, 48.880069641507845],
						[13.669918073628562, 48.88245406395832],
						[13.669447885657588, 48.88320526961153],
						[13.669225704320683, 48.883560307012694],
						[13.669515618729402, 48.885807135483375],
						[13.669530857515946, 48.88592898741472],
						[13.669179920792232, 48.88631062554358],
						[13.667976391194172, 48.88761914738514],
						[13.6681337263618, 48.887878316487274],
						[13.669582376139527, 48.89026651884064],
						[13.66711424576169, 48.891860830354396],
						[13.665880195060605, 48.8926581442641],
						[13.665062892605766, 48.893184533552784],
						[13.661253920075772, 48.894222160554214],
						[13.660233486902749, 48.89448535658883],
						[13.65758990510636, 48.893947521486076],
						[13.655665392861799, 48.89355844994906],
						[13.655197139374087, 48.89346690378619],
						[13.654448496872709, 48.89474855287898],
						[13.653900156822854, 48.895687216229035],
						[13.65266513698495, 48.89780424648942],
						[13.651426313365066, 48.89992902540572],
						[13.648740777918457, 48.904598339727734],
						[13.648175246430778, 48.90558250301711],
						[13.647476209823893, 48.90679183489664],
						[13.64663696383364, 48.908557902149326],
						[13.646181106182777, 48.909564967720875],
						[13.64530182637749, 48.911369406001796],
						[13.643716809892924, 48.91370770866926],
						[13.641592979643088, 48.91684341662105],
						[13.639938344735354, 48.916412246891056],
						[13.6380863323542, 48.91905989969055],
						[13.637971874696566, 48.92001720576481],
						[13.637668613453174, 48.922569316796945],
						[13.63755894227395, 48.92298131904122],
						[13.637164117101442, 48.92447282190294],
						[13.637201311027919, 48.92463304605084],
						[13.637455935632035, 48.92536921227468],
						[13.638018614310365, 48.92569739458579],
						[13.635420807208805, 48.92807015526413],
						[13.634822837378598, 48.92861548177262],
						[13.632696164279842, 48.930603164448925],
						[13.632567408766366, 48.93059543145035],
						[13.632321351380503, 48.93059914328964],
						[13.631140712125248, 48.930618321126765],
						[13.6303815823525, 48.93134305877601],
						[13.622335442458214, 48.93899545423559],
						[13.624151222702332, 48.942356031405296],
						[13.625240326030715, 48.94307708852701],
						[13.630738250705264, 48.94672385435866],
						[13.63075827281144, 48.94710526888158],
						[13.63028240606866, 48.947731062084536],
						[13.629712106363154, 48.94831849854657],
						[13.629525197789766, 48.94849791594093],
						[13.629220960351942, 48.94879148017615],
						[13.628668778557545, 48.949207234497],
						[13.628046041440209, 48.94943243502151],
						[13.627585398526511, 48.949485641766294],
						[13.6268177161969, 48.949257038442965],
						[13.625988969991912, 48.948993789118376],
						[13.62522791743237, 48.948863865927045],
						[13.624119746627585, 48.9487608554412],
						[13.623193738395628, 48.94876858895981],
						[13.622420310192954, 48.94890593628691],
						[13.621811875367767, 48.94890222419606],
						[13.621402748529338, 48.94885644174657],
						[13.620919231912659, 48.94854741041555],
						[13.620437613425798, 48.9482535371056],
						[13.619814871032556, 48.94804380456003],
						[13.619050975872272, 48.947872120960376],
						[13.618373865085061, 48.94770043746989],
						[13.61775303973317, 48.94750988439032],
						[13.61709499120654, 48.94718167558641],
						[13.616683970433556, 48.9466592026397],
						[13.616248116927096, 48.94617446991009],
						[13.615607251687397, 48.945678601911006],
						[13.614906314061868, 48.945144686418594],
						[13.614176738017001, 48.94461046264592],
						[13.613375657809605, 48.94430916956564],
						[13.612476342808339, 48.94429772414726],
						[13.611673369142157, 48.94441619971787],
						[13.61074829591268, 48.94444280259467],
						[13.60975551961178, 48.94431690295672],
						[13.608923730364998, 48.94412882694846],
						[13.608657273585637, 48.94616085904831],
						[13.599762111106067, 48.945503826445275],
						[13.598699570894826, 48.94583512658342],
						[13.59783172223891, 48.94622798535059],
						[13.59702302240879, 48.94680799441795],
						[13.596446999947688, 48.94734964667747],
						[13.595873820541271, 48.947955952037724],
						[13.595254893142654, 48.94856256810021],
						[13.594746593210285, 48.94926075053869],
						[13.593828211203196, 48.94977580431475],
						[13.593114861052056, 48.95038613657817],
						[13.592550276326454, 48.95111463938869],
						[13.592161165305692, 48.951648566688824],
						[13.591631902020726, 48.95219053800656],
						[13.590728751989262, 48.95277396268495],
						[13.59025191400074, 48.95340719333657],
						[13.58978939365019, 48.954254184191235],
						[13.589499485506108, 48.95488370614352],
						[13.589531889197868, 48.95537556952642],
						[13.589535706123689, 48.95618049505978],
						[13.589616776175163, 48.9567070079877],
						[13.590199456706387, 48.95700058115344],
						[13.590543746080405, 48.95723723414872],
						[13.590517041071438, 48.95772167739827],
						[13.59098243226381, 48.95821756752609],
						[13.591730104259772, 48.958877415254555],
						[13.592336651501526, 48.95954128618756],
						[13.592673312176101, 48.960399742403],
						[13.592807777718537, 48.96082696073071],
						[13.59256649304066, 48.96166995326131],
						[13.592316638705706, 48.96217358455176],
						[13.59173394180269, 48.96262369807976],
						[13.591093077093229, 48.962886960704516],
						[13.590596208846087, 48.9632111669693],
						[13.59003258108735, 48.9633980188486],
						[13.589499482429652, 48.963707067191464],
						[13.589140896456229, 48.96399693567885],
						[13.588842404528725, 48.964466232492576],
						[13.588723191886105, 48.964813333232364],
						[13.58816622487886, 48.96521364426617],
						[13.587460504249645, 48.9656523165453],
						[13.5871143477742, 48.96612563792927],
						[13.586913122654272, 48.96665588261046],
						[13.58656884606259, 48.96716323555736],
						[13.586186416206282, 48.96783455159514],
						[13.585577000950696, 48.96841801011794],
						[13.585477839447822, 48.96851360338975],
						[13.585163119944461, 48.96864322668307],
						[13.582298267130613, 48.96982561673792]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ31",
				"name": " Jihočeský kraj",
				"region": "jihocesky"
			},
			"id": 2
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[15.535946835511997, 48.909076589938266],
						[15.538476931106631, 48.91128527696999],
						[15.54528046883147, 48.91762935976842],
						[15.554747571846558, 48.92441931077042],
						[15.561072350656625, 48.93024064171343],
						[15.56552219322818, 48.932983391924374],
						[15.569383623576655, 48.93594362609951],
						[15.57393360573634, 48.93845753067808],
						[15.57802487787339, 48.94141782482768],
						[15.584994322715072, 48.945396486525055],
						[15.591567028005255, 48.951175580052634],
						[15.60565377266792, 48.947315310037105],
						[15.612124435955074, 48.94428627872934],
						[15.615434648869643, 48.94326021445179],
						[15.62244987971945, 48.941593216314125],
						[15.628952012709103, 48.93881975510653],
						[15.630794538498378, 48.93827069606455],
						[15.63729001601277, 48.93732848241595],
						[15.649536132936365, 48.93688583491899],
						[15.661911976949838, 48.937053799607106],
						[15.666558259843695, 48.937404577027266],
						[15.670796406273366, 48.93812190898955],
						[15.674276344760104, 48.93946068628424],
						[15.675461760361898, 48.940345681109726],
						[15.678444865628842, 48.9442482304517],
						[15.68051146826304, 48.946079193892004],
						[15.684006680329436, 48.947402853011745],
						[15.68826293811083, 48.9480895868717],
						[15.700346962350237, 48.94853225273173],
						[15.746413240088215, 48.94806298363559],
						[15.75342369578364, 48.94854741041555],
						[15.757659907972672, 48.94944759275588],
						[15.760852810238099, 48.95098873663928],
						[15.76603030028423, 48.95599736036921],
						[15.769148825653371, 48.95969008506912],
						[15.772012711984754, 48.964355482083185],
						[15.779495225337731, 48.974059927398436],
						[15.781759270182427, 48.97630317688503],
						[15.784864430766607, 48.97834782643294],
						[15.788565649045582, 48.97992718884433],
						[15.790616984784155, 48.98049922660438],
						[15.801292419753157, 48.98229980769317],
						[15.805394156623962, 48.98329910445617],
						[15.816014291429122, 48.987003341200406],
						[15.818795219042897, 48.988201281174305],
						[15.8231058143324, 48.99105074143867],
						[15.827759755767568, 48.99349987820246],
						[15.832055081727107, 48.996181392956984],
						[15.835268036372453, 48.99729552734949],
						[15.842223162572065, 48.99896998627791],
						[15.848787319727222, 49.00168620855792],
						[15.850648866240272, 49.00220476601711],
						[15.85488415618352, 49.00283440007653],
						[15.85952852686047, 49.003108840543426],
						[15.884012221319026, 49.00318526313593],
						[15.888504020336509, 49.00360481427396],
						[15.892551406134396, 49.0046041901983],
						[15.894274726559969, 49.00545134211239],
						[15.89649105712384, 49.00759893678207],
						[15.900214186427586, 49.015121377562956],
						[15.905559529734028, 49.0219382300837],
						[15.907469762467251, 49.023731353140164],
						[15.909895910779124, 49.02499784054627],
						[15.911289202784067, 49.025401954326476],
						[15.924997330574751, 49.026187904769536],
						[15.926801676096, 49.02653879834868],
						[15.929757107747516, 49.02764501347469],
						[15.937063220760422, 49.032455477825856],
						[15.93862723837102, 49.034587816628914],
						[15.94091129225044, 49.03915023078407],
						[15.9427089849959, 49.0410081433409],
						[15.948713311153817, 49.04513557746983],
						[15.951732650282363, 49.04629911815115],
						[15.953587520351265, 49.04663456539272],
						[15.95744992140495, 49.046802598624666],
						[15.961212143350064, 49.046367507268684],
						[15.964240084519188, 49.04537973492245],
						[15.969133381114796, 49.04314426359054],
						[15.977719304327014, 49.04086301279887],
						[15.980446803364726, 49.03958500097227],
						[15.992533678091437, 49.03226084202757],
						[15.995413787405147, 49.03112799640972],
						[16.000255573246246, 49.029785049869766],
						[16.003633484238435, 49.02899537568959],
						[16.00827406608587, 49.028331642724716],
						[16.02528570859263, 49.027122384277355],
						[16.03533935381647, 49.025886520351044],
						[16.042224890764725, 49.025825562763444],
						[16.048912050707276, 49.02671053214603],
						[16.052890779691847, 49.02791978873643],
						[16.062755571967436, 49.03164661074479],
						[16.068651186446132, 49.03464877620848],
						[16.070314417460626, 49.035118196379365],
						[16.073984134256186, 49.03557957191662],
						[16.077741638387106, 49.03545393906255],
						[16.07952881053345, 49.035179156079536],
						[16.08244513526992, 49.03426352427631],
						[16.08592033420537, 49.03261947948265],
						[16.08931733155836, 49.031650633413605],
						[16.103006362100487, 49.02953719342096],
						[16.106702819627113, 49.029159684663234],
						[16.11253355402153, 49.029228069406976],
						[16.124975217772388, 49.030311706904776],
						[16.146499617608512, 49.03063568504241],
						[16.152870168219817, 49.03147116055617],
						[16.154773709189797, 49.03208539143697],
						[16.156467432627426, 49.03297038147765],
						[16.157764428580258, 49.03409952161378],
						[16.158630381533584, 49.035350895410915],
						[16.159671799037152, 49.039470815708626],
						[16.15952490310321, 49.04844270753082],
						[16.159973160351047, 49.05281844347099],
						[16.161151887623912, 49.05551911902497],
						[16.16221429539262, 49.056739955867364],
						[16.164716721790036, 49.058403026221676],
						[16.171087271955624, 49.06114584608131],
						[16.177045831676736, 49.06304940373557],
						[16.181905745574504, 49.06380080365844],
						[16.18943977165912, 49.06415174652037],
						[16.196910855349824, 49.06395337399952],
						[16.203834540575716, 49.06319052316469],
						[16.207704534546277, 49.062179478372855],
						[16.212623607068263, 49.0598946611992],
						[16.214418411490332, 49.05933761811838],
						[16.21853637861988, 49.05860139462614],
						[16.22304726130339, 49.05827335959062],
						[16.22770880328784, 49.058349488440385],
						[16.232347498698083, 49.058937166753594],
						[16.23459052979555, 49.059513086563676],
						[16.23831558024503, 49.0611839109122],
						[16.24119375766356, 49.06340777295769],
						[16.24226952443122, 49.06468589853285],
						[16.243637081668883, 49.067577332033046],
						[16.245401394654312, 49.076194874487115],
						[16.246757515677167, 49.078666763153215],
						[16.255956651141698, 49.087211621284524],
						[16.259220107716764, 49.08950410014647],
						[16.266551973561295, 49.09393312480995],
						[16.275648133490275, 49.09806075724886],
						[16.284582133291792, 49.10368342834463],
						[16.288881289984552, 49.10847080872666],
						[16.290864935921658, 49.112022322403845],
						[16.29088973321419, 49.11466973829422],
						[16.28972055190959, 49.11713424520673],
						[16.28693580880025, 49.12073137668721],
						[16.284194963244225, 49.12328354015231],
						[16.281570443060055, 49.12475975115054],
						[16.277854928418805, 49.12593849711923],
						[16.26649093338944, 49.127357456651225],
						[16.26228523827704, 49.12835698569886],
						[16.260408396103614, 49.129257153196235],
						[16.257860181775182, 49.13183973455724],
						[16.257158264275365, 49.13333116117849],
						[16.256513598731555, 49.13652422907246],
						[16.256832117331566, 49.14157099520619],
						[16.259159085276373, 49.149799320961655],
						[16.26063727996999, 49.159294097958146],
						[16.262247097806675, 49.16367351192201],
						[16.263202673185912, 49.16493230496644],
						[16.265893931518704, 49.16679759585654],
						[16.275711065347434, 49.16981893054797],
						[16.279201501713466, 49.17217249332444],
						[16.280992516342806, 49.17485054005363],
						[16.281848917963913, 49.177806949309485],
						[16.281831755027746, 49.18402112012943],
						[16.280609145841094, 49.1882783339194],
						[16.277481080355837, 49.19597245398409],
						[16.276086815471636, 49.1984596996812],
						[16.270334234131653, 49.20367422907772],
						[16.25864790374121, 49.21599183836631],
						[16.25478554486635, 49.21924597538691],
						[16.25316237423704, 49.22153464025768],
						[16.250093462499933, 49.22808458610203],
						[16.247909535776525, 49.23129644761653],
						[16.25292395278753, 49.23274600956875],
						[16.2631912357185, 49.234569663339244],
						[16.26668357426818, 49.23564144128859],
						[16.271095290104984, 49.238330969711555],
						[16.275728236566675, 49.24075327198599],
						[16.279598223109048, 49.2436751146885],
						[16.2842883970353, 49.24610892445078],
						[16.28854753258215, 49.248932035674486],
						[16.295677187099393, 49.25201036387472],
						[16.29857445147106, 49.253967319793546],
						[16.299753185309903, 49.25512310435631],
						[16.30066107236564, 49.25641237377599],
						[16.301343901367545, 49.258876651917035],
						[16.30089759509026, 49.26134869572161],
						[16.30018234605933, 49.262657197361236],
						[16.293426527346675, 49.27012646610459],
						[16.288328171449816, 49.27394867550757],
						[16.28744887205746, 49.2750128707545],
						[16.28631210631367, 49.27745440366138],
						[16.285802841414256, 49.28014373984686],
						[16.28594970358985, 49.284366576631484],
						[16.28671073505275, 49.287166558645936],
						[16.28825759394768, 49.28987117138557],
						[16.295181270316444, 49.29767604951598],
						[16.301521292499764, 49.302406232086064],
						[16.31324005613322, 49.3149223764931],
						[16.3176918159917, 49.31769573463389],
						[16.32148931972409, 49.32071291399309],
						[16.325990688437184, 49.323215588416204],
						[16.329788200171848, 49.326171804648745],
						[16.334405901303526, 49.328681966043796],
						[16.33881187495587, 49.3316345265638],
						[16.341815941432966, 49.33290093771614],
						[16.35234832482333, 49.33637616497316],
						[16.356611264807608, 49.33730709257576],
						[16.367862710456933, 49.33851250159174],
						[16.372007376389995, 49.33920675279041],
						[16.375595080088768, 49.340515023221464],
						[16.376918804229675, 49.341419322899995],
						[16.3788108831151, 49.34346771729272],
						[16.381814955705536, 49.34758376217251],
						[16.38627815302296, 49.35167694589685],
						[16.39010430649137, 49.358013266241564],
						[16.39171790428605, 49.36293786937232],
						[16.395004258040952, 49.37705599315116],
						[16.39224051085643, 49.381118654524045],
						[16.38869667481282, 49.388179817246915],
						[16.387762063526274, 49.39134592268108],
						[16.38728333383878, 49.39461525044828],
						[16.386831291830525, 49.4232102176556],
						[16.38626862557185, 49.42812737656456],
						[16.38403510796445, 49.43623731285405],
						[16.383718505537765, 49.43918241452911],
						[16.384052285878212, 49.443607412838524],
						[16.38603210026895, 49.45015331323855],
						[16.38685228149436, 49.45510879465707],
						[16.387239461861927, 49.46361165335392],
						[16.386621465784213, 49.470352088940125],
						[16.385641091890708, 49.473590796302865],
						[16.383947356052406, 49.47646317217821],
						[16.377042773492278, 49.48410036942331],
						[16.37237359043374, 49.48784264432008],
						[16.371637327813808, 49.48892197196999],
						[16.37096787274, 49.49129111506693],
						[16.371391288818202, 49.493724755693194],
						[16.372087478300955, 49.49488067327519],
						[16.373176567285455, 49.49592965203364],
						[16.374599455570642, 49.496749867115554],
						[16.37780952205838, 49.49777219477556],
						[16.38430215502502, 49.4993363825268],
						[16.38922309993874, 49.501461039565875],
						[16.397666944839752, 49.503639342661735],
						[16.40078161733906, 49.50495898107088],
						[16.402988447365566, 49.5069085367464],
						[16.406738277180278, 49.51223369804666],
						[16.410274512546618, 49.51545340005865],
						[16.41176032674275, 49.51780697619706],
						[16.412681563599552, 49.52041230339048],
						[16.41377831922903, 49.52544415632334],
						[16.413896544877765, 49.52759538015821],
						[16.412399284906336, 49.531738218495576],
						[16.41020775692449, 49.534652785339446],
						[16.40202140691478, 49.54037474552748],
						[16.39263533699457, 49.545234605165646],
						[16.389345157998555, 49.54621495926774],
						[16.382322324292957, 49.547763938764525],
						[16.379457474372195, 49.54896164487721],
						[16.37313841939518, 49.55289833301894],
						[16.371353142875233, 49.554859103379236],
						[16.37082670610803, 49.55605684253554],
						[16.37053678861209, 49.55854783539512],
						[16.371164327618313, 49.56098180120035],
						[16.372627268552584, 49.562969298655226],
						[16.376001368111552, 49.56614312521951],
						[16.379892346150847, 49.57165524604364],
						[16.381059651407558, 49.5726738401341],
						[16.38363456366194, 49.574127165395545],
						[16.393678663097088, 49.57847974858101],
						[16.399066940637113, 49.58298124748264],
						[16.40442466831957, 49.58850861445285],
						[16.406536098726438, 49.59014126485022],
						[16.414472583963544, 49.59476855956042],
						[16.416334148207735, 49.595378840288404],
						[16.420576106792936, 49.5961075818825],
						[16.43017769837732, 49.59650048299747],
						[16.45322226141919, 49.5963820234029],
						[16.46286009799931, 49.59691230107152],
						[16.46705627352526, 49.5976562421766],
						[16.46884726707344, 49.59822838676332],
						[16.473573678777658, 49.600570626676266],
						[16.476400370405457, 49.60148234772401],
						[16.48095129836069, 49.60240926744887],
						[16.484056459292958, 49.60267627305043],
						[16.48717879164278, 49.60240926744887],
						[16.490219132377515, 49.60182967088138],
						[16.4945487899279, 49.60040657925395],
						[16.498643888719442, 49.59762585187657],
						[16.503082263718724, 49.59515370607022],
						[16.506071099300225, 49.59314735338268],
						[16.508974065003052, 49.59200277807266],
						[16.51078987322034, 49.59164430471052],
						[16.514623647358732, 49.59141545260133],
						[16.518396373958744, 49.59178539926991],
						[16.520130140453855, 49.59222015705975],
						[16.52629470010319, 49.594886708307435],
						[16.531272898011785, 49.59622201000614],
						[16.534603107191234, 49.59738148918683],
						[16.53730392277411, 49.59923933370879],
						[16.53892708615895, 49.60160453099533],
						[16.541292185918078, 49.606830556336924],
						[16.545381547759607, 49.613437667811816],
						[16.54637147324178, 49.616455194370054],
						[16.547626482666303, 49.623935588389365],
						[16.548658355329103, 49.62663255359068],
						[16.550497049189577, 49.6287154638485],
						[16.556596768334213, 49.63285838434592],
						[16.559774387290783, 49.63402547311592],
						[16.56173706814435, 49.63434988938383],
						[16.563791258415584, 49.634498451081875],
						[16.568042755527717, 49.63432693831499],
						[16.5722694368181, 49.6335258232451],
						[16.57607079885019, 49.632106897374285],
						[16.58619691245125, 49.626953238787806],
						[16.58982087759729, 49.62582029762313],
						[16.593189230281222, 49.62551108898485],
						[16.59630967412803, 49.62588511673312],
						[16.60247228804987, 49.62829956275223],
						[16.61100579872911, 49.63045133874282],
						[16.617170329798327, 49.63322063721244],
						[16.61883163930071, 49.63366321910847],
						[16.62250327646207, 49.6340865725154],
						[16.62804793015574, 49.63368213818346],
						[16.62969018065023, 49.633266539153404],
						[16.634485248215604, 49.63120654259575],
						[16.63623428194079, 49.63069914460709],
						[16.642549518374448, 49.62988284384428],
						[16.651964176938552, 49.62987509024012],
						[16.66197205931315, 49.630935785475245],
						[16.66777801478464, 49.63111877135576],
						[16.69135095312748, 49.629089496284784],
						[16.69731329787786, 49.62786474368681],
						[16.702405934670228, 49.62570957793736],
						[16.704179779482587, 49.62520994432142],
						[16.708190933635912, 49.624523298598426],
						[16.71680450247317, 49.62358854536986],
						[16.720832826867667, 49.62287523233133],
						[16.72262384207858, 49.62234893263885],
						[16.727602004123927, 49.62010573578198],
						[16.738050477706622, 49.61750808071585],
						[16.74601745123876, 49.61403651840266],
						[16.75479127714492, 49.611896665146574],
						[16.76125718946529, 49.609054719578964],
						[16.764827731510426, 49.60810854849882],
						[16.77090837214053, 49.60733046418331],
						[16.780109404936567, 49.606765742053604],
						[16.791303644615997, 49.60816964170781],
						[16.796361927495788, 49.60454563016782],
						[16.79927253126074, 49.601913400641564],
						[16.805143343761756, 49.59363545072079],
						[16.80909919362307, 49.58562847704214],
						[16.80960653558089, 49.58242402107902],
						[16.8089008420267, 49.57933433581075],
						[16.807931906615092, 49.57789617504693],
						[16.806396500467194, 49.57661833348839],
						[16.804389936377188, 49.57568344494374],
						[16.802198394715422, 49.575115071582346],
						[16.795167925505623, 49.57464220326905],
						[16.782545075112136, 49.57540499455271],
						[16.779397955755094, 49.57530204860489],
						[16.77434541159661, 49.574310420775795],
						[16.770593638159433, 49.57263942182034],
						[16.769205085790002, 49.57139199361617],
						[16.767593371967145, 49.56851948996665],
						[16.763347639395036, 49.549949764369465],
						[16.76105116975505, 49.547042775412656],
						[16.75979043672422, 49.543167254615156],
						[16.760221493204714, 49.540596111301895],
						[16.760988233238177, 49.539371471098896],
						[16.762273779195013, 49.538257518627226],
						[16.763992300476097, 49.53742973073875],
						[16.7658844098499, 49.53693398937864],
						[16.76984977333147, 49.53666302170905],
						[16.775821681451042, 49.537490807132485],
						[16.780296313226533, 49.53898609818444],
						[16.79502867277826, 49.54137027293718],
						[16.801242811463766, 49.54135880156234],
						[16.805139550133465, 49.54049689972678],
						[16.8068866558563, 49.53966507418116],
						[16.80835531636387, 49.5384977946363],
						[16.809980386186403, 49.53582376781863],
						[16.810649875884142, 49.53138354949132],
						[16.810354236719835, 49.526649509100366],
						[16.809406297910797, 49.52183929230655],
						[16.806671147487137, 49.51340488867842],
						[16.80585861833292, 49.5065117425389],
						[16.805585866523, 49.48715977507613],
						[16.806264870361645, 49.476745545154984],
						[16.807083120157337, 49.473430549229874],
						[16.81113813970292, 49.46338260498583],
						[16.813793171740674, 49.460357573823345],
						[16.824371338170124, 49.452255251445244],
						[16.8253383760692, 49.45103846827091],
						[16.826589573302577, 49.44823827703115],
						[16.827371604609976, 49.44354635862932],
						[16.82727811978173, 49.43700775293484],
						[16.82591055356707, 49.430824152516806],
						[16.824415201831386, 49.42821879749254],
						[16.82030679035193, 49.423603165484565],
						[16.818847658011624, 49.419357315099994],
						[16.818445207357893, 49.414741530611565],
						[16.818685533567944, 49.41167833116161],
						[16.819459906836332, 49.408767627879755],
						[16.82104682515901, 49.40618511483859],
						[16.828599939143636, 49.39999016285396],
						[16.832941066472966, 49.39717874694524],
						[16.83682061038153, 49.39375693561219],
						[16.839643468834435, 49.391788399670425],
						[16.845046995873627, 49.38941954527627],
						[16.84955025982336, 49.3885079526346],
						[16.85651206701625, 49.38814542347666],
						[16.86317442863188, 49.38868704842186],
						[16.86707688827591, 49.38961041619928],
						[16.87226486440316, 49.39184572342504],
						[16.87556266806793, 49.39286422921171],
						[16.893581377601272, 49.39678181080654],
						[16.89768790316884, 49.398326797497745],
						[16.90058899083803, 49.40045930321632],
						[16.9014720748842, 49.40160736823795],
						[16.902614594528988, 49.404094704890035],
						[16.904239645008555, 49.41052619325144],
						[16.90532302286846, 49.41284937704954],
						[16.90707586858828, 49.414672736054776],
						[16.910139072702297, 49.41675176518066],
						[16.91378592231764, 49.41978062646169],
						[16.916917805220898, 49.42179492862576],
						[16.91878701925469, 49.42367568115833],
						[16.920177454523593, 49.42736811925375],
						[16.92022324146453, 49.43133549563437],
						[16.919525132794192, 49.43388354889741],
						[16.918888109722456, 49.435070190362495],
						[16.916999807850615, 49.436992567247444],
						[16.913822177410534, 49.43902590770629],
						[16.909919738955143, 49.44196701209954],
						[16.90523720879888, 49.4443856228251],
						[16.901227966598743, 49.447227612224665],
						[16.896615975111146, 49.449684083120054],
						[16.88973045309037, 49.45478057515191],
						[16.887916565980223, 49.45664978924173],
						[16.88678360001802, 49.45900344990615],
						[16.885065062949195, 49.4653547831608],
						[16.884019835843326, 49.46767411862816],
						[16.883281710428072, 49.468685173145786],
						[16.87978553839141, 49.47186279876767],
						[16.87900543133543, 49.472930901353166],
						[16.877981190614527, 49.475338022762806],
						[16.87753297017976, 49.477932072952804],
						[16.87761688952872, 49.48056799430752],
						[16.87836074846548, 49.48313141019691],
						[16.8790893719457, 49.4843446245934],
						[16.880138385628392, 49.485473532831776],
						[16.88274763242122, 49.48706802337692],
						[16.891145694094533, 49.49031437949067],
						[16.895236957397188, 49.491496939854834],
						[16.901706712039648, 49.49240889442658],
						[16.915000916688776, 49.49314881370634],
						[16.92465209263106, 49.494197785432746],
						[16.928552628473494, 49.49436951466127],
						[16.932453162506796, 49.494205534944214],
						[16.93990515643407, 49.493339450981814],
						[16.95266532111212, 49.492454461241806],
						[16.9584102683218, 49.49151615844278],
						[16.961364739788685, 49.49033731770052],
						[16.96921540843961, 49.485962045997375],
						[16.97682570874623, 49.479988052109036],
						[16.977655417425666, 49.478927669442136],
						[16.978717812286707, 49.476516795123736],
						[16.980388623910375, 49.46835693643634],
						[16.981401458356064, 49.46562970530934],
						[16.985727324108648, 49.45906078849569],
						[16.989368438994635, 49.45124054190234],
						[16.991212845841286, 49.44931031125554],
						[16.9951305296011, 49.44614783853779],
						[17.00587654634914, 49.43454365434457],
						[17.012142199427384, 49.42975250457107],
						[17.020336139616283, 49.42102422378431],
						[17.022819503254816, 49.41803346439826],
						[17.027574521303876, 49.41399749675418],
						[17.029037474077278, 49.41182707445912],
						[17.031343444180123, 49.40718446439629],
						[17.033224098822522, 49.40533822719518],
						[17.038116459084517, 49.402153049501614],
						[17.04054069744545, 49.40102388408667],
						[17.04210283071483, 49.40069976121993],
						[17.045412078140938, 49.40068829607814],
						[17.048776633496843, 49.401550352203735],
						[17.05167769179187, 49.4031409183229],
						[17.05645369878421, 49.40756220403511],
						[17.057573329882302, 49.40830621948086],
						[17.06097031452091, 49.40945060057841],
						[17.064870820261945, 49.409789918443515],
						[17.068838131286448, 49.409301858640085],
						[17.070703511719334, 49.408664748300176],
						[17.072084409550836, 49.407897800909396],
						[17.074129119283146, 49.4061051670398],
						[17.07706452258938, 49.402900767935044],
						[17.07903482202015, 49.40041747098322],
						[17.08033371014438, 49.39763641723342],
						[17.08067321332092, 49.394779167213436],
						[17.080194460371626, 49.392059215789665],
						[17.078828802141768, 49.389667429619],
						[17.074304570630513, 49.38562384573444],
						[17.070821780002568, 49.38004318332119],
						[17.066312786587105, 49.37604901320142],
						[17.065507896907924, 49.3749199609217],
						[17.064643864016908, 49.37234119162208],
						[17.064685828495307, 49.36954122791872],
						[17.06574441545969, 49.36669172173378],
						[17.06671904357235, 49.36534490170594],
						[17.069309232377126, 49.362899761045604],
						[17.074155813539814, 49.35969930109775],
						[17.079769129312606, 49.35711665456448],
						[17.08390807886062, 49.35595701244416],
						[17.093875870607764, 49.35415637076334],
						[17.10211182091724, 49.35088352251649],
						[17.10929681156899, 49.349357715094555],
						[17.11262894418884, 49.34838492069835],
						[17.11742974505731, 49.34606943675541],
						[17.119016642682126, 49.34553905316816],
						[17.127920135128335, 49.3435095403944],
						[17.130823136859043, 49.34232331590636],
						[17.134300231817374, 49.34032821555835],
						[17.14161110567122, 49.33713918459025],
						[17.146047603704723, 49.334243873067585],
						[17.151046737492496, 49.32957445302134],
						[17.155511869157223, 49.32682048529471],
						[17.159360898553825, 49.32382213199936],
						[17.163885122305985, 49.32130055553587],
						[17.16772271500782, 49.31830226543519],
						[17.172157302669266, 49.31552518366266],
						[17.184040084244927, 49.303039676015075],
						[17.186235433290282, 49.30136113038503],
						[17.19190023998298, 49.29790866929624],
						[17.19653320282868, 49.29410934195174],
						[17.189058297551487, 49.28575510380467],
						[17.175430281212165, 49.27619538379712],
						[17.164482126242284, 49.264736257253674],
						[17.159955990093906, 49.26081476698068],
						[17.158788693784803, 49.258518328275784],
						[17.158788681872373, 49.25483322865175],
						[17.15986444214345, 49.252594135403456],
						[17.16307068183846, 49.249488857366046],
						[17.164508813766506, 49.24712748314074],
						[17.167144773308735, 49.236766797339484],
						[17.172901157724283, 49.22333530177664],
						[17.173969266737107, 49.21872327944094],
						[17.174709332840848, 49.20612346162053],
						[17.175361637277494, 49.201690707946334],
						[17.176328643714704, 49.19903932758307],
						[17.18018915005338, 49.19453826542616],
						[17.181354533368975, 49.192218872013626],
						[17.18195151504451, 49.18958275792538],
						[17.18281364813815, 49.18126681667439],
						[17.183788289939738, 49.17866889324829],
						[17.18470191425136, 49.177455856569146],
						[17.186052335162554, 49.17635737893654],
						[17.189271936066664, 49.1750641657558],
						[17.19140626119599, 49.17465982507956],
						[17.195947638610754, 49.17438118331863],
						[17.20066642069549, 49.174606263918314],
						[17.20533943867244, 49.17525488102088],
						[17.214851371837554, 49.178062374214505],
						[17.218784315341907, 49.17881378927195],
						[17.222969061454773, 49.17880635870468],
						[17.225013744511504, 49.1784363786409],
						[17.22693254173811, 49.17774595697463],
						[17.22850226142703, 49.17676915271282],
						[17.230556486062667, 49.174438459656685],
						[17.23352050880792, 49.16858673947916],
						[17.234365446331942, 49.16537842562723],
						[17.234720236391805, 49.162063652493345],
						[17.234348304895487, 49.155441350795435],
						[17.232837661271393, 49.15130601755187],
						[17.23064611547307, 49.14895233028937],
						[17.228927601817603, 49.14796820234172],
						[17.219562540239338, 49.145088279189075],
						[17.214548105755217, 49.14302439990284],
						[17.202621451477945, 49.13996498452231],
						[17.194623957688396, 49.13573083402211],
						[17.191886906792956, 49.133926434039765],
						[17.190067308771592, 49.13204589639398],
						[17.18854333483994, 49.128967415319934],
						[17.1878776518808, 49.125671359641935],
						[17.187068923814582, 49.11716829406786],
						[17.18606565614739, 49.11386093184048],
						[17.184062942857047, 49.1109770445493],
						[17.18122864548869, 49.10871130977076],
						[17.177705755173697, 49.10694114050025],
						[17.17540169737254, 49.10617073827764],
						[17.16722870187481, 49.104362514890376],
						[17.16295814860293, 49.10378649834254],
						[17.153064713477548, 49.10313403188111],
						[17.148456566774403, 49.10249704292005],
						[17.146305075503015, 49.101886673973326],
						[17.144340501838325, 49.1009482189679],
						[17.14289475827746, 49.099800225565716],
						[17.14118004018078, 49.09711457791293],
						[17.140525813784418, 49.094158137319766],
						[17.140554410570438, 49.09105285764424],
						[17.141141895351918, 49.08787921435222],
						[17.142332085883524, 49.08474739095442],
						[17.144037261449512, 49.081733830974436],
						[17.149261482660044, 49.074417183793855],
						[17.159519195458127, 49.075157164677016],
						[17.166425715442017, 49.0749665211418],
						[17.170555119620833, 49.07437137994204],
						[17.172359461416388, 49.073883012334626],
						[17.177410117401408, 49.07175438371917],
						[17.181194294648325, 49.070842650042415],
						[17.190204615258896, 49.070045427217416],
						[17.19975088973205, 49.069965271793215],
						[17.20670509287115, 49.07028960740304],
						[17.210992823428125, 49.07080087006048],
						[17.214712143965787, 49.07171631738329],
						[17.219747540573422, 49.07391736515995],
						[17.223230372166782, 49.07479104255354],
						[17.227239608986125, 49.07533264350579],
						[17.23772430622508, 49.076210039378516],
						[17.240520470160526, 49.07264321872963],
						[17.244070050927427, 49.06723783533094],
						[17.247575768658738, 49.06394966031878],
						[17.249160765224904, 49.06194304237056],
						[17.250341403297377, 49.057998553191226],
						[17.250955575211073, 49.0492095392547],
						[17.25209807706447, 49.04486078455748],
						[17.254045497791367, 49.042198278640726],
						[17.255416864992828, 49.04103846913573],
						[17.2587718818533, 49.03911959575827],
						[17.260723119909986, 49.03839116395429],
						[17.26477050212331, 49.03750986932951],
						[17.277032849666856, 49.03644941085424],
						[17.2806968725517, 49.03588870325415],
						[17.282316225112954, 49.0354653883596],
						[17.287450772685595, 49.033428040060784],
						[17.291095735196425, 49.03264237783513],
						[17.295234695907595, 49.032219068067],
						[17.30626488725196, 49.03163918427944],
						[17.31252669545577, 49.03083031966099],
						[17.31438829059604, 49.03033460506019],
						[17.317277902314196, 49.02895731543321],
						[17.321582797665815, 49.02550128100732],
						[17.32455445588828, 49.023697006753345],
						[17.328138356713573, 49.02228169189834],
						[17.33224867030449, 49.021545260798945],
						[17.336391439629153, 49.021461406797755],
						[17.340238560739387, 49.02194967880374],
						[17.341924654867107, 49.02241505421694],
						[17.346670149217204, 49.02465437525452],
						[17.348325717786604, 49.02519216164484],
						[17.354345323158032, 49.02619935367097],
						[17.358829515569163, 49.02651992310923],
						[17.365806565749477, 49.026622653936904],
						[17.37046049700418, 49.02638996247996],
						[17.374986641156603, 49.02577203149233],
						[17.379144672822143, 49.0245247249569],
						[17.382602706837066, 49.02274335477785],
						[17.38536263815698, 49.02065288229277],
						[17.38892555431718, 49.016998307656145],
						[17.392801281175895, 49.01388928188937],
						[17.394310006382792, 49.0116692342674],
						[17.395921699148687, 49.0081137927449],
						[17.39732931754049, 49.005924114685115],
						[17.400743467325533, 49.00277313831951],
						[17.404769899920726, 48.99622347070632],
						[17.40723611236293, 48.994495503843694],
						[17.411771763100123, 48.99311437591418],
						[17.416511526136443, 48.99246589177043],
						[17.44407463415726, 48.99422076277647],
						[17.447086323652584, 48.994167237803936],
						[17.450069415096664, 48.99342717106729],
						[17.452407845564096, 48.991939618335465],
						[17.453939442415106, 48.98967365323653],
						[17.456018460166987, 48.97900401094464],
						[17.457284924009073, 48.97629544257669],
						[17.460742941999786, 48.97105781995291],
						[17.46435929630381, 48.96322261318997],
						[17.46620749999552, 48.96129223041073],
						[17.47014426379241, 48.958125999473786],
						[17.481599804396577, 48.945491762302275],
						[17.485418334636293, 48.94234860740376],
						[17.48926352330895, 48.93576421704464],
						[17.491664870955837, 48.9340437521213],
						[17.49451637271333, 48.93307495145057],
						[17.497377379143998, 48.93256364138543],
						[17.500453944664073, 48.93257137444031],
						[17.501968370247265, 48.93290698923537],
						[17.50440979888197, 48.934059218315966],
						[17.511404049019852, 48.940097907012806],
						[17.512851705158504, 48.94229880473207],
						[17.514381422302662, 48.9458314145348],
						[17.515880594243193, 48.948017201328426],
						[17.524045954728464, 48.9539414345193],
						[17.52854919886794, 48.95561222109616],
						[17.533433918538854, 48.95689014316004],
						[17.53738022381815, 48.95756916739252],
						[17.541931163466852, 48.95786676306185],
						[17.546546933285192, 48.957778907341535],
						[17.551101696643418, 48.95729075178295],
						[17.554670332100056, 48.956569656690064],
						[17.561922063335825, 48.954822455294476],
						[17.56581117151961, 48.95346844386434],
						[17.56968496435657, 48.95160278377349],
						[17.573343273276627, 48.94950482094429],
						[17.599830623008295, 48.93255992951916],
						[17.60520362537987, 48.92964551158739],
						[17.61266326730152, 48.92612455802074],
						[17.618080139301345, 48.92134475827492],
						[17.622404101035695, 48.91799928893473],
						[17.64354515513049, 48.903492010845156],
						[17.64631842616172, 48.901222148646454],
						[17.651298519177303, 48.89635464341498],
						[17.65575982939236, 48.893585357104136],
						[17.659593578642, 48.890590638055784],
						[17.664112088924714, 48.888092022937975],
						[17.667982096247023, 48.88517375373699],
						[17.672527315316714, 48.8826751885024],
						[17.676424008722687, 48.879707186388124],
						[17.681020734492833, 48.87705991793479],
						[17.685091022606954, 48.87371066550589],
						[17.691232694233925, 48.869815935808724],
						[17.690691002147638, 48.866336889078134],
						[17.689863190502567, 48.86389910891502],
						[17.68820190697566, 48.861450217935186],
						[17.68699456979542, 48.86027541368797],
						[17.686552047187224, 48.85998534698213],
						[17.681709280693013, 48.8598174300433],
						[17.67076875000179, 48.85943613837384],
						[17.66772650731121, 48.85931769995111],
						[17.64673043268857, 48.85850533127225],
						[17.62582777696685, 48.85789860756102],
						[17.611734396716052, 48.8546677183589],
						[17.609579068825493, 48.85417541931512],
						[17.593784333364937, 48.84148789377965],
						[17.581155767984566, 48.83257667521127],
						[17.565305699726846, 48.82754126520643],
						[17.559679015236405, 48.82575593553687],
						[17.542396549093855, 48.81996157927125],
						[17.533929834237934, 48.81627663059426],
						[17.52804821041057, 48.81371624203729],
						[17.526674268887916, 48.81311796608134],
						[17.515165331551046, 48.809707663577086],
						[17.501089108730604, 48.812503922975374],
						[17.49520450819266, 48.81906028037997],
						[17.49178312754945, 48.82287203749896],
						[17.482450501159867, 48.83151640214973],
						[17.479658121769525, 48.83457942447101],
						[17.475208298434666, 48.83946623155217],
						[17.465318667940473, 48.844314473608314],
						[17.446525590421025, 48.84539427752099],
						[17.432897570352328, 48.839889548693264],
						[17.428718575049267, 48.83819968543711],
						[17.41709326839724, 48.83291618609234],
						[17.410539614461776, 48.829940687540635],
						[17.409854899446774, 48.829628081192105],
						[17.39948463326743, 48.82828520755287],
						[17.38895224408064, 48.82691945959063],
						[17.362857803018688, 48.82868562623969],
						[17.340446471381078, 48.83699034965938],
						[17.319768921721636, 48.84624495080149],
						[17.318033224487944, 48.84701924823943],
						[17.312145241411496, 48.84953696703432],
						[17.294572814362848, 48.85704789784777],
						[17.2786026051916, 48.86355213754218],
						[17.27421951687392, 48.86533740584414],
						[17.26707839710633, 48.86746595082848],
						[17.25333976054382, 48.87156289794043],
						[17.248891821914874, 48.87233726747082],
						[17.228130355653434, 48.87594999027766],
						[17.223560324072363, 48.87674323708189],
						[17.199533459851537, 48.88122937743758],
						[17.184957493214505, 48.87248601842009],
						[17.181741725496106, 48.87055597344976],
						[17.17109488443212, 48.86370459460599],
						[17.160352721025312, 48.856788758158494],
						[17.159780501582986, 48.85641860320714],
						[17.15223139358875, 48.85243722736689],
						[17.14676093649524, 48.84955211918306],
						[17.14616775475446, 48.849414822192706],
						[17.1457833668868, 48.849337206131935],
						[17.1137146403127, 48.833919569993505],
						[17.105741533123194, 48.82576521155275],
						[17.1040039173726, 48.81768808558941],
						[17.103879939294583, 48.81711206265819],
						[17.101484525096627, 48.81458011154521],
						[17.096044534041166, 48.80883020550711],
						[17.095506661767693, 48.80669779008861],
						[17.094342823095882, 48.802080241768905],
						[17.09291838737332, 48.79642860486922],
						[17.08813095112979, 48.79410553155606],
						[17.088045110775262, 48.794063485162106],
						[17.07726479579831, 48.78883370616548],
						[17.07275966519146, 48.7870776902435],
						[17.049945928516117, 48.7740266404942],
						[17.04412652516357, 48.76747352677077],
						[17.041303629169168, 48.76122660587656],
						[17.036507501312965, 48.75889424836505],
						[17.03085518405295, 48.75614552326961],
						[17.025667198006502, 48.75362402808457],
						[17.016834263251486, 48.74292377377404],
						[17.016126619635767, 48.740703467617585],
						[17.01475524613415, 48.73637387587545],
						[17.015296938112296, 48.72776033327146],
						[17.006448751840843, 48.72085195218659],
						[17.001234063133015, 48.71633537233678],
						[16.999683370246796, 48.714992435876454],
						[16.999408733173613, 48.71177683283251],
						[16.99918174766223, 48.70912933549083],
						[17.001279827712068, 48.700515718594595],
						[16.987390505591925, 48.69512546834482],
						[16.985704410383114, 48.69446934909896],
						[16.982557302242114, 48.693252612077394],
						[16.977739323898312, 48.6903685619254],
						[16.976047517747737, 48.68935395951228],
						[16.972158417292697, 48.6870268471491],
						[16.97149086926033, 48.68490990275542],
						[16.96803283472826, 48.6739311024412],
						[16.967601776267855, 48.67214584479008],
						[16.9663848821556, 48.66710657927368],
						[16.964948653222933, 48.661170951026094],
						[16.9628791830782, 48.652553577614384],
						[16.960313803474907, 48.64461904557363],
						[16.96019361896298, 48.64439378704127],
						[16.957035081138905, 48.638500359720425],
						[16.955139160547883, 48.634963992738726],
						[16.949657432822075, 48.63069909223599],
						[16.94580652028351, 48.62770477147277],
						[16.9270363026165, 48.6214372261045],
						[16.926317226194985, 48.621196846854616],
						[16.925895677546645, 48.62140262136674],
						[16.922806546321745, 48.62130931218468],
						[16.92260465604176, 48.621465033486196],
						[16.92250251625204, 48.62305067679577],
						[16.92232702646217, 48.6258085807354],
						[16.922037138296417, 48.630317809681216],
						[16.921916949600103, 48.63224400260762],
						[16.92260933954171, 48.63285455356086],
						[16.923124317871004, 48.633308450864995],
						[16.92459487134086, 48.636665274705436],
						[16.9238414926303, 48.63665785899674],
						[16.922643666046763, 48.63594440695181],
						[16.921716699643245, 48.635391320662855],
						[16.92146681935042, 48.63933556071473],
						[16.921176921220834, 48.64384470082427],
						[16.92252920363115, 48.64388641527076],
						[16.92565917535456, 48.64398189502741],
						[16.924669270504193, 48.64516071739011],
						[16.922090539145124, 48.64787681738153],
						[16.92135620683002, 48.64865117341087],
						[16.920839302545616, 48.64919656114058],
						[16.92020987530028, 48.65418235092746],
						[16.92142105539417, 48.65756229473357],
						[16.922195421458248, 48.65972507255105],
						[16.922386160324873, 48.6628226423588],
						[16.922628395990372, 48.6667746899896],
						[16.92303657524162, 48.669818877498976],
						[16.923196778121763, 48.67100893494872],
						[16.923494322915218, 48.673248148090735],
						[16.92152213761251, 48.67382046990237],
						[16.919221890333812, 48.67449199155325],
						[16.919162742444968, 48.67540734030844],
						[16.918918624604764, 48.67923749897395],
						[16.918874725537364, 48.67991243319871],
						[16.91872406347235, 48.68227008040029],
						[16.91858673971374, 48.68442161715691],
						[16.918455123465513, 48.68650054544168],
						[16.918367374083783, 48.6878699209139],
						[16.918298727420833, 48.68893056576198],
						[16.918010723420803, 48.69343958808029],
						[16.917812359035626, 48.6965409358141],
						[16.917724600290754, 48.69794837508557],
						[16.91743470554429, 48.70245754491587],
						[16.91530991319594, 48.70239264201655],
						[16.91482354086449, 48.70384987031952],
						[16.910406095568636, 48.70631774961998],
						[16.910087599460308, 48.706497316904255],
						[16.909851088470372, 48.70663083344618],
						[16.906511306650458, 48.709686278299266],
						[16.905216224743082, 48.71112067392711],
						[16.903173452760733, 48.713382775216346],
						[16.903121935284688, 48.71417987750407],
						[16.90311050094584, 48.71434399617562],
						[16.904788958017065, 48.71674335433149],
						[16.900148381490922, 48.71872702086304],
						[16.89493749968193, 48.71807084538696],
						[16.894796380588875, 48.71805199156927],
						[16.893457425582216, 48.71786128991222],
						[16.890260699450966, 48.717407253597784],
						[16.885265347424255, 48.71892545011879],
						[16.883977900236637, 48.72021493468821],
						[16.883821496821803, 48.72037132991995],
						[16.88278389816989, 48.721408918719035],
						[16.88163947949486, 48.723152150893135],
						[16.880062101096414, 48.72555158587375],
						[16.87629508325291, 48.721157016401804],
						[16.873306605052196, 48.71871156687717],
						[16.873005829463974, 48.71899128415581],
						[16.856572719784953, 48.719818074459724],
						[16.818125433168085, 48.710774514418766],
						[16.81450265920062, 48.71048244267213],
						[16.79890179998977, 48.70922421967435],
						[16.780505008161974, 48.71377189930961],
						[16.780362480172307, 48.71383433229713],
						[16.752547797998762, 48.72603314445717],
						[16.744331499684435, 48.72963651523467],
						[16.729035293317718, 48.73309898549135],
						[16.691001428758955, 48.73206537080633],
						[16.689616888485034, 48.73222702739204],
						[16.682520300001272, 48.73305663935881],
						[16.680414190821654, 48.738220133787436],
						[16.677408210739234, 48.741775443901915],
						[16.677213659238117, 48.74461737590881],
						[16.67695807586927, 48.74831001500056],
						[16.677864077364394, 48.75387194162603],
						[16.676816952978683, 48.762420768237554],
						[16.67567634699188, 48.767158518789685],
						[16.66888237310662, 48.76693346914863],
						[16.668571485664284, 48.77144253470815],
						[16.661794665846163, 48.77122119121401],
						[16.661483763550763, 48.77572630848386],
						[16.654703128659413, 48.77550496152761],
						[16.65439225689288, 48.780014168210876],
						[16.647615436310122, 48.77979281778788],
						[16.640838627406307, 48.77956775776481],
						[16.63855539283858, 48.7794932530452],
						[16.624028752073464, 48.78337989145993],
						[16.605528613138297, 48.784827038430514],
						[16.565195086152645, 48.79257269734437],
						[16.565013882476162, 48.79512021193521],
						[16.56431770132155, 48.79509733366458],
						[16.564573271648182, 48.796115727728356],
						[16.56650161793837, 48.802410130312154],
						[16.56747244234997, 48.806125500485194],
						[16.562311187025486, 48.808879983708366],
						[16.54990007189689, 48.81549469076121],
						[16.54048729656877, 48.81431204580404],
						[16.528490066917705, 48.81084823961012],
						[16.526140204284488, 48.80808631620163],
						[16.523304560207578, 48.80475460741368],
						[16.51953901476609, 48.80560082544101],
						[16.51034061882497, 48.80477408554853],
						[16.50887974471687, 48.80436504500864],
						[16.506099711748515, 48.80448160449539],
						[16.49102021197274, 48.80846413503871],
						[16.479618080996154, 48.81147773820888],
						[16.464735041199166, 48.80952462769339],
						[16.461328490771137, 48.80534729985268],
						[16.463218695791415, 48.80431372174906],
						[16.46627234954456, 48.80126186019519],
						[16.466610532595727, 48.8008812687683],
						[16.453083136662443, 48.80219030763033],
						[16.435719841134894, 48.7945420724398],
						[16.385670206414794, 48.73786683083615],
						[16.37885095318378, 48.73578658732774],
						[16.36988257849261, 48.74043269226309],
						[16.363506333497337, 48.74373641711567],
						[16.345621099447584, 48.74579230114063],
						[16.34085464589701, 48.742801676560795],
						[16.336946487828232, 48.74035263430419],
						[16.31680299370495, 48.74144377374519],
						[16.30886460880291, 48.74242796669368],
						[16.285646439749875, 48.74529648887992],
						[16.27962112009417, 48.74520870176499],
						[16.2797377917829, 48.736546971686955],
						[16.22307111966746, 48.742096604854815],
						[16.17775110401246, 48.7465347847668],
						[16.16875546046744, 48.74617745267938],
						[16.09329011410405, 48.74318095086658],
						[16.093660338680312, 48.74438461704762],
						[16.094968785426037, 48.748176478215846],
						[16.096986784140014, 48.75352109148042],
						[16.089439380640698, 48.75462712103896],
						[16.087177288950297, 48.75495540680254],
						[16.084629061693924, 48.75582125466066],
						[16.070871347396373, 48.76049799318835],
						[16.06640434468062, 48.750041980620274],
						[16.065801623977404, 48.750019106114664],
						[16.06102802154429, 48.749836110138354],
						[16.05897596556932, 48.7504243560843],
						[16.047136607534092, 48.75381691840174],
						[16.04506505114054, 48.75441042792064],
						[16.044750211523223, 48.758243541160915],
						[16.037979128618517, 48.75798418608333],
						[16.037607201122725, 48.76248939486315],
						[16.0308360959781, 48.76222601709625],
						[16.03046417593245, 48.766731295590205],
						[16.02369307035908, 48.766467913747036],
						[16.01692009050216, 48.76620484129017],
						[16.016548144409747, 48.77070987606083],
						[16.00977517533035, 48.770443089875485],
						[16.00940132933951, 48.77494819434629],
						[16.009241118370937, 48.77687849029261],
						[16.009065629229553, 48.77899552494056],
						[16.009027491264554, 48.77945337293389],
						[16.0079936994954, 48.77941132879182],
						[16.003446567542056, 48.779235732738925],
						[15.999732980015096, 48.78074654260411],
						[15.995303146816372, 48.78105538321639],
						[15.995103828280401, 48.7834281192639],
						[15.991617201958361, 48.78329085553647],
						[15.988330824867344, 48.78316101153339],
						[15.98809433633289, 48.785987914903906],
						[15.987955093865077, 48.78766632531061],
						[15.985999100594315, 48.78758996344206],
						[15.981179250784715, 48.7874032324849],
						[15.980832099534082, 48.79154967905039],
						[15.98080254057784, 48.791908306968025],
						[15.980382935596966, 48.791893158020606],
						[15.974026675258488, 48.79164119095707],
						[15.973666182710529, 48.795955579290855],
						[15.97365093733882, 48.79614262525504],
						[15.973241789772858, 48.796127166906054],
						[15.966875060418912, 48.79587921510755],
						[15.96671676395464, 48.7977561725316],
						[15.969646439998169, 48.79923616765021],
						[15.975013737945144, 48.801799821361605],
						[15.972411142267887, 48.803497188536966],
						[15.971879010755982, 48.80382924302096],
						[15.951878563890036, 48.816364440505865],
						[15.952303877534279, 48.8173216940512],
						[15.953315735842887, 48.81793976748803],
						[15.95650291071942, 48.8180656085244],
						[15.958203309469793, 48.81813424911413],
						[15.957821830122857, 48.82263550170198],
						[15.957270607179838, 48.822612621125984],
						[15.956404678260125, 48.825233387152146],
						[15.95267583392936, 48.825225966353884],
						[15.950834279607676, 48.82485585429724],
						[15.94735239481799, 48.824161393096944],
						[15.946144090381964, 48.826694360741634],
						[15.944304477181738, 48.8266182971616],
						[15.943882931679353, 48.82660283708694],
						[15.939463621830662, 48.82642751990177],
						[15.93945311930208, 48.82613748925031],
						[15.939409261293436, 48.82485585429724],
						[15.93957327397318, 48.822273123074936],
						[15.93973733331886, 48.81968701517701],
						[15.937649722017847, 48.81988520837494],
						[15.937866223877473, 48.81732571353377],
						[15.93343829865373, 48.81715009312017],
						[15.93108844857542, 48.81705857266775],
						[15.930999750880282, 48.818099928817134],
						[15.930764201381894, 48.82087710410937],
						[15.930706989168202, 48.821563827053225],
						[15.930139553768988, 48.821540946567104],
						[15.926682476026881, 48.82521823635592],
						[15.926258082963797, 48.8303908907852],
						[15.926594734437874, 48.83059311144062],
						[15.932016357389683, 48.83385834646319],
						[15.926416384057207, 48.83485400356224],
						[15.917714125783514, 48.83859640811074],
						[15.91171074892846, 48.83811959885679],
						[15.908174508839794, 48.83753580241126],
						[15.903428073060205, 48.8367538016116],
						[15.89603519960581, 48.83605961931066],
						[15.895435331582634, 48.83628843644382],
						[15.895269389619544, 48.83822627789755],
						[15.894871720167096, 48.842800219721994],
						[15.895415312014157, 48.842891748817244],
						[15.898865693320124, 48.84019845621146],
						[15.90034104149462, 48.84009177639832],
						[15.900714860664777, 48.84006487453899],
						[15.902847291758901, 48.839912430719636],
						[15.903828617747655, 48.8432235420454],
						[15.901873582120418, 48.846637665281115],
						[15.901107802981477, 48.84708418542497],
						[15.896010404758819, 48.85004812059924],
						[15.891832349913763, 48.84730528119669],
						[15.89156533658219, 48.84712995068884],
						[15.88653467637464, 48.84445176802624],
						[15.881068214866698, 48.846538404323724],
						[15.880491241415816, 48.85274491219908],
						[15.880339607526166, 48.8541410944778],
						[15.879773141809398, 48.859348314577645],
						[15.877241125091901, 48.861499696509206],
						[15.87572764027277, 48.86278521486687],
						[15.875521645679283, 48.860648975530474],
						[15.875221260284446, 48.857528760335846],
						[15.875187878371719, 48.85717777702118],
						[15.870613090933235, 48.858226708237815],
						[15.865493764281274, 48.8593977927692],
						[15.845403656344264, 48.86400208713496],
						[15.824490224460105, 48.868792936822494],
						[15.824284306018342, 48.869421332357724],
						[15.818496556411512, 48.87231531047687],
						[15.809173907168788, 48.87229953855275],
						[15.787904078927765, 48.87226335590677],
						[15.779222462781151, 48.87086831756386],
						[15.77678222854064, 48.870016948758824],
						[15.77530240437318, 48.86950080965247],
						[15.770532175131653, 48.867836739317774],
						[15.743669052968626, 48.858465748848175],
						[15.740524243264904, 48.8578098565506],
						[15.73192978973536, 48.85892496716917],
						[15.717764856457531, 48.860927601046804],
						[15.710957531583933, 48.861892742251534],
						[15.70942114292261, 48.86177430275873],
						[15.705028525857628, 48.861431044990155],
						[15.702658648844517, 48.86124797435746],
						[15.699914921291244, 48.86103428902822],
						[15.69655324621935, 48.86077514554024],
						[15.695474620603294, 48.86069103219389],
						[15.686876284910554, 48.86002338343019],
						[15.683614730663434, 48.862678526198366],
						[15.671587955704466, 48.87247859633335],
						[15.667922972693063, 48.875465384110925],
						[15.65771675455859, 48.88253787477829],
						[15.642059330220672, 48.889778175830884],
						[15.63814830715042, 48.889106744287034],
						[15.631775844059927, 48.888015632913834],
						[15.624805445914728, 48.89343257398306],
						[15.618960378113057, 48.89797589831618],
						[15.610757835272874, 48.8981209519266],
						[15.61070060053451, 48.89874261113622],
						[15.60616301921476, 48.898548071857164],
						[15.60391329127262, 48.898448791929106],
						[15.600505835324018, 48.89830404742631],
						[15.599188810963048, 48.89832693437247],
						[15.594855300343083, 48.89900581155953],
						[15.590810785788515, 48.89963922561186],
						[15.590553272014445, 48.89966953550108],
						[15.575600636131913, 48.90146648499133],
						[15.575506222323767, 48.901477928597714],
						[15.568366064611782, 48.90369428590304],
						[15.567025173571212, 48.90182865990278],
						[15.56669141111936, 48.90136349255584],
						[15.5627660776278, 48.90119555001968],
						[15.555978768111673, 48.90090172815339],
						[15.555753723141185, 48.90331664405936],
						[15.555559155914144, 48.90540311409326],
						[15.548769938578696, 48.90510928766429],
						[15.548382757601868, 48.90509413241499],
						[15.54198266086784, 48.90481577084446],
						[15.541795724441092, 48.90682214558598],
						[15.54156302320916, 48.90931691252426],
						[15.535946835511997, 48.909076589938266]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ64",
				"name": " Jihomoravský kraj",
				"region": "jihomoravsky"
			},
			"id": 3
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[12.980576514519225, 50.41903685792438],
						[12.983346938092097, 50.41921995998657],
						[12.986342431199153, 50.41941834663847],
						[12.988455773993628, 50.412788408277905],
						[12.988572121309774, 50.41279984213384],
						[12.992954253942486, 50.40298843159789],
						[12.997284890257635, 50.39868928118103],
						[13.001581191109889, 50.392150869142306],
						[13.004055021428615, 50.39038084037118],
						[13.010195732206737, 50.388320923820686],
						[13.01582813228053, 50.387195583404484],
						[13.032702446142917, 50.386142732421824],
						[13.03925323396205, 50.385265340660204],
						[13.048404692500752, 50.38334654577954],
						[13.058271407356045, 50.380451194613684],
						[13.062561989378876, 50.37953186623074],
						[13.069414137658265, 50.378871905550334],
						[13.085189820203588, 50.37806321119327],
						[13.089114188037785, 50.377372729814915],
						[13.090832708506605, 50.376819591763706],
						[13.100210190382404, 50.372032171549925],
						[13.104491234949712, 50.36944199810585],
						[13.112484932437194, 50.366996770389505],
						[13.115429878105132, 50.36553573469682],
						[13.117355348462373, 50.36324312207919],
						[13.119586944986075, 50.35517120795246],
						[13.121027944759042, 50.35272977905163],
						[13.127949713507606, 50.347732531624274],
						[13.13099002946163, 50.346611034490145],
						[13.134753226897859, 50.34619140266089],
						[13.13853931603716, 50.34640504816469],
						[13.141940116107829, 50.3471946633622],
						[13.146560669235972, 50.349395755053784],
						[13.148274422885615, 50.349926007606754],
						[13.152279852548203, 50.350589738624166],
						[13.158866881108723, 50.35079191819496],
						[13.16514110533507, 50.35007476469047],
						[13.16825199193392, 50.349056250948365],
						[13.171925546256984, 50.34737397857045],
						[13.173686028664488, 50.34684373159709],
						[13.177759170014854, 50.346126550887305],
						[13.187019348049422, 50.345558165491376],
						[13.196627615986293, 50.345664968500955],
						[13.201250075121067, 50.345966326645765],
						[13.205528259028915, 50.34652328227236],
						[13.209156038009212, 50.347473161865985],
						[13.212690354648268, 50.34915162464873],
						[13.215686796814733, 50.35015104841596],
						[13.217573165212391, 50.35048293344587],
						[13.221680642079727, 50.35073853499574],
						[13.226008413422749, 50.35042570113088],
						[13.230235099253106, 50.34940337562779],
						[13.234007834865867, 50.34779357356545],
						[13.23904132759102, 50.344802847551755],
						[13.243363381745029, 50.34146119555024],
						[13.24725723264432, 50.337348937757156],
						[13.251195908313676, 50.334167488104875],
						[13.253038405623347, 50.33214568298677],
						[13.25467109661872, 50.32830047413598],
						[13.255849838050226, 50.3222465493242],
						[13.255079270231068, 50.319126137858674],
						[13.253922462031628, 50.31719970245549],
						[13.252301215623161, 50.315395349899845],
						[13.249823570802748, 50.31398010838306],
						[13.242487908144074, 50.311820991679085],
						[13.24127483398479, 50.311054232978364],
						[13.240492820333714, 50.310188289148854],
						[13.23986720980467, 50.308189385895545],
						[13.24042224822811, 50.305953972992825],
						[13.243493080876833, 50.30121613331718],
						[13.244631766615468, 50.29845427768936],
						[13.245470047595486, 50.293991095218445],
						[13.245577813023315, 50.289455422614736],
						[13.244936942901395, 50.28515243367869],
						[13.243898392161968, 50.28261185157918],
						[13.243122101541601, 50.281524665761644],
						[13.239809035883315, 50.27835082613006],
						[13.238617896563934, 50.27602385975175],
						[13.238259315550138, 50.273376465476],
						[13.238714217250644, 50.2706146145707],
						[13.240099906379275, 50.26795577426515],
						[13.246029853144593, 50.26126479383737],
						[13.247837066682518, 50.25947189365079],
						[13.251792908380605, 50.25635910741715],
						[13.25327014883055, 50.25386046937742],
						[13.253852844088, 50.25104522545239],
						[13.25375747688674, 50.248176575557316],
						[13.253041268261585, 50.24546051946747],
						[13.25159835872475, 50.2431488097764],
						[13.24903392700871, 50.241016378272995],
						[13.247546196876536, 50.23921204562909],
						[13.246875762947882, 50.236892700283775],
						[13.246924401179097, 50.23567582080607],
						[13.24796485863724, 50.233283992626994],
						[13.249088286644414, 50.23220442970972],
						[13.250591277531125, 50.23136138336074],
						[13.254112243265089, 50.23034286087076],
						[13.2620468133629, 50.22902297333525],
						[13.2670545572904, 50.22776412421795],
						[13.269210814690489, 50.22447966743583],
						[13.270307541470757, 50.22147751467927],
						[13.270753859705385, 50.21839903968509],
						[13.27065754024356, 50.21538163162564],
						[13.26940918002361, 50.211292270419406],
						[13.268623352163942, 50.21016693235584],
						[13.26545333918239, 50.20709229110722],
						[13.264802933343033, 50.206043249832554],
						[13.264120102720659, 50.202468880499254],
						[13.264745712023146, 50.200061795358906],
						[13.266248703061986, 50.19809722963234],
						[13.269906997370892, 50.19500350622381],
						[13.273542404443575, 50.1909561185819],
						[13.280922888948075, 50.18358611250452],
						[13.286445616831363, 50.17996977861584],
						[13.29041099493191, 50.17696380028692],
						[13.294953346630102, 50.17420196934696],
						[13.296908378700465, 50.172412873370895],
						[13.301837920394991, 50.16695403258192],
						[13.303622246441547, 50.1643905709044],
						[13.304566383449435, 50.16159439179978],
						[13.304670334294856, 50.158809666462815],
						[13.303974151546992, 50.15620040825141],
						[13.30328083008084, 50.15502547896099],
						[13.299315452495197, 50.150772093869605],
						[13.295970916365986, 50.14503478597235],
						[13.293734550332827, 50.14311599578878],
						[13.290932655121285, 50.141864774341045],
						[13.28750896451451, 50.141239166003956],
						[13.284036636661414, 50.141227725457725],
						[13.277364731164191, 50.14198303573541],
						[13.27335071560285, 50.14210128747472],
						[13.269415855045368, 50.141754146524995],
						[13.265869140317886, 50.140655514299866],
						[13.263404845907107, 50.138759610003426],
						[13.260421753041287, 50.1346054089063],
						[13.256273269241689, 50.13076018847385],
						[13.255164146741635, 50.12844467503038],
						[13.255150795119048, 50.12596130516492],
						[13.256411552348995, 50.123527525998995],
						[13.257687568733548, 50.12244415356864],
						[13.259486198422067, 50.12157821651826],
						[13.261475562883456, 50.121044157162515],
						[13.26577758747573, 50.120548243859446],
						[13.279681206072308, 50.12015915261422],
						[13.283995628378754, 50.119636535877326],
						[13.28732204413899, 50.11867904413963],
						[13.291071891685103, 50.1171073902953],
						[13.301180839620201, 50.11427688685533],
						[13.303856849948033, 50.11264038381732],
						[13.306302071066245, 50.10966110707301],
						[13.308112144019796, 50.10651397225212],
						[13.309329033215203, 50.10226822237318],
						[13.306427002287563, 50.093093875634665],
						[13.302437782157323, 50.08313369611946],
						[13.299984932026922, 50.06894683924486],
						[13.296853065702468, 50.06005859601202],
						[13.29555034625575, 50.057598112744564],
						[13.29461193100973, 50.05650711233286],
						[13.28628063220883, 50.050632478835965],
						[13.279215812727111, 50.047386169903845],
						[13.276214599706368, 50.04557037457351],
						[13.269763946572413, 50.04001236003803],
						[13.26081180575566, 50.03438186678277],
						[13.247571945125557, 50.0293807976433],
						[13.238916397091286, 50.02656936641807],
						[13.23541831960176, 50.024806975238555],
						[13.233880996725617, 50.02374649071036],
						[13.231377601682762, 50.02128601137962],
						[13.229846954336237, 50.018363952534294],
						[13.228958129870291, 50.01372909532354],
						[13.228895187361601, 50.008979797187536],
						[13.229538917535228, 50.00275039666088],
						[13.230266575587597, 49.99984364631423],
						[13.231469168217984, 49.99725356718],
						[13.235704407895199, 49.993099060851414],
						[13.236409185180568, 49.99203870380974],
						[13.237232196376878, 49.988433710054025],
						[13.236626620606085, 49.985984754279905],
						[13.234963411935592, 49.98395914288441],
						[13.229986187977635, 49.98058316055247],
						[13.22747135468724, 49.97921756231519],
						[13.223493588995106, 49.978187700601616],
						[13.216862670110773, 49.97777929763447],
						[13.21026133261823, 49.97834764567259],
						[13.206386553405846, 49.97942719994737],
						[13.197351455025306, 49.9846458363433],
						[13.193563470072691, 49.98764047557432],
						[13.18916894089862, 49.9902344921634],
						[13.18532085120425, 49.99320217724328],
						[13.180719378545069, 49.995742829569224],
						[13.176372520893223, 49.998630446034305],
						[13.163474082944257, 50.003894805880925],
						[13.1571283340531, 50.00622558601997],
						[13.15095996859161, 50.009368896750765],
						[13.147628784125788, 50.01043319643851],
						[13.140570640552323, 50.01209640490311],
						[13.134031295809805, 50.014869690304366],
						[13.132195472709459, 50.01541137686892],
						[13.125795364339812, 50.016368865532314],
						[13.10848712919082, 50.01750183083088],
						[13.105044364914248, 50.01747131331409],
						[13.097531318676062, 50.01677703869798],
						[13.091476440401205, 50.015922546076354],
						[13.087936401400508, 50.014869690304366],
						[13.078899383559218, 50.00976562515561],
						[13.075096130397716, 50.00674819975155],
						[13.07071399687876, 50.00389862051333],
						[13.065797816946166, 49.99897396809288],
						[13.056037900541257, 49.99097058657118],
						[13.049804680964609, 49.98490517154403],
						[13.045372974232048, 49.982074860802996],
						[13.041510577710392, 49.97907252423453],
						[13.032528865889867, 49.97396456677626],
						[13.029249198609188, 49.97287758260937],
						[13.022188186666327, 49.971263885725996],
						[13.015583997554822, 49.96854025247245],
						[13.01377773294425, 49.96801757916769],
						[13.00972556633453, 49.96731944089741],
						[12.998983394487913, 49.96614087116779],
						[12.995184891189952, 49.96530143478514],
						[12.9899663797502, 49.96327195451634],
						[12.988170619680325, 49.962810471333505],
						[12.975468632620988, 49.96135708439212],
						[12.971280102469192, 49.96053319167146],
						[12.967984207181836, 49.959133232452004],
						[12.965882307546739, 49.95735938237772],
						[12.96470546359626, 49.95517345249743],
						[12.964408863419795, 49.95105349726345],
						[12.963605887784103, 49.943088609110006],
						[12.962478638588708, 49.93832016975531],
						[12.959299078333057, 49.93196477294665],
						[12.955961228054754, 49.927425391555005],
						[12.951543819254578, 49.92369092026602],
						[12.94524001947718, 49.919742570152486],
						[12.936139118631763, 49.915825021437065],
						[12.931253424642177, 49.913326168503815],
						[12.927333829119549, 49.912403077184784],
						[12.920770631327041, 49.912021484089756],
						[12.914284711119565, 49.91255956467609],
						[12.910553935272933, 49.91352084712831],
						[12.904564868836593, 49.916385776408646],
						[12.899975771351171, 49.917514742060554],
						[12.895296095308899, 49.9181938005891],
						[12.87344645525916, 49.91744984813222],
						[12.855857843849712, 49.91743463376867],
						[12.848860731260762, 49.91787709267818],
						[12.844721796601998, 49.91855242620796],
						[12.836182594600336, 49.921745303645125],
						[12.829834939495237, 49.922626511466625],
						[12.815242761398455, 49.92300408419741],
						[12.777070035041698, 49.92264545219034],
						[12.768464081475893, 49.92228309465923],
						[12.754974375998716, 49.92350399633883],
						[12.75176716548173, 49.923599321314136],
						[12.747099870499726, 49.92300408419741],
						[12.742501255335233, 49.92186733118131],
						[12.73992824089445, 49.92069239167937],
						[12.736810670849852, 49.91869339260941],
						[12.727671625985895, 49.91368106122963],
						[12.724335675344438, 49.91258626691656],
						[12.714686396453066, 49.91032031251795],
						[12.711125377341562, 49.908840218831436],
						[12.708015448253851, 49.907039713900694],
						[12.702277194373433, 49.90285504151067],
						[12.694292073352443, 49.899955804406005],
						[12.691521643366446, 49.898548112401464],
						[12.689705845768366, 49.89665981808949],
						[12.687768923556975, 49.89356598947895],
						[12.68583201673163, 49.891662519940205],
						[12.683253281106548, 49.89047996068286],
						[12.679041868039743, 49.88961035319755],
						[12.676106466114245, 49.889633327437174],
						[12.673419953926057, 49.890396135481375],
						[12.671371453079702, 49.891662519940205],
						[12.667948729857628, 49.89447410881575],
						[12.661771764813412, 49.8986052395806],
						[12.659251206207019, 49.89994804251838],
						[12.653009404145694, 49.9017866851852],
						[12.64778042251986, 49.90264515772262],
						[12.64201069706015, 49.902603243081884],
						[12.62566089871571, 49.900329617199276],
						[12.621322632203237, 49.899452213635236],
						[12.611226079767334, 49.896553015942956],
						[12.606611247586695, 49.895835828290316],
						[12.60190106034883, 49.89553839782315],
						[12.595046055475171, 49.895748275652636],
						[12.590913783608594, 49.896373874072744],
						[12.589097987812643, 49.89686597119882],
						[12.584023463810789, 49.89895234956873],
						[12.578387272044266, 49.900112284112],
						[12.557994854560379, 49.90128340120789],
						[12.557641996645524, 49.90166870365614],
						[12.554712301391808, 49.9030304622674],
						[12.55132483693156, 49.90486136554054],
						[12.551343907096754, 49.90474307208042],
						[12.550879483440552, 49.90470891912334],
						[12.550805089343463, 49.9054717731028],
						[12.55098533895496, 49.90697482269058],
						[12.551256170272621, 49.90923298460526],
						[12.55059337276956, 49.9111098856924],
						[12.550243377008057, 49.91157530966333],
						[12.549036029633905, 49.91317371692762],
						[12.548857685535719, 49.91519161201846],
						[12.548255915696929, 49.91663355226189],
						[12.548349375216432, 49.91930383393503],
						[12.547730448830112, 49.9203415255102],
						[12.544550900901182, 49.92255789016811],
						[12.541384689151995, 49.92408743543834],
						[12.53849505360459, 49.92482364499563],
						[12.536451341296084, 49.92485811120689],
						[12.53500556735337, 49.92495343669885],
						[12.530723579418186, 49.92577752243554],
						[12.529207219125269, 49.926280855716705],
						[12.527502054255011, 49.926612789200426],
						[12.526412966563328, 49.926822693109095],
						[12.521975514807322, 49.92768094110322],
						[12.520480161844576, 49.92786414203382],
						[12.513840681250512, 49.92786414203382],
						[12.512205125019197, 49.927585614570454],
						[12.510930055908062, 49.927963194796305],
						[12.50815105964484, 49.928813994436894],
						[12.504449839912155, 49.929340311723955],
						[12.501377110205972, 49.93060689338773],
						[12.498567578026792, 49.93235012268704],
						[12.493048676885815, 49.933227641720414],
						[12.493111617040727, 49.93424613901633],
						[12.494069087816037, 49.93579469759231],
						[12.494348536849845, 49.93690884593888],
						[12.4942359836817, 49.936878104320776],
						[12.492211337637688, 49.93636698665974],
						[12.49084853770755, 49.93647380581711],
						[12.48310755869725, 49.93572607267556],
						[12.481113445750534, 49.93583692831965],
						[12.478408805023408, 49.93567266325117],
						[12.477739340406668, 49.93618781625717],
						[12.477051736838932, 49.9367256383719],
						[12.475514410047268, 49.93791959518771],
						[12.475027083299569, 49.93860243547629],
						[12.473917013303037, 49.94008643179549],
						[12.473012922024887, 49.94248959918763],
						[12.47145652277538, 49.94396585537092],
						[12.470510475847613, 49.945026318243855],
						[12.469839095884332, 49.947330472734876],
						[12.469803819262632, 49.94748698211384],
						[12.469955456466145, 49.94778074799908],
						[12.470481878376688, 49.949031896432246],
						[12.47384453259992, 49.95135503083516],
						[12.474660876597284, 49.95191959209727],
						[12.476031297477958, 49.954677513978126],
						[12.478298197054194, 49.95677959203293],
						[12.479382521714333, 49.95713050943452],
						[12.48140526123531, 49.95827487625247],
						[12.484475137053936, 49.9584236287974],
						[12.485224711080997, 49.95825562227612],
						[12.487391470846047, 49.95798109800082],
						[12.488201131890337, 49.9579314103815],
						[12.488814341910528, 49.9580267485098],
						[12.48985768441712, 49.9582711496763],
						[12.490610114793686, 49.958602815175055],
						[12.490763652909548, 49.959182609761804],
						[12.491037378214457, 49.959549058027164],
						[12.491135599362128, 49.96011736445388],
						[12.491312031604773, 49.96081548253804],
						[12.491223336092832, 49.961341867351464],
						[12.490942949306756, 49.96168130074424],
						[12.490771285085048, 49.96200551751833],
						[12.49114037535985, 49.96244060218573],
						[12.491969096304045, 49.96327195451634],
						[12.492570868065332, 49.96397008144079],
						[12.49275873760851, 49.96418747011749],
						[12.492959028491573, 49.96442038676734],
						[12.493504521274817, 49.96554180584644],
						[12.493946067209597, 49.96639242313201],
						[12.494056708344058, 49.966816024791626],
						[12.494015686829142, 49.96761695687825],
						[12.493698127659496, 49.96844491032018],
						[12.493864055299815, 49.96975703272271],
						[12.495527266323942, 49.97077940602446],
						[12.496432316358018, 49.97106947260431],
						[12.499541288911956, 49.972015452257054],
						[12.498823164196805, 49.97282789201806],
						[12.497241983532248, 49.97402202178574],
						[12.4965772629488, 49.97452545246311],
						[12.494797713013428, 49.975627972309354],
						[12.494214068145327, 49.976394769978064],
						[12.49215220335656, 49.97857653811802],
						[12.49198244866561, 49.97927843485389],
						[12.490928660094255, 49.97974025914027],
						[12.490219121767845, 49.98078161859584],
						[12.48989008685667, 49.98176179867207],
						[12.486372938409662, 49.98099125754602],
						[12.48393249349054, 49.98116300632871],
						[12.48189257827036, 49.98089591062381],
						[12.481147760328, 49.98132699081053],
						[12.477363578360464, 49.98086920106908],
						[12.476532937513866, 49.980770127280714],
						[12.476183880779345, 49.98181521797605],
						[12.475639334514913, 49.98344792863236],
						[12.473703377956378, 49.98522941857064],
						[12.471196171283799, 49.9865111923255],
						[12.469786644713862, 49.98796845318858],
						[12.46888350890613, 49.98882287417562],
						[12.468626985729202, 49.989437214308175],
						[12.468474395326403, 49.989803396535024],
						[12.470330245393708, 49.99072273681831],
						[12.46897507221311, 49.991710720825374],
						[12.468286505252244, 49.99221791439219],
						[12.467431064189643, 49.99285120897609],
						[12.465820308281032, 49.99314875549277],
						[12.463788976028793, 49.99424732019584],
						[12.462507234431609, 49.994560087455454],
						[12.460667620562166, 49.99487316570241],
						[12.458964335868718, 49.99476228377818],
						[12.457906711432285, 49.99419389822065],
						[12.456776624743163, 49.99411780298513],
						[12.455391874162027, 49.99367893581611],
						[12.453925125802787, 49.99348823227724],
						[12.454035767279995, 49.993034457832515],
						[12.454027167543636, 49.9923933980167],
						[12.45346070054506, 49.991642080501784],
						[12.452400205750331, 49.99144361379044],
						[12.451184285120894, 49.99108519387127],
						[12.450188634811727, 49.99067304266201],
						[12.448934558303893, 49.99026492977927],
						[12.44773674403349, 49.99029164034319],
						[12.44674873322069, 49.98965835228056],
						[12.4438114133556, 49.9882812125476],
						[12.442865374257904, 49.98772433344589],
						[12.441910739418269, 49.986957500851304],
						[12.440742482661655, 49.986392860136704],
						[12.439934738037213, 49.98696526544653],
						[12.436862951276815, 49.985912388547206],
						[12.433932291954633, 49.985137797002096],
						[12.431519521013659, 49.98438277444595],
						[12.431373589998552, 49.98540489726232],
						[12.431488982824538, 49.98582449371564],
						[12.43175126256279, 49.987125526746055],
						[12.431824671024888, 49.98755630714649],
						[12.431433673940168, 49.98857875359398],
						[12.42691706420893, 49.99012361230863],
						[12.425876615251385, 49.99097058657118],
						[12.425579070803197, 49.99119949063513],
						[12.425950051388373, 49.9914016842238],
						[12.42768098175364, 49.99230208439839],
						[12.428545956660237, 49.99275213041338],
						[12.431280133980481, 49.99308011477203],
						[12.431998264646314, 49.99316801216895],
						[12.433793058194192, 49.993381388664694],
						[12.435233116934743, 49.993782052448594],
						[12.435349453554835, 49.994220609206785],
						[12.435507764446319, 49.99469364261178],
						[12.43560981137947, 49.995124746722425],
						[12.435437191699835, 49.9961012562058],
						[12.435280813184637, 49.99698272703125],
						[12.435205452679526, 49.99890128797937],
						[12.434090616710893, 49.9996414458561],
						[12.431915283204154, 50.00039672852673],
						[12.43122386933467, 50.00261688244879],
						[12.42830753326258, 50.002323150615894],
						[12.426146507269127, 50.001720428534185],
						[12.424395561216524, 50.00080871579912],
						[12.424526214599645, 50.000324249268004],
						[12.42405700683579, 50.000476837155865],
						[12.42123031616864, 50.0013427735124],
						[12.418891906732158, 50.002571105886716],
						[12.417334556571198, 50.00342559804827],
						[12.41618347166971, 50.00399017322537],
						[12.4152040481695, 50.00443649306619],
						[12.414399147031924, 50.0046157836705],
						[12.413335800183289, 50.00482559218245],
						[12.412339210505104, 50.00484085076964],
						[12.411193847655493, 50.00485992430828],
						[12.41041469575243, 50.004779815819894],
						[12.409677505492418, 50.00481414793935],
						[12.408761024479245, 50.004997253465625],
						[12.407846450806208, 50.00522613526003],
						[12.406890869136808, 50.00533676143011],
						[12.40582084656589, 50.00537872324016],
						[12.404744148280866, 50.005252838437926],
						[12.403407096851605, 50.00508499132538],
						[12.4024820327708, 50.00505447381861],
						[12.40189933779502, 50.005252838437926],
						[12.401728630068078, 50.00561523440034],
						[12.401859283443315, 50.00608825678992],
						[12.402279853799898, 50.00643920874366],
						[12.402778625486867, 50.00669479368357],
						[12.402601242079319, 50.00756454483718],
						[12.40152168275461, 50.00823593157334],
						[12.400241851811106, 50.00862121587227],
						[12.39932346344452, 50.00862121587227],
						[12.398258209249025, 50.007911682363634],
						[12.397637367241886, 50.00855255119182],
						[12.398050308226106, 50.00964355466969],
						[12.399634361269785, 50.01049804690526],
						[12.401336669919768, 50.01125717160658],
						[12.401936531074002, 50.011795044025526],
						[12.402215957667563, 50.01204681426216],
						[12.402927398642127, 50.01332473709538],
						[12.402808189383208, 50.013889312642235],
						[12.401832580560088, 50.01457977287525],
						[12.4006490707739, 50.01500320473643],
						[12.400377273584347, 50.0149993899334],
						[12.39963150024146, 50.01498794552457],
						[12.399257659925778, 50.01486206070242],
						[12.398917198154994, 50.01466369598743],
						[12.398533821059784, 50.01432418770294],
						[12.397934913602866, 50.01413345299722],
						[12.397149086005118, 50.01389694221426],
						[12.396604537938344, 50.013668060008406],
						[12.395734787022864, 50.01364517252744],
						[12.395032882642601, 50.013656615660985],
						[12.393620491016897, 50.01345443713025],
						[12.389919281041493, 50.012756348064336],
						[12.389216422991966, 50.01264190624764],
						[12.38656139368598, 50.012500762343294],
						[12.382811546313722, 50.01298141465733],
						[12.382150650025409, 50.013111114512796],
						[12.381358146677986, 50.01346588146836],
						[12.379620552050303, 50.01404190048761],
						[12.37782859807327, 50.01647186337722],
						[12.37775230411488, 50.01657486005153],
						[12.377750396695001, 50.017593383403735],
						[12.377747535686726, 50.01787948586674],
						[12.37785148615914, 50.01802444404005],
						[12.378238678019363, 50.01863861130874],
						[12.378506660497226, 50.01905822795124],
						[12.37835311887071, 50.01906967133446],
						[12.375885009785703, 50.01924514793444],
						[12.375748634297402, 50.01925659132629],
						[12.37335014343837, 50.01865768439103],
						[12.37048053739578, 50.01787948586674],
						[12.36894989008657, 50.01762008609218],
						[12.367532730106651, 50.01744461064165],
						[12.367446899460651, 50.019439697800976],
						[12.367320060734995, 50.01992416387537],
						[12.366970062283063, 50.02035522492164],
						[12.365699768015306, 50.02157974184295],
						[12.36557197576144, 50.02204132141489],
						[12.365783691309547, 50.02276992686446],
						[12.364546775810606, 50.0229911803356],
						[12.364425659269068, 50.02309036357597],
						[12.362470626825704, 50.024677276548445],
						[12.362037658776117, 50.024837494871335],
						[12.361581802411653, 50.0249023442498],
						[12.361088752848644, 50.024948121291146],
						[12.36067771916879, 50.02518844664997],
						[12.360137939522756, 50.02543640216868],
						[12.359809875578735, 50.02547454938024],
						[12.359600067226573, 50.025264741002694],
						[12.359700203027698, 50.02501678565563],
						[12.359801292514225, 50.02480316271156],
						[12.359626769963402, 50.02455902034926],
						[12.359113693304144, 50.02454376297635],
						[12.358642578141726, 50.024681091500355],
						[12.35834503182419, 50.02501678565563],
						[12.358246803294128, 50.025321960569194],
						[12.35814571386969, 50.025539398925325],
						[12.35783767696974, 50.025627135858386],
						[12.357617378319583, 50.02564621069151],
						[12.356043815564634, 50.026885985772985],
						[12.35544013981546, 50.027530670682886],
						[12.355186462308627, 50.02809142958509],
						[12.354974746728075, 50.02870178250313],
						[12.354358673057341, 50.02904128984072],
						[12.353585243193121, 50.029384612667535],
						[12.352537155158343, 50.02975463875151],
						[12.351610183800162, 50.03017807103951],
						[12.350754737867492, 50.03070831314422],
						[12.350687980576074, 50.0307502737854],
						[12.349845886295283, 50.031345368178044],
						[12.349358558753819, 50.03196334952857],
						[12.349338531448012, 50.03247070259379],
						[12.349520683198863, 50.033100127140685],
						[12.349305152894376, 50.03361129762241],
						[12.348811149540776, 50.034072875326416],
						[12.34856033315255, 50.034687041091566],
						[12.348209381072127, 50.03578185998999],
						[12.347721099920513, 50.0363731391986],
						[12.347241401598064, 50.036613463500395],
						[12.346987724224222, 50.03673934844489],
						[12.345857620146832, 50.03701019180657],
						[12.34516048421894, 50.03730010876738],
						[12.344387054505068, 50.037643433327986],
						[12.34341144561743, 50.03786087035908],
						[12.342482566777953, 50.0382575982358],
						[12.341586112905386, 50.038475035805924],
						[12.340807914834485, 50.03868866082629],
						[12.34027004238123, 50.039028167284485],
						[12.339807510417632, 50.039287567617855],
						[12.338880538956934, 50.03961181659631],
						[12.337591171250411, 50.03993225081251],
						[12.337088584834847, 50.03916168137852],
						[12.336093902512275, 50.03871154697869],
						[12.335666656448344, 50.038516997762315],
						[12.333543777565955, 50.03603363152487],
						[12.333639144999948, 50.034889222372406],
						[12.330953597988122, 50.03339385946654],
						[12.32885265342954, 50.03221893225188],
						[12.327686309784033, 50.032348632460746],
						[12.325409889274809, 50.033020020149976],
						[12.324605941869963, 50.033973694972765],
						[12.32452964783948, 50.03525924696713],
						[12.32545852651273, 50.036884306724424],
						[12.325175285392529, 50.03737640442135],
						[12.324412345920958, 50.03842544595655],
						[12.324464797897212, 50.03884887607204],
						[12.323347091638754, 50.03924179035489],
						[12.32243728639925, 50.04123306300129],
						[12.320549965075472, 50.04210663038672],
						[12.319605827344152, 50.04269027724446],
						[12.318932533283675, 50.04324340842822],
						[12.318331718578452, 50.0437965408474],
						[12.317654609753514, 50.044227600942634],
						[12.316976547367874, 50.04466247704774],
						[12.316665649361786, 50.04513931214086],
						[12.316282272187275, 50.04561614815219],
						[12.315611839376151, 50.04611206149049],
						[12.317399978509568, 50.04703521580726],
						[12.318500518759258, 50.0479583735661],
						[12.31915473948212, 50.04880523799581],
						[12.319241523921129, 50.049919130476475],
						[12.318851471010573, 50.051326752439174],
						[12.318404197626972, 50.05239105148514],
						[12.317333221269859, 50.053379056926595],
						[12.315987587167875, 50.053001406032045],
						[12.314372062820617, 50.052539827026834],
						[12.313357353303038, 50.053871155852775],
						[12.31206798537171, 50.054946897532176],
						[12.310935974025929, 50.055538176391885],
						[12.309566497908245, 50.05570221068975],
						[12.307225227316033, 50.05599594070119],
						[12.30502605430585, 50.05651855380523],
						[12.30144596092015, 50.05805969147678],
						[12.299114227222638, 50.05865859901727],
						[12.299072265754715, 50.058670045443456],
						[12.298883438188938, 50.05864334197081],
						[12.298068046597429, 50.05852127107019],
						[12.295053482131376, 50.05804443446727],
						[12.292268753218172, 50.057174684540456],
						[12.289209366016065, 50.057003023221014],
						[12.287865638928091, 50.056930544248736],
						[12.283198356622181, 50.05642318718309],
						[12.281990051208478, 50.055717467554835],
						[12.28128528583148, 50.05543517929628],
						[12.2802515030686, 50.055217743820926],
						[12.279292106668603, 50.055164337623765],
						[12.279355049009268, 50.05609130715865],
						[12.279234886058914, 50.056591032656804],
						[12.278881073061969, 50.057144165777274],
						[12.278467178547757, 50.05756759878339],
						[12.277950286849947, 50.057846069157776],
						[12.277168273913926, 50.05806350694289],
						[12.276046752840477, 50.05849075214087],
						[12.275151252656842, 50.059013365660526],
						[12.27427387226104, 50.059669493303645],
						[12.273603439486925, 50.060287477388506],
						[12.273042678830867, 50.06087493893949],
						[12.272547721698391, 50.06122970390701],
						[12.27251625045052, 50.061252592143504],
						[12.271933555443084, 50.061252592143504],
						[12.27127170577089, 50.06135940717801],
						[12.270147323817312, 50.06134033444829],
						[12.269503593479557, 50.06117248575224],
						[12.268943786426721, 50.061046598091366],
						[12.268140792916409, 50.06090164265301],
						[12.267518997325219, 50.06079101716233],
						[12.266716957019009, 50.06048202429792],
						[12.26564598103526, 50.06003570788603],
						[12.26447868331357, 50.0595970135502],
						[12.263299942222856, 50.05924225092425],
						[12.26303482051132, 50.05882644600752],
						[12.262578010621231, 50.05847549510477],
						[12.261663436969403, 50.05811691376584],
						[12.260911941625984, 50.058429719147846],
						[12.261052131525437, 50.05884551854344],
						[12.260993003918266, 50.059375763785155],
						[12.260622024494834, 50.05988311719724],
						[12.260172843869753, 50.060367583493175],
						[12.259805679121337, 50.061000821658666],
						[12.259867668153607, 50.06159973146556],
						[12.260204315276631, 50.06227493391516],
						[12.260698318347181, 50.062969206207576],
						[12.260913848817188, 50.06351852347685],
						[12.260933876231926, 50.06407165752507],
						[12.261113166622005, 50.064693448760075],
						[12.261797905146963, 50.065261842890095],
						[12.262593269455257, 50.06567764406272],
						[12.26323127744133, 50.06606674166039],
						[12.263564109608126, 50.06661605610163],
						[12.263621330188776, 50.06709289466742],
						[12.263985633862795, 50.06746292129028],
						[12.264702797059988, 50.06785202169745],
						[12.265537261972153, 50.06826782237147],
						[12.266100883309283, 50.068737028006765],
						[12.26650524158478, 50.06912994605604],
						[12.26691246040422, 50.06957626431853],
						[12.267442703216778, 50.07019424403471],
						[12.268124580309156, 50.070713042354754],
						[12.268921852170998, 50.071178436962775],
						[12.269642829831389, 50.07166671679301],
						[12.270241737559745, 50.07203674540769],
						[12.270920753421805, 50.07247543268708],
						[12.271403312568513, 50.072845457657934],
						[12.271972656314933, 50.07346344069324],
						[12.272858619524186, 50.074203489292906],
						[12.273430824266375, 50.074897765957445],
						[12.273763656569178, 50.07546997015844],
						[12.274327278036438, 50.07591247441921],
						[12.274843215754407, 50.076156614035845],
						[12.27535343182596, 50.07646942282338],
						[12.271656990016151, 50.07723236043234],
						[12.270446777426415, 50.07748031711889],
						[12.266643524186835, 50.07840728779268],
						[12.265245437618415, 50.07915496821873],
						[12.26398849505634, 50.08071899626109],
						[12.263333320207, 50.08153533460293],
						[12.259108543039797, 50.082996364283616],
						[12.259169578951186, 50.08347321018485],
						[12.259152412040638, 50.083984370671985],
						[12.258955955559596, 50.084190369278545],
						[12.25842380497601, 50.08430480655005],
						[12.258075713769529, 50.084396358347306],
						[12.257598876609661, 50.08452224333774],
						[12.25714397422358, 50.08472061063756],
						[12.256934165640212, 50.08505630129212],
						[12.256590843391553, 50.08526230079287],
						[12.256095886030586, 50.08540344006735],
						[12.25558567006578, 50.085613246039436],
						[12.255296706983014, 50.085807798321184],
						[12.25492858923842, 50.086074833398996],
						[12.254556656112266, 50.086223604939526],
						[12.254282951339077, 50.086399078183604],
						[12.253569603131787, 50.087139131554046],
						[12.253144263880918, 50.08775710665565],
						[12.252794266071012, 50.08835220711992],
						[12.252890587126494, 50.08894729930887],
						[12.253126144456889, 50.08932495172364],
						[12.253250122485252, 50.08972168449005],
						[12.253376007009841, 50.09005737223441],
						[12.253204345954263, 50.09041977219388],
						[12.252593040415308, 50.09090423524865],
						[12.252495765778571, 50.09128570663635],
						[12.252470969945055, 50.09162139650764],
						[12.25200176220006, 50.0919380165987],
						[12.25148487077476, 50.091968534804245],
						[12.251327514481826, 50.09170913503246],
						[12.251314163506043, 50.09135055886997],
						[12.251375198443734, 50.090995789493114],
						[12.251217842060205, 50.090759276858485],
						[12.250661849562624, 50.09071731089122],
						[12.250002861412739, 50.090919499141954],
						[12.24945068378335, 50.09099960546778],
						[12.24914932292407, 50.09086227896661],
						[12.248740196269626, 50.09082031298185],
						[12.248384475992422, 50.091205600217684],
						[12.248365402114858, 50.091682432844195],
						[12.248378753970814, 50.09204101919871],
						[12.248538017310626, 50.092346191841266],
						[12.248362541550026, 50.092613224281735],
						[12.247880935457957, 50.09259414428432],
						[12.247424125983189, 50.09226990107275],
						[12.246790885674162, 50.09213638014716],
						[12.246167182955851, 50.092288971335165],
						[12.245996475530882, 50.09269714715814],
						[12.245899200455044, 50.093055725276926],
						[12.245577812274536, 50.09336853119667],
						[12.2450685499159, 50.093612668651694],
						[12.244487762610813, 50.09393310731725],
						[12.24442958800192, 50.094364162598595],
						[12.244444847249559, 50.094768525820754],
						[12.244573593369346, 50.09524154929074],
						[12.244798660559754, 50.09543609945118],
						[12.245032310227042, 50.09563827214764],
						[12.245440483277685, 50.09568023895165],
						[12.245566368451659, 50.09549332068696],
						[12.245651244984264, 50.095367430101746],
						[12.245677948392316, 50.095081333911466],
						[12.246076584259054, 50.094860081498695],
						[12.246562958127926, 50.09499741022431],
						[12.246683120725296, 50.09523391721033],
						[12.246693611469487, 50.09552002328752],
						[12.247103690748759, 50.0956077534883],
						[12.247620582973715, 50.095577244542774],
						[12.247968674029757, 50.09565735238041],
						[12.24803352351085, 50.09567260685765],
						[12.248006820493137, 50.095996854539955],
						[12.247911452897009, 50.096427913426275],
						[12.247776031446907, 50.09676361029227],
						[12.24748802183003, 50.09698104834463],
						[12.247163772597347, 50.09722518937372],
						[12.246949195937907, 50.09744262783286],
						[12.246692657534888, 50.097496033458775],
						[12.246322631700872, 50.09732818447044],
						[12.245745659169463, 50.09709930761499],
						[12.245424271030558, 50.096832280030256],
						[12.245184898027595, 50.096645351182794],
						[12.244890212705641, 50.096565243024415],
						[12.244473457091892, 50.09667586997047],
						[12.243948936603562, 50.09687805339282],
						[12.243347167980424, 50.096900940077255],
						[12.242874145839732, 50.09672165301411],
						[12.242434501799586, 50.09638977226318],
						[12.241725921917855, 50.09617615078657],
						[12.24120140044006, 50.096183773186056],
						[12.240564346413448, 50.09627914544539],
						[12.239725113301553, 50.096206669516164],
						[12.238885879722904, 50.096118929392425],
						[12.238123893786115, 50.096004486643956],
						[12.237262725512416, 50.09585570920834],
						[12.236842155548217, 50.09551239119848],
						[12.236734390399176, 50.09521103068049],
						[12.236406326436366, 50.094768525820754],
						[12.235856055971752, 50.09458923059692],
						[12.235310554180652, 50.0945587120673],
						[12.234569549451901, 50.09448242061484],
						[12.233599662751713, 50.0941505428755],
						[12.232610702216943, 50.09408568990615],
						[12.231797218636784, 50.09416199094597],
						[12.231067657315268, 50.09442519961343],
						[12.230848312258987, 50.09478759627625],
						[12.230870246613247, 50.09539031664608],
						[12.230640411425359, 50.096004486643956],
						[12.230284690891027, 50.096385956205175],
						[12.22982025109973, 50.09645461612798],
						[12.229310989195412, 50.09635162139589],
						[12.228568076735877, 50.09623717853953],
						[12.228065490805808, 50.09630584813099],
						[12.227648735445102, 50.09658813938995],
						[12.227391242831954, 50.09700393503864],
						[12.227272033761345, 50.09746933064438],
						[12.227442741284854, 50.09786605708316],
						[12.22771167720171, 50.098312373875515],
						[12.22792339309721, 50.09879684271478],
						[12.228213310368492, 50.09928131250545],
						[12.228578567602694, 50.099910737218224],
						[12.228935241876018, 50.100200655125526],
						[12.229154587192026, 50.1006240891096],
						[12.229339599417829, 50.101123807592835],
						[12.229469298902387, 50.101657862631406],
						[12.229334831277077, 50.102005005338256],
						[12.22877216338526, 50.102310180594706],
						[12.228110313483919, 50.10243988116406],
						[12.22727584862718, 50.10239410676952],
						[12.226369857480265, 50.102428432709495],
						[12.225337981824033, 50.10255431718761],
						[12.22439765911655, 50.102661130664366],
						[12.223608016835149, 50.10284042204423],
						[12.222749710120576, 50.1031494144969],
						[12.222334861412868, 50.10346602996123],
						[12.221917152344055, 50.103675841579914],
						[12.221313476417091, 50.1038742048554],
						[12.221054076748429, 50.10386657250789],
						[12.220565796091739, 50.10368347392152],
						[12.219775199884024, 50.103324890066396],
						[12.219355583408797, 50.10297775521218],
						[12.218733787477078, 50.10266494681944],
						[12.218003272953219, 50.10243606501247],
						[12.217119216691005, 50.102558133341034],
						[12.216387748749169, 50.102794647575344],
						[12.215574264852888, 50.10282898328138],
						[12.21494197806461, 50.10275649571756],
						[12.214254379004531, 50.102684017885345],
						[12.213709831346735, 50.102466584516534],
						[12.212926864618174, 50.102310180594706],
						[12.21221351597378, 50.10204696351505],
						[12.211276054160152, 50.10171508531028],
						[12.210478782985856, 50.1016807594696],
						[12.209692955108595, 50.10195541488028],
						[12.20898818985039, 50.10241699396575],
						[12.206778525997686, 50.10646819710135],
						[12.205048561076662, 50.10737609840661],
						[12.203723907591094, 50.1082954420709],
						[12.201422691131446, 50.108501431842825],
						[12.20096588138203, 50.10898590127677],
						[12.200948714930375, 50.109428402512265],
						[12.200732231148692, 50.109767913917715],
						[12.200356483410498, 50.11021423282879],
						[12.199912071520993, 50.11059952122586],
						[12.19960689529411, 50.11119460882068],
						[12.199616432023028, 50.111450193372775],
						[12.19962692285122, 50.11174011513689],
						[12.200034141626592, 50.11215210060977],
						[12.200373649870158, 50.11252594311242],
						[12.200489044555898, 50.11298752256574],
						[12.200674057007937, 50.11359405518784],
						[12.201148986809892, 50.11407089225693],
						[12.201820373471024, 50.11456680223377],
						[12.202260971270054, 50.11500168079631],
						[12.202343940468731, 50.11548232723171],
						[12.202194213673017, 50.11586379779395],
						[12.20155048373621, 50.11633682288817],
						[12.20081615432278, 50.116641996464665],
						[12.200108528545577, 50.116966252300834],
						[12.199407577421347, 50.11748123060433],
						[12.199197769206766, 50.11798858691034],
						[12.199445724401656, 50.118530272443316],
						[12.199593544046792, 50.11901092576195],
						[12.199286460591038, 50.11956405308167],
						[12.19905185721531, 50.11989975231814],
						[12.198634147829626, 50.12049865938179],
						[12.197966575855993, 50.12103271755483],
						[12.197400093432181, 50.121650699906546],
						[12.196900367581659, 50.122291563139406],
						[12.196656227030685, 50.12277603055253],
						[12.19650840781063, 50.123222353603786],
						[12.196531296145311, 50.123870853892846],
						[12.196618080004525, 50.12445831142325],
						[12.196748733226114, 50.12476348534996],
						[12.196904182671844, 50.12512588776947],
						[12.197253227116292, 50.12575149399439],
						[12.19724273668787, 50.126361845431205],
						[12.196965217594318, 50.12683105473375],
						[12.196586608803738, 50.12721252344913],
						[12.19653701785234, 50.1276779178302],
						[12.19668865222542, 50.12824249484606],
						[12.19704723358934, 50.13004302987434],
						[12.197131156621145, 50.130546566338246],
						[12.197045326425373, 50.13100815042784],
						[12.19702148426998, 50.131137846681156],
						[12.19643497488088, 50.13252258544991],
						[12.19749832188018, 50.135612491820346],
						[12.195259094620253, 50.137203220985484],
						[12.19450664486537, 50.13770675267574],
						[12.194562912033211, 50.13810348563958],
						[12.195201873583176, 50.14304351579096],
						[12.198646545057086, 50.14380263872518],
						[12.200174331791416, 50.14577865747167],
						[12.202141761487436, 50.14559554714516],
						[12.20360755956853, 50.14583588069068],
						[12.203272819887385, 50.14627075622378],
						[12.202507018886527, 50.14709091004965],
						[12.201427459772772, 50.1483154303359],
						[12.203314780926524, 50.15048217469164],
						[12.200061798247344, 50.15153122124025],
						[12.200498581207148, 50.152450564706186],
						[12.203130722326575, 50.153987887775195],
						[12.211218834153868, 50.1587905910482],
						[12.213066100834153, 50.16185378750341],
						[12.21461772914714, 50.16442489577927],
						[12.215995788261784, 50.168178554733146],
						[12.215415000798505, 50.16836166246339],
						[12.213796616296307, 50.16886902660756],
						[12.21026611359031, 50.16872787833354],
						[12.20858383096872, 50.16866301542557],
						[12.207302093414556, 50.16950988663719],
						[12.208540915863955, 50.171508782358906],
						[12.208428382837537, 50.17284774738453],
						[12.20842361524882, 50.172904976908725],
						[12.208300591113588, 50.174148566497486],
						[12.206622123481088, 50.175399777527936],
						[12.206251144925265, 50.17638397814183],
						[12.205429077786992, 50.177677161934405],
						[12.20460319453205, 50.17916106415448],
						[12.20366573407853, 50.18084336185311],
						[12.203597067985372, 50.181095114013246],
						[12.203169823080023, 50.182659153651684],
						[12.202142715309137, 50.18449401687563],
						[12.201989173862728, 50.18684387176483],
						[12.201260566626063, 50.18878936668688],
						[12.199954986115937, 50.18843841024459],
						[12.199981689805721, 50.18869018962861],
						[12.20007705640675, 50.18939208430883],
						[12.199281693239897, 50.18989945308944],
						[12.198939324250663, 50.19000626565834],
						[12.195261955982831, 50.19114685894224],
						[12.192739486082367, 50.19235228783207],
						[12.190710067419694, 50.19362639999359],
						[12.190222740322518, 50.19411087208885],
						[12.18922519721114, 50.19520569279482],
						[12.189034461342644, 50.19540786010469],
						[12.188941001056673, 50.1955070398809],
						[12.190302848979915, 50.19711303900811],
						[12.190681458308262, 50.19726181943672],
						[12.191639899450704, 50.19764327126431],
						[12.196391106304228, 50.19760132591104],
						[12.197294235361225, 50.19775772247092],
						[12.197896957573738, 50.198162080896424],
						[12.197606086557387, 50.19863509930857],
						[12.197454453257903, 50.19883728887598],
						[12.196875571395132, 50.19925307290491],
						[12.19599628501485, 50.199573522980906],
						[12.194998741551359, 50.199684147713434],
						[12.193919181187432, 50.199581138872375],
						[12.191666603321696, 50.19882965357939],
						[12.1901569361321, 50.200767511142594],
						[12.187788962525284, 50.20034026181379],
						[12.187657356564914, 50.20034408919975],
						[12.186642646887679, 50.20037841910611],
						[12.18649196576397, 50.20038222706433],
						[12.185724257729717, 50.19968032033777],
						[12.18523120945631, 50.1993751601768],
						[12.185025215365298, 50.199356081608016],
						[12.18412590055357, 50.19925690027391],
						[12.183406830555256, 50.19918824078032],
						[12.183028221125351, 50.19930267328029],
						[12.182820320856328, 50.19936371692099],
						[12.18232154782729, 50.19994353512456],
						[12.18200397474089, 50.20042419232205],
						[12.18205547371068, 50.20080566850149],
						[12.182529449292309, 50.20129394333516],
						[12.183199882367797, 50.20169067221124],
						[12.183947562736885, 50.20184707138157],
						[12.184615135877609, 50.20195008117539],
						[12.18502902924425, 50.202190392196215],
						[12.185420990524879, 50.20261383675883],
						[12.185956955476708, 50.203056341480334],
						[12.18561077054482, 50.203750603001716],
						[12.185365676567235, 50.204158779335955],
						[12.18500232675752, 50.20438003299232],
						[12.184078216403892, 50.204490659895455],
						[12.184017181349942, 50.204845427926834],
						[12.18380260536258, 50.20506287417249],
						[12.183138846924733, 50.20519256097718],
						[12.181432724674288, 50.205196388438964],
						[12.180818557607441, 50.2056579574557],
						[12.17959308567686, 50.20562743484916],
						[12.17839050217227, 50.20513915137695],
						[12.178424834656878, 50.20603942235753],
						[12.178356169836357, 50.2065429592692],
						[12.17806434597989, 50.20686339945348],
						[12.17768573726509, 50.20717620450031],
						[12.177268028117984, 50.207599638254294],
						[12.177114486698441, 50.20788955693284],
						[12.177071571602704, 50.20815658862094],
						[12.177213669101173, 50.20850372636499],
						[12.177313805373279, 50.208904275011],
						[12.177326201579524, 50.20925139438605],
						[12.177101135107522, 50.209617613048955],
						[12.176874161481322, 50.20992661350766],
						[12.176778793695158, 50.21028900563906],
						[12.1767368308501, 50.210544576736716],
						[12.176707267654082, 50.21072006101418],
						[12.176551819301379, 50.211223607551666],
						[12.176250458015213, 50.21187973313901],
						[12.176050185597752, 50.21232604331978],
						[12.17572307666425, 50.21286011666513],
						[12.17473316235691, 50.21273804209977],
						[12.173494339114574, 50.21258163597336],
						[12.170973777251564, 50.212303155598406],
						[12.170374870915243, 50.212623603321695],
						[12.169486045228428, 50.213050835222994],
						[12.16770458279189, 50.212646491073016],
						[12.167463303425594, 50.2121811007401],
						[12.16681289615751, 50.212020867400994],
						[12.165766715564043, 50.21258544412133],
						[12.16494751005645, 50.21361160615493],
						[12.161870001975732, 50.21183013021631],
						[12.159498214706081, 50.21118164044336],
						[12.159663200551869, 50.211631776913784],
						[12.159651755969552, 50.21218871702364],
						[12.157933235548011, 50.21354294263661],
						[12.157711028978472, 50.214420317740924],
						[12.159919739003868, 50.215396883821725],
						[12.162410736296762, 50.21684646853236],
						[12.164037704711143, 50.217842104872645],
						[12.163881301600297, 50.217994686698944],
						[12.162656784344664, 50.21919632290915],
						[12.162905692271778, 50.21994017647152],
						[12.16218757659962, 50.21990967151397],
						[12.160678864332946, 50.21984864218033],
						[12.160223007250645, 50.22188568171423],
						[12.160821914778897, 50.22255706910163],
						[12.16168403693244, 50.222854622114674],
						[12.162042617601873, 50.222976682296945],
						[12.162127494701831, 50.223545073183814],
						[12.161578178694377, 50.22347259856045],
						[12.15900516465743, 50.223129267325525],
						[12.157641410001522, 50.223213186217286],
						[12.156533241340387, 50.223625183898385],
						[12.157444954105099, 50.224811556120834],
						[12.158599852971285, 50.225738519076366],
						[12.158453941372224, 50.2264595034877],
						[12.157606124994784, 50.227149964733606],
						[12.156257628766374, 50.22787093387569],
						[12.155420304178264, 50.22781373037118],
						[12.154716491732893, 50.228618622216906],
						[12.152834892027041, 50.22896194172765],
						[12.15239048026989, 50.229076388148535],
						[12.151585578337615, 50.22928237241052],
						[12.150235176439367, 50.22962952069724],
						[12.149079322876487, 50.229690552471475],
						[12.147532463576777, 50.229274755594815],
						[12.146385192270252, 50.22991942661826],
						[12.145544051980565, 50.23038863969125],
						[12.146227837430567, 50.230831155777416],
						[12.148548125698388, 50.23233413090076],
						[12.149646758767766, 50.23279571225195],
						[12.149772644628644, 50.23284912788954],
						[12.150918960684004, 50.23336410653234],
						[12.151803015833718, 50.234348287502264],
						[12.151331902093512, 50.23572540913359],
						[12.14964389807111, 50.23599243234603],
						[12.147448540266295, 50.235809332348744],
						[12.143958092237316, 50.23429108248212],
						[12.1420879356003, 50.23378752732041],
						[12.141396522395372, 50.23322295995567],
						[12.141260147840832, 50.232776650508505],
						[12.141186713615362, 50.23253630944886],
						[12.141847610026629, 50.23170470672294],
						[12.142187118393297, 50.23097991784173],
						[12.141357421182997, 50.23051070363397],
						[12.139371871739543, 50.230731961687404],
						[12.138033867035475, 50.23138046442463],
						[12.135387420304905, 50.23194121908472],
						[12.132536887590415, 50.23212050773228],
						[12.131906509644454, 50.232162478432855],
						[12.130347251544334, 50.23226165367242],
						[12.129199981167856, 50.23233413090076],
						[12.126988410147625, 50.232490530226215],
						[12.121939659538569, 50.234184270019455],
						[12.121586798914585, 50.23500441682748],
						[12.120239258010253, 50.23523712388132],
						[12.118874550346746, 50.23563004099541],
						[12.117130278839166, 50.23612975257621],
						[12.11468887396529, 50.236827858185755],
						[12.111638069392521, 50.237792971538006],
						[12.108920096915494, 50.237930292779964],
						[12.10864925343214, 50.2389793347901],
						[12.108573913778129, 50.23927688835977],
						[12.108400344930452, 50.24079132175298],
						[12.108342171549214, 50.24318314569018],
						[12.107959746767492, 50.24387740452255],
						[12.10715293902118, 50.24534225671496],
						[12.107001304292925, 50.24584960549326],
						[12.106912612533648, 50.2461204484416],
						[12.106832503501312, 50.246246328915454],
						[12.106616020855853, 50.24649430081356],
						[12.106356621379351, 50.246704108437854],
						[12.10581874854116, 50.24686813432578],
						[12.105084419043095, 50.2470550512965],
						[12.10453033371206, 50.24710845061953],
						[12.103952407712987, 50.24711608742322],
						[12.103206634629142, 50.24697876101754],
						[12.10248565640784, 50.24688338848635],
						[12.102134704341372, 50.24678420731167],
						[12.101826668228473, 50.24658203640556],
						[12.101540566171195, 50.24633408385037],
						[12.101293563990422, 50.246227266122624],
						[12.101140976553094, 50.24616242154702],
						[12.100469589200502, 50.24615478477313],
						[12.09982395238619, 50.24622345745064],
						[12.099201202088498, 50.24629211071549],
						[12.098414420894228, 50.24630355616682],
						[12.09776973655775, 50.24641799127779],
						[12.097361564354918, 50.246673580708034],
						[12.097093581902717, 50.24694442457018],
						[12.096442222575734, 50.24754714943006],
						[12.095600128839017, 50.24797440349851],
						[12.094708442587319, 50.24831390263658],
						[12.093751906886217, 50.24878692088213],
						[12.092910766625142, 50.249229431426926],
						[12.092325210515801, 50.24971389705726],
						[12.092157363724834, 50.25023650928827],
						[12.091831206639279, 50.250862114171454],
						[12.091455459843178, 50.251403811488174],
						[12.090760230404662, 50.25238417864335],
						[12.094460487146478, 50.25281905872581],
						[12.095194816055997, 50.252971642957284],
						[12.097914696131472, 50.25352859953066],
						[12.102355004079593, 50.2557144249123],
						[12.102511405926897, 50.25578308084605],
						[12.1024532316124, 50.2561378455824],
						[12.10224628504228, 50.25747299842897],
						[12.101887702883008, 50.25889968803478],
						[12.101855594975575, 50.25893002296347],
						[12.102392619260401, 50.25915558202928],
						[12.109110554785635, 50.26380645550663],
						[12.10945200437497, 50.26615866611165],
						[12.109909057507748, 50.26652145258519],
						[12.11113548272177, 50.267066954796256],
						[12.112149239005312, 50.26750565061953],
						[12.113453864920965, 50.267913816845045],
						[12.11471080772507, 50.26813506992673],
						[12.115711211720464, 50.26817702738488],
						[12.116495132359212, 50.26797866720051],
						[12.117191315388617, 50.26764679758297],
						[12.11776161145769, 50.267265314239054],
						[12.118170739023787, 50.26702118853251],
						[12.118852614755435, 50.26652526157398],
						[12.120054244575513, 50.266887659919966],
						[12.119885444708741, 50.26739120561994],
						[12.120431900596452, 50.26760864922172],
						[12.120355605593554, 50.26811217697671],
						[12.12049770275535, 50.26846694020876],
						[12.12080383293206, 50.268722533299275],
						[12.121498108024044, 50.26891708506259],
						[12.123362540402182, 50.26898955373928],
						[12.126700401126211, 50.269691465195876],
						[12.130454062665041, 50.271060934895786],
						[12.13162040655929, 50.27188872658444],
						[12.132865905578152, 50.27296829010564],
						[12.13412570975676, 50.27344131728444],
						[12.136076927919214, 50.27447129147124],
						[12.13675785053995, 50.27465057249015],
						[12.13712310849928, 50.27468491283697],
						[12.137609481620606, 50.27478408592002],
						[12.137948036887225, 50.2749099811833],
						[12.13829135880162, 50.275142667984156],
						[12.138422011887757, 50.275264734873],
						[12.138688087119784, 50.27565002043099],
						[12.139239310988495, 50.27656936379033],
						[12.139614106047066, 50.27722931861428],
						[12.139832496573426, 50.27745056071623],
						[12.139921187611511, 50.27757643792239],
						[12.139940261874075, 50.27771759071677],
						[12.139888763044516, 50.277854914992545],
						[12.139547348074029, 50.27821350157483],
						[12.13868141103408, 50.27882384432075],
						[12.13777160723174, 50.27940369563867],
						[12.137235640777137, 50.27979277750167],
						[12.136616706896143, 50.280204773504245],
						[12.136003494453579, 50.280811312025904],
						[12.135788918328185, 50.281185159264695],
						[12.135644912498368, 50.28143691760056],
						[12.135669707916252, 50.28214263526737],
						[12.135866165538815, 50.28292465647749],
						[12.135867119069431, 50.28296661648167],
						[12.135884285677722, 50.28346634727687],
						[12.135479927658412, 50.28398514483979],
						[12.134898185640207, 50.28426360979992],
						[12.134104729160033, 50.28454590378383],
						[12.133612632512383, 50.2849616976665],
						[12.133078574806937, 50.28540038683083],
						[12.132117271381123, 50.28571319531002],
						[12.131501198388767, 50.28590012261908],
						[12.131280899611559, 50.2859687870534],
						[12.130572319105227, 50.28624725428129],
						[12.130308151690333, 50.28635407010315],
						[12.129862786162885, 50.28652955056421],
						[12.129567146031505, 50.28675841972194],
						[12.129327774463263, 50.286945347833225],
						[12.128838538392777, 50.28746413337108],
						[12.128302574725007, 50.28785324754385],
						[12.12751770099639, 50.28837586378143],
						[12.126099585770168, 50.28891371849507],
						[12.124977112282965, 50.28944397513793],
						[12.124107361374078, 50.28997040414469],
						[12.123283385652892, 50.29057692811403],
						[12.12279510527884, 50.291126254680485],
						[12.122347831646513, 50.29164504912576],
						[12.122288704749055, 50.292377481557786],
						[12.122312545874621, 50.29308319205687],
						[12.122545242273567, 50.29370117145736],
						[12.122563362635635, 50.294216161968116],
						[12.122459411688252, 50.294895172897995],
						[12.121671677465343, 50.29655457505167],
						[12.12126922598159, 50.29715728652202],
						[12.120821953007258, 50.297679903297016],
						[12.120411873100945, 50.298034670718295],
						[12.120080948645715, 50.29822922645678],
						[12.119750976617574, 50.298477173490994],
						[12.119617461982683, 50.298934934486276],
						[12.119579315850117, 50.299427040178365],
						[12.119742393074086, 50.29990767946045],
						[12.120049476090383, 50.30032348014391],
						[12.120544432927385, 50.30086898030915],
						[12.121167182333224, 50.30139922412392],
						[12.121713638506684, 50.30183792347416],
						[12.122224808498999, 50.30232239650375],
						[12.122429847263945, 50.30296706627561],
						[12.122711180984485, 50.30367659761674],
						[12.122947692999578, 50.30417633205458],
						[12.123457908217256, 50.30463027475121],
						[12.124185562118459, 50.30500411969591],
						[12.124855041997899, 50.3052902278924],
						[12.125543593908647, 50.30561828089759],
						[12.12595939651984, 50.30597686950024],
						[12.12617111238701, 50.306266788451275],
						[12.126179694674017, 50.30641936728177],
						[12.126191139877596, 50.306613929725486],
						[12.126112937230827, 50.30680083421363],
						[12.12596511890902, 50.30715561493541],
						[12.12556076006286, 50.30761718245528],
						[12.124895095310938, 50.30799865126587],
						[12.124098778236059, 50.308341985369175],
						[12.123364449054655, 50.30862045876062],
						[12.122732163283876, 50.30904389364497],
						[12.122200011710596, 50.30957030674428],
						[12.12173366587395, 50.31009293074994],
						[12.121292114655919, 50.31043243869735],
						[12.120487212765198, 50.31052779722941],
						[12.119647025581575, 50.310558313522534],
						[12.118911743918114, 50.31079865376116],
						[12.118342399942405, 50.31115723056531],
						[12.117774009968334, 50.31155777283209],
						[12.117037773950223, 50.31177521700314],
						[12.116523742723329, 50.31188583429216],
						[12.116049766026094, 50.3122024476473],
						[12.115835189979714, 50.31253814883167],
						[12.115229607245613, 50.31281662702884],
						[12.114425658637717, 50.31293105450644],
						[12.11371707836735, 50.313022604302226],
						[12.113241195388023, 50.313301083054334],
						[12.112705620725842, 50.313442723064114],
						[12.149314818955052, 50.31171051048011],
						[12.168538451974557, 50.30297719270479],
						[12.17442956553958, 50.29372711823027],
						[12.17411950638191, 50.276570529855334],
						[12.178046915264195, 50.26876738649396],
						[12.189209025157695, 50.262462872820066],
						[12.203781778238316, 50.25956898120992],
						[12.232513875661171, 50.259103909610076],
						[12.239645223235797, 50.25657176071156],
						[12.242952514939024, 50.25295440629774],
						[12.242728973716149, 50.25096489199228],
						[12.24243574930432, 50.248355195993064],
						[12.240273420146146, 50.24561457592895],
						[12.237991577385728, 50.242722477440346],
						[12.236441284539954, 50.242567451217475],
						[12.235097696534345, 50.242257379635205],
						[12.233754110107474, 50.24168894523733],
						[12.232513874351207, 50.240965467524184],
						[12.229826700935066, 50.239053446250665],
						[12.228896524962297, 50.237038065565116],
						[12.229930053568033, 50.234815974019895],
						[12.232513875838023, 50.23249054965712],
						[12.249980509565667, 50.2211733959983],
						[12.254321330838648, 50.217401030654294],
						[12.258455445293384, 50.21088979437655],
						[12.260212443614225, 50.20505036207093],
						[12.261245971483373, 50.19988270505092],
						[12.273234903791417, 50.17233917059689],
						[12.2833634839833, 50.162210591806435],
						[12.300416707365121, 50.16081533219728],
						[12.314369344062593, 50.16732655971808],
						[12.3143693441772, 50.172834576436834],
						[12.315181731914631, 50.17268371280054],
						[12.316495894802774, 50.17256163881606],
						[12.317384720593937, 50.17233658692073],
						[12.318217277593394, 50.17206192092944],
						[12.31924533902377, 50.17192459776209],
						[12.320171357041923, 50.17194367419693],
						[12.320961951871526, 50.17198180764493],
						[12.321746826868004, 50.17188263738111],
						[12.322750091664542, 50.17181396612493],
						[12.323295594071002, 50.171840677007296],
						[12.323862075798553, 50.172031402504935],
						[12.32480430551083, 50.172168725732014],
						[12.326046944127642, 50.172637944762336],
						[12.326890944727628, 50.17267607831819],
						[12.327893257808412, 50.172554023763645],
						[12.32856559747134, 50.17235183643841],
						[12.329054832783243, 50.17208099737493],
						[12.329151154183414, 50.17202759498692],
						[12.330039978324253, 50.17180252415513],
						[12.331067084700884, 50.171611779409254],
						[12.331961631699098, 50.171546935165416],
						[12.332641601672842, 50.17153549320807],
						[12.333216667120492, 50.1716499322318],
						[12.333572387454565, 50.1716613741945],
						[12.33384323077486, 50.171672816157724],
						[12.334553719163589, 50.17174912182771],
						[12.335329055742886, 50.17210388134106],
						[12.336047173004197, 50.17238998937596],
						[12.336442946660867, 50.172748557344676],
						[12.336941718545763, 50.17298507106832],
						[12.337532044068544, 50.1733818124243],
						[12.335886000971158, 50.17382430324622],
						[12.334945679491181, 50.17413712441885],
						[12.334575652868947, 50.174423215397525],
						[12.333755493664805, 50.17501068689094],
						[12.332658767341186, 50.17548369949965],
						[12.331818580151705, 50.17556762150005],
						[12.330865860131233, 50.175563813927205],
						[12.32991504604635, 50.17557906364542],
						[12.328535079313797, 50.17580794551698],
						[12.327645301417554, 50.17598342435326],
						[12.327527999206911, 50.176078788693225],
						[12.327197074670144, 50.17635726676503],
						[12.327003479239188, 50.17699051172975],
						[12.327194213274975, 50.177684777145764],
						[12.32751274049122, 50.178291313949046],
						[12.327575683565064, 50.178413390783675],
						[12.327626227533413, 50.1790046600294],
						[12.32751464868971, 50.179637911826596],
						[12.327404975381578, 50.17973708522445],
						[12.327067375647513, 50.18004608686571],
						[12.32637405421129, 50.180404666021644],
						[12.326114653763188, 50.18052672448107],
						[12.325515746569668, 50.180809015255406],
						[12.323716163891568, 50.181320193368315],
						[12.323701858602528, 50.181510926233905],
						[12.323682784699777, 50.18176650617506],
						[12.32366180440968, 50.182037355929076],
						[12.326457023611123, 50.18196487415879],
						[12.327719688194733, 50.182525632234466],
						[12.327826499152247, 50.18257140211701],
						[12.328037261854844, 50.18367767210097],
						[12.328230858353006, 50.18468094449483],
						[12.32932090788245, 50.18604278896409],
						[12.336011886757296, 50.1884880084315],
						[12.338219642601596, 50.192478179501556],
						[12.336363792872294, 50.194488530573146],
						[12.334533691752984, 50.19646835724138],
						[12.333968161845453, 50.1970748822243],
						[12.3335237507741, 50.19754791796581],
						[12.332545279700534, 50.199779501843274],
						[12.332352638933338, 50.20018769098897],
						[12.332143783861186, 50.200630191327996],
						[12.328910828183668, 50.201168066565],
						[12.328800200722444, 50.20118712584647],
						[12.328174591153775, 50.20134735209695],
						[12.327241896905884, 50.20158385454957],
						[12.326008797111273, 50.20189667228218],
						[12.325860023678299, 50.203125002058044],
						[12.323054313454298, 50.20745467904373],
						[12.324035644306777, 50.20795821886559],
						[12.32703494947062, 50.210296621863755],
						[12.327015876775947, 50.21232223517584],
						[12.327925681321942, 50.212429038092445],
						[12.327055931239231, 50.21372604539492],
						[12.326759338781903, 50.21450806125318],
						[12.32675361706501, 50.215507515702974],
						[12.32669448831625, 50.216278073777545],
						[12.326762200179203, 50.21687699253772],
						[12.326789855596937, 50.217594142606835],
						[12.326763152808619, 50.21805190733701],
						[12.326520920333946, 50.21865463868112],
						[12.327691077785328, 50.21900558013214],
						[12.32918930019684, 50.21773147193598],
						[12.33132267073842, 50.21740342050849],
						[12.334514618130926, 50.21688080075253],
						[12.334712028219965, 50.217994686698944],
						[12.335036277242255, 50.22020339361049],
						[12.335299492175661, 50.22090149261147],
						[12.334961891815196, 50.22154618042404],
						[12.331855774738054, 50.22319031690774],
						[12.331604004480402, 50.22430802048158],
						[12.329049109785668, 50.2253303456121],
						[12.330786705057047, 50.22744369552461],
						[12.331000328682096, 50.23043061009448],
						[12.331515312892096, 50.23245621524576],
						[12.33269214660173, 50.234256747817845],
						[12.33041286386199, 50.2344436551403],
						[12.327895163854965, 50.23465728033907],
						[12.32880973877538, 50.235820777309],
						[12.332434654873309, 50.23845291866234],
						[12.332392693239452, 50.23990250403446],
						[12.331832737871121, 50.24110566642482],
						[12.333409226620232, 50.24240152391146],
						[12.334519386026898, 50.24225234682903],
						[12.336328506426716, 50.24195861767264],
						[12.337831497835808, 50.241649635034726],
						[12.338670730174936, 50.24146270276885],
						[12.340349197758673, 50.24109268612129],
						[12.341713904990842, 50.24067306126096],
						[12.342808724033537, 50.240169531811425],
						[12.343815803887939, 50.23972320967796],
						[12.34455966872426, 50.239368429924625],
						[12.345567703185537, 50.238952636015625],
						[12.345828057088966, 50.238838204401766],
						[12.346794128795686, 50.23841858341335],
						[12.347842216079018, 50.237857813892106],
						[12.348572731432567, 50.237190251312576],
						[12.349036216818165, 50.23649597261933],
						[12.34989070857936, 50.23771285618088],
						[12.351308823447171, 50.23700715041783],
						[12.355164527129881, 50.23765563094191],
						[12.353834152599669, 50.23841858341335],
						[12.352585793180072, 50.23845291866234],
						[12.351178169097658, 50.239231107874474],
						[12.351143837540047, 50.23925018955278],
						[12.356840132954328, 50.24276732585711],
						[12.357700348244832, 50.24282074367443],
						[12.359299658909944, 50.242317190366634],
						[12.359172821049208, 50.243030548143174],
						[12.358840942643843, 50.243724825973636],
						[12.358170508607685, 50.244331351530555],
						[12.357390404170726, 50.244739537296546],
						[12.356586455745228, 50.245212548618966],
						[12.35609531333348, 50.24581526920466],
						[12.355636596363242, 50.24656295415451],
						[12.355072974925662, 50.247264859402506],
						[12.354689598636838, 50.247962957968824],
						[12.354171752246774, 50.24851607497647],
						[12.353296280062306, 50.24914169488376],
						[12.352683066518484, 50.24989317931551],
						[12.352169989863134, 50.25057601157164],
						[12.351710319174247, 50.25130843722857],
						[12.351296424896502, 50.25189209019344],
						[12.350855826531433, 50.25246047061123],
						[12.350364684875506, 50.2530441263304],
						[12.350105285526096, 50.25353240831661],
						[12.350832938936756, 50.25460052249393],
						[12.351083754655816, 50.25531004904455],
						[12.351300238721318, 50.25609206193606],
						[12.351548195042248, 50.25672912776664],
						[12.351802826297163, 50.257537846008915],
						[12.351791381318657, 50.2581787050392],
						[12.351820945170944, 50.258941643904464],
						[12.352044105700566, 50.25989151195536],
						[12.352068900888117, 50.26053237716726],
						[12.3520164488663, 50.261081694322],
						[12.352116584964723, 50.261745455010534],
						[12.352549553322591, 50.26235962375812],
						[12.353016853976692, 50.26289749879712],
						[12.353932381098167, 50.26350403312836],
						[12.354687691382317, 50.2638244702688],
						[12.355854034903988, 50.26418686460191],
						[12.356575011948735, 50.26457977000573],
						[12.357151985295115, 50.265068055642715],
						[12.357434273049407, 50.26563644731851],
						[12.35787487088208, 50.266464240026416],
						[12.358196258682264, 50.26707840122193],
						[12.358638763503292, 50.267925263310495],
						[12.358992576650687, 50.26842117368229],
						[12.3595304491761, 50.26886368096706],
						[12.360177039359915, 50.269237509881336],
						[12.361126899837515, 50.26976776257604],
						[12.36146831566637, 50.27077484747679],
						[12.359496117067435, 50.27347946655828],
						[12.360189150896856, 50.27434629040956],
						[12.367182657208414, 50.2790509959932],
						[12.373019862325606, 50.28585134036925],
						[12.380063056797619, 50.28773498366803],
						[12.381597518893624, 50.28885269134127],
						[12.384684562621658, 50.28911590506323],
						[12.388799667835219, 50.28944397513793],
						[12.39425659225867, 50.289596562857014],
						[12.396214485033468, 50.291812895195775],
						[12.396703719904815, 50.292022702946035],
						[12.397742271799357, 50.29246521422509],
						[12.398558617329089, 50.292812355246404],
						[12.400566100795903, 50.295207974139345],
						[12.400671005372528, 50.29600906512147],
						[12.400450707020092, 50.29825974120711],
						[12.400896073135472, 50.299198159110226],
						[12.401924133440298, 50.299945832880184],
						[12.403037071196229, 50.30072021448329],
						[12.401509284469668, 50.303443902984746],
						[12.401351928377768, 50.3046150169761],
						[12.399873733774008, 50.30628204633002],
						[12.398663519993885, 50.307605734124074],
						[12.398365975219631, 50.307899484089624],
						[12.398401260556135, 50.309402467861425],
						[12.398446083882284, 50.31127167669909],
						[12.398938179228777, 50.31224060299566],
						[12.39943122859018, 50.313209533153696],
						[12.400265693886062, 50.31484985602561],
						[12.400752068418063, 50.31583405506181],
						[12.400653807789142, 50.31673733923825],
						[12.408937215507164, 50.32199412673906],
						[12.415545341206126, 50.32436746532727],
						[12.436094188653644, 50.33174769214272],
						[12.438289430700886, 50.33253613219417],
						[12.450175008876954, 50.33935741188305],
						[12.45379235914218, 50.3407009916005],
						[12.462784056986813, 50.34049427159089],
						[12.466814817325789, 50.3418895281553],
						[12.468985230703845, 50.345558593169876],
						[12.468365114214507, 50.349485996662445],
						[12.467021524434891, 50.35284494464136],
						[12.466921576917704, 50.35384442251274],
						[12.467332838271378, 50.35402677537364],
						[12.468194960487455, 50.35443114041584],
						[12.46842288823961, 50.35453794733336],
						[12.469427109922192, 50.354991925859444],
						[12.478505132896732, 50.34941480648924],
						[12.47989082431882, 50.348583232163726],
						[12.479983329471862, 50.348159786654804],
						[12.480127333766704, 50.3474960234075],
						[12.481583595837156, 50.3470153871666],
						[12.483070373217554, 50.34692382455436],
						[12.484025956638089, 50.34724046415518],
						[12.484764099445671, 50.3479194677576],
						[12.485118866158002, 50.34842300629933],
						[12.485531807818361, 50.34861756351416],
						[12.485714911156032, 50.34870527760931],
						[12.486474036220143, 50.34890364532977],
						[12.487693787806897, 50.34915162464873],
						[12.488581657613617, 50.349430086519206],
						[12.489306448545157, 50.34981535354667],
						[12.48953437894225, 50.35026551292979],
						[12.489560127504754, 50.35087967195727],
						[12.489675522190723, 50.351623538975275],
						[12.490238190978019, 50.35212327487848],
						[12.490889548012765, 50.35272596871233],
						[12.491334916108269, 50.3533859359256],
						[12.491864205385927, 50.35406876709663],
						[12.492202757694661, 50.35456846915862],
						[12.492220878270919, 50.354595180619036],
						[12.492527963010646, 50.355953230916306],
						[12.492500305416224, 50.35627365382188],
						[12.492012976073564, 50.35660169795129],
						[12.49185085149721, 50.356704695423296],
						[12.491444588322349, 50.35696030353276],
						[12.491297722842882, 50.35744095948778],
						[12.490942955685345, 50.35792923723795],
						[12.490465162769452, 50.35847090086198],
						[12.490197182961813, 50.35903550609028],
						[12.490141869351408, 50.35970307249806],
						[12.489997863177118, 50.360240929629214],
						[12.489725112065997, 50.360698690419575],
						[12.489035608066384, 50.361164111900756],
						[12.48839187608791, 50.36170959323569],
						[12.487792016132078, 50.36233140223985],
						[12.487525939239436, 50.36294936345714],
						[12.487470626216542, 50.36362075115799],
						[12.487498282909614, 50.36425780714885],
						[12.487557410644317, 50.36468505242493],
						[12.487958907419717, 50.365291588034786],
						[12.488248825310896, 50.365924837872534],
						[12.488389969448422, 50.36728287389972],
						[12.488286019932618, 50.36741639935571],
						[12.486464502048529, 50.369762438850444],
						[12.486428261516254, 50.36980820502463],
						[12.486528395781084, 50.3708419707164],
						[12.487921714732114, 50.372184752850195],
						[12.488538741192377, 50.37277983639366],
						[12.488604545595258, 50.37332153322487],
						[12.488732339068681, 50.37437821687853],
						[12.489773750957973, 50.37527085082921],
						[12.490367890812188, 50.37578202873205],
						[12.496297836530323, 50.37919616953201],
						[12.497294424570583, 50.380458816164676],
						[12.498723984343084, 50.38229752235167],
						[12.499611331897041, 50.382939488219016],
						[12.5102230220933, 50.38876007204353],
						[12.550530638854914, 50.396356494226396],
						[12.625358112389431, 50.39992216314419],
						[12.678791542338496, 50.39372098965227],
						[12.691814005887391, 50.394651182756796],
						[12.700356218246288, 50.39991096322927],
						[12.702976114565354, 50.401524145210715],
						[12.706998320568475, 50.40550876874639],
						[12.715452794471156, 50.41388423304959],
						[12.725093628432292, 50.423434962748765],
						[12.732148990435292, 50.42790144401396],
						[12.737909383867255, 50.43154816651641],
						[12.754239135800823, 50.43532053381664],
						[12.77025883103201, 50.4359406652936],
						[12.788138875381575, 50.434338688169504],
						[12.794340046784457, 50.435888974644804],
						[12.802799971824646, 50.4394657681048],
						[12.807603763932146, 50.44149679401264],
						[12.808396036405844, 50.44183176051796],
						[12.817387736229097, 50.44302032749701],
						[12.825759316734917, 50.44141834221727],
						[12.918363484648268, 50.40539987818918],
						[12.942571085842618, 50.4045222609791],
						[12.947975021544005, 50.40432633659034],
						[12.952573283841822, 50.404159657094475],
						[12.960631104456453, 50.409234138721594],
						[12.972686240789168, 50.41682595426845],
						[12.973237036498759, 50.41690443695685],
						[12.97418308231096, 50.417026516868276],
						[12.975401879687487, 50.41722871307277],
						[12.976311682467523, 50.4175262323198],
						[12.976529119998785, 50.41761778276059],
						[12.977272989163787, 50.417934437101735],
						[12.978010178542604, 50.418346415055325],
						[12.978917121747527, 50.41858291475334],
						[12.979729652926673, 50.41870880689232],
						[12.980550767773163, 50.419006366855314],
						[12.980576514519225, 50.41903685792438]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ41",
				"name": " Karlovarský kraj",
				"region": "karlovarsky"
			},
			"id": 4
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[16.56035567900757, 50.15060502439303],
						[16.55814361537634, 50.15068435372921],
						[16.54157257087439, 50.15042114320813],
						[16.537256240492155, 50.15004348453237],
						[16.533433914390663, 50.14939117608019],
						[16.528396606387325, 50.147438048820476],
						[16.525678634084574, 50.14673995493074],
						[16.522449493925723, 50.14661789383675],
						[16.520759582692982, 50.14678573756866],
						[16.51707458512045, 50.14768219130746],
						[16.508840560839573, 50.1506042474163],
						[16.506046295027055, 50.15176010012729],
						[16.501409530704496, 50.15442657526186],
						[16.498123169251556, 50.15554046893421],
						[16.491056442439, 50.15733337555182],
						[16.48477745008247, 50.16034698075281],
						[16.48308372466925, 50.16091537212715],
						[16.47734451274768, 50.16194915606796],
						[16.47160339359357, 50.16237258944512],
						[16.46859168990866, 50.162307737928394],
						[16.465568542419163, 50.161529540488516],
						[16.463302612122476, 50.15998840175452],
						[16.461923598834048, 50.157726284326536],
						[16.460645675384185, 50.15023040535154],
						[16.459745407381618, 50.147872927187095],
						[16.458059310782502, 50.14596557504865],
						[16.450750351163695, 50.14104461851935],
						[16.447429657211398, 50.13995742994965],
						[16.442045211424297, 50.138851162605214],
						[16.43874168435384, 50.13792419772788],
						[16.43389320423325, 50.13565063905502],
						[16.432287216321107, 50.135116578307844],
						[16.42337226843857, 50.13307189736046],
						[16.420503616447153, 50.13190078833829],
						[16.415636062268984, 50.12932586365267],
						[16.39763450600871, 50.122375486407094],
						[16.391550063736986, 50.11919784243425],
						[16.38822174022981, 50.11815261414766],
						[16.381088256665592, 50.116554258779956],
						[16.37289238026089, 50.1132392926582],
						[16.36294174151837, 50.11146926511823],
						[16.35886383093853, 50.11045837724761],
						[16.34832763672652, 50.10657501227333],
						[16.345504761034345, 50.10515594735814],
						[16.34432220439502, 50.104274748064995],
						[16.338867187348416, 50.098266600246895],
						[16.33663177519554, 50.09502029673434],
						[16.33554458644424, 50.09203720320795],
						[16.33411979704297, 50.08460617317338],
						[16.333023071301177, 50.08194351206773],
						[16.332136154115705, 50.08077621408599],
						[16.324434280299617, 50.07478713905859],
						[16.319850921466657, 50.07232284403044],
						[16.315807342363385, 50.069488523945836],
						[16.31116676328165, 50.067054748325006],
						[16.303550720008747, 50.06127548038209],
						[16.302379608142743, 50.05899429311168],
						[16.302202224802137, 50.05777740540025],
						[16.302530288540297, 50.05535888535884],
						[16.303728103488822, 50.053222654951476],
						[16.307104110535914, 50.050327299441065],
						[16.30789375309067, 50.049270630221486],
						[16.308822631659538, 50.04681777800268],
						[16.3088779448048, 50.04411315794546],
						[16.30783462530085, 50.04134368945915],
						[16.305482864488656, 50.03888321017751],
						[16.302146911594452, 50.036933898692276],
						[16.297918319601376, 50.035602568699815],
						[16.2908535002918, 50.034759520833866],
						[16.273319244493155, 50.03408813571275],
						[16.26987266544772, 50.034267425907146],
						[16.266519546438243, 50.03478240905021],
						[16.26113510131901, 50.03591537476151],
						[16.2574195861777, 50.037143707240006],
						[16.24497222885978, 50.043437956502984],
						[16.241168975705776, 50.04500579725143],
						[16.232221603464126, 50.04723358216029],
						[16.226772308379886, 50.04802322414222],
						[16.220945358428406, 50.0479393018692],
						[16.204652786041763, 50.04571151546467],
						[16.200321197440896, 50.04484558044994],
						[16.190206527571576, 50.041870115972294],
						[16.185752868544714, 50.04111480618295],
						[16.178796768295687, 50.040596009241796],
						[16.169557571534703, 50.04063415635993],
						[16.163146972423267, 50.0412521341817],
						[16.159492492883167, 50.04214096251674],
						[16.154487609631882, 50.04430770670349],
						[16.152734756503254, 50.044818878468774],
						[16.14523315420207, 50.045909880757186],
						[16.139259338177283, 50.051116941583054],
						[16.13464546225536, 50.054294588112235],
						[16.125749588114555, 50.05854797452966],
						[16.12144470189402, 50.061408994340425],
						[16.116662978872732, 50.06379318014185],
						[16.112243652230696, 50.066394804911724],
						[16.100538253899888, 50.06971359355025],
						[16.09612274185345, 50.07229614393793],
						[16.09127998378316, 50.074600222044246],
						[16.086719512923285, 50.07716369614526],
						[16.083330154181503, 50.0781936624553],
						[16.073566436514998, 50.08032226339386],
						[16.0683612820695, 50.082744595922534],
						[16.065584183272033, 50.08477020734221],
						[16.061893463321393, 50.08840561077886],
						[16.058029174479405, 50.09153365801406],
						[16.0565414427521, 50.093700407884334],
						[16.05487442068443, 50.0971565292365],
						[16.05329704255037, 50.099296567206736],
						[16.04717636113347, 50.103477478463994],
						[16.04473304701299, 50.10481643259281],
						[16.04079628027997, 50.1058731112043],
						[16.033899306914957, 50.106445309529164],
						[16.006052017137275, 50.106010436350665],
						[15.998924255568221, 50.10621261771405],
						[15.994565010034705, 50.10684204069524],
						[15.992572784221336, 50.10744476138877],
						[15.990795135208092, 50.10833358507513],
						[15.989450454836572, 50.10946273914203],
						[15.987927437352871, 50.11204529273203],
						[15.986023902985654, 50.122318268642694],
						[15.982049941894347, 50.13446807753018],
						[15.979544640040361, 50.13796234532092],
						[15.97586917883224, 50.14133071952851],
						[15.968504905420511, 50.14696883906938],
						[15.959913253722291, 50.15417861883517],
						[15.957096100338777, 50.155559544096555],
						[15.948496818798382, 50.158805849437265],
						[15.942225456400445, 50.16043472434318],
						[15.928544998588421, 50.16191101446529],
						[15.92449855750628, 50.1626129102591],
						[15.922739028114407, 50.163120262526206],
						[15.917651175976298, 50.16526031070947],
						[15.913775444024587, 50.166164398138385],
						[15.909378052811443, 50.166618356530925],
						[15.902384759029689, 50.16658783878309],
						[15.897733689375736, 50.16599656059527],
						[15.895494461958734, 50.16544724310509],
						[15.891723631914282, 50.16392134820943],
						[15.888632774389556, 50.161983490314256],
						[15.883828163651396, 50.15724182578027],
						[15.880106925763737, 50.15404510319268],
						[15.878663063350745, 50.15186691552738],
						[15.87701702127592, 50.14841842737506],
						[15.875441551316285, 50.14628219700461],
						[15.869272231550543, 50.14209365394253],
						[15.866798400464651, 50.14078139889228],
						[15.86274242384472, 50.13973235935338],
						[15.858115196217252, 50.13927841176788],
						[15.840570449733354, 50.138965605833285],
						[15.833538055287915, 50.13833999515713],
						[15.831451416136371, 50.137901307232525],
						[15.82830905935578, 50.13667679023259],
						[15.820537566714258, 50.132278438584095],
						[15.817498207194223, 50.130241394955085],
						[15.814480781795277, 50.12895965791185],
						[15.812528610052212, 50.128494261107946],
						[15.808316231051293, 50.12798309574711],
						[15.801802635220032, 50.12815856957885],
						[15.797702789665738, 50.12910080277921],
						[15.79589176150634, 50.129959103993336],
						[15.794537544711412, 50.13101196702197],
						[15.792878151038423, 50.13340377895858],
						[15.78650379165428, 50.15053558210823],
						[15.784485817370681, 50.160831455134655],
						[15.78293991169486, 50.163436896871325],
						[15.781584740122385, 50.164585117443046],
						[15.779744148071583, 50.16552352741469],
						[15.777677536549778, 50.16617203241825],
						[15.773167610045244, 50.166889189568245],
						[15.765849113618517, 50.167224885415195],
						[15.7558059703047, 50.16702652934485],
						[15.748728752184931, 50.166286468942076],
						[15.74464511905569, 50.16513443300478],
						[15.742165566324477, 50.16376114640413],
						[15.735999107260435, 50.15942001252485],
						[15.734368324656613, 50.15712738375752],
						[15.731645584339981, 50.15055847377952],
						[15.727510452613442, 50.14402771304583],
						[15.724068641556249, 50.136203764910526],
						[15.722208976369295, 50.134254452176464],
						[15.71649646745657, 50.129882811294145],
						[15.714264869327852, 50.128570553376846],
						[15.711597442967959, 50.12772369692147],
						[15.69778346971283, 50.12690352995679],
						[15.694322586418142, 50.12614822711185],
						[15.689271926979526, 50.12405014128045],
						[15.68570899969346, 50.123134613575424],
						[15.67385196728009, 50.121734622955906],
						[15.668804168978983, 50.12160492194419],
						[15.659333228753841, 50.12256240563243],
						[15.655379295420055, 50.12317657534934],
						[15.651870727187465, 50.12410354296012],
						[15.646840096018927, 50.12629318688858],
						[15.64500617961232, 50.12682723820444],
						[15.638501167787645, 50.127746586470266],
						[15.63120555859423, 50.12807464434027],
						[15.620992660444259, 50.128116606956006],
						[15.602934837061925, 50.12779235586298],
						[15.587590217108625, 50.12712478199907],
						[15.584327698172608, 50.12732315443985],
						[15.579669952321098, 50.128196715658326],
						[15.575366020570128, 50.12961578703315],
						[15.571254730017635, 50.13228225519791],
						[15.562548637403598, 50.13685989392018],
						[15.559490203622437, 50.13743209625013],
						[15.556121826696371, 50.13737106800496],
						[15.544635772443696, 50.134712216856514],
						[15.531536102364285, 50.13249969545702],
						[15.527458191269517, 50.13126373611616],
						[15.516953468314474, 50.12739562980776],
						[15.514163970582434, 50.125869747646284],
						[15.512052536081622, 50.124008179357695],
						[15.510457992033214, 50.121440882697144],
						[15.507499694665334, 50.11365890357667],
						[15.504685401446146, 50.109615321627345],
						[15.502621650912571, 50.107864381864786],
						[15.499295235085608, 50.10643768681256],
						[15.491147994772447, 50.10414886270871],
						[15.487590789887687, 50.10236358727445],
						[15.484675407469565, 50.101234436583034],
						[15.475842475985653, 50.099147797496116],
						[15.470932960361823, 50.09692382676384],
						[15.467943191491866, 50.095947265289645],
						[15.466110229900925, 50.09565735238041],
						[15.462271690160303, 50.09553146171151],
						[15.45853519399043, 50.09601974114267],
						[15.45684909768761, 50.096534724250425],
						[15.447905540244573, 50.10145950113845],
						[15.443631172603459, 50.10416412742146],
						[15.43779373206799, 50.10592270245007],
						[15.438025474612973, 50.1183815008368],
						[15.43772792781537, 50.12129592577645],
						[15.436994553072578, 50.12401581232899],
						[15.436361312847014, 50.12526321393419],
						[15.434501648131603, 50.12725830245383],
						[15.428430556844088, 50.13156127556129],
						[15.424410820504535, 50.133506779465975],
						[15.415678977540585, 50.13649749364875],
						[15.411567688275811, 50.137626650589745],
						[15.404763221219008, 50.138462061855],
						[15.388699531513474, 50.138893127058324],
						[15.382581711170621, 50.13968658774015],
						[15.379455566459152, 50.140861511717254],
						[15.372967720498885, 50.1448745770538],
						[15.370998382326645, 50.14690017477661],
						[15.370331763798127, 50.14817046729663],
						[15.369382858173495, 50.15234374905247],
						[15.369347572234036, 50.156749724489394],
						[15.370083808639949, 50.16104125738224],
						[15.37128829993522, 50.16363144265455],
						[15.37325000851825, 50.16559983117353],
						[15.37643718747719, 50.16763305923735],
						[15.379283905815571, 50.16983414418922],
						[15.384918212826632, 50.1729202264617],
						[15.392821311996002, 50.17869567912641],
						[15.394429207218304, 50.18114090305571],
						[15.39541912129769, 50.185478215120284],
						[15.395680426580968, 50.191802969614066],
						[15.395593642785938, 50.20816039670008],
						[15.395284653718535, 50.21286011666513],
						[15.394709587097406, 50.21579742431741],
						[15.393531798442963, 50.21843337212309],
						[15.392594336767567, 50.21957015353599],
						[15.380743980352992, 50.22817230174444],
						[15.379151344790724, 50.23050308677999],
						[15.378343582509489, 50.233196261810036],
						[15.378088951477762, 50.23899841644876],
						[15.378788947926, 50.24326324340933],
						[15.379812240689152, 50.24583435139729],
						[15.38377189718848, 50.25035477441108],
						[15.384766579300537, 50.25256348229499],
						[15.385017395718348, 50.256233221729005],
						[15.383940697546173, 50.26051331325877],
						[15.380106925511347, 50.272731776860454],
						[15.377993583851014, 50.28213882603455],
						[15.376092911330877, 50.28635407010315],
						[15.37381363014054, 50.28881836843282],
						[15.370956421254, 50.29088974324257],
						[15.359145163916303, 50.29650878381231],
						[15.357370377031371, 50.29695511271119],
						[15.353586196399016, 50.29734420318157],
						[15.347964287821858, 50.296852121137285],
						[15.344983100283057, 50.29588698783597],
						[15.340069769985343, 50.29367827610503],
						[15.329964637391498, 50.290824886789295],
						[15.326354027368211, 50.289070134658466],
						[15.323348046025332, 50.28796387339391],
						[15.317543029598133, 50.28692245311611],
						[15.308067321530496, 50.28609847795543],
						[15.30300903388253, 50.286312109515414],
						[15.283732413936516, 50.28902053548643],
						[15.276020049687888, 50.28943633700853],
						[15.252466202614528, 50.28999710850402],
						[15.239580155018114, 50.291389470860175],
						[15.22796821662907, 50.29219818749223],
						[15.223667145427365, 50.29274368888227],
						[15.219834327694711, 50.29378509518673],
						[15.217329025180447, 50.29509353556229],
						[15.212146758910182, 50.29854965096212],
						[15.210230826309141, 50.300712576000045],
						[15.209150315199828, 50.30359268991262],
						[15.20874214178055, 50.30673599295646],
						[15.208930014924372, 50.32018660908385],
						[15.208414078347888, 50.32498169489221],
						[15.207302093446545, 50.327861785340914],
						[15.206342697800192, 50.32913971553399],
						[15.20434474996322, 50.330776219331845],
						[15.19798374066839, 50.33488463347035],
						[15.19470882353352, 50.33600234408684],
						[15.187814712326267, 50.33760833557134],
						[15.181146621161005, 50.340171808944625],
						[15.179179192366806, 50.34068299058457],
						[15.174752233765455, 50.341289505031504],
						[15.16745185981516, 50.34149552589273],
						[15.15990257303239, 50.34111023319965],
						[15.154809951927483, 50.340492249880185],
						[15.15012931630156, 50.34441373939768],
						[15.144501684685642, 50.34790037755932],
						[15.14228439321333, 50.34956741242953],
						[15.131195070123157, 50.36106111253353],
						[15.126383782710104, 50.365131390008344],
						[15.125466345297639, 50.366332994438636],
						[15.1242551819368, 50.3690414574922],
						[15.123224259490717, 50.37493516003986],
						[15.12301921779287, 50.38026046149016],
						[15.123476027877558, 50.38234710170105],
						[15.124200822245504, 50.383552563518165],
						[15.12521171441613, 50.384651172209004],
						[15.127823830958794, 50.386558544821966],
						[15.134881018999966, 50.389816278698376],
						[15.138083457550369, 50.39230346312938],
						[15.139710424332502, 50.39495466292017],
						[15.141765595305053, 50.4020233230327],
						[15.142957688581909, 50.40460206190707],
						[15.14480018711783, 50.40653992586698],
						[15.150643346858836, 50.410835249167945],
						[15.156966209167148, 50.414688108094325],
						[15.158343315923346, 50.416439063767],
						[15.158810615437792, 50.418403624548255],
						[15.158223153200145, 50.42658616071014],
						[15.1575584406279, 50.429504389604425],
						[15.156385422242725, 50.432197575316714],
						[15.15551376494327, 50.43338395562656],
						[15.151060103057683, 50.437595355326955],
						[15.147669792876943, 50.44325638464467],
						[15.143330573433891, 50.447471613101065],
						[15.142493248743863, 50.44865036710012],
						[15.141394615759937, 50.451332097695875],
						[15.13968277062656, 50.46401215384322],
						[15.140724180841788, 50.47434614902682],
						[15.140434266310402, 50.47732163557098],
						[15.139518738717317, 50.480144509249136],
						[15.138714789507537, 50.481441490092976],
						[15.136444093704643, 50.48345567553786],
						[15.125628473236988, 50.48892976570528],
						[15.119347571780068, 50.49313353988163],
						[15.116029740083965, 50.49669647865965],
						[15.11479282444127, 50.49899674061033],
						[15.113697051960695, 50.50223922691442],
						[15.113797186763684, 50.50443266861895],
						[15.114609719213409, 50.50645829068079],
						[15.115898132370413, 50.508491516538484],
						[15.117844582935144, 50.510360730039544],
						[15.120759965242565, 50.51188279352847],
						[15.129677770448215, 50.51554868696315],
						[15.139350889498592, 50.520385727335274],
						[15.144865035141182, 50.51594161187543],
						[15.14777564805367, 50.51397703265903],
						[15.155226707404, 50.51030731150966],
						[15.159473418417862, 50.507415764392725],
						[15.168643950943617, 50.50239562554212],
						[15.171908379847428, 50.50132752609664],
						[15.178926466657144, 50.49968336875548],
						[15.186978341802822, 50.49625398246528],
						[15.195780752868052, 50.494049061060046],
						[15.202152253243021, 50.491111764962234],
						[15.20759296344808, 50.48978041938409],
						[15.211491586631254, 50.48933412343532],
						[15.216732976911079, 50.4891242805953],
						[15.219795225876261, 50.489517201153596],
						[15.222491264132055, 50.49072265431444],
						[15.224427224818308, 50.492752089963844],
						[15.225005150010611, 50.494026185631796],
						[15.226511955985583, 50.50215149588798],
						[15.227041244986387, 50.503425602533106],
						[15.228699683728104, 50.50548553087055],
						[15.234490396177817, 50.5098800804179],
						[15.2371168144227, 50.51116944056936],
						[15.2433309552477, 50.51255798104325],
						[15.248265268320184, 50.51276017972553],
						[15.256895066685496, 50.511398328009804],
						[15.266574858211497, 50.50851820614672],
						[15.270862581017933, 50.50752641296231],
						[15.28463935774305, 50.50595092064574],
						[15.288746835312132, 50.505222334327414],
						[15.297149657966456, 50.501945493448694],
						[15.307546616966182, 50.499347699201],
						[15.311202048510934, 50.497650139706735],
						[15.314300535915805, 50.49658583508253],
						[15.318319319934321, 50.49586867608629],
						[15.32901287213979, 50.494636547932906],
						[15.332778929635515, 50.49376677531543],
						[15.337944984195444, 50.49168014307616],
						[15.339734078010299, 50.49118805437631],
						[15.343745232007723, 50.49050903664932],
						[15.352313042850142, 50.489547740055606],
						[15.35631942552565, 50.48878858689673],
						[15.359418867264049, 50.487647994324185],
						[15.364381788946993, 50.48513029903675],
						[15.378232957580954, 50.47988130157338],
						[15.388932229690392, 50.477439894893116],
						[15.394588469080722, 50.476924883750456],
						[15.400164603342278, 50.47741316983728],
						[15.408139228993608, 50.47946167148679],
						[15.410803794034585, 50.480804435880145],
						[15.41676902703326, 50.48518752439608],
						[15.41854572336582, 50.487281802973285],
						[15.419505119860352, 50.48996353634567],
						[15.419855116141322, 50.49287413052945],
						[15.42012882234853, 50.50517272968973],
						[15.420894623183205, 50.50809479103566],
						[15.422591210027193, 50.51077271063795],
						[15.423632623818705, 50.51170732445549],
						[15.426216124906858, 50.51321410607785],
						[15.429850577643673, 50.514362329207536],
						[15.437288284181822, 50.51601028334171],
						[15.4403381347097, 50.51726913401646],
						[15.442534447793403, 50.518863687692395],
						[15.443519593675068, 50.51997758211312],
						[15.446818350889682, 50.52581023398519],
						[15.448636057127947, 50.52768709199538],
						[15.455673219053672, 50.53277970513129],
						[15.460070610597956, 50.53428268929091],
						[15.464669228377035, 50.53507996304545],
						[15.467965127797246, 50.53505708370306],
						[15.4725370423923, 50.53415681444339],
						[15.47548008033469, 50.5330886902314],
						[15.476786612466507, 50.53234099444418],
						[15.478834150695421, 50.530223832709616],
						[15.48187160487846, 50.52470016442629],
						[15.484221459943484, 50.522251142714495],
						[15.485651968534924, 50.52020643905298],
						[15.487790106271605, 50.512256609223215],
						[15.489286424448185, 50.50971986409134],
						[15.490604399738988, 50.508586875487644],
						[15.492032049626133, 50.50781630156295],
						[15.495688440354492, 50.50674821689681],
						[15.502431870053208, 50.506080632352315],
						[15.509633064578779, 50.50600815096712],
						[15.51686668588079, 50.506286638341194],
						[15.523655889665246, 50.50704573011306],
						[15.52756976940516, 50.50804899859806],
						[15.532629011932299, 50.51040648401196],
						[15.542566301318395, 50.513412492434064],
						[15.54801559463612, 50.51575470108334],
						[15.563043596463286, 50.51505281423052],
						[15.572126387249076, 50.515117633628726],
						[15.576145170423642, 50.51545713815785],
						[15.591666221599477, 50.51777648908543],
						[15.595155715965625, 50.51914215108543],
						[15.597272872210022, 50.52097701388162],
						[15.598969457481278, 50.52392957762813],
						[15.599376677430776, 50.5259971526179],
						[15.59923458267753, 50.52704621864059],
						[15.597978592272888, 50.52999115306035],
						[15.596705436317272, 50.531936642032846],
						[15.591203688137192, 50.536758410016766],
						[15.58845043102506, 50.54126738789056],
						[15.58675479964175, 50.543415076296185],
						[15.582671164936698, 50.546493525544776],
						[15.577791214074027, 50.551456452171685],
						[15.568176270524445, 50.55957795076329],
						[15.565947534816901, 50.562053699737305],
						[15.562994958242975, 50.56711579505697],
						[15.561297417591074, 50.56932831617907],
						[15.558785439299019, 50.57095719063827],
						[15.552609442358028, 50.57287977958672],
						[15.549694059703711, 50.574272141683565],
						[15.5485124566663, 50.575355510707126],
						[15.547100065276448, 50.57790754561565],
						[15.546656608877935, 50.582126620079016],
						[15.547286987049148, 50.58490752945556],
						[15.547923088305273, 50.5862159749684],
						[15.549766540999906, 50.58828735773555],
						[15.552890777473184, 50.59052276508974],
						[15.558054924744923, 50.59532547651702],
						[15.566732404952448, 50.60197447247216],
						[15.569210053872064, 50.60439683238371],
						[15.57016754215237, 50.60571671110119],
						[15.57127189654602, 50.60852050944924],
						[15.5713767997624, 50.61130141521625],
						[15.57107162314438, 50.61262510771429],
						[15.570505141022965, 50.613880146878444],
						[15.568677902530862, 50.61585998810543],
						[15.561708451937896, 50.620677962437775],
						[15.556038855125278, 50.62374495228893],
						[15.55012130749151, 50.62804031477634],
						[15.548261644244569, 50.63006974861035],
						[15.547201154895857, 50.632766708295165],
						[15.54680347356348, 50.635704032837],
						[15.546893119755982, 50.64021301219536],
						[15.54751682428339, 50.64522935268346],
						[15.547311781023614, 50.64730451875742],
						[15.544986728299252, 50.65232470721033],
						[15.54081630968554, 50.65636827893769],
						[15.538964274426855, 50.659984614294835],
						[15.536870958912017, 50.674747489223705],
						[15.534645080037482, 50.68119430070932],
						[15.532746313947056, 50.688564291140565],
						[15.530370716639395, 50.69504932469006],
						[15.529560091342141, 50.699733753984766],
						[15.529277797589206, 50.7045020707912],
						[15.529657361963547, 50.712303144469715],
						[15.530730246034246, 50.716556536058285],
						[15.532151218040179, 50.71894451231506],
						[15.535535810544722, 50.722167952454754],
						[15.53634166578385, 50.723339068444055],
						[15.537371635589764, 50.72602844373904],
						[15.537790302622637, 50.73050311923922],
						[15.536913869410578, 50.735099771565295],
						[15.536230091449145, 50.73658756144431],
						[15.534367562230118, 50.739196785246456],
						[15.52851390693411, 50.745727526162106],
						[15.522152901713692, 50.750507363779974],
						[15.511284826066543, 50.762046795127596],
						[15.507357598179631, 50.76520539066511],
						[15.505545616290178, 50.767055512721015],
						[15.502280236440798, 50.772762308808545],
						[15.497094153732142, 50.77809142509985],
						[15.493471149715432, 50.78590396697982],
						[15.49122619228542, 50.789134943658766],
						[15.490740797047406, 50.78933219717912],
						[15.514278445526603, 50.78410433359324],
						[15.519124652502047, 50.783027956696515],
						[15.521535666507658, 50.78249245771179],
						[15.522128062270175, 50.78236088126365],
						[15.53604769136321, 50.77926920644164],
						[15.641866497478915, 50.75576610703647],
						[15.653235305703758, 50.75096014714523],
						[15.666464474339982, 50.738092729568535],
						[15.673802531802824, 50.73354524287496],
						[15.684344526378727, 50.73142652373424],
						[15.724483796743609, 50.73759214814031],
						[15.738458899265655, 50.739738806426686],
						[15.766411496558648, 50.744032570970184],
						[15.767440230162233, 50.74419060841762],
						[15.773779452026817, 50.74380754888276],
						[15.79224491263821, 50.74269194410244],
						[15.794415325859678, 50.73587069198641],
						[15.797619265756383, 50.72977287208501],
						[15.848158810603243, 50.67515083807528],
						[15.854566691640082, 50.67370392458555],
						[15.872041001375853, 50.67402995044238],
						[15.879108556847276, 50.67416177807745],
						[15.882265253640286, 50.6742206450191],
						[15.89043738415549, 50.67617455299804],
						[15.893025288288284, 50.676793362662224],
						[15.912950813049921, 50.6815574023799],
						[15.92074025659813, 50.683419796419194],
						[15.941486452573383, 50.68838004832138],
						[15.958022909959109, 50.68688142597586],
						[15.971458783711252, 50.678613203482406],
						[15.984481238111773, 50.66290351032758],
						[15.993162882803425, 50.6493643259568],
						[15.997026590138022, 50.639632135352215],
						[15.998640582491207, 50.63556669892979],
						[15.996662721253337, 50.62522787880362],
						[15.99636681909213, 50.623681115462325],
						[15.991937697646875, 50.62138689355539],
						[15.990020606347697, 50.62039389235001],
						[15.982000773132969, 50.616239727153435],
						[15.980037066222575, 50.61298409557072],
						[15.979210244477873, 50.60978015878453],
						[15.979933715541492, 50.60662791470089],
						[15.982000770949918, 50.603630659199005],
						[16.024478800774624, 50.60859162070581],
						[16.025315783467722, 50.60910707091371],
						[16.02634620574418, 50.60914611019181],
						[16.033388139091286, 50.609409343297784],
						[16.040433882671078, 50.60967253777193],
						[16.04004287860319, 50.61417008662067],
						[16.047086715441505, 50.614433286353965],
						[16.049844740922655, 50.61453627763309],
						[16.051303862295736, 50.61458968053611],
						[16.05413245966036, 50.614696486378016],
						[16.0611763010702, 50.61495972561637],
						[16.060783387694986, 50.619457257518434],
						[16.060396192678787, 50.62395475758963],
						[16.06037521145995, 50.62419889489959],
						[16.060331346240154, 50.62471009712828],
						[16.060005188298565, 50.62845230370354],
						[16.059838825257582, 50.630367493264686],
						[16.064320095988585, 50.633127205727654],
						[16.06655031313499, 50.634500651064286],
						[16.086490519158794, 50.64678049936667],
						[16.12865848831554, 50.64404164970995],
						[16.160284464582404, 50.62864206641698],
						[16.17547733419131, 50.624094537067926],
						[16.192323850940625, 50.626575003928785],
						[16.19520015608366, 50.62887850123822],
						[16.200963075489778, 50.633493698386445],
						[16.20110016168987, 50.633603510051344],
						[16.203428269312305, 50.63368607319756],
						[16.20800209185479, 50.6338501096325],
						[16.215049745878876, 50.634101886706105],
						[16.21467590279215, 50.63860320593567],
						[16.221725464731936, 50.638851173158066],
						[16.221349715703795, 50.64335250442162],
						[16.220975874847817, 50.64785002802442],
						[16.22060203944714, 50.652351412901744],
						[16.22056007478733, 50.65284348332166],
						[16.22041129747462, 50.654628726475025],
						[16.220226288391657, 50.65684891216355],
						[16.22147750976155, 50.6568946942225],
						[16.227277759969052, 50.65710071359702],
						[16.227019365861374, 50.660209245304365],
						[16.23201135629564, 50.66088820063514],
						[16.268288205383623, 50.66042305373471],
						[16.300947713914642, 50.655100402273874],
						[16.331643514319563, 50.64404164970995],
						[16.416806275828193, 50.58662913700474],
						[16.425116887845633, 50.5692051859255],
						[16.42590132560088, 50.567560523622376],
						[16.40454456056309, 50.561975442017236],
						[16.394482054160306, 50.55934395839896],
						[16.398306109124523, 50.55179919909371],
						[16.398306109955016, 50.5484919141357],
						[16.39551558318665, 50.545701389098255],
						[16.391174762626008, 50.53991362333539],
						[16.3896244705208, 50.53484934093059],
						[16.38828088451181, 50.527149561347244],
						[16.38835659877651, 50.52283395181805],
						[16.38838423626485, 50.521258436752895],
						[16.391174764268648, 50.521826886281154],
						[16.382596475253624, 50.51417876565301],
						[16.366807592620617, 50.504221450892665],
						[16.366514832010466, 50.504036844651196],
						[16.362029254022044, 50.501207971151075],
						[16.360138353679954, 50.49951448349328],
						[16.359895340481525, 50.49929685082888],
						[16.353126526824163, 50.49906540722692],
						[16.346097944233197, 50.498821242055094],
						[16.33906936599362, 50.49858092867961],
						[16.337133406905426, 50.498512262201594],
						[16.33204269537043, 50.498336802905015],
						[16.331733702518356, 50.502181997491775],
						[16.331680297884187, 50.502834320346246],
						[16.32816123799038, 50.50271223581243],
						[16.324651719405015, 50.50259019024589],
						[16.31762313639868, 50.50234602148871],
						[16.317331314617693, 50.50592804408325],
						[16.317258835580883, 50.50684738792792],
						[16.312723160881113, 50.506687173626545],
						[16.310230256622795, 50.506603253745],
						[16.307407377403287, 50.50650404390899],
						[16.303201673366598, 50.50635526813768],
						[16.303321837317107, 50.50488661812091],
						[16.303567886932893, 50.50185776252965],
						[16.30381202552828, 50.498813616760565],
						[16.30392837490047, 50.49735641185617],
						[16.30478859174469, 50.49738695175504],
						[16.31095886441669, 50.49760438816624],
						[16.31119572870084, 50.49466222449945],
						[16.30342818385738, 50.49604035988012],
						[16.28771854712515, 50.49278473007078],
						[16.28187585175668, 50.48304689287129],
						[16.279967082381724, 50.47986562427043],
						[16.264980917084394, 50.47164906872364],
						[16.247410928047874, 50.46498280081951],
						[16.232011351058407, 50.456766247899296],
						[16.226533650686417, 50.45537098930036],
						[16.22295224615904, 50.45392233278739],
						[16.217335244304802, 50.451650274400286],
						[16.211237429099715, 50.45128857208893],
						[16.2122444765351, 50.448985187964695],
						[16.209291457198155, 50.448879233914],
						[16.20226859907361, 50.448623645241234],
						[16.202413559928598, 50.44688416362451],
						[16.202642440921732, 50.44412613023533],
						[16.197340010602037, 50.44393538570754],
						[16.195623397740324, 50.44387435838132],
						[16.195817949106427, 50.44153214983758],
						[16.1959991440324, 50.43937300362803],
						[16.19624171429359, 50.43645512203886],
						[16.190153444494218, 50.42415843990426],
						[16.199558554394926, 50.40627839304851],
						[16.23201135038415, 50.40260934106716],
						[16.2449304604881, 50.37682281920877],
						[16.24968469354693, 50.37103506834032],
						[16.262500445937366, 50.364420454219655],
						[16.269838501174345, 50.365454002501316],
						[16.276969850015142, 50.369433093739794],
						[16.280566092356327, 50.37018098386169],
						[16.28598848300965, 50.37130865597444],
						[16.288648719815225, 50.37186185920293],
						[16.334227332809114, 50.37186185920293],
						[16.343735800000875, 50.369949858582075],
						[16.350763795465184, 50.36064810456308],
						[16.351487262224705, 50.35134631877132],
						[16.350660443107778, 50.34225130008771],
						[16.35324426166935, 50.33351795357729],
						[16.37102095627317, 50.31837677234311],
						[16.415566039262448, 50.307938124685826],
						[16.43778690647283, 50.29796458404379],
						[16.452152955103145, 50.28499380443128],
						[16.47757775890695, 50.255331522204415],
						[16.49204716051971, 50.242722477440346],
						[16.50475956253418, 50.22799468701938],
						[16.535041951580205, 50.20773752541573],
						[16.545894002125227, 50.18882394753152],
						[16.55726281690399, 50.154717509179],
						[16.56035567900757, 50.15060502439303]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ52",
				"name": " Královéhradecký kraj",
				"region": "kralovehradecky"
			},
			"id": 5
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[14.468014718374594, 50.497543347221466],
						[14.466141699052748, 50.50071714678545],
						[14.463054658325806, 50.503334058353985],
						[14.460000038893229, 50.50462723497415],
						[14.452761649470963, 50.50633239153667],
						[14.44947910334517, 50.507396700474104],
						[14.442976951369143, 50.51142883078906],
						[14.440956114228658, 50.5129890297771],
						[14.439361573841564, 50.51539231866789],
						[14.437000274285305, 50.523536678531954],
						[14.435503004176908, 50.525924665212415],
						[14.428048134050622, 50.53202057078265],
						[14.424963950959908, 50.53409957740168],
						[14.423087121417144, 50.535873426217655],
						[14.41970443576069, 50.54150389182248],
						[14.414465903257721, 50.546737661460014],
						[14.411256788805526, 50.55248640659525],
						[14.406027793286245, 50.55773543734233],
						[14.402783392685015, 50.56346129237297],
						[14.397542000367777, 50.56870270307063],
						[14.394295691330884, 50.574432362304655],
						[14.389891623410193, 50.5786323446919],
						[14.385800360722744, 50.5853843601068],
						[14.381380080578262, 50.58955764192657],
						[14.379820825234495, 50.59169770798186],
						[14.377283095972672, 50.59628295569343],
						[14.372135160423257, 50.60164640470035],
						[14.360277176662054, 50.62918473022398],
						[14.359429361369255, 50.630294818466346],
						[14.35473346664599, 50.63462447679804],
						[14.351184844731005, 50.63943862683551],
						[14.348133087792366, 50.642921453876475],
						[14.353676795610065, 50.64651488920661],
						[14.359752654192683, 50.64958571580715],
						[14.363946911493077, 50.652481048443576],
						[14.368513108781888, 50.65498734948799],
						[14.375357631842732, 50.660076179630444],
						[14.377256393333697, 50.66199493313006],
						[14.37856578634721, 50.664455395317695],
						[14.382129667765142, 50.67495726168758],
						[14.382767678455412, 50.679874431209235],
						[14.383262637007016, 50.689895656123916],
						[14.384128574108866, 50.69475940303608],
						[14.387037278906554, 50.70369722077343],
						[14.388315197469106, 50.70616909637507],
						[14.389273646130226, 50.707271601243875],
						[14.395483017407315, 50.71126938287959],
						[14.397976874229798, 50.7123222247886],
						[14.399486544543752, 50.71264269649696],
						[14.401061058017467, 50.712783813216724],
						[14.404244424564963, 50.712612167946126],
						[14.412594795637906, 50.71060562527558],
						[14.41732216176744, 50.71045306175287],
						[14.420191764959508, 50.71104049805144],
						[14.423787117354268, 50.712360385430976],
						[14.43192863287423, 50.714450819246714],
						[14.435050965735662, 50.716003431174],
						[14.436250685246529, 50.71717451664387],
						[14.43704605235249, 50.71846772509652],
						[14.43776226040667, 50.721229552931916],
						[14.43736457749388, 50.72544478649778],
						[14.436269758572156, 50.72802732883439],
						[14.435441970312326, 50.72914504514374],
						[14.432916644823791, 50.73138812636004],
						[14.431484221549242, 50.73322676786995],
						[14.430785182470082, 50.735557588016405],
						[14.430950163276602, 50.73798750379051],
						[14.431391714759066, 50.73915480377569],
						[14.432954792277798, 50.74106220321294],
						[14.43945312532508, 50.746070864920924],
						[14.442598343570893, 50.74808121372573],
						[14.444553371333473, 50.74981685718908],
						[14.44809627736165, 50.755374927841736],
						[14.452301982946794, 50.759658850508636],
						[14.453126910917023, 50.760902438823265],
						[14.454410555614274, 50.76523592601302],
						[14.454543116823514, 50.77164843667981],
						[14.453912736683424, 50.776527420970844],
						[14.451752659119068, 50.78439709150987],
						[14.451699260335301, 50.78694156108639],
						[14.452642437926391, 50.790508242924496],
						[14.45475769396547, 50.795051608382956],
						[14.456456188232568, 50.797130621333125],
						[14.4586057678465, 50.79882813975643],
						[14.461553572922188, 50.80029677691662],
						[14.465071678926375, 50.801059730177215],
						[14.46688080234482, 50.80110172267295],
						[14.470184327593483, 50.800537122897936],
						[14.475730893196076, 50.79758450706454],
						[14.494611738349603, 50.78984449619346],
						[14.49930381502915, 50.78720090189967],
						[14.50262832972621, 50.78612902923692],
						[14.509702685077624, 50.784484887794754],
						[14.51607513471742, 50.781612400415575],
						[14.519743919918467, 50.780654912406256],
						[14.52619171472003, 50.77997210765598],
						[14.535482408273072, 50.77982713362199],
						[14.542499542961403, 50.78029633255135],
						[14.547042848562139, 50.78115465039439],
						[14.55113506044686, 50.782638524014736],
						[14.55475139428565, 50.78453825112499],
						[14.559435840603163, 50.78787609303476],
						[14.561938283109471, 50.79039761833938],
						[14.564008716361323, 50.794281039822465],
						[14.565542224280815, 50.802253753490064],
						[14.56647777411864, 50.80491255339122],
						[14.5672302264454, 50.806091325936706],
						[14.570496561697977, 50.80936815767013],
						[14.574415205624074, 50.816078173905275],
						[14.576386455548134, 50.817886388649505],
						[14.583998682497393, 50.822547935063106],
						[14.587250705909598, 50.82360836427352],
						[14.594170571022792, 50.82524490968053],
						[14.596917152342941, 50.82644271792317],
						[14.604643819003414, 50.831165288185346],
						[14.609726904163466, 50.835731490737146],
						[14.614385607210707, 50.83858110732497],
						[14.617878910417216, 50.839996305342694],
						[14.627338533463659, 50.84305418140996],
						[14.647921995613896, 50.83937854799509],
						[14.662184692741766, 50.834365952953085],
						[14.700425255897585, 50.81596917346969],
						[14.737528935007727, 50.81069817841407],
						[14.75923303382967, 50.81018139305582],
						[14.77535607600129, 50.8129718760785],
						[14.78507124456988, 50.82005154309251],
						[14.788089365715596, 50.82372578314392],
						[14.794579713440717, 50.83162710938532],
						[14.810392701669292, 50.85844717947565],
						[14.819094254853574, 50.858257115135764],
						[14.831683393722798, 50.857982110465805],
						[14.867856896070684, 50.86438998235245],
						[14.982061804175597, 50.85906724694848],
						[14.984128864519137, 50.86769724159459],
						[14.98397443645147, 50.87202132028826],
						[14.98624038786575, 50.87212754122697],
						[14.992436409159872, 50.872421266142595],
						[14.993316646802606, 50.87246319347554],
						[15.000395774894862, 50.872795105470985],
						[14.999896998922857, 50.87728496477596],
						[14.999400140163806, 50.88177872901147],
						[14.998899459100445, 50.88627242366739],
						[14.998401639975889, 50.89076612670158],
						[14.997902867621391, 50.895256019105624],
						[14.997401235632076, 50.89974973889617],
						[14.996902465590587, 50.90424346713824],
						[15.002952577653389, 50.904525774830795],
						[15.003986358466129, 50.90457534628855],
						[15.003486635879122, 50.90906527013146],
						[15.003436091379333, 50.909523035984435],
						[15.002989767203113, 50.9135589437162],
						[14.995903965582622, 50.91322705180261],
						[14.995402337302107, 50.91772080547074],
						[14.99147033847623, 50.917533888786465],
						[14.988319395542499, 50.91738508824696],
						[14.987990851911206, 50.92032830102728],
						[14.99467085531149, 50.925109746578435],
						[14.99777144033775, 50.93017401856694],
						[14.997724351263592, 50.931377118920615],
						[15.000990865761223, 50.93152998186287],
						[15.000616074066228, 50.93490601003721],
						[15.000492093873824, 50.93601987853921],
						[15.002491000405461, 50.936115293094595],
						[15.007579806948495, 50.93635562257658],
						[15.007082935503107, 50.94084545626274],
						[15.014170648785067, 50.94117738746523],
						[15.013671872189164, 50.94567105592554],
						[15.013175012449889, 50.95016481103947],
						[15.012803081094084, 50.95351031536748],
						[15.0126762371818, 50.954654676912384],
						[15.012177463446918, 50.95914837146136],
						[15.011677745559494, 50.96364215274177],
						[15.011178973146437, 50.96813204462885],
						[15.016378401583534, 50.9683761494124],
						[15.01794815249325, 50.96844865583309],
						[15.018271441953402, 50.96846385879514],
						[15.017990111923629, 50.97100448261572],
						[15.017773625485498, 50.97295758606169],
						[15.017274855691321, 50.977447501793634],
						[15.01333046302663, 50.97726443553412],
						[15.010180469564906, 50.97711559684589],
						[15.009680746981283, 50.981609335337566],
						[15.009424206589788, 50.98391720897575],
						[15.009181979049783, 50.98610308272064],
						[15.009043691724075, 50.98735044731665],
						[15.00868320288278, 50.99059294045301],
						[15.006613730551916, 50.9904975815351],
						[15.001583101213324, 50.99026109470637],
						[14.994488713078363, 50.9899291714626],
						[14.98739147253294, 50.98959732666396],
						[14.987474444815481, 50.98885348454661],
						[14.987893102634864, 50.985103589692365],
						[14.980797770190707, 50.98477175178416],
						[14.980307578671518, 50.98913573882233],
						[14.980294231391417, 50.98926166176588],
						[14.979277606837423, 50.98921581489062],
						[14.973196982396262, 50.988929739949725],
						[14.972940440782658, 50.99123378770406],
						[14.972695351204512, 50.9934196523015],
						[14.972191814290214, 50.99791339417566],
						[14.979289056142935, 50.99824525085424],
						[14.979008741855543, 51.00076117031993],
						[14.982061808861792, 51.001177477852295],
						[14.996531208381203, 51.00784372436715],
						[15.001182088730648, 51.012442938645584],
						[15.001311873927808, 51.01282628209762],
						[15.006182671503518, 51.01305390231931],
						[15.005679133523314, 51.01754763441723],
						[15.00910507465618, 51.01770765022172],
						[15.022989543637204, 51.009652410787666],
						[15.073632443163179, 51.0026243843078],
						[15.082107383851751, 50.99275423782207],
						[15.093889608279968, 50.985416169583885],
						[15.107945594354973, 50.98102363807817],
						[15.119211056008007, 50.982470574962164],
						[15.122518349660057, 50.99265084689871],
						[15.122518353859371, 50.99275423782207],
						[15.122575817337971, 50.99283774590911],
						[15.12273788333353, 50.991352070569114],
						[15.129835131448903, 50.99167635461945],
						[15.136932370976188, 50.99200056115061],
						[15.144031526543863, 50.9923248461061],
						[15.143544199114297, 50.99681474610223],
						[15.136445043515511, 50.9964942755709],
						[15.135958670051043, 51.00098417819537],
						[15.13581371473848, 51.002323165649216],
						[15.135471344574508, 51.00547791050689],
						[15.135253927016912, 51.00749064422188],
						[15.141512406390886, 51.01026937141489],
						[15.142064058131213, 51.010514300248175],
						[15.144429157958708, 51.01156443262714],
						[15.156108031374567, 51.00784372436715],
						[15.160758909656746, 50.99265084689871],
						[15.170164017860818, 50.97797471471405],
						[15.227111452703651, 50.977406335262756],
						[15.253776487019184, 50.969034711247666],
						[15.269796184643921, 50.95265331472604],
						[15.268762659024464, 50.94298984306795],
						[15.26008101136079, 50.93249946732284],
						[15.253053020169316, 50.91410269250201],
						[15.25605025271191, 50.89989166939563],
						[15.265352013502742, 50.88227003147665],
						[15.277134238444512, 50.86573356296493],
						[15.287779581239759, 50.8548814921534],
						[15.307726682637679, 50.844752888796975],
						[15.325813433354698, 50.839688595279966],
						[15.341006303773606, 50.83173042904926],
						[15.35299523588401, 50.8129718760785],
						[15.353305299698164, 50.80325675022164],
						[15.350514768642118, 50.79323149382],
						[15.349687951999199, 50.78372307888488],
						[15.356095825431854, 50.77545481787369],
						[15.368578785019565, 50.77294911017466],
						[15.370255165477742, 50.77261258738679],
						[15.379928844907456, 50.77907679120271],
						[15.380108829682579, 50.77731319990188],
						[15.380133626161353, 50.777080511845824],
						[15.3804969771534, 50.77709578028838],
						[15.38494587262422, 50.77728655800368],
						[15.387200357028064, 50.777385725084514],
						[15.389645576839813, 50.777492526441335],
						[15.394267079238462, 50.77769086081811],
						[15.401331903120253, 50.777999891972726],
						[15.400874141784286, 50.78249362624185],
						[15.400802614956618, 50.78318788992878],
						[15.40041637261241, 50.78698729043103],
						[15.404902453859691, 50.78718181552787],
						[15.407484058597289, 50.78729251650576],
						[15.414553643260568, 50.7875976650724],
						[15.414097783910377, 50.79209516610968],
						[15.413656237020232, 50.796455403654264],
						[15.413641933874612, 50.79658893564568],
						[15.413823123883022, 50.79659649259263],
						[15.420709612536776, 50.7968940962629],
						[15.420488651741525, 50.79907214588959],
						[15.44177534788158, 50.80020780611646],
						[15.477982979689289, 50.79216582611931],
						[15.484979469439601, 50.7906118561394],
						[15.490740797047406, 50.78933219717912],
						[15.49122619228542, 50.789134943658766],
						[15.493471149715432, 50.78590396697982],
						[15.497094153732142, 50.77809142509985],
						[15.502280236440798, 50.772762308808545],
						[15.505545616290178, 50.767055512721015],
						[15.507357598179631, 50.76520539066511],
						[15.511284826066543, 50.762046795127596],
						[15.522152901713692, 50.750507363779974],
						[15.52851390693411, 50.745727526162106],
						[15.534367562230118, 50.739196785246456],
						[15.536230091449145, 50.73658756144431],
						[15.536913869410578, 50.735099771565295],
						[15.537790302622637, 50.73050311923922],
						[15.537371635589764, 50.72602844373904],
						[15.53634166578385, 50.723339068444055],
						[15.535535810544722, 50.722167952454754],
						[15.532151218040179, 50.71894451231506],
						[15.530730246034246, 50.716556536058285],
						[15.529657361963547, 50.712303144469715],
						[15.529277797589206, 50.7045020707912],
						[15.529560091342141, 50.699733753984766],
						[15.530370716639395, 50.69504932469006],
						[15.532746313947056, 50.688564291140565],
						[15.534645080037482, 50.68119430070932],
						[15.536870958912017, 50.674747489223705],
						[15.538964274426855, 50.659984614294835],
						[15.54081630968554, 50.65636827893769],
						[15.544986728299252, 50.65232470721033],
						[15.547311781023614, 50.64730451875742],
						[15.54751682428339, 50.64522935268346],
						[15.546893119755982, 50.64021301219536],
						[15.54680347356348, 50.635704032837],
						[15.547201154895857, 50.632766708295165],
						[15.548261644244569, 50.63006974861035],
						[15.55012130749151, 50.62804031477634],
						[15.556038855125278, 50.62374495228893],
						[15.561708451937896, 50.620677962437775],
						[15.568677902530862, 50.61585998810543],
						[15.570505141022965, 50.613880146878444],
						[15.57107162314438, 50.61262510771429],
						[15.5713767997624, 50.61130141521625],
						[15.57127189654602, 50.60852050944924],
						[15.57016754215237, 50.60571671110119],
						[15.569210053872064, 50.60439683238371],
						[15.566732404952448, 50.60197447247216],
						[15.558054924744923, 50.59532547651702],
						[15.552890777473184, 50.59052276508974],
						[15.549766540999906, 50.58828735773555],
						[15.547923088305273, 50.5862159749684],
						[15.547286987049148, 50.58490752945556],
						[15.546656608877935, 50.582126620079016],
						[15.547100065276448, 50.57790754561565],
						[15.5485124566663, 50.575355510707126],
						[15.549694059703711, 50.574272141683565],
						[15.552609442358028, 50.57287977958672],
						[15.558785439299019, 50.57095719063827],
						[15.561297417591074, 50.56932831617907],
						[15.562994958242975, 50.56711579505697],
						[15.565947534816901, 50.562053699737305],
						[15.568176270524445, 50.55957795076329],
						[15.577791214074027, 50.551456452171685],
						[15.582671164936698, 50.546493525544776],
						[15.58675479964175, 50.543415076296185],
						[15.58845043102506, 50.54126738789056],
						[15.591203688137192, 50.536758410016766],
						[15.596705436317272, 50.531936642032846],
						[15.597978592272888, 50.52999115306035],
						[15.59923458267753, 50.52704621864059],
						[15.599376677430776, 50.5259971526179],
						[15.598969457481278, 50.52392957762813],
						[15.597272872210022, 50.52097701388162],
						[15.595155715965625, 50.51914215108543],
						[15.591666221599477, 50.51777648908543],
						[15.576145170423642, 50.51545713815785],
						[15.572126387249076, 50.515117633628726],
						[15.563043596463286, 50.51505281423052],
						[15.54801559463612, 50.51575470108334],
						[15.542566301318395, 50.513412492434064],
						[15.532629011932299, 50.51040648401196],
						[15.52756976940516, 50.50804899859806],
						[15.523655889665246, 50.50704573011306],
						[15.51686668588079, 50.506286638341194],
						[15.509633064578779, 50.50600815096712],
						[15.502431870053208, 50.506080632352315],
						[15.495688440354492, 50.50674821689681],
						[15.492032049626133, 50.50781630156295],
						[15.490604399738988, 50.508586875487644],
						[15.489286424448185, 50.50971986409134],
						[15.487790106271605, 50.512256609223215],
						[15.485651968534924, 50.52020643905298],
						[15.484221459943484, 50.522251142714495],
						[15.48187160487846, 50.52470016442629],
						[15.478834150695421, 50.530223832709616],
						[15.476786612466507, 50.53234099444418],
						[15.47548008033469, 50.5330886902314],
						[15.4725370423923, 50.53415681444339],
						[15.467965127797246, 50.53505708370306],
						[15.464669228377035, 50.53507996304545],
						[15.460070610597956, 50.53428268929091],
						[15.455673219053672, 50.53277970513129],
						[15.448636057127947, 50.52768709199538],
						[15.446818350889682, 50.52581023398519],
						[15.443519593675068, 50.51997758211312],
						[15.442534447793403, 50.518863687692395],
						[15.4403381347097, 50.51726913401646],
						[15.437288284181822, 50.51601028334171],
						[15.429850577643673, 50.514362329207536],
						[15.426216124906858, 50.51321410607785],
						[15.423632623818705, 50.51170732445549],
						[15.422591210027193, 50.51077271063795],
						[15.420894623183205, 50.50809479103566],
						[15.42012882234853, 50.50517272968973],
						[15.419855116141322, 50.49287413052945],
						[15.419505119860352, 50.48996353634567],
						[15.41854572336582, 50.487281802973285],
						[15.41676902703326, 50.48518752439608],
						[15.410803794034585, 50.480804435880145],
						[15.408139228993608, 50.47946167148679],
						[15.400164603342278, 50.47741316983728],
						[15.394588469080722, 50.476924883750456],
						[15.388932229690392, 50.477439894893116],
						[15.378232957580954, 50.47988130157338],
						[15.364381788946993, 50.48513029903675],
						[15.359418867264049, 50.487647994324185],
						[15.35631942552565, 50.48878858689673],
						[15.352313042850142, 50.489547740055606],
						[15.343745232007723, 50.49050903664932],
						[15.339734078010299, 50.49118805437631],
						[15.337944984195444, 50.49168014307616],
						[15.332778929635515, 50.49376677531543],
						[15.32901287213979, 50.494636547932906],
						[15.318319319934321, 50.49586867608629],
						[15.314300535915805, 50.49658583508253],
						[15.311202048510934, 50.497650139706735],
						[15.307546616966182, 50.499347699201],
						[15.297149657966456, 50.501945493448694],
						[15.288746835312132, 50.505222334327414],
						[15.28463935774305, 50.50595092064574],
						[15.270862581017933, 50.50752641296231],
						[15.266574858211497, 50.50851820614672],
						[15.256895066685496, 50.511398328009804],
						[15.248265268320184, 50.51276017972553],
						[15.2433309552477, 50.51255798104325],
						[15.2371168144227, 50.51116944056936],
						[15.234490396177817, 50.5098800804179],
						[15.228699683728104, 50.50548553087055],
						[15.227041244986387, 50.503425602533106],
						[15.226511955985583, 50.50215149588798],
						[15.225005150010611, 50.494026185631796],
						[15.224427224818308, 50.492752089963844],
						[15.222491264132055, 50.49072265431444],
						[15.219795225876261, 50.489517201153596],
						[15.216732976911079, 50.4891242805953],
						[15.211491586631254, 50.48933412343532],
						[15.20759296344808, 50.48978041938409],
						[15.202152253243021, 50.491111764962234],
						[15.195780752868052, 50.494049061060046],
						[15.186978341802822, 50.49625398246528],
						[15.178926466657144, 50.49968336875548],
						[15.171908379847428, 50.50132752609664],
						[15.168643950943617, 50.50239562554212],
						[15.159473418417862, 50.507415764392725],
						[15.155226707404, 50.51030731150966],
						[15.14777564805367, 50.51397703265903],
						[15.144865035141182, 50.51594161187543],
						[15.139350889498592, 50.520385727335274],
						[15.131691930690932, 50.52170560915368],
						[15.1232357029938, 50.52280426466543],
						[15.119397163807907, 50.52360916521513],
						[15.116378784944901, 50.524864203824215],
						[15.110019684672606, 50.52902985388128],
						[15.10814666679802, 50.53107070294],
						[15.107496260293404, 50.53234862080491],
						[15.105452535519138, 50.54054639865215],
						[15.104312896482979, 50.54288863909578],
						[15.101792334557517, 50.54593276099946],
						[15.10112190077576, 50.54874037139603],
						[15.086388588421103, 50.55418777898471],
						[15.074391365456105, 50.5593223609114],
						[15.068056104508216, 50.561767559127865],
						[15.06201744094399, 50.565181733544215],
						[15.052590371555052, 50.56930924733033],
						[15.043670654146057, 50.574565886057194],
						[15.022555352051853, 50.588268287372735],
						[15.016974449007977, 50.59128951887809],
						[15.01292705426125, 50.592929829937574],
						[15.00382614041106, 50.59514998514054],
						[14.99799442454727, 50.59614183031497],
						[14.991041183049045, 50.59658813085275],
						[14.972209931448667, 50.59709168434156],
						[14.967670438711437, 50.597621899525144],
						[14.958662984883407, 50.599552137172225],
						[14.955018995442739, 50.60056303307866],
						[14.951148988146956, 50.60208512587511],
						[14.938461305319207, 50.6083526760696],
						[14.92686367168047, 50.612197888348504],
						[14.917695999009206, 50.61594390742473],
						[14.912732122863474, 50.60871504374175],
						[14.910776138029366, 50.606689450552864],
						[14.907258988503001, 50.60401917505737],
						[14.905559540991247, 50.602096568755435],
						[14.904527664357886, 50.59972381753246],
						[14.903046608195375, 50.59338760584799],
						[14.901990890275462, 50.59103774812484],
						[14.90115165748801, 50.589992526765776],
						[14.899124147461382, 50.58843995961208],
						[14.892778398339724, 50.584369675587325],
						[14.889470102157313, 50.58330156055435],
						[14.88407230235286, 50.58221052752771],
						[14.880727769459174, 50.58125306589682],
						[14.875894546768984, 50.57876205687208],
						[14.866310121061026, 50.57520676997469],
						[14.85815525151118, 50.57177735274584],
						[14.85558223751239, 50.57032013190732],
						[14.853603361259934, 50.56816099411336],
						[14.85025310515207, 50.56255340565395],
						[14.847657202365307, 50.560203539988464],
						[14.846131324090134, 50.55827330907986],
						[14.8452024453202, 50.55589293811838],
						[14.843788147575456, 50.54950714676032],
						[14.842740059425779, 50.54715729253444],
						[14.841923714398472, 50.546115881939585],
						[14.837948799279847, 50.54320907730112],
						[14.834292413377476, 50.5401344446878],
						[14.82985973189777, 50.5373840174034],
						[14.824904441740989, 50.53251647862258],
						[14.820622445940135, 50.52910234222617],
						[14.809084893362773, 50.521465311760565],
						[14.803885458657257, 50.51865385793843],
						[14.796310423155747, 50.51554106113699],
						[14.791480065249463, 50.51302338453847],
						[14.787798881050618, 50.51207732701881],
						[14.783599852711548, 50.5116004868079],
						[14.77677917456397, 50.51134872209522],
						[14.740646361698307, 50.511596673957506],
						[14.733974455760663, 50.51120375616355],
						[14.729995725848864, 50.51049803088944],
						[14.726956367108773, 50.50928496951222],
						[14.723761560347992, 50.50728990365213],
						[14.71914863779509, 50.50483323971531],
						[14.715443612423872, 50.501770031642685],
						[14.711396216034784, 50.49888609597311],
						[14.70983505229574, 50.49671172911453],
						[14.707703589276733, 50.49217604532596],
						[14.704345701896353, 50.48864363458827],
						[14.703851698653825, 50.48704146224128],
						[14.688124657915274, 50.48301316483115],
						[14.679433823556732, 50.479702004638554],
						[14.675325392894845, 50.478973381239264],
						[14.659269332196118, 50.47728728591695],
						[14.64089870440979, 50.47396469002771],
						[14.635886191730958, 50.47336577805763],
						[14.62811184133024, 50.47290422474134],
						[14.599124906540007, 50.472240429767766],
						[14.59607314866809, 50.47254179028027],
						[14.592082975877739, 50.47404478625319],
						[14.584689141455561, 50.480140696898225],
						[14.583885191159375, 50.48139189036691],
						[14.583005903403103, 50.48416136023196],
						[14.582475663759007, 50.49316789180096],
						[14.581905364090398, 50.496013632755265],
						[14.580298422925592, 50.498588553966776],
						[14.577972411309082, 50.50011443326671],
						[14.576504706845927, 50.50062179096336],
						[14.571990965964048, 50.50099562802001],
						[14.56454467895945, 50.50029755810877],
						[14.559274673446357, 50.49900817856095],
						[14.554317472581216, 50.49681089599893],
						[14.552533149776329, 50.49628067071272],
						[14.548420905549333, 50.4955825756067],
						[14.543886183197799, 50.49524687288138],
						[14.53678417056437, 50.49524687288138],
						[14.523010253613025, 50.49621581749851],
						[14.510724066874369, 50.495094291498845],
						[14.50440692901765, 50.494869232191355],
						[14.500424383576048, 50.49567030423261],
						[14.496133802678886, 50.49781034797586],
						[14.49329471437979, 50.498817429407794],
						[14.487488746692229, 50.499515533919556],
						[14.481082914347736, 50.499259930326744],
						[14.468014718374594, 50.497543347221466]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ51",
				"name": " Liberecký kraj",
				"region": "liberecky"
			},
			"id": 6
		},
		{
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					[
						[
							[18.443853371621508, 49.40092844442433],
							[18.43789290843513, 49.404735522519886],
							[18.432775501066022, 49.40975955025123],
							[18.42888640341111, 49.412887492683105],
							[18.428104382487156, 49.41394791523168],
							[18.427095426188455, 49.41631327427355],
							[18.425220491700163, 49.42387773348433],
							[18.4246387312648, 49.42502962068195],
							[18.42296791869943, 49.42694479552914],
							[18.419977174014075, 49.429244883403584],
							[18.413890856562446, 49.435379170500696],
							[18.403841014194242, 49.44329067491435],
							[18.39885519472952, 49.4481772217317],
							[18.394334789374156, 49.45092007551094],
							[18.390478125832622, 49.45389168815445],
							[18.385925274058728, 49.456371157402224],
							[18.38208198783435, 49.459362048753],
							[18.377613050701935, 49.462131365987936],
							[18.36495400712132, 49.47555933275709],
							[18.360488885627767, 49.47834773092154],
							[18.356632235106925, 49.48136522322567],
							[18.352069862025324, 49.483875332503814],
							[18.34820555946677, 49.48682779526469],
							[18.343645085302107, 49.48933020821513],
							[18.33974264926319, 49.49225607516612],
							[18.33502961625296, 49.4946519071968],
							[18.33183860484236, 49.4966506724094],
							[18.32910919313171, 49.4978332617772],
							[18.32038881170169, 49.50003447334025],
							[18.31878089331982, 49.50074000576012],
							[18.31651117293912, 49.50240340836638],
							[18.310310374780773, 49.50909432577431],
							[18.30870057247085, 49.5117417251665],
							[18.30595779549162, 49.518230448577945],
							[18.305141437108148, 49.51930990328329],
							[18.301576597370207, 49.52247606114552],
							[18.299224850229155, 49.526401493665],
							[18.289926544770044, 49.52584469988203],
							[18.285421382799342, 49.525295347729504],
							[18.281171783563106, 49.52440249797076],
							[18.273023601750722, 49.522209138865286],
							[18.265634549460056, 49.52119074455084],
							[18.257894526256653, 49.52077873776575],
							[18.250026695229725, 49.520671783516114],
							[18.242166536036898, 49.52080167868305],
							[18.234466554407156, 49.521331800448735],
							[18.230157863372888, 49.521991819071154],
							[18.2192382755112, 49.524211837745966],
							[18.209762555635518, 49.52710709820515],
							[18.199550641646507, 49.533084973078594],
							[18.195728308915584, 49.53604512968002],
							[18.191244141466107, 49.53865064129813],
							[18.186965953589823, 49.541587919118584],
							[18.177532180263977, 49.54529940391414],
							[18.171674736150035, 49.54701239110259],
							[18.16740036778785, 49.54752737463912],
							[18.16123006826886, 49.5473097234341],
							[18.157718656612936, 49.546550736057135],
							[18.15420915019101, 49.54505168055694],
							[18.151407257415496, 49.54419720732746],
							[18.146011342487633, 49.54376594125601],
							[18.142402640552945, 49.54411690683238],
							[18.140750888647265, 49.54450228742915],
							[18.135862361842566, 49.54650888020074],
							[18.130496959780267, 49.547824707565816],
							[18.11437415063765, 49.55042258724525],
							[18.10425186467517, 49.551021600818586],
							[18.093957910289575, 49.5509568006287],
							[18.08637999684059, 49.55047219494161],
							[18.065093982645436, 49.547420409280306],
							[18.060848248340534, 49.546383002629256],
							[18.043943424007747, 49.54092040940476],
							[18.032306683248105, 49.536281683252035],
							[18.026353825511332, 49.53309241373122],
							[18.02279661921557, 49.5322531714768],
							[18.01893043540312, 49.53207397640328],
							[18.01700592550608, 49.53222278891232],
							[18.015146253636544, 49.53255079678791],
							[18.012138370987866, 49.53371432903884],
							[18.00514413005403, 49.538589564629284],
							[18.003553377085613, 49.54076756139523],
							[18.00192449564256, 49.54429611028828],
							[18.000474945955308, 49.5464822164736],
							[17.99670030092429, 49.54964839837368],
							[17.992471681266558, 49.55471027778007],
							[17.986116416722957, 49.561069548423546],
							[17.983728411787666, 49.56273272053909],
							[17.981956474937004, 49.56345361783715],
							[17.980005272926373, 49.5639649135339],
							[17.97577665614732, 49.564552176189956],
							[17.96894454424048, 49.56483836645021],
							[17.91812514673695, 49.5644607069974],
							[17.91817284688411, 49.57322701438658],
							[17.917762773522824, 49.57596220571571],
							[17.916870111357312, 49.57846827554976],
							[17.915344226587305, 49.58049001762513],
							[17.91289900274279, 49.58283984767965],
							[17.909589761380325, 49.58804316369861],
							[17.907239927792183, 49.589996450045355],
							[17.90553091254744, 49.59070191908444],
							[17.90165139254891, 49.59138878421167],
							[17.899593370048002, 49.591449873433966],
							[17.89541052540397, 49.591117759106446],
							[17.891378420632265, 49.59021010617801],
							[17.885688790421927, 49.588291238612385],
							[17.881446832172927, 49.587196299769595],
							[17.876756685962444, 49.586506034864165],
							[17.871988297656312, 49.586170205844745],
							[17.867301952889733, 49.58620462597332],
							[17.86281776140405, 49.58680341291324],
							[17.860712051909204, 49.58745956841028],
							[17.857976912494248, 49.58906554398053],
							[17.85631942425493, 49.59126660581068],
							[17.855993252549535, 49.592460483543924],
							[17.85620499403577, 49.59481817582549],
							[17.857196813844432, 49.59684376804795],
							[17.859218612463238, 49.599727752757204],
							[17.860902803467077, 49.60151304859125],
							[17.864835751854006, 49.60449229065818],
							[17.866426462231995, 49.60690684494019],
							[17.867338173455572, 49.61111825919663],
							[17.866722118292532, 49.61536416678624],
							[17.866100294165864, 49.61666856244593],
							[17.86424444460089, 49.61871324548601],
							[17.857387532894872, 49.623832622940334],
							[17.852880476268833, 49.626564012609435],
							[17.847736362124966, 49.63113024674583],
							[17.844848647030236, 49.63308727351178],
							[17.841630938257683, 49.634784719482624],
							[17.835977550660978, 49.637168854581915],
							[17.832454663745853, 49.639148568945814],
							[17.82954216235075, 49.64032747241186],
							[17.8206863401616, 49.64240646223941],
							[17.81260107840037, 49.64575186317296],
							[17.8037395431312, 49.64780422289788],
							[17.795642849954728, 49.651161170862146],
							[17.786693565582727, 49.653129517351815],
							[17.780063629722758, 49.65582275855957],
							[17.771314610002026, 49.65779486315289],
							[17.767778400761962, 49.6589660982632],
							[17.765369430377177, 49.66052258375439],
							[17.76447485100187, 49.66147980533683],
							[17.763444885590914, 49.66373049992384],
							[17.76340483807665, 49.666057520649915],
							[17.765119536811287, 49.67213045620813],
							[17.76554872058635, 49.67659389867701],
							[17.764717093632203, 49.68084709952409],
							[17.76277731118826, 49.68328843354294],
							[17.759735115196893, 49.68483358982874],
							[17.751590737943303, 49.68708045799816],
							[17.746547711433447, 49.689186197549745],
							[17.742595664809222, 49.690002377952226],
							[17.738168703962817, 49.69033803329036],
							[17.733530048779024, 49.69038394551518],
							[17.719524398329703, 49.68975079184778],
							[17.71479606096453, 49.69032283262312],
							[17.71012496127816, 49.691429071307255],
							[17.707494731885582, 49.692623107186854],
							[17.699920664873936, 49.69744118731952],
							[17.693910608760525, 49.70328529887839],
							[17.685024253094753, 49.710430076914584],
							[17.682693479815683, 49.71834944349725],
							[17.68141174514373, 49.724716202663444],
							[17.680141449012332, 49.73619079620487],
							[17.680717478950935, 49.7430535233617],
							[17.679885867598653, 49.7469978604657],
							[17.679161075767823, 49.74823001297394],
							[17.676916124564784, 49.75022889917181],
							[17.67416761786738, 49.751571531528946],
							[17.66738320270584, 49.754238199852594],
							[17.661434162417954, 49.75592031913945],
							[17.65157890772934, 49.75772098421597],
							[17.64307402180571, 49.760898477192605],
							[17.639085787303983, 49.76155104733953],
							[17.634721749144607, 49.761871282092905],
							[17.625490199506892, 49.76185235347702],
							[17.61853789175312, 49.76128759870387],
							[17.61410332760927, 49.760513390225576],
							[17.60398864014186, 49.75759500240659],
							[17.59698866569263, 49.75662221394589],
							[17.589927691728732, 49.756508024030474],
							[17.58345033062221, 49.75726329198186],
							[17.581590646204017, 49.75778956054745],
							[17.57512282587558, 49.76053231874129],
							[17.56818200536234, 49.762241476455394],
							[17.56496429062544, 49.763404814989705],
							[17.5564308010914, 49.76897799138665],
							[17.55293272210674, 49.772468426329965],
							[17.550321585211808, 49.77444081646233],
							[17.546993268606094, 49.77605448881113],
							[17.543165206247494, 49.77695846015083],
							[17.541250219051882, 49.77709189937977],
							[17.537403099511007, 49.7768172629039],
							[17.53360175263823, 49.77581398891346],
							[17.51742173344168, 49.768760771743565],
							[17.515848147892005, 49.766269586092115],
							[17.513631825560893, 49.76444248396356],
							[17.51065444605395, 49.76289746343738],
							[17.507364281882854, 49.761879039722764],
							[17.5023403186343, 49.760906234792635],
							[17.498983367240342, 49.760574209723714],
							[17.489877707417435, 49.761268670131656],
							[17.485788353660748, 49.76181418594438],
							[17.48195267739106, 49.76264580503267],
							[17.47892760771198, 49.76384731326002],
							[17.47406004145219, 49.766414501177124],
							[17.462125785726602, 49.770832123792054],
							[17.45812417229649, 49.77191171610408],
							[17.448221202418324, 49.77381893471519],
							[17.441432956663608, 49.77650073309852],
							[17.439632417883733, 49.7769966299696],
							[17.435609807171065, 49.77765265523543],
							[17.424951569946302, 49.77884306304733],
							[17.421165455990742, 49.77980414456194],
							[17.41618536085873, 49.78227218885027],
							[17.406690585413013, 49.78615941526559],
							[17.38885116857878, 49.795509361579406],
							[17.38768577190282, 49.796348539924104],
							[17.385759372299663, 49.79862991498322],
							[17.38335038283678, 49.803802577193395],
							[17.381792050033777, 49.80639251722404],
							[17.3744182541824, 49.8151054011686],
							[17.365665441142735, 49.82087711943574],
							[17.361114484519973, 49.82251343618116],
							[17.35447119680854, 49.82410041286315],
							[17.350023280339663, 49.82459267873645],
							[17.34546662687725, 49.824657548649036],
							[17.338769913783832, 49.82397843288067],
							[17.33381460335479, 49.82274994566459],
							[17.329065332448675, 49.82124336543166],
							[17.321737275584347, 49.81714237181722],
							[17.310029997804193, 49.812606930021936],
							[17.30801963741667, 49.81206130446348],
							[17.303737655588645, 49.81143964037785],
							[17.299472809784366, 49.81140518974195],
							[17.29550362590363, 49.8119660218506],
							[17.292427045419064, 49.813129279146374],
							[17.285924918950048, 49.816925110716575],
							[17.281063072437206, 49.82057946736188],
							[17.276550283547678, 49.82315437118837],
							[17.27230071217858, 49.82608407018641],
							[17.25954627671924, 49.83142087193435],
							[17.251893987479995, 49.834304728798976],
							[17.246910110478364, 49.83675778687042],
							[17.245042805058965, 49.83731464028175],
							[17.240800851501927, 49.837989756856885],
							[17.236150756625264, 49.83827221996167],
							[17.20918082946699, 49.83817289224034],
							[17.204786297495748, 49.838607761710485],
							[17.200902951874667, 49.839721788359114],
							[17.198667529446823, 49.84126665878051],
							[17.197620400256508, 49.843162606760714],
							[17.197885501258334, 49.85324849577069],
							[17.19715117387331, 49.85596839025422],
							[17.195253377339736, 49.858341259943856],
							[17.192094801155804, 49.859889969954054],
							[17.184091553183734, 49.86210238505017],
							[17.180534350452678, 49.86380757530515],
							[17.177629457251353, 49.86487949493417],
							[17.170436844221598, 49.8664015479606],
							[17.16707420704667, 49.86737444983622],
							[17.160514814493414, 49.87047944142262],
							[17.153078079924267, 49.872764593251674],
							[17.147899619261683, 49.87467568037663],
							[17.14572907466211, 49.879375538942945],
							[17.141433702786028, 49.88365543923708],
							[17.140001291399003, 49.88616175744689],
							[17.139327997305433, 49.88903040957646],
							[17.139394774482263, 49.89360821307427],
							[17.140174856297982, 49.89667503118964],
							[17.14170647189535, 49.899517102894706],
							[17.153059008046583, 49.914321918661436],
							[17.15454482878419, 49.91715239196816],
							[17.155338301947378, 49.9202042841869],
							[17.15568162421191, 49.923343775941106],
							[17.15606689641796, 49.93601609847036],
							[17.15730476052849, 49.94053265714769],
							[17.15921785053003, 49.94320692072663],
							[17.16190528394004, 49.945400198469294],
							[17.16504479232581, 49.94713980469556],
							[17.17055894416708, 49.949485901213315],
							[17.179386150639512, 49.95489893161718],
							[17.181665435800344, 49.95773328109801],
							[17.182590495209876, 49.959697811332745],
							[17.18298147429512, 49.961765149869514],
							[17.182456986712257, 49.96382536279837],
							[17.181364070839166, 49.96575174251874],
							[17.17969702172949, 49.96760546617093],
							[17.178546899030696, 49.968410438085186],
							[17.1753387417441, 49.96963498175547],
							[17.17020036054417, 49.970707044714075],
							[17.166995996232455, 49.97165674976602],
							[17.15939902250851, 49.9762953874009],
							[17.157493577934833, 49.97825229976354],
							[17.156061189777805, 49.98215498986412],
							[17.15505407526434, 49.99071869916774],
							[17.154354104083612, 49.99340064535892],
							[17.153059009556472, 49.995742829569224],
							[17.148853302002205, 50.000122070314035],
							[17.147632598885934, 50.002605438307484],
							[17.144580841007247, 50.011409759047],
							[17.14426422112954, 50.013923644504914],
							[17.144531249946862, 50.01644134477376],
							[17.147417068368444, 50.025306700722524],
							[17.148643493507954, 50.027816771262245],
							[17.153873443650074, 50.03313827553159],
							[17.156425476049453, 50.03769683817308],
							[17.15812492385018, 50.03981018185729],
							[17.16602706925771, 50.04560470718374],
							[17.170547485406928, 50.048114777069024],
							[17.17445755012819, 50.051074982345646],
							[17.178995132557965, 50.05381774994621],
							[17.184854507277038, 50.05934142926456],
							[17.19265556335854, 50.06577682498367],
							[17.194929122991038, 50.06814956719636],
							[17.197076797681035, 50.072128297513466],
							[17.19883537285168, 50.08026122986533],
							[17.199806213546207, 50.08266067642905],
							[17.20054054276901, 50.083717347564274],
							[17.20482444815306, 50.08799362612378],
							[17.207540511612798, 50.09394454566767],
							[17.2063064576209, 50.10679626548359],
							[17.206468582422964, 50.11090088112622],
							[17.207376479702173, 50.11467361120427],
							[17.208711624621614, 50.11680984889044],
							[17.212373734041467, 50.1199035687401],
							[17.213222503332457, 50.12091445651436],
							[17.216547012484515, 50.12659073003786],
							[17.21741104070313, 50.12756728668004],
							[17.22100257834345, 50.13052749311569],
							[17.22172927850742, 50.131626128680864],
							[17.222379684251937, 50.13406753378588],
							[17.222051620804496, 50.13656616474936],
							[17.22063827560516, 50.13880920787098],
							[17.216493606732644, 50.14142227308716],
							[17.21281242325221, 50.144191738211255],
							[17.20983886730986, 50.14596939187479],
							[17.208349227542076, 50.147743222111046],
							[17.208087921697373, 50.149921421798346],
							[17.208452224397565, 50.15105437957913],
							[17.210380554359258, 50.15335846078769],
							[17.213222503383438, 50.155239102933436],
							[17.220531463679016, 50.15816497848703],
							[17.225345612077298, 50.160675052973914],
							[17.22876930237224, 50.16165542605833],
							[17.234239578692964, 50.16273498901021],
							[17.237529754074295, 50.1637573195889],
							[17.241853714995898, 50.16640473237562],
							[17.246580124774628, 50.16880799055617],
							[17.250806808330942, 50.17172241095528],
							[17.260124205880064, 50.17579650336096],
							[17.272403717677495, 50.182289128741466],
							[17.279943466576395, 50.185489657727864],
							[17.28413772636076, 50.18841171698247],
							[17.288806915152648, 50.19087219131619],
							[17.291868210054666, 50.19303894219258],
							[17.294328689136904, 50.19437408089335],
							[17.306257248242304, 50.19891739150561],
							[17.317279816538445, 50.20249176730147],
							[17.321006774827826, 50.204223632204695],
							[17.331577301785778, 50.20978165291945],
							[17.339145660482806, 50.21297836370785],
							[17.342523574626433, 50.215137480040596],
							[17.345092773864014, 50.21644592631973],
							[17.359123228893736, 50.22135924409951],
							[17.369323731647246, 50.22320176127732],
							[17.372863768368095, 50.224201192949636],
							[17.37772369356418, 50.22673034437837],
							[17.385473251491838, 50.22957229735062],
							[17.395317078310413, 50.23381424496162],
							[17.397821426987164, 50.235271458683336],
							[17.398885727563467, 50.23630142726147],
							[17.4022064200855, 50.241962426278114],
							[17.404062271791993, 50.24374771663625],
							[17.411384582411042, 50.24877166660266],
							[17.415328186611905, 50.2503108184879],
							[17.419122355548936, 50.242722477440346],
							[17.424186644750105, 50.24055206097782],
							[17.429560994161108, 50.239776918302],
							[17.434831991679975, 50.24050039249553],
							[17.439999634549643, 50.242722477440346],
							[17.451418299858968, 50.251608123953694],
							[17.45178229200099, 50.25189137119276],
							[17.46935184686764, 50.265563454932646],
							[17.46957107482599, 50.2655763005027],
							[17.47203370374438, 50.265720536284306],
							[17.51699751889077, 50.2683539911577],
							[17.528005596056982, 50.26710683266873],
							[17.529051804104345, 50.26698828735542],
							[17.60639774592836, 50.2582254024259],
							[17.629548787723706, 50.26210114177903],
							[17.646705361878595, 50.27109282605541],
							[17.650292727207088, 50.27427395618017],
							[17.653597474860923, 50.27720448136343],
							[17.655508334249955, 50.278898959048675],
							[17.660302617103433, 50.283150334917615],
							[17.66072604566206, 50.2835258182833],
							[17.676367634670584, 50.29739613637898],
							[17.681948690664473, 50.30556102028074],
							[17.684532510584617, 50.31238230069944],
							[17.686815965336297, 50.31332467999823],
							[17.691043741269574, 50.31506948014027],
							[17.707993611644927, 50.31103872211701],
							[17.713574666104677, 50.30767974983],
							[17.73197147664049, 50.29176341207881],
							[17.734451945433296, 50.289489648435726],
							[17.734968710184294, 50.28680247939175],
							[17.73424523875208, 50.28380523503307],
							[17.731971476268058, 50.28065297712633],
							[17.721119424653924, 50.26194610324951],
							[17.719155720443936, 50.252799373579094],
							[17.721429484558477, 50.242722477440346],
							[17.73197147599695, 50.23600453797523],
							[17.747577759414952, 50.21750437729752],
							[17.738172649175173, 50.20236318935214],
							[17.732874389360934, 50.19941669783981],
							[17.727518081657628, 50.19930267328029],
							[17.72743225186566, 50.20105744116243],
							[17.727298737693587, 50.20380783973925],
							[17.72030639703745, 50.20365524732609],
							[17.714717865585385, 50.20353317734974],
							[17.71331977843973, 50.203502655007995],
							[17.7133541108007, 50.20281601018144],
							[17.713434218269672, 50.20119856918741],
							[17.713542937806146, 50.19899749416144],
							[17.707338333993114, 50.198860175338915],
							[17.706556319572986, 50.19884490474456],
							[17.70659828125309, 50.19800185672899],
							[17.706781387282952, 50.194339751828196],
							[17.70700454828327, 50.18983460401154],
							[17.70714837943673, 50.18695552039886],
							[17.690233202271692, 50.18044810429502],
							[17.6753341049696, 50.17471628076025],
							[17.64866906812468, 50.16799836100847],
							[17.61027270001837, 50.16705283176626],
							[17.600403279214543, 50.16680979672253],
							[17.59411176721959, 50.16476208402392],
							[17.58949774243006, 50.163260358604525],
							[17.589447875870146, 50.16324411895519],
							[17.582109822951793, 50.15316721561171],
							[17.584176879830885, 50.145880837638394],
							[17.6327527261188, 50.106348369954404],
							[17.648359009438963, 50.10180084652633],
							[17.65848758873838, 50.102989397898895],
							[17.666962524050884, 50.10614166340754],
							[17.67760786894273, 50.10774363154006],
							[17.690733682613118, 50.10546986589937],
							[17.717915486670513, 50.09678822536159],
							[17.73197147588976, 50.09487620011771],
							[17.732384887512673, 50.093894345101496],
							[17.732591593658533, 50.09296417026838],
							[17.73238488815658, 50.09218902725208],
							[17.731971475615463, 50.091465552923324],
							[17.722669718745074, 50.08634958795821],
							[17.719465779780492, 50.080871886241475],
							[17.72256636478996, 50.07513580231691],
							[17.731971476302235, 50.06908966341975],
							[17.743030231742008, 50.06056304793424],
							[17.749851521829147, 50.04950429263124],
							[17.755432577016176, 50.03715362612854],
							[17.76328739395421, 50.02521636963289],
							[17.774552857012715, 50.01519114210095],
							[17.83935512065376, 49.973643440102634],
							[17.87573532809145, 49.96868248936683],
							[17.91211551812505, 49.97581369303457],
							[17.915377277816397, 49.977690784532264],
							[17.94157109158398, 49.992763622282254],
							[17.95343007321682, 49.994751413003954],
							[17.95976118026837, 49.99581240281007],
							[17.999862103756236, 49.99658764881155],
							[18.030497354724208, 50.00247154061935],
							[18.036657333360544, 50.00258636463869],
							[18.043613433846847, 50.00271606452341],
							[18.050575256349287, 50.00284576417252],
							[18.05038642884836, 50.00735092175195],
							[18.050195693948933, 50.01185989363479],
							[18.05012893670227, 50.013492583712626],
							[18.050006866383903, 50.01636505070826],
							[18.04981613168842, 50.02087020950193],
							[18.04962730398094, 50.02537918014894],
							[18.04943656912415, 50.02988433767092],
							[18.04924774184343, 50.03438949698531],
							[18.049218710849075, 50.03507578904038],
							[18.09163944499511, 50.01720652296095],
							[18.08512822238096, 49.99875810200604],
							[18.09815066258581, 49.989042769255896],
							[18.16202274507672, 49.98123971875277],
							[18.17721561611202, 49.97581369303457],
							[18.208738238757032, 49.958295372422484],
							[18.22052045430966, 49.954884646602245],
							[18.24398154827287, 49.95173233648744],
							[18.25586713332093, 49.94604796902365],
							[18.260104595687483, 49.94057023078715],
							[18.267029249433087, 49.92506739262783],
							[18.272610309273094, 49.91829781749049],
							[18.29245406442181, 49.90780754275105],
							[18.306923475993045, 49.909667977300636],
							[18.32053091478448, 49.9173253387762],
							[18.325159370845984, 49.9199298017664],
							[18.32877468257298, 49.92196420804639],
							[18.331973802281617, 49.9237645099568],
							[18.33493208212135, 49.92542913318275],
							[18.334177032179234, 49.926561865793545],
							[18.3388214142967, 49.92663576683866],
							[18.340377822263218, 49.926658744478964],
							[18.345771781787022, 49.92674630793848],
							[18.345716486906785, 49.92823799655315],
							[18.34564688876716, 49.93020074196086],
							[18.3688318116777, 49.932043643836245],
							[18.407485785027056, 49.923155299752054],
							[18.481796525715477, 49.89664553640444],
							[18.505050901921816, 49.89669707466293],
							[18.5185468558555, 49.90227599864672],
							[18.534039517970854, 49.908680628803864],
							[18.544428364931953, 49.912975312673325],
							[18.55920781781706, 49.90718750447078],
							[18.565408984599408, 49.88904903729504],
							[18.56292852345657, 49.873701197971506],
							[18.56726934672024, 49.86145390048008],
							[18.591311457615465, 49.853081180694026],
							[18.591393858144066, 49.85037590693406],
							[18.589753009760493, 49.84914511789889],
							[18.58460889078833, 49.845287029113265],
							[18.571375900935905, 49.83536224438382],
							[18.571042873519083, 49.83511268644559],
							[18.566339149450616, 49.8315847582969],
							[18.56675256074621, 49.804764684824164],
							[18.584115857359834, 49.7743790626675],
							[18.607680313654008, 49.74295981817666],
							[18.617705507486207, 49.713865722581055],
							[18.624010047219635, 49.706372761461836],
							[18.63734256731044, 49.70032661917471],
							[18.64434950409972, 49.69992704338724],
							[18.65820755930827, 49.699136269864184],
							[18.66814174370903, 49.6985697933641],
							[18.68240440322528, 49.69577899985362],
							[18.695426893536617, 49.68885457653791],
							[18.71506393107898, 49.673816684646035],
							[18.727672956624158, 49.668907234927616],
							[18.74224571259099, 49.66968240490993],
							[18.757852018615832, 49.67407507935722],
							[18.77345829758302, 49.675832046264894],
							[18.78844446355319, 49.66859735370964],
							[18.792578590394957, 49.66079430280139],
							[18.79929650182525, 49.62637761845017],
							[18.803947399166276, 49.616765942702465],
							[18.815729610024125, 49.59929918437387],
							[18.820173768699707, 49.59025569031063],
							[18.834539847201853, 49.547622868388345],
							[18.837433700225123, 49.5269520882548],
							[18.836944208236808, 49.52502408228471],
							[18.814744936041365, 49.5206984445713],
							[18.806327817732747, 49.518894179382386],
							[18.80462075224677, 49.518528057695136],
							[18.798187243461474, 49.51714696828721],
							[18.797506320183448, 49.51692190256608],
							[18.78210637982051, 49.511863555792345],
							[18.76649094769088, 49.50450143126014],
							[18.757740037148682, 49.49993527737252],
							[18.74976156730207, 49.49576939111432],
							[18.741130819637213, 49.494098591706546],
							[18.734830847550526, 49.49287789203167],
							[18.73088455400033, 49.49423219326542],
							[18.728677754023856, 49.49499133661343],
							[18.715980538838636, 49.49935157187167],
							[18.693325050918915, 49.50310522736568],
							[18.687091810739783, 49.503711570758135],
							[18.679855359332986, 49.504413703306426],
							[18.668514250107258, 49.505516039760465],
							[18.66163064480443, 49.50524913502964],
							[18.65357971685149, 49.50494007147593],
							[18.641988762323365, 49.504489961525984],
							[18.635959637494715, 49.50408945112848],
							[18.620223990821184, 49.50304787901013],
							[18.594682676510224, 49.507392750504174],
							[18.593885416799232, 49.50752635894169],
							[18.577177058109157, 49.51119240305918],
							[18.57388115846306, 49.51191718608608],
							[18.558023455802406, 49.512805962577204],
							[18.542940146216253, 49.50471501640285],
							[18.538398758217898, 49.49704373165618],
							[18.536247249389, 49.49341198617721],
							[18.53818772981489, 49.48273217277473],
							[18.535643338598334, 49.481683557543285],
							[18.53047571079636, 49.473467123988286],
							[18.528861127113334, 49.461357751836154],
							[18.52286910766899, 49.45391462313629],
							[18.50972746497972, 49.438907520429765],
							[18.50959358079194, 49.43882353367733],
							[18.481796492437464, 49.42907691617837],
							[18.449318089791536, 49.403141538066116],
							[18.44840238600452, 49.402725070953004],
							[18.443853371621508, 49.40092844442433]
						]
					],
					[
						[
							[18.01907389916929, 50.04408711133444],
							[18.033245075991875, 50.04180450493529],
							[18.040521267898427, 50.03873948847382],
							[18.035129547106937, 50.0386390685072],
							[18.035175323542266, 50.03755950971831],
							[18.035320282044662, 50.034130096926155],
							[18.028354644655842, 50.034000395784936],
							[18.021392822280514, 50.03387069713852],
							[18.0144290925152, 50.03373718346864],
							[18.0074672698002, 50.03360366744381],
							[18.00727272048874, 50.03811264157971],
							[18.00720405593244, 50.03965759392768],
							[18.007076263396947, 50.04261779760879],
							[18.006932220789228, 50.04604281850253],
							[18.01907389916929, 50.04408711133444]
						]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ80",
				"name": " Moravskoslezský kraj",
				"region": "moravskoslezsky"
			},
			"id": 7
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[17.19653320282868, 49.29410934195174],
						[17.19190023998298, 49.29790866929624],
						[17.186235433290282, 49.30136113038503],
						[17.184040084244927, 49.303039676015075],
						[17.172157302669266, 49.31552518366266],
						[17.16772271500782, 49.31830226543519],
						[17.163885122305985, 49.32130055553587],
						[17.159360898553825, 49.32382213199936],
						[17.155511869157223, 49.32682048529471],
						[17.151046737492496, 49.32957445302134],
						[17.146047603704723, 49.334243873067585],
						[17.14161110567122, 49.33713918459025],
						[17.134300231817374, 49.34032821555835],
						[17.130823136859043, 49.34232331590636],
						[17.127920135128335, 49.3435095403944],
						[17.119016642682126, 49.34553905316816],
						[17.11742974505731, 49.34606943675541],
						[17.11262894418884, 49.34838492069835],
						[17.10929681156899, 49.349357715094555],
						[17.10211182091724, 49.35088352251649],
						[17.093875870607764, 49.35415637076334],
						[17.08390807886062, 49.35595701244416],
						[17.079769129312606, 49.35711665456448],
						[17.074155813539814, 49.35969930109775],
						[17.069309232377126, 49.362899761045604],
						[17.06671904357235, 49.36534490170594],
						[17.06574441545969, 49.36669172173378],
						[17.064685828495307, 49.36954122791872],
						[17.064643864016908, 49.37234119162208],
						[17.065507896907924, 49.3749199609217],
						[17.066312786587105, 49.37604901320142],
						[17.070821780002568, 49.38004318332119],
						[17.074304570630513, 49.38562384573444],
						[17.078828802141768, 49.389667429619],
						[17.080194460371626, 49.392059215789665],
						[17.08067321332092, 49.394779167213436],
						[17.08033371014438, 49.39763641723342],
						[17.07903482202015, 49.40041747098322],
						[17.07706452258938, 49.402900767935044],
						[17.074129119283146, 49.4061051670398],
						[17.072084409550836, 49.407897800909396],
						[17.070703511719334, 49.408664748300176],
						[17.068838131286448, 49.409301858640085],
						[17.064870820261945, 49.409789918443515],
						[17.06097031452091, 49.40945060057841],
						[17.057573329882302, 49.40830621948086],
						[17.05645369878421, 49.40756220403511],
						[17.05167769179187, 49.4031409183229],
						[17.048776633496843, 49.401550352203735],
						[17.045412078140938, 49.40068829607814],
						[17.04210283071483, 49.40069976121993],
						[17.04054069744545, 49.40102388408667],
						[17.038116459084517, 49.402153049501614],
						[17.033224098822522, 49.40533822719518],
						[17.031343444180123, 49.40718446439629],
						[17.029037474077278, 49.41182707445912],
						[17.027574521303876, 49.41399749675418],
						[17.022819503254816, 49.41803346439826],
						[17.020336139616283, 49.42102422378431],
						[17.012142199427384, 49.42975250457107],
						[17.00587654634914, 49.43454365434457],
						[16.9951305296011, 49.44614783853779],
						[16.991212845841286, 49.44931031125554],
						[16.989368438994635, 49.45124054190234],
						[16.985727324108648, 49.45906078849569],
						[16.981401458356064, 49.46562970530934],
						[16.980388623910375, 49.46835693643634],
						[16.978717812286707, 49.476516795123736],
						[16.977655417425666, 49.478927669442136],
						[16.97682570874623, 49.479988052109036],
						[16.96921540843961, 49.485962045997375],
						[16.961364739788685, 49.49033731770052],
						[16.9584102683218, 49.49151615844278],
						[16.95266532111212, 49.492454461241806],
						[16.93990515643407, 49.493339450981814],
						[16.932453162506796, 49.494205534944214],
						[16.928552628473494, 49.49436951466127],
						[16.92465209263106, 49.494197785432746],
						[16.915000916688776, 49.49314881370634],
						[16.901706712039648, 49.49240889442658],
						[16.895236957397188, 49.491496939854834],
						[16.891145694094533, 49.49031437949067],
						[16.88274763242122, 49.48706802337692],
						[16.880138385628392, 49.485473532831776],
						[16.8790893719457, 49.4843446245934],
						[16.87836074846548, 49.48313141019691],
						[16.87761688952872, 49.48056799430752],
						[16.87753297017976, 49.477932072952804],
						[16.877981190614527, 49.475338022762806],
						[16.87900543133543, 49.472930901353166],
						[16.87978553839141, 49.47186279876767],
						[16.883281710428072, 49.468685173145786],
						[16.884019835843326, 49.46767411862816],
						[16.885065062949195, 49.4653547831608],
						[16.88678360001802, 49.45900344990615],
						[16.887916565980223, 49.45664978924173],
						[16.88973045309037, 49.45478057515191],
						[16.896615975111146, 49.449684083120054],
						[16.901227966598743, 49.447227612224665],
						[16.90523720879888, 49.4443856228251],
						[16.909919738955143, 49.44196701209954],
						[16.913822177410534, 49.43902590770629],
						[16.916999807850615, 49.436992567247444],
						[16.918888109722456, 49.435070190362495],
						[16.919525132794192, 49.43388354889741],
						[16.92022324146453, 49.43133549563437],
						[16.920177454523593, 49.42736811925375],
						[16.91878701925469, 49.42367568115833],
						[16.916917805220898, 49.42179492862576],
						[16.91378592231764, 49.41978062646169],
						[16.910139072702297, 49.41675176518066],
						[16.90707586858828, 49.414672736054776],
						[16.90532302286846, 49.41284937704954],
						[16.904239645008555, 49.41052619325144],
						[16.902614594528988, 49.404094704890035],
						[16.9014720748842, 49.40160736823795],
						[16.90058899083803, 49.40045930321632],
						[16.89768790316884, 49.398326797497745],
						[16.893581377601272, 49.39678181080654],
						[16.87556266806793, 49.39286422921171],
						[16.87226486440316, 49.39184572342504],
						[16.86707688827591, 49.38961041619928],
						[16.86317442863188, 49.38868704842186],
						[16.85651206701625, 49.38814542347666],
						[16.84955025982336, 49.3885079526346],
						[16.845046995873627, 49.38941954527627],
						[16.839643468834435, 49.391788399670425],
						[16.83682061038153, 49.39375693561219],
						[16.832941066472966, 49.39717874694524],
						[16.828599939143636, 49.39999016285396],
						[16.82104682515901, 49.40618511483859],
						[16.819459906836332, 49.408767627879755],
						[16.818685533567944, 49.41167833116161],
						[16.818445207357893, 49.414741530611565],
						[16.818847658011624, 49.419357315099994],
						[16.82030679035193, 49.423603165484565],
						[16.824415201831386, 49.42821879749254],
						[16.82591055356707, 49.430824152516806],
						[16.82727811978173, 49.43700775293484],
						[16.827371604609976, 49.44354635862932],
						[16.826589573302577, 49.44823827703115],
						[16.8253383760692, 49.45103846827091],
						[16.824371338170124, 49.452255251445244],
						[16.813793171740674, 49.460357573823345],
						[16.81113813970292, 49.46338260498583],
						[16.807083120157337, 49.473430549229874],
						[16.806264870361645, 49.476745545154984],
						[16.805585866523, 49.48715977507613],
						[16.80585861833292, 49.5065117425389],
						[16.806671147487137, 49.51340488867842],
						[16.809406297910797, 49.52183929230655],
						[16.810354236719835, 49.526649509100366],
						[16.810649875884142, 49.53138354949132],
						[16.809980386186403, 49.53582376781863],
						[16.80835531636387, 49.5384977946363],
						[16.8068866558563, 49.53966507418116],
						[16.805139550133465, 49.54049689972678],
						[16.801242811463766, 49.54135880156234],
						[16.79502867277826, 49.54137027293718],
						[16.780296313226533, 49.53898609818444],
						[16.775821681451042, 49.537490807132485],
						[16.76984977333147, 49.53666302170905],
						[16.7658844098499, 49.53693398937864],
						[16.763992300476097, 49.53742973073875],
						[16.762273779195013, 49.538257518627226],
						[16.760988233238177, 49.539371471098896],
						[16.760221493204714, 49.540596111301895],
						[16.75979043672422, 49.543167254615156],
						[16.76105116975505, 49.547042775412656],
						[16.763347639395036, 49.549949764369465],
						[16.767593371967145, 49.56851948996665],
						[16.769205085790002, 49.57139199361617],
						[16.770593638159433, 49.57263942182034],
						[16.77434541159661, 49.574310420775795],
						[16.779397955755094, 49.57530204860489],
						[16.782545075112136, 49.57540499455271],
						[16.795167925505623, 49.57464220326905],
						[16.802198394715422, 49.575115071582346],
						[16.804389936377188, 49.57568344494374],
						[16.806396500467194, 49.57661833348839],
						[16.807931906615092, 49.57789617504693],
						[16.8089008420267, 49.57933433581075],
						[16.80960653558089, 49.58242402107902],
						[16.80909919362307, 49.58562847704214],
						[16.805143343761756, 49.59363545072079],
						[16.79927253126074, 49.601913400641564],
						[16.796361927495788, 49.60454563016782],
						[16.791303644615997, 49.60816964170781],
						[16.799173342148453, 49.61679447450439],
						[16.805915831640185, 49.62725066381276],
						[16.80722619546489, 49.62987912211426],
						[16.80756951443035, 49.63232431042284],
						[16.80709649437781, 49.63474284921982],
						[16.802547441429503, 49.642551306708576],
						[16.801418300851303, 49.647178618978614],
						[16.801273344579283, 49.650356280949666],
						[16.80164719874235, 49.65351878401696],
						[16.80275345993546, 49.65658579187218],
						[16.803606036008766, 49.65794374867359],
						[16.80681420413617, 49.66159829510214],
						[16.810943613590677, 49.66546258051177],
						[16.81380842482434, 49.66693101191949],
						[16.822368635295454, 49.6691743100334],
						[16.82509041685039, 49.670341564913336],
						[16.833047884549586, 49.67490020708066],
						[16.838005052930214, 49.678924449134804],
						[16.843063350878165, 49.68227001905963],
						[16.843229290944198, 49.69276425755088],
						[16.842626557705266, 49.70170962779763],
						[16.843496324132765, 49.71011735294158],
						[16.843580260049073, 49.71563351286176],
						[16.842920309278256, 49.71978001905549],
						[16.841733947674385, 49.722450386286525],
						[16.840816503807083, 49.72369389905457],
						[16.838478071691053, 49.72596344967045],
						[16.835683811017574, 49.72800435613348],
						[16.830888747550574, 49.730651850173295],
						[16.82731820461612, 49.73204433205402],
						[16.825408923875656, 49.73257054823141],
						[16.821208967850406, 49.73323452539088],
						[16.810894001606275, 49.7338255906335],
						[16.807111751823168, 49.73434839752144],
						[16.80535888072337, 49.73485941514756],
						[16.803775787981284, 49.73563385548052],
						[16.802547446303315, 49.73665993051099],
						[16.801713936410344, 49.73781198160152],
						[16.800903323856787, 49.74029544054588],
						[16.801036828496898, 49.74414820107065],
						[16.80238722820033, 49.74767676924018],
						[16.803142549636828, 49.74864579986204],
						[16.805623998301247, 49.750713263756374],
						[16.806823728791393, 49.75241087430108],
						[16.807020175346306, 49.75450505440759],
						[16.806085577427066, 49.756725233152906],
						[16.804199207769063, 49.758830930109],
						[16.79688642807536, 49.76502214061429],
						[16.79487039423222, 49.767326506155264],
						[16.793539051168818, 49.769752536090195],
						[16.79053689854342, 49.77722564900323],
						[16.788961411397196, 49.77939606462176],
						[16.782901749684985, 49.78636920181932],
						[16.780803672590167, 49.787959985411966],
						[16.777402871839204, 49.789905496957424],
						[16.773540486272573, 49.79287329213503],
						[16.768987667384994, 49.79553232722182],
						[16.767087919062845, 49.79732117097989],
						[16.76107598578894, 49.80444346461022],
						[16.759773240466444, 49.80691516383071],
						[16.759056101003043, 49.80968483649929],
						[16.75839233953177, 49.81951146109577],
						[16.75796890249972, 49.822139739234906],
						[16.75700950836255, 49.824543017570655],
						[16.756214133752373, 49.82561104517769],
						[16.752212537553113, 49.82864009668474],
						[16.7483100890747, 49.831985473318525],
						[16.746074681390052, 49.83328632717919],
						[16.74121094711182, 49.834877096529574],
						[16.735435501861513, 49.835914749157745],
						[16.733480446084435, 49.84540932983613],
						[16.73303223006866, 49.850101500987634],
						[16.733444217514833, 49.854629547848745],
						[16.73451613566796, 49.8573416967189],
						[16.736402523877675, 49.85938273455526],
						[16.742263785334412, 49.86367409012307],
						[16.744495396195546, 49.86500553038391],
						[16.752552036380425, 49.8691215849455],
						[16.760583859640644, 49.871234740627486],
						[16.763618482675216, 49.87265407598808],
						[16.765495287138496, 49.87491596429132],
						[16.765928265844853, 49.87619779283724],
						[16.76603316508374, 49.87889092695469],
						[16.765228256493007, 49.881626001124864],
						[16.760215748278515, 49.889430905830885],
						[16.757350935715888, 49.900272489626616],
						[16.756160731749954, 49.90327449913525],
						[16.75272751966068, 49.90855798673128],
						[16.75136566151777, 49.91133499057349],
						[16.750350946803405, 49.91577906815075],
						[16.74919511649711, 49.92640319597651],
						[16.747714992889772, 49.930770844609555],
						[16.739683156917895, 49.94185643266834],
						[16.734346400862144, 49.948158358778464],
						[16.73011208672053, 49.956363771079005],
						[16.729454037715353, 49.95928571210064],
						[16.729509341336115, 49.96371449471072],
						[16.73182676618925, 49.97290025394496],
						[16.731750476475582, 49.975837606917274],
						[16.73096657403908, 49.97874455835107],
						[16.73023416103673, 49.980144627847494],
						[16.7280922059199, 49.9826966381481],
						[16.71981047068793, 49.989528526874054],
						[16.71755028997045, 49.99201975781117],
						[16.716766363945446, 49.9933472235657],
						[16.715868011607704, 49.99606336359065],
						[16.71577264525201, 49.99875654901329],
						[16.716051101684894, 50.00006484985574],
						[16.717485427848892, 50.002510070736484],
						[16.71878051757887, 50.00356674194971],
						[16.72050476074819, 50.004402160695584],
						[16.72239112852987, 50.004936218174095],
						[16.726427078279308, 50.00547409085118],
						[16.737451553333248, 50.0059509276358],
						[16.741983413727297, 50.00645446803665],
						[16.746437072776722, 50.00754928608264],
						[16.752567291268466, 50.010234832836694],
						[16.760038375783516, 50.01465225159409],
						[16.79639244077296, 50.03818130473737],
						[16.801559448165115, 50.041767119709114],
						[16.805898666119486, 50.045677182839626],
						[16.806970596189263, 50.04713058366629],
						[16.808258056753804, 50.050170899394345],
						[16.808692932140524, 50.05325698862301],
						[16.808500290104163, 50.056282045038124],
						[16.807064056496806, 50.06039810265404],
						[16.806205749396966, 50.061550139410535],
						[16.802698135222695, 50.0646972643285],
						[16.801273345918304, 50.06711578344657],
						[16.80060005177659, 50.06988143833501],
						[16.800804137901327, 50.07416534185318],
						[16.80188560497968, 50.076801301073445],
						[16.80281257637438, 50.07794570990752],
						[16.80686759956094, 50.08073043885408],
						[16.814039230911153, 50.08635330676429],
						[16.814598083464837, 50.08731460544874],
						[16.814899444495403, 50.089439391374924],
						[16.81406021163499, 50.091754917154645],
						[16.81227493255571, 50.09403228501833],
						[16.80761528054743, 50.099075320724246],
						[16.802505493685434, 50.10293198071783],
						[16.800849914678118, 50.105201722265306],
						[16.79987525919392, 50.10773467844235],
						[16.799350738925924, 50.11029434542069],
						[16.799186706155364, 50.11251067788196],
						[16.79965019231776, 50.11450195360602],
						[16.800298690965228, 50.11544799947417],
						[16.80226135283383, 50.11702728519964],
						[16.809360504247362, 50.12006759725241],
						[16.81385803274041, 50.12274551824467],
						[16.818956374639175, 50.127326961265574],
						[16.82301330611354, 50.13044357678097],
						[16.824657440342776, 50.132732392679564],
						[16.82757949885973, 50.139324193016925],
						[16.83194923422509, 50.145866395861454],
						[16.835834503635944, 50.15588379294517],
						[16.84024810758201, 50.162429806815155],
						[16.84396934434263, 50.17013930644743],
						[16.84585380543174, 50.17200088408422],
						[16.85655212338996, 50.18003081744315],
						[16.858242035362963, 50.182163242302956],
						[16.86022758444178, 50.185791012298395],
						[16.86198425203925, 50.18818282335038],
						[16.86235662458171, 50.18851646959695],
						[16.869762081406552, 50.189728860030684],
						[16.88096398985338, 50.1915628047732],
						[16.890369100297885, 50.19693715648945],
						[16.907008910624892, 50.21176828686847],
						[16.918997844026247, 50.21709097155673],
						[16.927782836475075, 50.217297664624994],
						[16.946282999781047, 50.21306020017639],
						[16.955274699665587, 50.21347361853807],
						[16.957755166410198, 50.21714263509257],
						[16.957548461730905, 50.22923492276136],
						[16.96033898789141, 50.23197376578402],
						[16.9750150959254, 50.231818746379815],
						[16.98100956404432, 50.22918325667145],
						[16.984200033222383, 50.22503562641331],
						[16.98566043999827, 50.22313709768164],
						[16.987564530858794, 50.221306957912695],
						[16.9917068014336, 50.21732554624699],
						[16.992122522477743, 50.21692597473376],
						[16.99630578616005, 50.21290517332815],
						[17.00839807203383, 50.2099596235772],
						[17.01480594829568, 50.218486221159836],
						[17.0142721333083, 50.22206840211376],
						[17.019393920178597, 50.22221373915169],
						[17.019102096226522, 50.226718899843675],
						[17.018810271321083, 50.231220237940406],
						[17.018518448636783, 50.23572540913359],
						[17.011526107532067, 50.23552703645274],
						[17.011234283442143, 50.240028381304114],
						[17.010942459980402, 50.24452973135989],
						[17.006986617378086, 50.24441527770178],
						[17.003950118013076, 50.244331351530555],
						[17.003656386669817, 50.24883651187115],
						[17.003646850628662, 50.2489814761836],
						[17.003362656691596, 50.253337868821056],
						[17.00306892429904, 50.25784302046735],
						[17.010063170248202, 50.25804137241019],
						[17.00977134700033, 50.26254272423258],
						[17.00947761635894, 50.267047890377064],
						[17.016473770560708, 50.26724624980435],
						[17.01618003935755, 50.271747596599496],
						[17.01588821313101, 50.276252738475236],
						[17.008890153044984, 50.276054391154354],
						[17.008596420360256, 50.28055572569366],
						[17.008304595679235, 50.285057065653916],
						[17.008171080867875, 50.287090295930916],
						[17.008010863661227, 50.28956222040826],
						[17.00772094765729, 50.294063571353725],
						[17.000717163771654, 50.29386520952876],
						[17.000423430940877, 50.29836654286335],
						[16.993425368677574, 50.298168177531494],
						[16.99312973044936, 50.302673341703155],
						[16.986129761034825, 50.30247116330924],
						[16.98460769662076, 50.30242919994322],
						[16.980794905954248, 50.3023185675187],
						[16.979127883669676, 50.30227279463113],
						[16.979070663686617, 50.30313492015426],
						[16.978996276775327, 50.304279326728704],
						[16.978832245844732, 50.306774147447115],
						[16.971813202531767, 50.3065719656448],
						[16.967870712544887, 50.30645752172275],
						[16.96482849151473, 50.30636978401056],
						[16.96476554940056, 50.307331090958456],
						[16.964530945503, 50.31087494458614],
						[16.95752906791654, 50.31067275937444],
						[16.95052719035102, 50.31047057433083],
						[16.95013237100116, 50.31045914530243],
						[16.94352531515024, 50.310268408892455],
						[16.943340302144733, 50.31302643345579],
						[16.943225861721785, 50.31476975420969],
						[16.940277099815294, 50.31468582324037],
						[16.93622207639689, 50.31456756575888],
						[16.936052321380018, 50.31712721942609],
						[16.935922623192482, 50.31906891293598],
						[16.935621260974116, 50.32357024630253],
						[16.928617477110606, 50.32336806996768],
						[16.928316115122016, 50.32786940523881],
						[16.928014753817312, 50.33237074618421],
						[16.92771339264425, 50.33687590291854],
						[16.92741203272584, 50.34137725535619],
						[16.92711067350129, 50.34587861354111],
						[16.920103075043514, 50.3456764380661],
						[16.91979980402368, 50.35017775938973],
						[16.919498445741553, 50.35467912538788],
						[16.915348052540857, 50.35456084842228],
						[16.91248893904991, 50.35447694257565],
						[16.912185668978093, 50.35897827175616],
						[16.912166597062715, 50.359245313588346],
						[16.911882399610274, 50.363479606777325],
						[16.91157913094983, 50.36798094766354],
						[16.911275862511587, 50.372486105089116],
						[16.910972595284225, 50.37698745784922],
						[16.910846712070597, 50.378845230297884],
						[16.9106693287741, 50.38148881654741],
						[16.910364150940527, 50.38599014232163],
						[16.903350831090357, 50.38578797225307],
						[16.90304756087403, 50.390289300250124],
						[16.89603233369657, 50.39008331566093],
						[16.89441108812582, 50.39003754565238],
						[16.889020921236547, 50.38987733124717],
						[16.888824463824783, 50.392768867607195],
						[16.888715743472613, 50.39437865758362],
						[16.885826110739426, 50.39429473793606],
						[16.88275146608571, 50.39420319633331],
						[16.881698608525525, 50.39417266951085],
						[16.881574629117793, 50.39599608031909],
						[16.881507871191015, 50.396972636811775],
						[16.881391523678094, 50.398673998041886],
						[16.879844664507655, 50.398628226407006],
						[16.87821769713401, 50.3985786437197],
						[16.876392787503224, 50.3985242388847],
						[16.87423484874034, 50.400560364709264],
						[16.871754584060483, 50.40290062005356],
						[16.86587447117544, 50.4084487934552],
						[16.865850054863092, 50.41174509064517],
						[16.865771119185734, 50.42240143883009],
						[16.872563692426155, 50.42503581735255],
						[16.892952918928483, 50.4329434038595],
						[16.915793904875176, 50.43108307623132],
						[16.944004628158233, 50.42026669351593],
						[16.958788693935, 50.41459826996666],
						[16.981939738731114, 50.41635529202115],
						[17.084672486897713, 50.397958491547946],
						[17.095627890823017, 50.39366934692925],
						[17.118882286337346, 50.38116365512552],
						[17.13169803851467, 50.37682281920877],
						[17.145443970026783, 50.37671946321821],
						[17.175933065001658, 50.380750224013084],
						[17.187611936827377, 50.3784764432898],
						[17.185441529303173, 50.37568594462429],
						[17.1854545460333, 50.37564449353979],
						[17.188265962090167, 50.366699118890224],
						[17.188852174634988, 50.36483389633296],
						[17.195053342745954, 50.3519147566136],
						[17.201047809515934, 50.34323312189369],
						[17.210866333602382, 50.33641184991169],
						[17.24610965841038, 50.322149145198395],
						[17.26988081868191, 50.317756650412136],
						[17.316803019686493, 50.31863515856784],
						[17.329025587574968, 50.31530449896081],
						[17.329233169154566, 50.31172561320265],
						[17.3328957126728, 50.311819378388876],
						[17.31907678109418, 50.30824818264994],
						[17.321867309208205, 50.30447581168846],
						[17.325381305872423, 50.30111683285129],
						[17.329515422741938, 50.29822296801801],
						[17.334062947466876, 50.29569082078659],
						[17.332822712117498, 50.282668348836786],
						[17.334786418617085, 50.27000763500947],
						[17.341711059781975, 50.259724018228894],
						[17.355043579743057, 50.25326447203039],
						[17.35804667564159, 50.25832682303984],
						[17.36076346501169, 50.26290655472777],
						[17.365895629693593, 50.27155792051598],
						[17.388013141591973, 50.27264311846234],
						[17.40982059699804, 50.26132598898303],
						[17.415328186611905, 50.2503108184879],
						[17.411384582411042, 50.24877166660266],
						[17.404062271791993, 50.24374771663625],
						[17.4022064200855, 50.241962426278114],
						[17.398885727563467, 50.23630142726147],
						[17.397821426987164, 50.235271458683336],
						[17.395317078310413, 50.23381424496162],
						[17.385473251491838, 50.22957229735062],
						[17.37772369356418, 50.22673034437837],
						[17.372863768368095, 50.224201192949636],
						[17.369323731647246, 50.22320176127732],
						[17.359123228893736, 50.22135924409951],
						[17.345092773864014, 50.21644592631973],
						[17.342523574626433, 50.215137480040596],
						[17.339145660482806, 50.21297836370785],
						[17.331577301785778, 50.20978165291945],
						[17.321006774827826, 50.204223632204695],
						[17.317279816538445, 50.20249176730147],
						[17.306257248242304, 50.19891739150561],
						[17.294328689136904, 50.19437408089335],
						[17.291868210054666, 50.19303894219258],
						[17.288806915152648, 50.19087219131619],
						[17.28413772636076, 50.18841171698247],
						[17.279943466576395, 50.185489657727864],
						[17.272403717677495, 50.182289128741466],
						[17.260124205880064, 50.17579650336096],
						[17.250806808330942, 50.17172241095528],
						[17.246580124774628, 50.16880799055617],
						[17.241853714995898, 50.16640473237562],
						[17.237529754074295, 50.1637573195889],
						[17.234239578692964, 50.16273498901021],
						[17.22876930237224, 50.16165542605833],
						[17.225345612077298, 50.160675052973914],
						[17.220531463679016, 50.15816497848703],
						[17.213222503383438, 50.155239102933436],
						[17.210380554359258, 50.15335846078769],
						[17.208452224397565, 50.15105437957913],
						[17.208087921697373, 50.149921421798346],
						[17.208349227542076, 50.147743222111046],
						[17.20983886730986, 50.14596939187479],
						[17.21281242325221, 50.144191738211255],
						[17.216493606732644, 50.14142227308716],
						[17.22063827560516, 50.13880920787098],
						[17.222051620804496, 50.13656616474936],
						[17.222379684251937, 50.13406753378588],
						[17.22172927850742, 50.131626128680864],
						[17.22100257834345, 50.13052749311569],
						[17.21741104070313, 50.12756728668004],
						[17.216547012484515, 50.12659073003786],
						[17.213222503332457, 50.12091445651436],
						[17.212373734041467, 50.1199035687401],
						[17.208711624621614, 50.11680984889044],
						[17.207376479702173, 50.11467361120427],
						[17.206468582422964, 50.11090088112622],
						[17.2063064576209, 50.10679626548359],
						[17.207540511612798, 50.09394454566767],
						[17.20482444815306, 50.08799362612378],
						[17.20054054276901, 50.083717347564274],
						[17.199806213546207, 50.08266067642905],
						[17.19883537285168, 50.08026122986533],
						[17.197076797681035, 50.072128297513466],
						[17.194929122991038, 50.06814956719636],
						[17.19265556335854, 50.06577682498367],
						[17.184854507277038, 50.05934142926456],
						[17.178995132557965, 50.05381774994621],
						[17.17445755012819, 50.051074982345646],
						[17.170547485406928, 50.048114777069024],
						[17.16602706925771, 50.04560470718374],
						[17.15812492385018, 50.03981018185729],
						[17.156425476049453, 50.03769683817308],
						[17.153873443650074, 50.03313827553159],
						[17.148643493507954, 50.027816771262245],
						[17.147417068368444, 50.025306700722524],
						[17.144531249946862, 50.01644134477376],
						[17.14426422112954, 50.013923644504914],
						[17.144580841007247, 50.011409759047],
						[17.147632598885934, 50.002605438307484],
						[17.148853302002205, 50.000122070314035],
						[17.153059009556472, 49.995742829569224],
						[17.154354104083612, 49.99340064535892],
						[17.15505407526434, 49.99071869916774],
						[17.156061189777805, 49.98215498986412],
						[17.157493577934833, 49.97825229976354],
						[17.15939902250851, 49.9762953874009],
						[17.166995996232455, 49.97165674976602],
						[17.17020036054417, 49.970707044714075],
						[17.1753387417441, 49.96963498175547],
						[17.178546899030696, 49.968410438085186],
						[17.17969702172949, 49.96760546617093],
						[17.181364070839166, 49.96575174251874],
						[17.182456986712257, 49.96382536279837],
						[17.18298147429512, 49.961765149869514],
						[17.182590495209876, 49.959697811332745],
						[17.181665435800344, 49.95773328109801],
						[17.179386150639512, 49.95489893161718],
						[17.17055894416708, 49.949485901213315],
						[17.16504479232581, 49.94713980469556],
						[17.16190528394004, 49.945400198469294],
						[17.15921785053003, 49.94320692072663],
						[17.15730476052849, 49.94053265714769],
						[17.15606689641796, 49.93601609847036],
						[17.15568162421191, 49.923343775941106],
						[17.155338301947378, 49.9202042841869],
						[17.15454482878419, 49.91715239196816],
						[17.153059008046583, 49.914321918661436],
						[17.14170647189535, 49.899517102894706],
						[17.140174856297982, 49.89667503118964],
						[17.139394774482263, 49.89360821307427],
						[17.139327997305433, 49.88903040957646],
						[17.140001291399003, 49.88616175744689],
						[17.141433702786028, 49.88365543923708],
						[17.14572907466211, 49.879375538942945],
						[17.147899619261683, 49.87467568037663],
						[17.153078079924267, 49.872764593251674],
						[17.160514814493414, 49.87047944142262],
						[17.16707420704667, 49.86737444983622],
						[17.170436844221598, 49.8664015479606],
						[17.177629457251353, 49.86487949493417],
						[17.180534350452678, 49.86380757530515],
						[17.184091553183734, 49.86210238505017],
						[17.192094801155804, 49.859889969954054],
						[17.195253377339736, 49.858341259943856],
						[17.19715117387331, 49.85596839025422],
						[17.197885501258334, 49.85324849577069],
						[17.197620400256508, 49.843162606760714],
						[17.198667529446823, 49.84126665878051],
						[17.200902951874667, 49.839721788359114],
						[17.204786297495748, 49.838607761710485],
						[17.20918082946699, 49.83817289224034],
						[17.236150756625264, 49.83827221996167],
						[17.240800851501927, 49.837989756856885],
						[17.245042805058965, 49.83731464028175],
						[17.246910110478364, 49.83675778687042],
						[17.251893987479995, 49.834304728798976],
						[17.25954627671924, 49.83142087193435],
						[17.27230071217858, 49.82608407018641],
						[17.276550283547678, 49.82315437118837],
						[17.281063072437206, 49.82057946736188],
						[17.285924918950048, 49.816925110716575],
						[17.292427045419064, 49.813129279146374],
						[17.29550362590363, 49.8119660218506],
						[17.299472809784366, 49.81140518974195],
						[17.303737655588645, 49.81143964037785],
						[17.30801963741667, 49.81206130446348],
						[17.310029997804193, 49.812606930021936],
						[17.321737275584347, 49.81714237181722],
						[17.329065332448675, 49.82124336543166],
						[17.33381460335479, 49.82274994566459],
						[17.338769913783832, 49.82397843288067],
						[17.34546662687725, 49.824657548649036],
						[17.350023280339663, 49.82459267873645],
						[17.35447119680854, 49.82410041286315],
						[17.361114484519973, 49.82251343618116],
						[17.365665441142735, 49.82087711943574],
						[17.3744182541824, 49.8151054011686],
						[17.381792050033777, 49.80639251722404],
						[17.38335038283678, 49.803802577193395],
						[17.385759372299663, 49.79862991498322],
						[17.38768577190282, 49.796348539924104],
						[17.38885116857878, 49.795509361579406],
						[17.406690585413013, 49.78615941526559],
						[17.41618536085873, 49.78227218885027],
						[17.421165455990742, 49.77980414456194],
						[17.424951569946302, 49.77884306304733],
						[17.435609807171065, 49.77765265523543],
						[17.439632417883733, 49.7769966299696],
						[17.441432956663608, 49.77650073309852],
						[17.448221202418324, 49.77381893471519],
						[17.45812417229649, 49.77191171610408],
						[17.462125785726602, 49.770832123792054],
						[17.47406004145219, 49.766414501177124],
						[17.47892760771198, 49.76384731326002],
						[17.48195267739106, 49.76264580503267],
						[17.485788353660748, 49.76181418594438],
						[17.489877707417435, 49.761268670131656],
						[17.498983367240342, 49.760574209723714],
						[17.5023403186343, 49.760906234792635],
						[17.507364281882854, 49.761879039722764],
						[17.51065444605395, 49.76289746343738],
						[17.513631825560893, 49.76444248396356],
						[17.515848147892005, 49.766269586092115],
						[17.51742173344168, 49.768760771743565],
						[17.53360175263823, 49.77581398891346],
						[17.537403099511007, 49.7768172629039],
						[17.541250219051882, 49.77709189937977],
						[17.543165206247494, 49.77695846015083],
						[17.546993268606094, 49.77605448881113],
						[17.550321585211808, 49.77444081646233],
						[17.55293272210674, 49.772468426329965],
						[17.5564308010914, 49.76897799138665],
						[17.56496429062544, 49.763404814989705],
						[17.56818200536234, 49.762241476455394],
						[17.57512282587558, 49.76053231874129],
						[17.581590646204017, 49.75778956054745],
						[17.58345033062221, 49.75726329198186],
						[17.589927691728732, 49.756508024030474],
						[17.59698866569263, 49.75662221394589],
						[17.60398864014186, 49.75759500240659],
						[17.61410332760927, 49.760513390225576],
						[17.61853789175312, 49.76128759870387],
						[17.625490199506892, 49.76185235347702],
						[17.634721749144607, 49.761871282092905],
						[17.639085787303983, 49.76155104733953],
						[17.64307402180571, 49.760898477192605],
						[17.65157890772934, 49.75772098421597],
						[17.661434162417954, 49.75592031913945],
						[17.66738320270584, 49.754238199852594],
						[17.67416761786738, 49.751571531528946],
						[17.676916124564784, 49.75022889917181],
						[17.679161075767823, 49.74823001297394],
						[17.679885867598653, 49.7469978604657],
						[17.680717478950935, 49.7430535233617],
						[17.680141449012332, 49.73619079620487],
						[17.68141174514373, 49.724716202663444],
						[17.682693479815683, 49.71834944349725],
						[17.685024253094753, 49.710430076914584],
						[17.693910608760525, 49.70328529887839],
						[17.699920664873936, 49.69744118731952],
						[17.707494731885582, 49.692623107186854],
						[17.71012496127816, 49.691429071307255],
						[17.71479606096453, 49.69032283262312],
						[17.719524398329703, 49.68975079184778],
						[17.733530048779024, 49.69038394551518],
						[17.738168703962817, 49.69033803329036],
						[17.742595664809222, 49.690002377952226],
						[17.746547711433447, 49.689186197549745],
						[17.751590737943303, 49.68708045799816],
						[17.759735115196893, 49.68483358982874],
						[17.76277731118826, 49.68328843354294],
						[17.764717093632203, 49.68084709952409],
						[17.76554872058635, 49.67659389867701],
						[17.765119536811287, 49.67213045620813],
						[17.76340483807665, 49.666057520649915],
						[17.763444885590914, 49.66373049992384],
						[17.76447485100187, 49.66147980533683],
						[17.765369430377177, 49.66052258375439],
						[17.767778400761962, 49.6589660982632],
						[17.771314610002026, 49.65779486315289],
						[17.780063629722758, 49.65582275855957],
						[17.786693565582727, 49.653129517351815],
						[17.795642849954728, 49.651161170862146],
						[17.8037395431312, 49.64780422289788],
						[17.81260107840037, 49.64575186317296],
						[17.8206863401616, 49.64240646223941],
						[17.82954216235075, 49.64032747241186],
						[17.832454663745853, 49.639148568945814],
						[17.835977550660978, 49.637168854581915],
						[17.841630938257683, 49.634784719482624],
						[17.844848647030236, 49.63308727351178],
						[17.847736362124966, 49.63113024674583],
						[17.852880476268833, 49.626564012609435],
						[17.857387532894872, 49.623832622940334],
						[17.86424444460089, 49.61871324548601],
						[17.866100294165864, 49.61666856244593],
						[17.866722118292532, 49.61536416678624],
						[17.867338173455572, 49.61111825919663],
						[17.866426462231995, 49.60690684494019],
						[17.864835751854006, 49.60449229065818],
						[17.860902803467077, 49.60151304859125],
						[17.859218612463238, 49.599727752757204],
						[17.857196813844432, 49.59684376804795],
						[17.85620499403577, 49.59481817582549],
						[17.855993252549535, 49.592460483543924],
						[17.85631942425493, 49.59126660581068],
						[17.857976912494248, 49.58906554398053],
						[17.860712051909204, 49.58745956841028],
						[17.86281776140405, 49.58680341291324],
						[17.867301952889733, 49.58620462597332],
						[17.871988297656312, 49.586170205844745],
						[17.876756685962444, 49.586506034864165],
						[17.881446832172927, 49.587196299769595],
						[17.885688790421927, 49.588291238612385],
						[17.891378420632265, 49.59021010617801],
						[17.89541052540397, 49.591117759106446],
						[17.899593370048002, 49.591449873433966],
						[17.90165139254891, 49.59138878421167],
						[17.90553091254744, 49.59070191908444],
						[17.907239927792183, 49.589996450045355],
						[17.909589761380325, 49.58804316369861],
						[17.91289900274279, 49.58283984767965],
						[17.915344226587305, 49.58049001762513],
						[17.916870111357312, 49.57846827554976],
						[17.917762773522824, 49.57596220571571],
						[17.91817284688411, 49.57322701438658],
						[17.91812514673695, 49.5644607069974],
						[17.918569567944274, 49.55221560149764],
						[17.917976360637503, 49.547824707565816],
						[17.91690446829245, 49.54520050056771],
						[17.915084821317354, 49.54317841603124],
						[17.908458709350395, 49.5380287140683],
						[17.899288162066462, 49.5330313383807],
						[17.897415179287403, 49.53244414767857],
						[17.893177026349687, 49.53178782259106],
						[17.888574594300685, 49.53161234814625],
						[17.88382530261506, 49.53181076448846],
						[17.876859661216475, 49.53285214276578],
						[17.865451821411522, 49.536270212103965],
						[17.858821877056332, 49.53718573534089],
						[17.855827334643205, 49.53712465901955],
						[17.853120812684136, 49.53644568972248],
						[17.84884260685632, 49.534133797190584],
						[17.846044521722984, 49.533019867377384],
						[17.842187884827958, 49.532260922131606],
						[17.83365820792958, 49.531288061765935],
						[17.82960511129737, 49.53060538756544],
						[17.82642555483806, 49.52956773864638],
						[17.822790150829306, 49.52793888319139],
						[17.81459234429761, 49.525729993071735],
						[17.811485294663072, 49.524246249581],
						[17.809375748506376, 49.52181232111975],
						[17.80820845298638, 49.51745976656466],
						[17.808050141492497, 49.51269901163405],
						[17.8085003003445, 49.497680749292485],
						[17.808021562897313, 49.491089010163684],
						[17.807197587787513, 49.487915177972646],
						[17.803987515623362, 49.48082743439721],
						[17.800521853377013, 49.475475334123544],
						[17.797977465734057, 49.47261443753323],
						[17.793643962849945, 49.46979913539312],
						[17.789793010998753, 49.4667892167035],
						[17.785305040988664, 49.46410384457858],
						[17.781135541977815, 49.46038422865677],
						[17.777862539745914, 49.4580649584714],
						[17.771596906261294, 49.453308086529105],
						[17.768299120678705, 49.451210168861785],
						[17.760446541264717, 49.44764322091845],
						[17.755613343888246, 49.44507612730908],
						[17.753732668559334, 49.4444922356057],
						[17.749494557978302, 49.44379429459363],
						[17.74489973420477, 49.443553796704805],
						[17.740150452380668, 49.44367218610158],
						[17.735412599312692, 49.44419099262944],
						[17.731033337928082, 49.44521342262979],
						[17.718988422907106, 49.44968036399437],
						[17.7130527620211, 49.45326624578328],
						[17.70758437933501, 49.45583342049451],
						[17.704519255491203, 49.457584246374765],
						[17.701793672514505, 49.459560409607526],
						[17.697721467286424, 49.46323383213536],
						[17.69516181992905, 49.464679721896786],
						[17.692131037735223, 49.46564861202926],
						[17.687511425727173, 49.466483918492514],
						[17.684246050624683, 49.466457263031295],
						[17.67967986578484, 49.46554942925158],
						[17.675390240969513, 49.46387479577516],
						[17.668846117952693, 49.45825185064918],
						[17.665618887209828, 49.45630638096633],
						[17.661897641216765, 49.45486053793923],
						[17.658254630837604, 49.45430761746483],
						[17.646215456077055, 49.45470061238927],
						[17.639678972950346, 49.45455184452442],
						[17.635692583262248, 49.45376957490691],
						[17.633932119004466, 49.45293430943919],
						[17.632669448520723, 49.451847073671445],
						[17.631523132681348, 49.44940948781714],
						[17.631481179752978, 49.448169783523625],
						[17.632263174022604, 49.445789257972045],
						[17.63400460284841, 49.443916403143135],
						[17.638067263275868, 49.441108850797455],
						[17.645528807030583, 49.43373882177726],
						[17.647853837085304, 49.430194737007454],
						[17.64894485513776, 49.42686081264675],
						[17.648906713063127, 49.42464069935939],
						[17.64826773167474, 49.423217655148434],
						[17.64723013033683, 49.4219129982063],
						[17.64433858924079, 49.41964706328556],
						[17.640693661399876, 49.41781995071947],
						[17.63664054930762, 49.41658783457122],
						[17.62694547791692, 49.41471085195561],
						[17.624042524907708, 49.4135934076214],
						[17.61905859079943, 49.41109451454123],
						[17.609344492896607, 49.40769204247899],
						[17.60567091397708, 49.406803006794256],
						[17.60397912029859, 49.40663536394708],
						[17.6007270817937, 49.40676117354131],
						[17.59796334363808, 49.407470790372464],
						[17.594516757113645, 49.40898516254648],
						[17.591154098242672, 49.4099082924513],
						[17.575571041973514, 49.41252121097249],
						[17.5710353936198, 49.41296775245001],
						[17.566400545657054, 49.41306319652942],
						[17.559539789696682, 49.41257853929414],
						[17.543811813393642, 49.41008771284333],
						[17.54024314798384, 49.409133904303694],
						[17.536497123998156, 49.4074593249323],
						[17.533449167247984, 49.4064559459364],
						[17.518947585189018, 49.40440736667958],
						[17.516998280948055, 49.40387717431258],
						[17.513948455622646, 49.40237057863779],
						[17.507598884113385, 49.396308958709845],
						[17.502077108954463, 49.39020162117946],
						[17.493537896837722, 49.38425059075387],
						[17.49075127350788, 49.38297277605736],
						[17.482282648205107, 49.3798256728308],
						[17.47831917597171, 49.378700322308674],
						[17.476179130491968, 49.37834555284546],
						[17.46977044449524, 49.3781357898179],
						[17.46583555564502, 49.37864671955533],
						[17.462768548945164, 49.37963480907419],
						[17.45919989507569, 49.381313237514746],
						[17.45578955047295, 49.382282126638636],
						[17.425064072221957, 49.38791644164453],
						[17.415149682233096, 49.388416235808506],
						[17.390075695449635, 49.38821421102169],
						[17.385395055765077, 49.38847355882103],
						[17.381013861869366, 49.38921349159592],
						[17.377618803834363, 49.39064037794411],
						[17.37556268592379, 49.39249053906895],
						[17.374938977843268, 49.39360820264295],
						[17.374628055075267, 49.39474477257175],
						[17.3747329773439, 49.39698415210375],
						[17.376235958510918, 49.40122220038008],
						[17.37665557135555, 49.40377801513534],
						[17.376373289261867, 49.4063072057105],
						[17.375808702039873, 49.40752780770404],
						[17.37479972484674, 49.40867993233194],
						[17.373554230438423, 49.40952683085475],
						[17.370647446171354, 49.410640849027764],
						[17.36599730706383, 49.41136163217411],
						[17.36215592416728, 49.41099938106537],
						[17.35838889776017, 49.40967557292169],
						[17.354892714368383, 49.40784822054985],
						[17.348070158176363, 49.40353786415956],
						[17.341564162077297, 49.398856978557674],
						[17.338735563152184, 49.39636597359603],
						[17.33658407479088, 49.39364228727423],
						[17.335933681221427, 49.392215694339306],
						[17.335416794278075, 49.38936996843604],
						[17.335777295156095, 49.386657819795055],
						[17.33629035154747, 49.38540261238078],
						[17.337057096266836, 49.38425430894349],
						[17.341373442282478, 49.38018416243967],
						[17.344951627067182, 49.3746299526729],
						[17.346965798927915, 49.37290199354169],
						[17.350217828981698, 49.370933615097876],
						[17.353967666928835, 49.36800384776888],
						[17.357017527039606, 49.36605843351201],
						[17.35877226015051, 49.364162295969535],
						[17.359304416655277, 49.36297597770463],
						[17.359609593156357, 49.360473542361],
						[17.358945834728768, 49.35800923860793],
						[17.35820008003012, 49.356868801153965],
						[17.35439491548069, 49.35380937998692],
						[17.349399580780734, 49.34917461880258],
						[17.344831467541923, 49.34632874267427],
						[17.337387087642057, 49.34322359443267],
						[17.332550031420666, 49.34068665094333],
						[17.329189311560313, 49.33967981122241],
						[17.32381056615402, 49.33853139907875],
						[17.320522320024047, 49.33749018055732],
						[17.31144333220279, 49.332435636233186],
						[17.303688058036542, 49.326530530423376],
						[17.30210686503369, 49.324394291610865],
						[17.300392157255896, 49.32090001743034],
						[17.29887580923184, 49.318706516825685],
						[17.29500008814423, 49.31557474649266],
						[17.29014204812882, 49.3108443263811],
						[17.28712081756771, 49.308891283452],
						[17.283550263202866, 49.307304388705006],
						[17.27832413862963, 49.30596933536676],
						[17.271730410619426, 49.30485142702255],
						[17.264284150892525, 49.30424895414974],
						[17.257997499004762, 49.30308520969627],
						[17.24858856092897, 49.302524557437316],
						[17.239725125132505, 49.301612958007546],
						[17.227544771563878, 49.30153644946687],
						[17.216037757466157, 49.30030828910531],
						[17.210527426938363, 49.2990265480543],
						[17.204002397718277, 49.296085505677965],
						[17.19653320282868, 49.29410934195174]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ71",
				"name": " Olomoucký kraj",
				"region": "olomoucky"
			},
			"id": 8
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[16.791303644615997, 49.60816964170781],
						[16.780109404936567, 49.606765742053604],
						[16.77090837214053, 49.60733046418331],
						[16.764827731510426, 49.60810854849882],
						[16.76125718946529, 49.609054719578964],
						[16.75479127714492, 49.611896665146574],
						[16.74601745123876, 49.61403651840266],
						[16.738050477706622, 49.61750808071585],
						[16.727602004123927, 49.62010573578198],
						[16.72262384207858, 49.62234893263885],
						[16.720832826867667, 49.62287523233133],
						[16.71680450247317, 49.62358854536986],
						[16.708190933635912, 49.624523298598426],
						[16.704179779482587, 49.62520994432142],
						[16.702405934670228, 49.62570957793736],
						[16.69731329787786, 49.62786474368681],
						[16.69135095312748, 49.629089496284784],
						[16.66777801478464, 49.63111877135576],
						[16.66197205931315, 49.630935785475245],
						[16.651964176938552, 49.62987509024012],
						[16.642549518374448, 49.62988284384428],
						[16.63623428194079, 49.63069914460709],
						[16.634485248215604, 49.63120654259575],
						[16.62969018065023, 49.633266539153404],
						[16.62804793015574, 49.63368213818346],
						[16.62250327646207, 49.6340865725154],
						[16.61883163930071, 49.63366321910847],
						[16.617170329798327, 49.63322063721244],
						[16.61100579872911, 49.63045133874282],
						[16.60247228804987, 49.62829956275223],
						[16.59630967412803, 49.62588511673312],
						[16.593189230281222, 49.62551108898485],
						[16.58982087759729, 49.62582029762313],
						[16.58619691245125, 49.626953238787806],
						[16.57607079885019, 49.632106897374285],
						[16.5722694368181, 49.6335258232451],
						[16.568042755527717, 49.63432693831499],
						[16.563791258415584, 49.634498451081875],
						[16.56173706814435, 49.63434988938383],
						[16.559774387290783, 49.63402547311592],
						[16.556596768334213, 49.63285838434592],
						[16.550497049189577, 49.6287154638485],
						[16.548658355329103, 49.62663255359068],
						[16.547626482666303, 49.623935588389365],
						[16.54637147324178, 49.616455194370054],
						[16.545381547759607, 49.613437667811816],
						[16.541292185918078, 49.606830556336924],
						[16.53892708615895, 49.60160453099533],
						[16.53730392277411, 49.59923933370879],
						[16.534603107191234, 49.59738148918683],
						[16.531272898011785, 49.59622201000614],
						[16.52629470010319, 49.594886708307435],
						[16.520130140453855, 49.59222015705975],
						[16.518396373958744, 49.59178539926991],
						[16.514623647358732, 49.59141545260133],
						[16.51078987322034, 49.59164430471052],
						[16.508974065003052, 49.59200277807266],
						[16.506071099300225, 49.59314735338268],
						[16.503082263718724, 49.59515370607022],
						[16.498643888719442, 49.59762585187657],
						[16.4945487899279, 49.60040657925395],
						[16.490219132377515, 49.60182967088138],
						[16.48717879164278, 49.60240926744887],
						[16.484056459292958, 49.60267627305043],
						[16.48095129836069, 49.60240926744887],
						[16.476400370405457, 49.60148234772401],
						[16.473573678777658, 49.600570626676266],
						[16.46884726707344, 49.59822838676332],
						[16.46705627352526, 49.5976562421766],
						[16.46286009799931, 49.59691230107152],
						[16.45322226141919, 49.5963820234029],
						[16.43017769837732, 49.59650048299747],
						[16.420576106792936, 49.5961075818825],
						[16.416334148207735, 49.595378840288404],
						[16.414472583963544, 49.59476855956042],
						[16.406536098726438, 49.59014126485022],
						[16.40442466831957, 49.58850861445285],
						[16.399066940637113, 49.58298124748264],
						[16.393678663097088, 49.57847974858101],
						[16.382349027648175, 49.588390468645095],
						[16.3759880172931, 49.594791507081815],
						[16.37156486177791, 49.597568482442426],
						[16.367891294407073, 49.60065063471998],
						[16.363874428300054, 49.60348504432922],
						[16.36230277875903, 49.60558699328492],
						[16.36054421527471, 49.60903177077981],
						[16.35890578551845, 49.61115640413423],
						[16.350423811045943, 49.61671446141573],
						[16.347566588963886, 49.61770997488135],
						[16.33984756152955, 49.61956021362489],
						[16.337274552969543, 49.62065125910246],
						[16.33240701351615, 49.62322630615211],
						[16.322610850161325, 49.626628831907986],
						[16.318895342882104, 49.62749102318374],
						[16.315542234653982, 49.6276398910365],
						[16.31253050616256, 49.6271780908342],
						[16.307888014882682, 49.62522110930774],
						[16.304264052486104, 49.62434372895063],
						[16.30002974214824, 49.62389744154649],
						[16.295589434565734, 49.62382114787781],
						[16.29125787013139, 49.62416850135023],
						[16.28738784922705, 49.625125896801],
						[16.279373161190865, 49.629505088522556],
						[16.27441980146343, 49.63321319365521],
						[16.27005576177856, 49.63606254117407],
						[16.268224720464566, 49.637905158899855],
						[16.261613832074662, 49.64611041236003],
						[16.258705144388077, 49.65269093394817],
						[16.25708009129242, 49.65494930534169],
						[16.24933624232317, 49.66094970389336],
						[16.244869242119176, 49.66347893977136],
						[16.240976328767122, 49.66638942216465],
						[16.2317256766366, 49.67137513123187],
						[16.227983476249435, 49.67239381234239],
						[16.21725082610604, 49.673572559271314],
						[16.21320535366102, 49.67422118260525],
						[16.21141243232896, 49.67471315721583],
						[16.20630838048056, 49.67684950439428],
						[16.202543263477246, 49.677738232580246],
						[16.191770565532018, 49.67892848178418],
						[16.18772316373645, 49.679611241266315],
						[16.1790656965561, 49.68278496464915],
						[16.175012594532923, 49.683460289450025],
						[16.166322709736164, 49.684360518497996],
						[16.162277228256965, 49.68507772600044],
						[16.159187314506593, 49.68617246401338],
						[16.1555709741042, 49.68793478806071],
						[16.152242661614903, 49.68894578002848],
						[16.14515878463905, 49.690597685644036],
						[16.140180572045246, 49.69279465917801],
						[16.137201310675334, 49.693714155004926],
						[16.13349915472112, 49.6940842499113],
						[16.129751194773952, 49.69388570773194],
						[16.128000249794074, 49.693576726773614],
						[16.126428591054264, 49.693115117366496],
						[16.121978763344867, 49.690975221259556],
						[16.11862946421689, 49.690189439051835],
						[16.11486433470392, 49.689979421873204],
						[16.112960828383063, 49.69009792489804],
						[16.109371168811002, 49.69087967398426],
						[16.10695076607778, 49.69213109795895],
						[16.10178946296721, 49.695442096439585],
						[16.099775297182198, 49.69736083870198],
						[16.096675883138882, 49.7032204600844],
						[16.09297181106343, 49.70731743571407],
						[16.092138286129973, 49.708843192876685],
						[16.091493614870696, 49.71149452022822],
						[16.091262825154537, 49.71575171759997],
						[16.058652877778986, 49.71710967991811],
						[16.05228423151714, 49.717990792550154],
						[16.045202265174595, 49.720462888262226],
						[16.04118921061896, 49.721286925516786],
						[16.03419877612365, 49.72181715271008],
						[16.01940347483128, 49.72219101163692],
						[16.01263619237719, 49.72309882407043],
						[16.008914944318146, 49.72460171686479],
						[16.006795883029078, 49.72670745714816],
						[16.003803249377857, 49.73374554077193],
						[16.002040869350385, 49.73660284004637],
						[16.00036431287549, 49.73841484802164],
						[15.999129299888672, 49.73921970640389],
						[15.995945921789723, 49.740260999607],
						[15.99419497312239, 49.74048222842202],
						[15.990728387437626, 49.74040993343038],
						[15.985911380876372, 49.739566907088815],
						[15.980789176869859, 49.73807137222721],
						[15.977322584312065, 49.736240440005716],
						[15.974579808398213, 49.73391339729365],
						[15.972701065470075, 49.73102944532877],
						[15.97183895181923, 49.72780609770138],
						[15.971605302251426, 49.71276093746633],
						[15.971071250202138, 49.709522309778386],
						[15.969734183851163, 49.706447528655616],
						[15.96799088408359, 49.70438011527096],
						[15.96445558878991, 49.70173630771495],
						[15.957601532111669, 49.69860826160784],
						[15.954054835825772, 49.6966972655688],
						[15.950790403757457, 49.695541368117404],
						[15.94437026186215, 49.69465630043218],
						[15.937314986290373, 49.69443511154782],
						[15.927686689764348, 49.694641099506896],
						[15.920849788113376, 49.69519795032178],
						[15.916834821138753, 49.69593038937839],
						[15.910376550174131, 49.698589337713024],
						[15.908742889088124, 49.69902024445415],
						[15.905101787978976, 49.69944773940858],
						[15.901326173748288, 49.699325509282914],
						[15.897809977357454, 49.698604538874314],
						[15.891395578368323, 49.695678797410366],
						[15.88389111228839, 49.69331365894429],
						[15.878511420836745, 49.691287921684136],
						[15.870955473768863, 49.6949082016119],
						[15.868059173188838, 49.696628705750534],
						[15.864492430576608, 49.69962705172974],
						[15.862885487331196, 49.702060810189224],
						[15.862034805816064, 49.70485694666759],
						[15.861713397287447, 49.707866558322266],
						[15.86222744018696, 49.721874239846684],
						[15.861928947536963, 49.72626502374792],
						[15.860989554270816, 49.72895035194402],
						[15.860093101410083, 49.73017869352063],
						[15.858766539002106, 49.73126586920455],
						[15.857078556282685, 49.73208621832529],
						[15.855212210282017, 49.732631671289774],
						[15.851187717392476, 49.733196362170595],
						[15.838209157083645, 49.73363880766251],
						[15.834093092642407, 49.73401640726588],
						[15.83048917126109, 49.73481380515363],
						[15.82548238311128, 49.736988200932],
						[15.82193373733079, 49.737903512952286],
						[15.803941731574119, 49.74046330140506],
						[15.788812653854023, 49.74144378480033],
						[15.78478812278358, 49.74215308622916],
						[15.782923682440916, 49.742751929313755],
						[15.780200002657766, 49.74422453081518],
						[15.778163920854176, 49.74630747292449],
						[15.775836932152131, 49.75115573983694],
						[15.77439595166993, 49.75334175678516],
						[15.770584120768186, 49.75646985730395],
						[15.765925415612779, 49.761306837582],
						[15.761522277845506, 49.764228681604905],
						[15.754191395255607, 49.76733395364056],
						[15.750647547499026, 49.769245171803576],
						[15.747627257970471, 49.77033996280204],
						[15.743871685334426, 49.770992246994126],
						[15.731258387676972, 49.77199550184566],
						[15.727061286600176, 49.7726785118342],
						[15.723009118046596, 49.773853380221034],
						[15.714275369436548, 49.77695473626637],
						[15.711476337771622, 49.77817927656057],
						[15.707277311830408, 49.78111279775957],
						[15.70276070561888, 49.78364571419715],
						[15.698998448114063, 49.78661343579301],
						[15.694417942166325, 49.7890585815707],
						[15.691264157731132, 49.79110341071079],
						[15.688376410714865, 49.792365881409864],
						[15.686550141855115, 49.79284287849709],
						[15.676326759112689, 49.79469687573761],
						[15.66828727649764, 49.79702758124889],
						[15.664107327820453, 49.79792790348325],
						[15.64749337742805, 49.799690384335484],
						[15.644124016277726, 49.80055223233435],
						[15.639174468062635, 49.802795471686316],
						[15.63744355755538, 49.803302903388264],
						[15.6313390850816, 49.80414210766071],
						[15.622360215110106, 49.80428300983532],
						[15.617930395736087, 49.80403503447497],
						[15.613801966160379, 49.8035012210098],
						[15.610301030914323, 49.80257046407188],
						[15.605606082222883, 49.80029681218466],
						[15.603919982556471, 49.79980086954635],
						[15.600033759103459, 49.79925154748686],
						[15.59578799544829, 49.79926675469163],
						[15.59361552279949, 49.79950324236112],
						[15.58936690369284, 49.800537025052094],
						[15.585516937664671, 49.80219276208621],
						[15.580190664293989, 49.80524449858222],
						[15.556209574094423, 49.82109841885942],
						[15.516434685543539, 49.84682479430896],
						[15.508492479275294, 49.8526993674856],
						[15.501938816382374, 49.859401670497256],
						[15.504444138977885, 49.863849793889145],
						[15.505741114025827, 49.868423412402166],
						[15.506286612969598, 49.87470237857799],
						[15.505960480818821, 49.882450254640816],
						[15.505431191204785, 49.88535705054045],
						[15.504482277749405, 49.887989122311325],
						[15.502889619344469, 49.89010988815305],
						[15.498510359051664, 49.893188461178426],
						[15.49774454953099, 49.894946953110974],
						[15.497935311777418, 49.89605346813575],
						[15.498535153361493, 49.897098514593665],
						[15.50059796792071, 49.89896787328249],
						[15.505114541883916, 49.90121447528854],
						[15.508919709554192, 49.90221017723708],
						[15.51731109200071, 49.903301200384604],
						[15.521464342886846, 49.904167129655015],
						[15.5251894145566, 49.905704634976246],
						[15.528219212509343, 49.907833002543015],
						[15.530196173804613, 49.91035446624111],
						[15.531368257657075, 49.914348621090106],
						[15.531348212563763, 49.91992172875858],
						[15.530323015833094, 49.9263609668445],
						[15.530824667219036, 49.93529134513457],
						[15.53025722156301, 49.94420620585831],
						[15.531190869863737, 49.9504585052092],
						[15.531279556581927, 49.9549865049873],
						[15.530427944750768, 49.9592934758327],
						[15.529774658070536, 49.9606055500259],
						[15.527854916495416, 49.962661716169414],
						[15.52157688915031, 49.96678931674782],
						[15.518718734242125, 49.96802534317192],
						[15.50996209738025, 49.97003188053976],
						[15.501719484106168, 49.97330864890528],
						[15.4926471672406, 49.975349391481416],
						[15.484672551510512, 49.978542375053095],
						[15.475851049816944, 49.9805449597266],
						[15.472969064113789, 49.98173912652908],
						[15.466340054481526, 49.9854735358639],
						[15.463603015786852, 49.987808191345756],
						[15.462838164682237, 49.989715500327875],
						[15.464182853702766, 50.00167465213733],
						[15.463925361619685, 50.0036239622764],
						[15.46342086792247, 50.00457000734659],
						[15.461779594433553, 50.00622177135182],
						[15.453913688624242, 50.01058578458573],
						[15.45062637335234, 50.0117454534448],
						[15.44632720948354, 50.012401580909675],
						[15.432171821586408, 50.01304626457657],
						[15.425576210083054, 50.01381301936139],
						[15.423664093019546, 50.0142974853692],
						[15.416749954205207, 50.016872405835194],
						[15.406908988900083, 50.01873016308775],
						[15.402902603128732, 50.01979064922183],
						[15.392505645751053, 50.02374267577284],
						[15.38969707494239, 50.02511596727933],
						[15.382326126175517, 50.0311889655551],
						[15.373277664139913, 50.03791809040668],
						[15.375045776283647, 50.03975677412967],
						[15.376599311758893, 50.04208755428653],
						[15.379257202280462, 50.05071258666914],
						[15.38085079194291, 50.05328369151436],
						[15.38212585429347, 50.054378507685826],
						[15.38361072524133, 50.05517959445568],
						[15.387025832899795, 50.05626296784557],
						[15.39449024204231, 50.05801773106218],
						[15.399612426949627, 50.06031036553783],
						[15.402439117439545, 50.06224823005337],
						[15.40627002740188, 50.06576538308301],
						[15.40930271134762, 50.06806182732997],
						[15.411144256777801, 50.0701637285193],
						[15.41180038440696, 50.071475981610995],
						[15.412589073018118, 50.0743141159305],
						[15.412999153317907, 50.07887268232748],
						[15.412785530596606, 50.085083012473326],
						[15.411991119139516, 50.089523313172236],
						[15.410075187355153, 50.09335708316298],
						[15.405806541472915, 50.09773635891856],
						[15.402018547373835, 50.105453494117036],
						[15.399709702052668, 50.1086387681636],
						[15.40288162195196, 50.109546658040685],
						[15.406598091349558, 50.11026764122048],
						[15.412875175552328, 50.11054611276225],
						[15.416776657500902, 50.11013031370289],
						[15.418516158964566, 50.10971832189851],
						[15.423579216369932, 50.107723239452476],
						[15.427124023443575, 50.10689163213589],
						[15.43779373206799, 50.10592270245007],
						[15.443631172603459, 50.10416412742146],
						[15.447905540244573, 50.10145950113845],
						[15.45684909768761, 50.096534724250425],
						[15.45853519399043, 50.09601974114267],
						[15.462271690160303, 50.09553146171151],
						[15.466110229900925, 50.09565735238041],
						[15.467943191491866, 50.095947265289645],
						[15.470932960361823, 50.09692382676384],
						[15.475842475985653, 50.099147797496116],
						[15.484675407469565, 50.101234436583034],
						[15.487590789887687, 50.10236358727445],
						[15.491147994772447, 50.10414886270871],
						[15.499295235085608, 50.10643768681256],
						[15.502621650912571, 50.107864381864786],
						[15.504685401446146, 50.109615321627345],
						[15.507499694665334, 50.11365890357667],
						[15.510457992033214, 50.121440882697144],
						[15.512052536081622, 50.124008179357695],
						[15.514163970582434, 50.125869747646284],
						[15.516953468314474, 50.12739562980776],
						[15.527458191269517, 50.13126373611616],
						[15.531536102364285, 50.13249969545702],
						[15.544635772443696, 50.134712216856514],
						[15.556121826696371, 50.13737106800496],
						[15.559490203622437, 50.13743209625013],
						[15.562548637403598, 50.13685989392018],
						[15.571254730017635, 50.13228225519791],
						[15.575366020570128, 50.12961578703315],
						[15.579669952321098, 50.128196715658326],
						[15.584327698172608, 50.12732315443985],
						[15.587590217108625, 50.12712478199907],
						[15.602934837061925, 50.12779235586298],
						[15.620992660444259, 50.128116606956006],
						[15.63120555859423, 50.12807464434027],
						[15.638501167787645, 50.127746586470266],
						[15.64500617961232, 50.12682723820444],
						[15.646840096018927, 50.12629318688858],
						[15.651870727187465, 50.12410354296012],
						[15.655379295420055, 50.12317657534934],
						[15.659333228753841, 50.12256240563243],
						[15.668804168978983, 50.12160492194419],
						[15.67385196728009, 50.121734622955906],
						[15.68570899969346, 50.123134613575424],
						[15.689271926979526, 50.12405014128045],
						[15.694322586418142, 50.12614822711185],
						[15.69778346971283, 50.12690352995679],
						[15.711597442967959, 50.12772369692147],
						[15.714264869327852, 50.128570553376846],
						[15.71649646745657, 50.129882811294145],
						[15.722208976369295, 50.134254452176464],
						[15.724068641556249, 50.136203764910526],
						[15.727510452613442, 50.14402771304583],
						[15.731645584339981, 50.15055847377952],
						[15.734368324656613, 50.15712738375752],
						[15.735999107260435, 50.15942001252485],
						[15.742165566324477, 50.16376114640413],
						[15.74464511905569, 50.16513443300478],
						[15.748728752184931, 50.166286468942076],
						[15.7558059703047, 50.16702652934485],
						[15.765849113618517, 50.167224885415195],
						[15.773167610045244, 50.166889189568245],
						[15.777677536549778, 50.16617203241825],
						[15.779744148071583, 50.16552352741469],
						[15.781584740122385, 50.164585117443046],
						[15.78293991169486, 50.163436896871325],
						[15.784485817370681, 50.160831455134655],
						[15.78650379165428, 50.15053558210823],
						[15.792878151038423, 50.13340377895858],
						[15.794537544711412, 50.13101196702197],
						[15.79589176150634, 50.129959103993336],
						[15.797702789665738, 50.12910080277921],
						[15.801802635220032, 50.12815856957885],
						[15.808316231051293, 50.12798309574711],
						[15.812528610052212, 50.128494261107946],
						[15.814480781795277, 50.12895965791185],
						[15.817498207194223, 50.130241394955085],
						[15.820537566714258, 50.132278438584095],
						[15.82830905935578, 50.13667679023259],
						[15.831451416136371, 50.137901307232525],
						[15.833538055287915, 50.13833999515713],
						[15.840570449733354, 50.138965605833285],
						[15.858115196217252, 50.13927841176788],
						[15.86274242384472, 50.13973235935338],
						[15.866798400464651, 50.14078139889228],
						[15.869272231550543, 50.14209365394253],
						[15.875441551316285, 50.14628219700461],
						[15.87701702127592, 50.14841842737506],
						[15.878663063350745, 50.15186691552738],
						[15.880106925763737, 50.15404510319268],
						[15.883828163651396, 50.15724182578027],
						[15.888632774389556, 50.161983490314256],
						[15.891723631914282, 50.16392134820943],
						[15.895494461958734, 50.16544724310509],
						[15.897733689375736, 50.16599656059527],
						[15.902384759029689, 50.16658783878309],
						[15.909378052811443, 50.166618356530925],
						[15.913775444024587, 50.166164398138385],
						[15.917651175976298, 50.16526031070947],
						[15.922739028114407, 50.163120262526206],
						[15.92449855750628, 50.1626129102591],
						[15.928544998588421, 50.16191101446529],
						[15.942225456400445, 50.16043472434318],
						[15.948496818798382, 50.158805849437265],
						[15.957096100338777, 50.155559544096555],
						[15.959913253722291, 50.15417861883517],
						[15.968504905420511, 50.14696883906938],
						[15.97586917883224, 50.14133071952851],
						[15.979544640040361, 50.13796234532092],
						[15.982049941894347, 50.13446807753018],
						[15.986023902985654, 50.122318268642694],
						[15.987927437352871, 50.11204529273203],
						[15.989450454836572, 50.10946273914203],
						[15.990795135208092, 50.10833358507513],
						[15.992572784221336, 50.10744476138877],
						[15.994565010034705, 50.10684204069524],
						[15.998924255568221, 50.10621261771405],
						[16.006052017137275, 50.106010436350665],
						[16.033899306914957, 50.106445309529164],
						[16.04079628027997, 50.1058731112043],
						[16.04473304701299, 50.10481643259281],
						[16.04717636113347, 50.103477478463994],
						[16.05329704255037, 50.099296567206736],
						[16.05487442068443, 50.0971565292365],
						[16.0565414427521, 50.093700407884334],
						[16.058029174479405, 50.09153365801406],
						[16.061893463321393, 50.08840561077886],
						[16.065584183272033, 50.08477020734221],
						[16.0683612820695, 50.082744595922534],
						[16.073566436514998, 50.08032226339386],
						[16.083330154181503, 50.0781936624553],
						[16.086719512923285, 50.07716369614526],
						[16.09127998378316, 50.074600222044246],
						[16.09612274185345, 50.07229614393793],
						[16.100538253899888, 50.06971359355025],
						[16.112243652230696, 50.066394804911724],
						[16.116662978872732, 50.06379318014185],
						[16.12144470189402, 50.061408994340425],
						[16.125749588114555, 50.05854797452966],
						[16.13464546225536, 50.054294588112235],
						[16.139259338177283, 50.051116941583054],
						[16.14523315420207, 50.045909880757186],
						[16.152734756503254, 50.044818878468774],
						[16.154487609631882, 50.04430770670349],
						[16.159492492883167, 50.04214096251674],
						[16.163146972423267, 50.0412521341817],
						[16.169557571534703, 50.04063415635993],
						[16.178796768295687, 50.040596009241796],
						[16.185752868544714, 50.04111480618295],
						[16.190206527571576, 50.041870115972294],
						[16.200321197440896, 50.04484558044994],
						[16.204652786041763, 50.04571151546467],
						[16.220945358428406, 50.0479393018692],
						[16.226772308379886, 50.04802322414222],
						[16.232221603464126, 50.04723358216029],
						[16.241168975705776, 50.04500579725143],
						[16.24497222885978, 50.043437956502984],
						[16.2574195861777, 50.037143707240006],
						[16.26113510131901, 50.03591537476151],
						[16.266519546438243, 50.03478240905021],
						[16.26987266544772, 50.034267425907146],
						[16.273319244493155, 50.03408813571275],
						[16.2908535002918, 50.034759520833866],
						[16.297918319601376, 50.035602568699815],
						[16.302146911594452, 50.036933898692276],
						[16.305482864488656, 50.03888321017751],
						[16.30783462530085, 50.04134368945915],
						[16.3088779448048, 50.04411315794546],
						[16.308822631659538, 50.04681777800268],
						[16.30789375309067, 50.049270630221486],
						[16.307104110535914, 50.050327299441065],
						[16.303728103488822, 50.053222654951476],
						[16.302530288540297, 50.05535888535884],
						[16.302202224802137, 50.05777740540025],
						[16.302379608142743, 50.05899429311168],
						[16.303550720008747, 50.06127548038209],
						[16.31116676328165, 50.067054748325006],
						[16.315807342363385, 50.069488523945836],
						[16.319850921466657, 50.07232284403044],
						[16.324434280299617, 50.07478713905859],
						[16.332136154115705, 50.08077621408599],
						[16.333023071301177, 50.08194351206773],
						[16.33411979704297, 50.08460617317338],
						[16.33554458644424, 50.09203720320795],
						[16.33663177519554, 50.09502029673434],
						[16.338867187348416, 50.098266600246895],
						[16.34432220439502, 50.104274748064995],
						[16.345504761034345, 50.10515594735814],
						[16.34832763672652, 50.10657501227333],
						[16.35886383093853, 50.11045837724761],
						[16.36294174151837, 50.11146926511823],
						[16.37289238026089, 50.1132392926582],
						[16.381088256665592, 50.116554258779956],
						[16.38822174022981, 50.11815261414766],
						[16.391550063736986, 50.11919784243425],
						[16.39763450600871, 50.122375486407094],
						[16.415636062268984, 50.12932586365267],
						[16.420503616447153, 50.13190078833829],
						[16.42337226843857, 50.13307189736046],
						[16.432287216321107, 50.135116578307844],
						[16.43389320423325, 50.13565063905502],
						[16.43874168435384, 50.13792419772788],
						[16.442045211424297, 50.138851162605214],
						[16.447429657211398, 50.13995742994965],
						[16.450750351163695, 50.14104461851935],
						[16.458059310782502, 50.14596557504865],
						[16.459745407381618, 50.147872927187095],
						[16.460645675384185, 50.15023040535154],
						[16.461923598834048, 50.157726284326536],
						[16.463302612122476, 50.15998840175452],
						[16.465568542419163, 50.161529540488516],
						[16.46859168990866, 50.162307737928394],
						[16.47160339359357, 50.16237258944512],
						[16.47734451274768, 50.16194915606796],
						[16.48308372466925, 50.16091537212715],
						[16.48477745008247, 50.16034698075281],
						[16.491056442439, 50.15733337555182],
						[16.498123169251556, 50.15554046893421],
						[16.501409530704496, 50.15442657526186],
						[16.506046295027055, 50.15176010012729],
						[16.508840560839573, 50.1506042474163],
						[16.51707458512045, 50.14768219130746],
						[16.520759582692982, 50.14678573756866],
						[16.522449493925723, 50.14661789383675],
						[16.525678634084574, 50.14673995493074],
						[16.528396606387325, 50.147438048820476],
						[16.533433914390663, 50.14939117608019],
						[16.537256240492155, 50.15004348453237],
						[16.54157257087439, 50.15042114320813],
						[16.55814361537634, 50.15068435372921],
						[16.56035567900757, 50.15060502439303],
						[16.566667927604062, 50.14221180861628],
						[16.584237914439065, 50.127432348208764],
						[16.61865441866541, 50.10702016014557],
						[16.660615681595534, 50.09301584655602],
						[16.701233356977212, 50.09492787680572],
						[16.701782055252597, 50.095409367729594],
						[16.706087213860236, 50.09918722082952],
						[16.707115649755035, 50.100089686741356],
						[16.72581422332636, 50.11649800374296],
						[16.728447699464148, 50.118808918408064],
						[16.732032511527972, 50.12195465646966],
						[16.732402264078384, 50.12212663001526],
						[16.754253376879788, 50.13228993698317],
						[16.75522536398199, 50.1331754318626],
						[16.759316208766982, 50.13690226592375],
						[16.760353537957418, 50.13784729072208],
						[16.766449015939056, 50.14340037048474],
						[16.777301065677907, 50.15693959328404],
						[16.791887430550684, 50.17110681842566],
						[16.795284464809328, 50.1744062368104],
						[16.796455386430054, 50.175051054845895],
						[16.798527232465965, 50.176191986543074],
						[16.817712035860026, 50.18675689582399],
						[16.83755578488357, 50.18861723963386],
						[16.857606242291315, 50.18773875244035],
						[16.86235662458171, 50.18851646959695],
						[16.86198425203925, 50.18818282335038],
						[16.86022758444178, 50.185791012298395],
						[16.858242035362963, 50.182163242302956],
						[16.85655212338996, 50.18003081744315],
						[16.84585380543174, 50.17200088408422],
						[16.84396934434263, 50.17013930644743],
						[16.84024810758201, 50.162429806815155],
						[16.835834503635944, 50.15588379294517],
						[16.83194923422509, 50.145866395861454],
						[16.82757949885973, 50.139324193016925],
						[16.824657440342776, 50.132732392679564],
						[16.82301330611354, 50.13044357678097],
						[16.818956374639175, 50.127326961265574],
						[16.81385803274041, 50.12274551824467],
						[16.809360504247362, 50.12006759725241],
						[16.80226135283383, 50.11702728519964],
						[16.800298690965228, 50.11544799947417],
						[16.79965019231776, 50.11450195360602],
						[16.799186706155364, 50.11251067788196],
						[16.799350738925924, 50.11029434542069],
						[16.79987525919392, 50.10773467844235],
						[16.800849914678118, 50.105201722265306],
						[16.802505493685434, 50.10293198071783],
						[16.80761528054743, 50.099075320724246],
						[16.81227493255571, 50.09403228501833],
						[16.81406021163499, 50.091754917154645],
						[16.814899444495403, 50.089439391374924],
						[16.814598083464837, 50.08731460544874],
						[16.814039230911153, 50.08635330676429],
						[16.80686759956094, 50.08073043885408],
						[16.80281257637438, 50.07794570990752],
						[16.80188560497968, 50.076801301073445],
						[16.800804137901327, 50.07416534185318],
						[16.80060005177659, 50.06988143833501],
						[16.801273345918304, 50.06711578344657],
						[16.802698135222695, 50.0646972643285],
						[16.806205749396966, 50.061550139410535],
						[16.807064056496806, 50.06039810265404],
						[16.808500290104163, 50.056282045038124],
						[16.808692932140524, 50.05325698862301],
						[16.808258056753804, 50.050170899394345],
						[16.806970596189263, 50.04713058366629],
						[16.805898666119486, 50.045677182839626],
						[16.801559448165115, 50.041767119709114],
						[16.79639244077296, 50.03818130473737],
						[16.760038375783516, 50.01465225159409],
						[16.752567291268466, 50.010234832836694],
						[16.746437072776722, 50.00754928608264],
						[16.741983413727297, 50.00645446803665],
						[16.737451553333248, 50.0059509276358],
						[16.726427078279308, 50.00547409085118],
						[16.72239112852987, 50.004936218174095],
						[16.72050476074819, 50.004402160695584],
						[16.71878051757887, 50.00356674194971],
						[16.717485427848892, 50.002510070736484],
						[16.716051101684894, 50.00006484985574],
						[16.71577264525201, 49.99875654901329],
						[16.715868011607704, 49.99606336359065],
						[16.716766363945446, 49.9933472235657],
						[16.71755028997045, 49.99201975781117],
						[16.71981047068793, 49.989528526874054],
						[16.7280922059199, 49.9826966381481],
						[16.73023416103673, 49.980144627847494],
						[16.73096657403908, 49.97874455835107],
						[16.731750476475582, 49.975837606917274],
						[16.73182676618925, 49.97290025394496],
						[16.729509341336115, 49.96371449471072],
						[16.729454037715353, 49.95928571210064],
						[16.73011208672053, 49.956363771079005],
						[16.734346400862144, 49.948158358778464],
						[16.739683156917895, 49.94185643266834],
						[16.747714992889772, 49.930770844609555],
						[16.74919511649711, 49.92640319597651],
						[16.750350946803405, 49.91577906815075],
						[16.75136566151777, 49.91133499057349],
						[16.75272751966068, 49.90855798673128],
						[16.756160731749954, 49.90327449913525],
						[16.757350935715888, 49.900272489626616],
						[16.760215748278515, 49.889430905830885],
						[16.765228256493007, 49.881626001124864],
						[16.76603316508374, 49.87889092695469],
						[16.765928265844853, 49.87619779283724],
						[16.765495287138496, 49.87491596429132],
						[16.763618482675216, 49.87265407598808],
						[16.760583859640644, 49.871234740627486],
						[16.752552036380425, 49.8691215849455],
						[16.744495396195546, 49.86500553038391],
						[16.742263785334412, 49.86367409012307],
						[16.736402523877675, 49.85938273455526],
						[16.73451613566796, 49.8573416967189],
						[16.733444217514833, 49.854629547848745],
						[16.73303223006866, 49.850101500987634],
						[16.733480446084435, 49.84540932983613],
						[16.735435501861513, 49.835914749157745],
						[16.74121094711182, 49.834877096529574],
						[16.746074681390052, 49.83328632717919],
						[16.7483100890747, 49.831985473318525],
						[16.752212537553113, 49.82864009668474],
						[16.756214133752373, 49.82561104517769],
						[16.75700950836255, 49.824543017570655],
						[16.75796890249972, 49.822139739234906],
						[16.75839233953177, 49.81951146109577],
						[16.759056101003043, 49.80968483649929],
						[16.759773240466444, 49.80691516383071],
						[16.76107598578894, 49.80444346461022],
						[16.767087919062845, 49.79732117097989],
						[16.768987667384994, 49.79553232722182],
						[16.773540486272573, 49.79287329213503],
						[16.777402871839204, 49.789905496957424],
						[16.780803672590167, 49.787959985411966],
						[16.782901749684985, 49.78636920181932],
						[16.788961411397196, 49.77939606462176],
						[16.79053689854342, 49.77722564900323],
						[16.793539051168818, 49.769752536090195],
						[16.79487039423222, 49.767326506155264],
						[16.79688642807536, 49.76502214061429],
						[16.804199207769063, 49.758830930109],
						[16.806085577427066, 49.756725233152906],
						[16.807020175346306, 49.75450505440759],
						[16.806823728791393, 49.75241087430108],
						[16.805623998301247, 49.750713263756374],
						[16.803142549636828, 49.74864579986204],
						[16.80238722820033, 49.74767676924018],
						[16.801036828496898, 49.74414820107065],
						[16.800903323856787, 49.74029544054588],
						[16.801713936410344, 49.73781198160152],
						[16.802547446303315, 49.73665993051099],
						[16.803775787981284, 49.73563385548052],
						[16.80535888072337, 49.73485941514756],
						[16.807111751823168, 49.73434839752144],
						[16.810894001606275, 49.7338255906335],
						[16.821208967850406, 49.73323452539088],
						[16.825408923875656, 49.73257054823141],
						[16.82731820461612, 49.73204433205402],
						[16.830888747550574, 49.730651850173295],
						[16.835683811017574, 49.72800435613348],
						[16.838478071691053, 49.72596344967045],
						[16.840816503807083, 49.72369389905457],
						[16.841733947674385, 49.722450386286525],
						[16.842920309278256, 49.71978001905549],
						[16.843580260049073, 49.71563351286176],
						[16.843496324132765, 49.71011735294158],
						[16.842626557705266, 49.70170962779763],
						[16.843229290944198, 49.69276425755088],
						[16.843063350878165, 49.68227001905963],
						[16.838005052930214, 49.678924449134804],
						[16.833047884549586, 49.67490020708066],
						[16.82509041685039, 49.670341564913336],
						[16.822368635295454, 49.6691743100334],
						[16.81380842482434, 49.66693101191949],
						[16.810943613590677, 49.66546258051177],
						[16.80681420413617, 49.66159829510214],
						[16.803606036008766, 49.65794374867359],
						[16.80275345993546, 49.65658579187218],
						[16.80164719874235, 49.65351878401696],
						[16.801273344579283, 49.650356280949666],
						[16.801418300851303, 49.647178618978614],
						[16.802547441429503, 49.642551306708576],
						[16.80709649437781, 49.63474284921982],
						[16.80756951443035, 49.63232431042284],
						[16.80722619546489, 49.62987912211426],
						[16.805915831640185, 49.62725066381276],
						[16.799173342148453, 49.61679447450439],
						[16.791303644615997, 49.60816964170781]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ53",
				"name": " Pardubický kraj",
				"region": "pardubicky"
			},
			"id": 9
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[13.309329033215203, 50.10226822237318],
						[13.32036590542598, 50.097564693690494],
						[13.335468291923194, 50.0924491849017],
						[13.340586662604636, 50.09018707607326],
						[13.343691825599748, 50.089225766204194],
						[13.349506378305632, 50.08855438372379],
						[13.361782073718159, 50.0884819003531],
						[13.36641406996013, 50.0876731854587],
						[13.369445800834374, 50.08686065730251],
						[13.372044563047645, 50.08568191267543],
						[13.378588676813894, 50.081760410325565],
						[13.383415222021096, 50.078109739653215],
						[13.39083480830971, 50.0736427302892],
						[13.393801689114836, 50.07253265345759],
						[13.395624160668921, 50.07219314471725],
						[13.40135669687701, 50.0721511819043],
						[13.403214454578917, 50.07245635909986],
						[13.406311035356236, 50.073505403728994],
						[13.416914939849304, 50.079441070228576],
						[13.4225826264778, 50.084728242392956],
						[13.431099891506458, 50.07562637164078],
						[13.438178062533181, 50.07010269264524],
						[13.438976287730252, 50.068958281292744],
						[13.439753532211657, 50.066452024274774],
						[13.439534187323362, 50.06384658820196],
						[13.438255310060706, 50.06135177614421],
						[13.435237884661687, 50.05888366847394],
						[13.429978370631577, 50.056346892940994],
						[13.427689552229346, 50.05479812539759],
						[13.425681114075843, 50.052577971130994],
						[13.424249649083022, 50.049736023322076],
						[13.420882224932523, 50.03644180187423],
						[13.421299934311477, 50.034210204275695],
						[13.42197704307923, 50.03312683028567],
						[13.423063278285584, 50.03211212250747],
						[13.424807548422837, 50.0311698902955],
						[13.428818702619687, 50.030212401516735],
						[13.433154106075627, 50.029994963915826],
						[13.437673568771721, 50.03025436450085],
						[13.442217826809854, 50.03096771204885],
						[13.44661331171907, 50.03227233835477],
						[13.458305358898077, 50.037597656368824],
						[13.46033763893627, 50.03824997034108],
						[13.464110374445259, 50.0388946532624],
						[13.512147903365234, 50.03898620524154],
						[13.519883155853162, 50.03854370149102],
						[13.524729728608737, 50.03760909939433],
						[13.526827812191407, 50.03687286373237],
						[13.530353546233876, 50.034976960188004],
						[13.532852172742544, 50.032661436841984],
						[13.533587455861705, 50.03137588618885],
						[13.533847808798239, 50.030025481760404],
						[13.533571243322658, 50.0287323001885],
						[13.529390335179633, 50.02348709208047],
						[13.528586387582662, 50.021400451116676],
						[13.529001236012814, 50.019439697800976],
						[13.53087234498153, 50.017669677846975],
						[13.533760070834006, 50.016536712995304],
						[13.539936065629572, 50.014839171897975],
						[13.546423912094735, 50.01213455249009],
						[13.553526878402005, 50.01054382371558],
						[13.556798934909844, 50.00949478121336],
						[13.570426940911172, 50.001911163258036],
						[13.57363796233883, 50.000793457004676],
						[13.582122802039585, 49.998573295936836],
						[13.58717347559983, 49.996387625172595],
						[13.589121811802354, 49.99584190932433],
						[13.593547806776089, 49.995155184937175],
						[13.60349274270419, 49.9946861883686],
						[13.654195794011217, 49.99506387030411],
						[13.664500224278864, 49.9949377691993],
						[13.671600332190453, 49.99430074218249],
						[13.675662042972734, 49.99324038001379],
						[13.68487645448075, 49.98824704814963],
						[13.692548744927509, 49.98235313858349],
						[13.697752947092278, 49.97466272368198],
						[13.702103615535867, 49.97108841700725],
						[13.704237937892556, 49.968677520390955],
						[13.708579051809911, 49.961616395329635],
						[13.720686903108554, 49.963996789182296],
						[13.729966161798627, 49.96490858077217],
						[13.741963394611576, 49.96498497763051],
						[13.75009346479928, 49.96382908945762],
						[13.754546167214361, 49.96190645123704],
						[13.756112099011338, 49.96052170129092],
						[13.757889755417386, 49.95743950348483],
						[13.759632117582358, 49.950843883512405],
						[13.76108933303018, 49.94768914020705],
						[13.763118757112357, 49.94497694373773],
						[13.766081804952979, 49.942665047771804],
						[13.77087879815017, 49.94107825179066],
						[13.776288996487455, 49.94054042029586],
						[13.784706117688373, 49.941066762306626],
						[13.792344106835076, 49.94281782787832],
						[13.802433001287396, 49.93878160761223],
						[13.806982041383911, 49.93593598424499],
						[13.811808593220338, 49.93348319720633],
						[13.816143023980022, 49.930667754055996],
						[13.823170649615099, 49.927390924989524],
						[13.82616615186543, 49.925434101297036],
						[13.828693387985506, 49.92312238629707],
						[13.831675540728856, 49.91849529447318],
						[13.833955768021838, 49.913547549471396],
						[13.836066240390341, 49.900905550793176],
						[13.83859444125522, 49.89257435797118],
						[13.83994768614749, 49.87803253582163],
						[13.83991814979695, 49.874256270632706],
						[13.839246740752927, 49.87234487626207],
						[13.837521561253876, 49.87068184772714],
						[13.834782602113545, 49.869426745008816],
						[13.828022969517276, 49.867965829494736],
						[13.824848180729724, 49.867015897493566],
						[13.818330756337188, 49.86313238935692],
						[13.816262244346493, 49.861595145181525],
						[13.815301902464869, 49.860454635290644],
						[13.814061158265483, 49.857883384991375],
						[13.811568245604937, 49.84979232903596],
						[13.806778919809936, 49.844017153804074],
						[13.805723192121478, 49.8411483953085],
						[13.805197706181922, 49.83800496640059],
						[13.805050856024403, 49.83141714724553],
						[13.805973058645788, 49.8250275247379],
						[13.807122223655156, 49.822208333068055],
						[13.807974819463388, 49.820995373381294],
						[13.810521131312102, 49.8185921289017],
						[13.812076558247057, 49.81657780371765],
						[13.813018790015365, 49.813953308041384],
						[13.813318264296768, 49.811138275064934],
						[13.813043591121852, 49.80832668751559],
						[13.812132841954057, 49.805702277760076],
						[13.807315816513533, 49.80010594553446],
						[13.80622006023223, 49.797351895506374],
						[13.805615429520536, 49.79429249586774],
						[13.805134770114279, 49.78772350855893],
						[13.804959295724927, 49.77416990671074],
						[13.805213925794993, 49.76762006136649],
						[13.805746088372869, 49.76455698776841],
						[13.806909570923036, 49.76176081346939],
						[13.807868969194699, 49.76052487145624],
						[13.815135958582962, 49.7551880171721],
						[13.818469050367412, 49.75342181283861],
						[13.825997362411423, 49.75096522058825],
						[13.819228162611845, 49.74653615389265],
						[13.814916598563416, 49.74419008934223],
						[13.807701099537674, 49.74119556079731],
						[13.802955641983694, 49.73856750407968],
						[13.800029747640826, 49.73764412249838],
						[13.794509885122583, 49.73641202146723],
						[13.791148175403269, 49.73530186354166],
						[13.786882402791152, 49.732643151256696],
						[13.782254226237525, 49.730247572663686],
						[13.779184330573134, 49.72819889155314],
						[13.7766113153796, 49.72699724213566],
						[13.771946901199332, 49.72585671983594],
						[13.767222393063847, 49.725238680514124],
						[13.750861164527272, 49.72576519283337],
						[13.746312150248624, 49.725540253730074],
						[13.742120744178166, 49.724948897535306],
						[13.740266812334276, 49.724453102585336],
						[13.733535762714034, 49.721759755330254],
						[13.723616608935863, 49.7198945026789],
						[13.719564450625008, 49.71883405743311],
						[13.70902822947129, 49.7150381465261],
						[13.705032363144781, 49.713077697885325],
						[13.697731968105515, 49.707992515426845],
						[13.695926666864327, 49.70572281520629],
						[13.693222054209714, 49.70116051849348],
						[13.688738828026308, 49.69732671381419],
						[13.687233927040683, 49.69544985203803],
						[13.686130509372484, 49.69345077681194],
						[13.685373319281647, 49.69149793994302],
						[13.685336118426061, 49.68938070324611],
						[13.686044678639313, 49.687423554621226],
						[13.687309268207146, 49.68548968693301],
						[13.689555167998636, 49.68375778036484],
						[13.691329964798339, 49.68308648748997],
						[13.693204892195826, 49.68271268607887],
						[13.696974746821095, 49.68260566419916],
						[13.700506205603274, 49.68314356592803],
						[13.702054980308365, 49.6836281127492],
						[13.706380831065367, 49.6858175810133],
						[13.709650996281008, 49.68664553871222],
						[13.713389400226834, 49.6869278328859],
						[13.717165945806848, 49.68659590460416],
						[13.720309256761833, 49.685581199429485],
						[13.725633629570739, 49.68252190797689],
						[13.727730736568631, 49.68103012121181],
						[13.729149818044739, 49.67913817964023],
						[13.730075832037079, 49.676254228855065],
						[13.729924212125317, 49.67435084543058],
						[13.729459776694673, 49.673439174476755],
						[13.727955825787637, 49.671917041778414],
						[13.724968906379484, 49.67005153430177],
						[13.723202694452684, 49.66855609828061],
						[13.720946323748203, 49.664718752198546],
						[13.720339770046726, 49.66274256166421],
						[13.720504758427031, 49.65708920900254],
						[13.720203408328253, 49.654464813049366],
						[13.719284999498546, 49.65196978536535],
						[13.718488702612092, 49.650837043405176],
						[13.710457795611255, 49.64450066692672],
						[13.706782347650446, 49.642543862879464],
						[13.702033057587544, 49.64052597287297],
						[13.70544338658198, 49.635395095648654],
						[13.707431782031042, 49.633529545028246],
						[13.714388859684869, 49.62840284014252],
						[13.722483636123913, 49.62413407611894],
						[13.725597383261638, 49.623027819127074],
						[13.727557193081918, 49.62264263068372],
						[13.740776065252959, 49.62138751584355],
						[13.745229719709783, 49.62048719881154],
						[13.74720669951362, 49.619808319066586],
						[13.750713355043407, 49.6180191740888],
						[13.753527651639757, 49.6157570974466],
						[13.755290017913, 49.61349473067669],
						[13.758232118631488, 49.60775377400989],
						[13.758962641319512, 49.60331355235317],
						[13.758482944067277, 49.5988541810586],
						[13.75585174548886, 49.591075895986464],
						[13.753720284916952, 49.58057405050099],
						[13.754978191539715, 49.564529541437565],
						[13.756088262910302, 49.56006247255356],
						[13.75679207744147, 49.55872735896462],
						[13.758716587172698, 49.556678813348526],
						[13.765606894334994, 49.5516702237145],
						[13.771128664174736, 49.54853068086542],
						[13.776931771932063, 49.544185735826616],
						[13.778807647480553, 49.542102891799296],
						[13.780236252493825, 49.53776177567321],
						[13.78089523572543, 49.52642443508275],
						[13.781866085365477, 49.52182782180148],
						[13.783439644694605, 49.51916512836627],
						[13.789081586451989, 49.51426328984763],
						[13.79296303229259, 49.5096703033301],
						[13.787839885653781, 49.508075673244505],
						[13.778005601259476, 49.50626374646898],
						[13.774497980140717, 49.505218445653185],
						[13.76791954350589, 49.501285585754495],
						[13.765868195727336, 49.49968728761988],
						[13.765008924651363, 49.498519879058556],
						[13.764177334096212, 49.495922212452996],
						[13.764281264856637, 49.493152533456716],
						[13.764659886004106, 49.49175267118262],
						[13.76613236913237, 49.489059600518175],
						[13.77304936336761, 49.48139962935018],
						[13.777172083879183, 49.47829813709452],
						[13.779050829172512, 49.476493858139904],
						[13.782401082618945, 49.470821356498035],
						[13.786690722589745, 49.46661006704976],
						[13.787521356226007, 49.46543877851004],
						[13.788628574167433, 49.46277232689926],
						[13.790949826840295, 49.45380025817943],
						[13.792433742288997, 49.45100406618065],
						[13.796004308454886, 49.445743699370375],
						[13.79741764514324, 49.44116215650893],
						[13.79761410688396, 49.43807230282772],
						[13.797287950609945, 49.435096842596636],
						[13.796309472408817, 49.432373060400536],
						[13.795488361584232, 49.431175274682545],
						[13.791206369330698, 49.42701731213578],
						[13.788637170264513, 49.422470188184384],
						[13.786994942676525, 49.42031487985269],
						[13.783023821624596, 49.41722093577605],
						[13.778238302477616, 49.41192251811985],
						[13.773489006606148, 49.40769204247899],
						[13.779341706888054, 49.40089807726637],
						[13.781903264877558, 49.39858243697395],
						[13.785594954366129, 49.39596191184587],
						[13.78747175775694, 49.39392457016472],
						[13.7886848521191, 49.39130409191215],
						[13.79018879137186, 49.385742208754294],
						[13.791278846023722, 49.38315589606211],
						[13.792089462624165, 49.38200760252379],
						[13.796420096424486, 49.37777327508684],
						[13.799796095935738, 49.372089295903606],
						[13.804310806160768, 49.36798866610759],
						[13.805179586684929, 49.366798302681495],
						[13.805808081844175, 49.36549392837876],
						[13.806465143426946, 49.362693728318504],
						[13.806088444850241, 49.358421296831814],
						[13.804656016324355, 49.355827199767425],
						[13.8034095668019, 49.35472859673795],
						[13.800705911094596, 49.353492751305616],
						[13.794832222900055, 49.35213081861321],
						[13.79209993835729, 49.35126861603121],
						[13.785682676965024, 49.34732817267226],
						[13.783653261438472, 49.345767997820595],
						[13.782781588130566, 49.34465394697287],
						[13.781756400105783, 49.34211729940481],
						[13.780886639877515, 49.33365620247053],
						[13.780312551886205, 49.33093657802713],
						[13.778985024263143, 49.32847596028373],
						[13.777858746050612, 49.3274270372286],
						[13.774831776773109, 49.32598500722495],
						[13.768215182279963, 49.32423785369361],
						[13.765551578540386, 49.323093536404286],
						[13.762331010362402, 49.32114411946662],
						[13.757537835386291, 49.31879418215204],
						[13.747968686562489, 49.312240737764355],
						[13.742656704200089, 49.305877647498306],
						[13.741349230540665, 49.303451647704264],
						[13.741131787161619, 49.3023529547202],
						[13.741423598813723, 49.30027762388864],
						[13.74191475241806, 49.29936603226636],
						[13.744865421244956, 49.296512643962465],
						[13.745963096570955, 49.29439926096524],
						[13.746225363977285, 49.29199226142563],
						[13.745550163948414, 49.289600461068474],
						[13.743864056604187, 49.287685363900835],
						[13.736437787045046, 49.28289783693764],
						[13.729091657221007, 49.280017991163604],
						[13.726071349205926, 49.278423218132545],
						[13.723464970231449, 49.27656178428188],
						[13.721592905229354, 49.274417899598035],
						[13.721013082201624, 49.27213682796839],
						[13.721487058235928, 49.27013792552629],
						[13.722493185957765, 49.26813903827666],
						[13.724102021828314, 49.26632692105114],
						[13.728463179393605, 49.26378638530791],
						[13.73654174478151, 49.258247340539135],
						[13.738042824221045, 49.25589363021658],
						[13.738462457262465, 49.25320825825442],
						[13.738292692466132, 49.251819593194114],
						[13.737105361695429, 49.24907294427832],
						[13.736051549743527, 49.247825518642685],
						[13.733315477668572, 49.245681868026146],
						[13.730081564645195, 49.24399192056541],
						[13.724404344153516, 49.24176035179069],
						[13.71992397649217, 49.23910144646678],
						[13.716354376640808, 49.23743445718928],
						[13.714221013388135, 49.23604215915573],
						[13.712835316688476, 49.23426061058183],
						[13.712553978617118, 49.23129273159525],
						[13.713238719718662, 49.22748569530807],
						[13.714818952674634, 49.2237319753803],
						[13.7156867928527, 49.222633305532895],
						[13.720333087413707, 49.21853624867841],
						[13.72311686798341, 49.21394722410948],
						[13.7247781792889, 49.211841625481476],
						[13.727636348446717, 49.20959484639095],
						[13.729414000026365, 49.207660823348256],
						[13.730577463015827, 49.20521157656234],
						[13.731217378219872, 49.20264809718113],
						[13.731377598453163, 49.19826122695758],
						[13.73028277090602, 49.19641862692364],
						[13.72821521171589, 49.195022519933524],
						[13.726696000829477, 49.19445404734143],
						[13.718655595195733, 49.19242105567935],
						[13.717232716993625, 49.19166960200791],
						[13.716091160031622, 49.1906853154863],
						[13.715263375653025, 49.18954095928766],
						[13.714287760034082, 49.186962150913445],
						[13.712861054366279, 49.175331043324164],
						[13.711583143965427, 49.172512123879685],
						[13.709327703511013, 49.170044007273816],
						[13.704793938900174, 49.167160129434414],
						[13.699200636452186, 49.164836951029386],
						[13.69443987775132, 49.162330516976965],
						[13.685850130189184, 49.16006836912383],
						[13.682611459641842, 49.158809599157586],
						[13.680413246053318, 49.157184599735054],
						[13.675694470160352, 49.15255360718624],
						[13.665546416456843, 49.14829634777622],
						[13.66132545672135, 49.1453743198212],
						[13.656732567194041, 49.14293679296221],
						[13.653682716329104, 49.14099892243876],
						[13.650748251792711, 49.139915454663175],
						[13.648929608559179, 49.13960279764062],
						[13.645129196453128, 49.13946906722446],
						[13.64144991887294, 49.13993062318157],
						[13.638549796751342, 49.14092246042516],
						[13.635131824894488, 49.14269626098046],
						[13.631736762339457, 49.14376457135631],
						[13.616875658460465, 49.146305192278945],
						[13.613179198397168, 49.14631262193588],
						[13.609540930187633, 49.145591636611265],
						[13.606642712184842, 49.14413821787112],
						[13.604522713778353, 49.141861056381806],
						[13.6034831966669, 49.13903041954931],
						[13.603135099317784, 49.13449849158645],
						[13.603586194325787, 49.12657925670379],
						[13.604878415774971, 49.11405934146266],
						[13.604356759265023, 49.11189262972581],
						[13.60248089046164, 49.10737230671784],
						[13.59852313154424, 49.101570037894774],
						[13.597989081955514, 49.10036849561023],
						[13.59778975983604, 49.09822077547955],
						[13.598064429026392, 49.09719474148835],
						[13.599372854213962, 49.095428362805755],
						[13.60554982188282, 49.09050379670345],
						[13.609573374893145, 49.08768856173416],
						[13.61122416891663, 49.085338531800645],
						[13.613400445357, 49.078464356485476],
						[13.614523880637131, 49.0758856965826],
						[13.615323063626189, 49.07476040344678],
						[13.61876011775698, 49.07151422546319],
						[13.620216366140966, 49.0689925768043],
						[13.620938288062682, 49.06612000602761],
						[13.62108136202184, 49.06308375516869],
						[13.620072370943914, 49.058506078744195],
						[13.618182175701422, 49.05574409918538],
						[13.615465162815322, 49.05350111424113],
						[13.612247456023834, 49.05170810144059],
						[13.60655784179889, 49.049430800632514],
						[13.60290525992852, 49.047592015827234],
						[13.599670404786837, 49.046527804001826],
						[13.59767342250609, 49.04616172106277],
						[13.586983690576336, 49.04519282602873],
						[13.582960136164802, 49.04450615358052],
						[13.579853068394563, 49.043304558394546],
						[13.573477747337842, 49.03921892752133],
						[13.571572296000701, 49.03720847218401],
						[13.570914273275871, 49.03593450051965],
						[13.569208132502045, 49.02899537568959],
						[13.568247784315044, 49.026378513570414],
						[13.567505828299423, 49.025215059363184],
						[13.564229010548829, 49.02188872211063],
						[13.563441279524756, 49.02071383870519],
						[13.562352182577825, 49.018077873293535],
						[13.56034756497585, 49.01113518791942],
						[13.558929449659258, 49.008792946200394],
						[13.555671683222466, 49.00566854511516],
						[13.555007929520388, 49.004577581379394],
						[13.554369913645761, 49.0021704223836],
						[13.554576881396404, 48.999694907707465],
						[13.555690763523128, 48.997417429587664],
						[13.559840191766934, 48.99339282855497],
						[13.562423707542875, 48.98886491498959],
						[13.564088815326162, 48.986705713345955],
						[13.569098474585118, 48.98277284894925],
						[13.57285882293542, 48.97871412631206],
						[13.582298267130613, 48.96982561673792],
						[13.581908217419855, 48.969985867803885],
						[13.580124841977945, 48.97072587010143],
						[13.5775642477756, 48.970371336974544],
						[13.575891507929983, 48.970138694198845],
						[13.575773235922473, 48.96977611835842],
						[13.575114256114743, 48.96776587310342],
						[13.57497119694711, 48.967330909729014],
						[13.572756779899253, 48.96606840621447],
						[13.571597096541721, 48.96625897240379],
						[13.569140448075686, 48.96665588261046],
						[13.568450916521195, 48.96734606846924],
						[13.566827764908792, 48.96897115223807],
						[13.563251505846823, 48.97048580224376],
						[13.557067883474287, 48.967094557236706],
						[13.551276200610674, 48.96760933570575],
						[13.549789426836076, 48.96734235612462],
						[13.548029908216826, 48.966888522379755],
						[13.543487535924616, 48.968269206419215],
						[13.5426168441548, 48.96895599340643],
						[13.53733922278288, 48.97248090875971],
						[13.536922468164143, 48.973461297573714],
						[13.533633227600065, 48.97396464152854],
						[13.532207485438896, 48.97401042824106],
						[13.529236791828392, 48.974102001689396],
						[13.522437082204055, 48.9716604662083],
						[13.52057932729453, 48.97084033552127],
						[13.518440032293926, 48.96989429575453],
						[13.515949748564367, 48.97024202221537],
						[13.511567625681542, 48.96891763228533],
						[13.507300217725827, 48.967627897447755],
						[13.502100475540395, 48.96605634115183],
						[13.492592006730847, 48.95504920724458],
						[13.487252130052502, 48.94605135350342],
						[13.486109727952925, 48.946895537228094],
						[13.48553180057188, 48.94764320966401],
						[13.484434117898292, 48.948139081271435],
						[13.484275811483604, 48.948436666541184],
						[13.483695972034377, 48.94953142432248],
						[13.483551979598335, 48.95126343362282],
						[13.481346125892694, 48.95159907164554],
						[13.479772566391867, 48.95183943203443],
						[13.4784688942484, 48.95259856393483],
						[13.47762585272807, 48.953090732497884],
						[13.475987441021529, 48.95314796145881],
						[13.474567404022087, 48.95334996432065],
						[13.473098748524993, 48.953567434645706],
						[13.471361171037632, 48.95413601364946],
						[13.469367985441961, 48.95435719677385],
						[13.467123997395307, 48.95556272532586],
						[13.4669828360243, 48.95563882507648],
						[13.465885161837685, 48.9566268863889],
						[13.465363508883643, 48.9570961703775],
						[13.462687489111584, 48.95893093321422],
						[13.46150206940427, 48.96055596626041],
						[13.460175507161484, 48.962203901453066],
						[13.459490785088756, 48.9626122518845],
						[13.459306726707014, 48.96265803666841],
						[13.45815181335592, 48.96295161631209],
						[13.456785209432939, 48.96307381235915],
						[13.454223630573034, 48.963054632216455],
						[13.452036853429222, 48.9634933009826],
						[13.450390811250728, 48.96402354048627],
						[13.449827186162615, 48.96435919438668],
						[13.4494686176239, 48.9645729612821],
						[13.449130065524072, 48.965240558553276],
						[13.44751644032719, 48.96530150240875],
						[13.44522284876322, 48.96555703364825],
						[13.443058003053219, 48.96580111879933],
						[13.441038120736858, 48.96683871517822],
						[13.43932152299722, 48.96822744240214],
						[13.437879557622239, 48.96920008163561],
						[13.437728879019518, 48.96930309992795],
						[13.433669076921289, 48.9716604662083],
						[13.432816497036073, 48.97191229106958],
						[13.432024951195674, 48.972106883169076],
						[13.430530543768795, 48.97211832976752],
						[13.42947863153581, 48.972110595579316],
						[13.427314772217267, 48.972099458348694],
						[13.426188481560457, 48.9725038019889],
						[13.425576208023479, 48.973628975664404],
						[13.425575262159557, 48.97491842985662],
						[13.42461014688635, 48.97727213279287],
						[13.422974592818974, 48.978012155106185],
						[13.421385759249276, 48.97873299819437],
						[13.417551033591879, 48.97951881217123],
						[13.416651730212907, 48.9800339237587],
						[13.416121475024104, 48.98031607538828],
						[13.414719590617864, 48.981060127978616],
						[13.407170296417412, 48.98507309738404],
						[13.406089788051345, 48.98564916805941],
						[13.402895918582294, 48.98734273635922],
						[13.402747152806041, 48.988750441906944],
						[13.40223501857598, 48.993659833969026],
						[13.402174008418891, 48.99423994513917],
						[13.403594977338116, 48.996059491279205],
						[13.404575333959313, 48.99731811329302],
						[13.409274106178668, 49.00306707111945],
						[13.408402429007012, 49.00728210283386],
						[13.407028196403855, 49.00854108681431],
						[13.405080792369706, 49.00937649354781],
						[13.402514465312883, 49.01084526864917],
						[13.400936129547075, 49.013504059766404],
						[13.400293362608158, 49.0162393035175],
						[13.400379170121948, 49.01637637585502],
						[13.401429189555314, 49.019443658455465],
						[13.401464460503952, 49.02006528794104],
						[13.40180397071743, 49.02090073053308],
						[13.402574541133717, 49.021457693706054],
						[13.404719340483618, 49.021835191625016],
						[13.405612958811473, 49.02227797879529],
						[13.405855186829216, 49.02365121157776],
						[13.404671659684071, 49.02443684746384],
						[13.403056156748544, 49.02648557636536],
						[13.402196880647143, 49.03017803122566],
						[13.401122100198458, 49.03371055720968],
						[13.399449353117097, 49.03548055094298],
						[13.399683946668045, 49.03703301835498],
						[13.396282192604055, 49.03952404026989],
						[13.395363812015466, 49.03970723186395],
						[13.394570338138658, 49.03974900699163],
						[13.392599113602454, 49.04066094417938],
						[13.391992576265592, 49.04173286888719],
						[13.392008791454069, 49.04201137196703],
						[13.392194735532481, 49.0425680695466],
						[13.392859463470073, 49.04295735625679],
						[13.393905629738619, 49.04326618665669],
						[13.395888322899827, 49.043788847333026],
						[13.396843899261523, 49.04430377276221],
						[13.397337916655433, 49.04483417174534],
						[13.397848121284355, 49.046050936975284],
						[13.397971161323518, 49.04682549818931],
						[13.39801217355263, 49.04836286803448],
						[13.397916784885265, 49.04891957881678],
						[13.39737415480368, 49.050571460091476],
						[13.397147191295387, 49.05101027178007],
						[13.394210821560531, 49.05266959300392],
						[13.393465985249076, 49.05310809867121],
						[13.392256746440575, 49.054325210967434],
						[13.389767634100293, 49.05306229846913],
						[13.388231265857128, 49.05268847008559],
						[13.386239994415432, 49.05289828429618],
						[13.384839058432439, 49.056278234409156],
						[13.383599276756913, 49.05733103476825],
						[13.382600797197433, 49.057499074715075],
						[13.380855572608642, 49.05710233968784],
						[13.37888336748354, 49.05696493705423],
						[13.377846725179351, 49.057384572345725],
						[13.377028453098703, 49.05794130189354],
						[13.375877390494619, 49.058399312618015],
						[13.374592776792253, 49.06019206078568],
						[13.374701496093525, 49.06225963146295],
						[13.373965256584068, 49.063312455362954],
						[13.372968660118266, 49.06409820758838],
						[13.372251503184721, 49.06549826965866],
						[13.37164688037228, 49.06617354536443],
						[13.37011337227031, 49.06779860860241],
						[13.368282312041, 49.067871026428534],
						[13.36716650821289, 49.069381592479154],
						[13.364628802673721, 49.06944286946286],
						[13.364007940895403, 49.06906499495387],
						[13.363189703556156, 49.07024009049058],
						[13.361999503984183, 49.07155600555665],
						[13.360120769625848, 49.07267757139557],
						[13.358011254369625, 49.073772526250686],
						[13.356349003686999, 49.07572569174152],
						[13.355728157878964, 49.07633600085672],
						[13.355212198798512, 49.07780823806648],
						[13.354905117551084, 49.078346131255095],
						[13.354284295731851, 49.07887659775052],
						[13.35318183801432, 49.079360951100895],
						[13.351984033165937, 49.07970820049714],
						[13.350742340523318, 49.08005142694837],
						[13.349845883897503, 49.08033368383754],
						[13.349080081967266, 49.08063884348531],
						[13.348150265554699, 49.08108915577293],
						[13.347270955652062, 49.0816840024468],
						[13.346479420885212, 49.082275446004985],
						[13.34616278423843, 49.082797873429655],
						[13.346120848177392, 49.08357254109568],
						[13.346202845771016, 49.084224650218154],
						[13.346472730553703, 49.08510578927981],
						[13.34646414492763, 49.085704668384366],
						[13.346036921458799, 49.086574670345364],
						[13.345761310381079, 49.087066775164836],
						[13.345194823980771, 49.08779533956353],
						[13.344669342385943, 49.08846664811281],
						[13.343956957184332, 49.08894359080519],
						[13.34293174765318, 49.08925247432749],
						[13.34178256252845, 49.08959571304967],
						[13.341053008890054, 49.08987426598914],
						[13.339810361034079, 49.09017169894881],
						[13.339519508283795, 49.09031685625763],
						[13.339144701169754, 49.090721068710664],
						[13.338993070671245, 49.09109495029964],
						[13.33849810481218, 49.09156787411956],
						[13.338130946086286, 49.09197611204399],
						[13.337811466887416, 49.092468226824174],
						[13.337183002213331, 49.092887917882166],
						[13.336636548053125, 49.09321599542269],
						[13.335885047611637, 49.093746181961315],
						[13.335161216407162, 49.094024739233966],
						[13.334136972236267, 49.094364269991864],
						[13.332810406376415, 49.09474187079536],
						[13.331785208613134, 49.09508140246605],
						[13.33075809654038, 49.09530641594445],
						[13.330450069495454, 49.0953141536878],
						[13.329676640365337, 49.09547819389962],
						[13.328737262211675, 49.09578708498742],
						[13.327800748627906, 49.09615323590854],
						[13.326956737373447, 49.09660326486362],
						[13.326334000271325, 49.09710312597553],
						[13.326223386067067, 49.09729780897789],
						[13.325983052247063, 49.097770743795],
						[13.325752269276522, 49.09832012920687],
						[13.325364099872054, 49.09912857898113],
						[13.324801436878028, 49.0999487927807],
						[13.324382787783966, 49.10031897311809],
						[13.323789600804481, 49.10058979935935],
						[13.322528846875553, 49.10094079057733],
						[13.321340560297987, 49.10124968799275],
						[13.319611549825972, 49.10170746347799],
						[13.317713737780885, 49.10345840779703],
						[13.317028991734867, 49.10406104234521],
						[13.316409097813915, 49.10426315891123],
						[13.315479290778766, 49.10437025289654],
						[13.312693605666945, 49.10447703740448],
						[13.310847277869275, 49.10555262287765],
						[13.308683407617705, 49.10681547409579],
						[13.305367460013914, 49.108753095688584],
						[13.302772519124261, 49.110267607489156],
						[13.300434116517495, 49.11162953021494],
						[13.299864777771324, 49.11198053597321],
						[13.292902939869427, 49.11629478738946],
						[13.289188390183359, 49.11863332782574],
						[13.288169856335722, 49.11889643425627],
						[13.284327498488285, 49.11991109890224],
						[13.28236484784209, 49.12047198291062],
						[13.27635957046569, 49.12047972138478],
						[13.273777953719478, 49.120052248408975],
						[13.26925181718071, 49.11927406982279],
						[13.266342172639995, 49.11883174100396],
						[13.263595572953088, 49.11870947389537],
						[13.262976635174553, 49.118663662436234],
						[13.261587137884545, 49.11848444065497],
						[13.259761810656045, 49.118293766146195],
						[13.259356486155323, 49.11824021634927],
						[13.257098211500434, 49.117946776035],
						[13.255364408103151, 49.11760319126791],
						[13.24416256407316, 49.115230611261275],
						[13.241838464066154, 49.11474619276268],
						[13.238557824721443, 49.11406336537225],
						[13.236364370069198, 49.113594116013736],
						[13.235947595880036, 49.113731238267164],
						[13.233090390575033, 49.114601022151],
						[13.230232250568362, 49.115474832806505],
						[13.227806079310286, 49.11621461806822],
						[13.21971320410617, 49.11859123082099],
						[13.216730113632048, 49.119438124784985],
						[13.213327395106178, 49.120384073859896],
						[13.211519253679272, 49.12088026511469],
						[13.209504132362131, 49.12143712714407],
						[13.208560948043209, 49.121696521861224],
						[13.20565031793011, 49.122127402427445],
						[13.204510702316105, 49.12275329483734],
						[13.200772284885012, 49.12504576991315],
						[13.197168342939804, 49.12715903711667],
						[13.195924749479023, 49.12790287897356],
						[13.194059373808464, 49.12895967659892],
						[13.191493030518652, 49.130413012352136],
						[13.189541805300882, 49.13132464021613],
						[13.182791717573336, 49.134479608714884],
						[13.180283557071947, 49.1365090607485],
						[13.1787080748051, 49.137824993463006],
						[13.173446665928141, 49.14213192489472],
						[13.171032900015717, 49.14360421617802],
						[13.170321464766333, 49.14403915660639],
						[13.17231846844771, 49.148197284960816],
						[13.172896384150413, 49.149230945343945],
						[13.173069964493337, 49.15019619398247],
						[13.173648832301069, 49.15339658484114],
						[13.173824312445527, 49.154365563564625],
						[13.17391206153675, 49.15484633930476],
						[13.17383287991911, 49.15520080748796],
						[13.174014091799409, 49.1565094028629],
						[13.174231535244276, 49.15714652118624],
						[13.175442688698121, 49.15935508604876],
						[13.176464076967145, 49.161403612951325],
						[13.176710138087975, 49.161895856168904],
						[13.176773065205428, 49.16304009298876],
						[13.176875106136654, 49.16422643897217],
						[13.176330565988929, 49.16552733907521],
						[13.175868985010535, 49.16637035794663],
						[13.175045000423198, 49.16853317954497],
						[13.174129491458938, 49.170364440081116],
						[13.171824462520624, 49.17273720289214],
						[13.1716899787001, 49.17287435567156],
						[13.170907980939958, 49.17358024468831],
						[13.170250893666214, 49.17393876272459],
						[13.167916301768178, 49.17375950364582],
						[13.165522585203153, 49.17382823509173],
						[13.164438243987242, 49.174201923940664],
						[13.163114555996023, 49.17433938707978],
						[13.161948217495311, 49.17461028874508],
						[13.161893831434668, 49.174621434419514],
						[13.16092014467471, 49.17542268579945],
						[13.159703245904037, 49.1764601675185],
						[13.159180643983586, 49.176906617183604],
						[13.156732570859935, 49.17836393072239],
						[13.154344564671801, 49.1796494198094],
						[13.154266348698613, 49.17969121688585],
						[13.152624130780836, 49.18051910996672],
						[13.152489668824026, 49.18058784316602],
						[13.150512690358324, 49.18159097837493],
						[13.148706428559104, 49.18197241843891],
						[13.147172938033906, 49.18380748720454],
						[13.146826742232506, 49.18469236209305],
						[13.146696104315321, 49.18506637588103],
						[13.146673203609076, 49.185131085273774],
						[13.144395818285894, 49.186729319409075],
						[13.143946648176433, 49.18704605699777],
						[13.143283847815448, 49.18748478407843],
						[13.142166131535593, 49.18888085130614],
						[13.141330717103, 49.189926126243726],
						[13.139044758193378, 49.190307578315284],
						[13.137384427749282, 49.190586236831905],
						[13.134714116987357, 49.19291676238006],
						[13.132692345516464, 49.194683170134674],
						[13.131409658146467, 49.19551482561611],
						[13.129336349736542, 49.19685736954173],
						[13.128412255558791, 49.19702921317902],
						[13.128055569113913, 49.19709392549661],
						[13.126454345606435, 49.19704810050453],
						[13.124848358806624, 49.19725028786036],
						[13.123498919726881, 49.19716266299959],
						[13.122941961834195, 49.19781102573086],
						[13.12247372240305, 49.19835287736994],
						[13.11912822760869, 49.1990699810171],
						[13.117280006783556, 49.1990699810171],
						[13.117114061795833, 49.19920343186721],
						[13.115221979542813, 49.200725581362356],
						[13.111639026890593, 49.2022743681767],
						[13.11004255855422, 49.203140107421575],
						[13.10997010135524, 49.20317850221769],
						[13.109956728891904, 49.204952100166466],
						[13.111245166234106, 49.208198669834374],
						[13.112924572461305, 49.20926662502478],
						[13.114183417195848, 49.21273030991466],
						[13.114335049093707, 49.21417605414778],
						[13.114625938556527, 49.21472939634511],
						[13.114413272298668, 49.21594631974855],
						[13.11448478435431, 49.21726605319624],
						[13.114493374869653, 49.21743016879738],
						[13.114440927914307, 49.21757137022639],
						[13.114122377640308, 49.21842941825264],
						[13.113745685485691, 49.21870036506888],
						[13.11305808133297, 49.21919240519793],
						[13.110822672161595, 49.21940606671003],
						[13.110371588884387, 49.21945189557861],
						[13.10928535655002, 49.22082521705394],
						[13.107059489509906, 49.2210007921521],
						[13.10632227757228, 49.221057768928624],
						[13.105399126228864, 49.22155755487571],
						[13.1048974944941, 49.22237009613],
						[13.104375848155243, 49.22241220961682],
						[13.103694921265994, 49.222557129608134],
						[13.102931017107071, 49.222717222938876],
						[13.101950639670285, 49.22315972512596],
						[13.101303110531406, 49.22366725653932],
						[13.099770556589583, 49.22376263167892],
						[13.098367692384935, 49.223850265360305],
						[13.09709071907069, 49.22443769047035],
						[13.093992221523468, 49.225051747741986],
						[13.091112144793057, 49.22629937531251],
						[13.089937197966291, 49.22681031905777],
						[13.088849058337026, 49.227275743221206],
						[13.086633686587824, 49.228981066847076],
						[13.086050037394765, 49.229412121885495],
						[13.086056716287725, 49.22987755063789],
						[13.086816782833422, 49.23037332761055],
						[13.088478098348126, 49.231121175337464],
						[13.088828079369584, 49.23225394417199],
						[13.088835704404461, 49.23333345448231],
						[13.088859566763022, 49.234127142018],
						[13.088836659666555, 49.23472202214652],
						[13.088649756521058, 49.235565261608386],
						[13.088328359547228, 49.23701856312326],
						[13.087463370332076, 49.238315485877024],
						[13.087216367775664, 49.23940647908405],
						[13.086997018455186, 49.24037917936081],
						[13.086182594210163, 49.241344450900684],
						[13.085507394198576, 49.24227906752098],
						[13.083700190740416, 49.244781614291675],
						[13.083329213328259, 49.24529661974957],
						[13.082429898284918, 49.246040483889445],
						[13.080761900628449, 49.24741735036509],
						[13.079745281430261, 49.24747835878524],
						[13.078827848944767, 49.247333425099626],
						[13.077896109591258, 49.24692525758439],
						[13.077128411635965, 49.246849074643215],
						[13.076265347996598, 49.247036125481195],
						[13.075469018804984, 49.24710085005705],
						[13.074690827562444, 49.246833899994954],
						[13.07361889081652, 49.2465248328595],
						[13.072635658804735, 49.24649819983672],
						[13.071992871470833, 49.24673077434734],
						[13.071416854882322, 49.24683761623526],
						[13.070154184200891, 49.24703209955116],
						[13.069282537169709, 49.24705130014111],
						[13.06864261600005, 49.24732970885231],
						[13.068230615907318, 49.24779114329295],
						[13.068190566758016, 49.24841299715978],
						[13.06801223902539, 49.249153153824906],
						[13.067781446080815, 49.24961087517977],
						[13.067209243247884, 49.249790185724365],
						[13.066696166227494, 49.249706259703],
						[13.06608485761898, 49.249839736155444],
						[13.065583224131073, 49.249996129764696],
						[13.064884172912413, 49.24984345243814],
						[13.064114564959405, 49.24974435158393],
						[13.063426963450485, 49.249805360542894],
						[13.06252002430846, 49.249851194693974],
						[13.061436648204843, 49.249996129764696],
						[13.060791968715058, 49.250198357678265],
						[13.060086239694513, 49.2505987879866],
						[13.059011469531765, 49.251598472805384],
						[13.058355323945001, 49.25225440189486],
						[13.057824144811784, 49.253219716939505],
						[13.057724941262657, 49.25408159730165],
						[13.057765973974334, 49.25486388856694],
						[13.057698240442855, 49.25563038760721],
						[13.057368269826448, 49.25627889399227],
						[13.056998262052579, 49.25683604091584],
						[13.05695914359345, 49.25748052418089],
						[13.056990636877593, 49.25807205033461],
						[13.057455052966397, 49.25858677207969],
						[13.057776442048953, 49.25915135671563],
						[13.058059681624112, 49.25969302462743],
						[13.058313363476415, 49.26020805924461],
						[13.057600969135365, 49.26084511788933],
						[13.057143222099683, 49.26146328613781],
						[13.05680561612715, 49.26197058160675],
						[13.056571012268241, 49.26268011555444],
						[13.056308752114774, 49.26323324984982],
						[13.05586432887176, 49.26376718349759],
						[13.055185313336732, 49.26400751593397],
						[13.054612155022816, 49.26416391795954],
						[13.053798682878503, 49.26426705043518],
						[13.052858345887461, 49.264381332414885],
						[13.052306166406225, 49.26459874704991],
						[13.051831254008441, 49.264904118906145],
						[13.05084897080301, 49.26491557810034],
						[13.049959176567809, 49.26493447028647],
						[13.049370770964979, 49.26448446497577],
						[13.048918722031821, 49.26418683628394],
						[13.048065184961024, 49.26388549144786],
						[13.047152510689903, 49.263660334740074],
						[13.046566010336369, 49.26374054873078],
						[13.045932769889049, 49.263813020079354],
						[13.04480838717081, 49.26388549144786],
						[13.044055925994918, 49.26409516299824],
						[13.04310034351332, 49.26494964597794],
						[13.040403368004409, 49.26453401817254],
						[13.036017426494114, 49.26474771644055],
						[13.033896457022854, 49.26390469326678],
						[13.03285407376417, 49.26657097234458],
						[13.030903808648567, 49.26896658938266],
						[13.028500558855693, 49.273502371390684],
						[13.02566336402031, 49.278919086511785],
						[13.026592247450333, 49.28053275585885],
						[13.02750779207325, 49.28209316186066],
						[13.0283431929318, 49.283584507341374],
						[13.029734613375544, 49.28602983668489],
						[13.029934874111564, 49.2863844810194],
						[13.030617727292588, 49.28759399215473],
						[13.030655871446076, 49.28852474651359],
						[13.030696869524926, 49.28961563818414],
						[13.030746469692815, 49.291072955110415],
						[13.03060532703842, 49.2926064763],
						[13.030079841037962, 49.298339837263846],
						[13.029985441108431, 49.29937377598068],
						[13.029735564000427, 49.301036821367575],
						[13.029332155651927, 49.30368798964962],
						[13.029109008583617, 49.30434807555555],
						[13.025641432317785, 49.3045729573839],
						[13.023967741080076, 49.30490873171235],
						[13.021825800527917, 49.30500041924207],
						[13.019599926441131, 49.30473341037651],
						[13.01383209286738, 49.30513764084138],
						[13.013740531474003, 49.30514135790602],
						[13.010556226702752, 49.30531698927017],
						[13.007573130694498, 49.30599597441565],
						[13.0077562298797, 49.30650707297043],
						[13.007558822112331, 49.30708693871879],
						[13.006758692006027, 49.307037377493614],
						[13.00548840490803, 49.30730067160973],
						[13.005590431098597, 49.30793753470609],
						[13.005290039563505, 49.308475586105345],
						[13.005190854496451, 49.30873113767485],
						[13.005069729594707, 49.30957027785296],
						[13.004830357086608, 49.3102607351854],
						[13.004646300278658, 49.3111076243204],
						[13.004323967110752, 49.31179436854301],
						[13.003893850146369, 49.312271094616186],
						[13.003355023070473, 49.31253811115814],
						[13.002646444042211, 49.31268308080993],
						[13.002186763318702, 49.31315980849952],
						[13.001996986218082, 49.31353369495504],
						[13.00160215954246, 49.313972322992896],
						[13.001198774716862, 49.31425482957544],
						[13.00072478030342, 49.31432328790498],
						[13.000308034798802, 49.31433103206105],
						[12.999697678286415, 49.31463615199163],
						[12.999315260024064, 49.31474302149295],
						[12.998750689422469, 49.31477740560262],
						[12.998325346199653, 49.31494901645178],
						[12.998136510597858, 49.31502521913922],
						[12.997562409117533, 49.315444953851454],
						[12.997308744191859, 49.31574264064896],
						[12.99709034854917, 49.316120248009796],
						[12.996479038547555, 49.31642537002368],
						[12.996104240752372, 49.31666946789065],
						[12.995709423179841, 49.317104383943004],
						[12.995088569154646, 49.31721868892272],
						[12.994437221921467, 49.31731038075822],
						[12.993827831110611, 49.317634709906805],
						[12.993428225869675, 49.317993114218],
						[12.993117343827766, 49.31831372696025],
						[12.992862713789584, 49.31859221119683],
						[12.992401112100366, 49.3188933090582],
						[12.991876594726564, 49.31912223040042],
						[12.99129105084534, 49.319347434676544],
						[12.990827564679474, 49.319614458429484],
						[12.990813262241957, 49.31990440564347],
						[12.990890511696442, 49.320255378501756],
						[12.9907884586847, 49.32058714586368],
						[12.990528106979228, 49.320732119968895],
						[12.990090379629816, 49.320934402348065],
						[12.989839563685498, 49.32127391493134],
						[12.989829059566294, 49.32164378589245],
						[12.989511495243148, 49.321846068975695],
						[12.989048955909041, 49.32212827427325],
						[12.988976467011861, 49.32246004400754],
						[12.98892879725964, 49.322696712870346],
						[12.988673217899054, 49.32293709926406],
						[12.988661776001976, 49.32328807618624],
						[12.988678932620568, 49.32361984738978],
						[12.98836614070599, 49.32391754347737],
						[12.981219280572354, 49.32699953878377],
						[12.980292330039756, 49.32754909126052],
						[12.97644805331393, 49.3298148457299],
						[12.975936882648321, 49.33039848049255],
						[12.97568034798959, 49.330688439648334],
						[12.974069605473602, 49.332359428479286],
						[12.972595201268055, 49.33388885419376],
						[12.96972273471982, 49.3347395372225],
						[12.967496862269032, 49.33567417649929],
						[12.966869357493634, 49.33557132574254],
						[12.965115536896912, 49.33612430393156],
						[12.963896749804864, 49.33709333519597],
						[12.961871144427205, 49.33682629361328],
						[12.959861767691622, 49.336868425445786],
						[12.958370204374736, 49.33662028144166],
						[12.955283160971609, 49.33927150009569],
						[12.953332910945335, 49.34059154314851],
						[12.9499712050674, 49.342868873170445],
						[12.948918352296076, 49.34283076777092],
						[12.947886461561515, 49.34278863497788],
						[12.945931428983767, 49.34361642168463],
						[12.944342615872186, 49.34392932078555],
						[12.942958827631514, 49.344200087240445],
						[12.94189071669009, 49.34378433382886],
						[12.94152354979441, 49.34281156017327],
						[12.938720695283257, 49.34213247956255],
						[12.937363612218562, 49.342803815174584],
						[12.936409940345877, 49.34269321661877],
						[12.93582534696993, 49.34262846846633],
						[12.93529511794422, 49.34285369296998],
						[12.93245507496663, 49.34405912755217],
						[12.93067550185645, 49.344577735658994],
						[12.929012285467158, 49.3448370400982],
						[12.927443515275192, 49.34481442452754],
						[12.925224316229226, 49.34463133141807],
						[12.919901853563736, 49.34344107443142],
						[12.914125447241794, 49.34470754274755],
						[12.911872867724691, 49.34603504853461],
						[12.91079998411219, 49.346668288209024],
						[12.909501081704606, 49.34693533984277],
						[12.906572350534269, 49.3484688782885],
						[12.903251653493815, 49.34914023017324],
						[12.902499189567429, 49.349037064312306],
						[12.901668552254298, 49.34956745499781],
						[12.900616655846319, 49.34967433876511],
						[12.898459426274657, 49.34917059130522],
						[12.896195399308882, 49.34895310653961],
						[12.891887656203764, 49.35004796758213],
						[12.89043140049396, 49.35008235633092],
						[12.890034682095056, 49.35052879085908],
						[12.888720522664755, 49.35086834185054],
						[12.887524598957489, 49.35063164749969],
						[12.886048318225292, 49.35099412453784],
						[12.884654992012093, 49.35043708738231],
						[12.880237567121306, 49.35052476334084],
						[12.880105012600612, 49.348682335161314],
						[12.880101190506165, 49.34844192511086],
						[12.880098340526397, 49.34826657462075],
						[12.880118362859298, 49.347854532412704],
						[12.880187996059082, 49.34758004450525],
						[12.8804988871256, 49.34690095150803],
						[12.880911818218287, 49.3461989347807],
						[12.8810043207096, 49.34598145248774],
						[12.881004325684273, 49.34569922146281],
						[12.880990034105581, 49.345413273106146],
						[12.880878455779364, 49.34428032586619],
						[12.880871775784327, 49.34386828994141],
						[12.880913744258946, 49.34359752383016],
						[12.880990028811445, 49.34346771729272],
						[12.881121628108943, 49.343349373441235],
						[12.881413457278114, 49.343128175914835],
						[12.8817348536228, 49.34292990378132],
						[12.88188171661256, 49.342845947970076],
						[12.882178298337472, 49.34270467921201],
						[12.88223170938345, 49.34267803642848],
						[12.882420544214538, 49.34260182569056],
						[12.88282872088826, 49.342502689804554],
						[12.882989889004511, 49.34241873413051],
						[12.883136740218799, 49.34231557092216],
						[12.883254051524357, 49.342189792410906],
						[12.883343687577678, 49.342059986572345],
						[12.88349627552246, 49.34180440247231],
						[12.883787153281917, 49.341278054912706],
						[12.884169589464149, 49.340919618717116],
						[12.884509082209895, 49.34068293337416],
						[12.884967804583574, 49.3404617381033],
						[12.88533495761004, 49.34018694816044],
						[12.885493291081803, 49.339775228482026],
						[12.885594379195208, 49.33950818416129],
						[12.885709865305842, 49.33938674414274],
						[12.884670458398311, 49.339573551133384],
						[12.870924512344516, 49.336731187222156],
						[12.871793852045435, 49.334214133248146],
						[12.871191014644578, 49.334434393866026],
						[12.868535049821661, 49.33560571258742],
						[12.86721706329391, 49.33619307777125],
						[12.866556162725413, 49.3364867608577],
						[12.86410999728862, 49.33720021386401],
						[12.859150897645744, 49.33886349940163],
						[12.857090963084605, 49.33926406499761],
						[12.85593701085404, 49.33876808247466],
						[12.853479377274716, 49.33808126750455],
						[12.850161551562392, 49.340900411259845],
						[12.849062913916526, 49.341827327581406],
						[12.847930910221422, 49.34430696881301],
						[12.843334194610588, 49.345222434506944],
						[12.843451492243652, 49.34341040416426],
						[12.843002331791755, 49.34240355395616],
						[12.840308196185534, 49.34223564269865],
						[12.838606838153547, 49.34144596555531],
						[12.837038994292547, 49.340717320891045],
						[12.835828775861051, 49.340804993589714],
						[12.831548700353194, 49.34110270922755],
						[12.829258921862577, 49.34105685913846],
						[12.826729775661937, 49.34085084363466],
						[12.823228849271603, 49.34106460408537],
						[12.81950378393303, 49.34128951744388],
						[12.818671215714453, 49.34134280273072],
						[12.813827510428819, 49.341133069426085],
						[12.81273268586655, 49.3410872193317],
						[12.809243199827437, 49.34159466879745],
						[12.806413652067798, 49.34200670113936],
						[12.80253602210868, 49.341564308545315],
						[12.80069731811622, 49.34199895616456],
						[12.798509607763513, 49.34251415238948],
						[12.79545402886527, 49.3432350570492],
						[12.788602832047623, 49.3446960800665],
						[12.786286366593647, 49.345398092757925],
						[12.780611988473698, 49.347438773188955],
						[12.77881050807999, 49.34807976141888],
						[12.778648373154994, 49.3552016832629],
						[12.779705047246312, 49.356151576672346],
						[12.780522354832861, 49.35689172758458],
						[12.782340041185918, 49.359241387577484],
						[12.781380659108954, 49.36032111052621],
						[12.777158725726961, 49.36392961729511],
						[12.771939271815995, 49.36475747099264],
						[12.769268038873115, 49.36518100344673],
						[12.768383014040817, 49.365321974533046],
						[12.763854990825743, 49.36957561923483],
						[12.759470948222214, 49.37386713337004],
						[12.758089076127979, 49.37518704145321],
						[12.760306357811885, 49.38053893440482],
						[12.761125553064883, 49.382514821684765],
						[12.759315483101194, 49.38885870782143],
						[12.759133331954224, 49.38949576968653],
						[12.757631294925766, 49.394756237451816],
						[12.755591404506607, 49.39601148994099],
						[12.754830360007986, 49.39655684961019],
						[12.749407755155435, 49.39986404666561],
						[12.746678345448332, 49.401531140281975],
						[12.742305746005433, 49.404197582662356],
						[12.73746775671939, 49.40714634959855],
						[12.732945450384713, 49.409904573895275],
						[12.73241995915243, 49.410022638075425],
						[12.729405397041715, 49.410697867054274],
						[12.726572989626444, 49.411334982374754],
						[12.723319064941029, 49.41206754297005],
						[12.718972206806004, 49.41304398375736],
						[12.7147102408541, 49.41400152525331],
						[12.714425074452844, 49.415584420352815],
						[12.714806558398232, 49.41637804072848],
						[12.714186680946163, 49.41780104748496],
						[12.71415806348871, 49.41786581431057],
						[12.713635442709375, 49.4197158591589],
						[12.711034770366322, 49.422340342359675],
						[12.708719254778872, 49.42467881672224],
						[12.704893117240042, 49.42486196608028],
						[12.693619717713418, 49.42541110503094],
						[12.692323694205689, 49.42547618365171],
						[12.682809838068708, 49.426216221686055],
						[12.682761200678542, 49.426216221686055],
						[12.679196344945904, 49.42625031059101],
						[12.678894985163453, 49.426311360732015],
						[12.676612857625244, 49.4270935475646],
						[12.672937388345728, 49.42847818518198],
						[12.670485495360078, 49.42940138432927],
						[12.668296809567302, 49.43022913633862],
						[12.66807079401611, 49.43031312031027],
						[12.666797628837578, 49.43083561898779],
						[12.663200388428155, 49.4323197564943],
						[12.662431709122957, 49.43263617112129],
						[12.661802283440023, 49.43289556322361],
						[12.660922039484655, 49.43314348901171],
						[12.658540720367883, 49.433807311475015],
						[12.655893321377762, 49.43454737325324],
						[12.656595236558418, 49.43534477048717],
						[12.656991002887075, 49.43602750313977],
						[12.657196995881376, 49.43654629438166],
						[12.657155036242308, 49.43723677800162],
						[12.657403002490609, 49.43787395841185],
						[12.65775583870812, 49.43841537704246],
						[12.65808010268751, 49.43912508033552],
						[12.65814686686772, 49.439788918098564],
						[12.658175471963972, 49.440433542761795],
						[12.65802765895835, 49.44119655729363],
						[12.657763474074077, 49.44182197055335],
						[12.65779017261538, 49.442417013310184],
						[12.657631877393232, 49.442966499318075],
						[12.65736769287829, 49.44359191684499],
						[12.65706443107748, 49.44414512438804],
						[12.657024388523812, 49.44488149659524],
						[12.657014839752891, 49.4454802654362],
						[12.656743999526249, 49.44596095508686],
						[12.656329150262362, 49.44646829903082],
						[12.656029711427529, 49.4471169693066],
						[12.655845629334252, 49.44790634712486],
						[12.655582430435999, 49.44855502099806],
						[12.655681613834675, 49.44912342552533],
						[12.656212816546445, 49.449566000905605],
						[12.657145505903133, 49.450000828853256],
						[12.657978063331246, 49.450508180701966],
						[12.656905173319254, 49.452552784623904],
						[12.655433656939724, 49.455348993330766],
						[12.653657926216608, 49.45872512547349],
						[12.651802063683611, 49.46224976387047],
						[12.6513004409634, 49.463199738369184],
						[12.649328237723825, 49.4669342722233],
						[12.648494726017987, 49.4683113738665],
						[12.64724158798509, 49.46855158478418],
						[12.646735178968958, 49.46875367207721],
						[12.64605140316689, 49.46899791275851],
						[12.645304680612805, 49.469169625253606],
						[12.644474020014373, 49.4692114685684],
						[12.643878929330297, 49.46922293673737],
						[12.643248550785938, 49.469322120922385],
						[12.642464626778413, 49.46954714518304],
						[12.641880988932757, 49.46980285480763],
						[12.64153670065819, 49.47008119114674],
						[12.641194346753233, 49.4704094300426],
						[12.640718458106319, 49.470870948892056],
						[12.640383711356712, 49.47137059279178],
						[12.639966005123448, 49.47177880133398],
						[12.639565467045896, 49.47214888617242],
						[12.63952064323112, 49.472484566596705],
						[12.639479648868708, 49.47290052576893],
						[12.639182083130727, 49.47333136347041],
						[12.639080057778687, 49.47372066779457],
						[12.638880720613528, 49.47415150686156],
						[12.638579371109762, 49.47450640720736],
						[12.6383733743094, 49.47478102911904],
						[12.638087264670064, 49.475032714467886],
						[12.637724875890443, 49.475364679138636],
						[12.637207981930827, 49.47578808194177],
						[12.636721623425716, 49.47601714128736],
						[12.635874740497949, 49.47615042354389],
						[12.635261528116787, 49.47620001695919],
						[12.634608265440217, 49.47622295391698],
						[12.633763314021028, 49.4761962974527],
						[12.634581560903957, 49.477279605974616],
						[12.635207177512088, 49.47818376136717],
						[12.635474207847295, 49.47891620084309],
						[12.635578159273333, 49.479499860192156],
						[12.635878553348212, 49.48010242863424],
						[12.63599108559797, 49.48023974252397],
						[12.6363735239934, 49.48070530844443],
						[12.637097369616574, 49.48117459478101],
						[12.637860293341728, 49.481666509444295],
						[12.638232220764182, 49.48211657963453],
						[12.638251294868656, 49.482551462249816],
						[12.638504035747106, 49.48297890638836],
						[12.639021867816403, 49.48319619334606],
						[12.639227878293397, 49.48323834889682],
						[12.640124323048184, 49.48342897886285],
						[12.640989304486189, 49.48356629451893],
						[12.64176941618533, 49.48355110610193],
						[12.642708769207312, 49.48360814016227],
						[12.64322566629671, 49.48382945723296],
						[12.643915172567326, 49.484401658828794],
						[12.644093523520235, 49.484905358464694],
						[12.643992435068718, 49.48534024577048],
						[12.643962867932935, 49.485466093552134],
						[12.643713944273461, 49.48600761167599],
						[12.643699645411562, 49.48656462949861],
						[12.643759728546746, 49.487049115091615],
						[12.6440534554853, 49.48749919465186],
						[12.644116400196614, 49.48803327768123],
						[12.643903732716286, 49.48851776602696],
						[12.643691052731814, 49.488983036879844],
						[12.643667224233251, 49.48933795758061],
						[12.643803609583353, 49.48976913264226],
						[12.643905636680616, 49.49029919067716],
						[12.643930431022447, 49.490859937465956],
						[12.643765436951314, 49.49152359789655],
						[12.643712057148651, 49.49208465732022],
						[12.64381313486706, 49.492588061950514],
						[12.643757820511002, 49.49309921703987],
						[12.64370346428711, 49.4936333116429],
						[12.643849380775277, 49.49426660110267],
						[12.643754966060614, 49.49477775951296],
						[12.643374454261787, 49.49498761683659],
						[12.642813673823095, 49.49525823074191],
						[12.64236354795807, 49.496238704802934],
						[12.64154530412998, 49.4972191825856],
						[12.640486712182124, 49.498222293014976],
						[12.639929759155233, 49.49902329622966],
						[12.639902123944696, 49.499599561301906],
						[12.639981265212212, 49.500179237524065],
						[12.639703753057773, 49.50058749155876],
						[12.63977432765819, 49.50097280708264],
						[12.640065202325214, 49.50145731969582],
						[12.640515321360795, 49.50188820499729],
						[12.640883444735284, 49.50228499209789],
						[12.64101028698705, 49.50271990865947],
						[12.640892994036983, 49.50309003779997],
						[12.640666007670983, 49.503444667893014],
						[12.640579231495797, 49.50390252582282],
						[12.640734663966875, 49.50437154430041],
						[12.641024591518706, 49.504840873623394],
						[12.641070377830669, 49.50526060479751],
						[12.641305925157615, 49.505714436022586],
						[12.641593934403492, 49.506126418747776],
						[12.641986847170953, 49.506488802892434],
						[12.642456053212477, 49.50680158824759],
						[12.642449367737997, 49.50684343765489],
						[12.642585752672279, 49.507213572708146],
						[12.642595288556459, 49.50743862995981],
						[12.642599094234795, 49.50753007889916],
						[12.642742169158854, 49.508018633781695],
						[12.643288619207372, 49.50890739684391],
						[12.64355182604933, 49.50992202266562],
						[12.6438026503637, 49.51083001230928],
						[12.643814098189962, 49.511715065037215],
						[12.643651002640727, 49.51294701388892],
						[12.643429749583447, 49.513534470181426],
						[12.64322853119221, 49.514068607064],
						[12.642925259251784, 49.51459499492882],
						[12.642476093954395, 49.5151254139405],
						[12.642186162387452, 49.51595685026133],
						[12.64230441314144, 49.51697150381006],
						[12.642340669316175, 49.51777659533557],
						[12.642649661511228, 49.51900113289466],
						[12.642926207987417, 49.51953497108872],
						[12.643013960344367, 49.51996619659259],
						[12.64419554461346, 49.521400313341275],
						[12.644249927951881, 49.523040908043654],
						[12.642455096894437, 49.524612379389424],
						[12.641834260488425, 49.52588655237959],
						[12.641383179500407, 49.52680978920245],
						[12.641022691967224, 49.52774822035019],
						[12.639927872102753, 49.52862558060978],
						[12.63965035224988, 49.528976525550114],
						[12.63908291771668, 49.530178174567354],
						[12.637938498001564, 49.53118513347818],
						[12.63680839466968, 49.53167342316027],
						[12.635890003701775, 49.532012901294245],
						[12.632193563250887, 49.53197476811167],
						[12.630558018517256, 49.530994468234546],
						[12.62950515527637, 49.529106114880406],
						[12.629136074397332, 49.52822100245103],
						[12.62858675836382, 49.52698123011834],
						[12.627739915991501, 49.52725993810747],
						[12.62695694917643, 49.527347673832736],
						[12.626318923394079, 49.52739324681844],
						[12.625405316233385, 49.52741246808011],
						[12.624334328803661, 49.52717964289392],
						[12.623003965535382, 49.52688605404427],
						[12.621635427361218, 49.5265425524146],
						[12.620703708578324, 49.5265580533808],
						[12.62067223834965, 49.5270959374856],
						[12.62041378853701, 49.52787408881165],
						[12.619952213418356, 49.528598918734545],
						[12.619352336184773, 49.52909464405189],
						[12.6188144611169, 49.52934638235181],
						[12.616533279695823, 49.52902984938148],
						[12.614717483833799, 49.52836609247627],
						[12.613420487379667, 49.529342662079564],
						[12.61206531822052, 49.53036883920684],
						[12.608460414734392, 49.530826434917316],
						[12.60170554404371, 49.53247825058665],
						[12.599476819669562, 49.533374848662355],
						[12.598199839163623, 49.53389352525364],
						[12.595834738627122, 49.53482826185578],
						[12.589724530716865, 49.537719611213355],
						[12.58893204673978, 49.53825007782534],
						[12.58850191784904, 49.53853592878481],
						[12.588948244620596, 49.53865808211157],
						[12.589033126341402, 49.53868102462102],
						[12.589318264575967, 49.538761013386235],
						[12.591974268686206, 49.539516567406054],
						[12.593593610131778, 49.540180353050644],
						[12.594239243159615, 49.5408097263543],
						[12.594676978331384, 49.541236956991],
						[12.595008840224931, 49.54154575403203],
						[12.594779012034923, 49.54166790878708],
						[12.593778617235559, 49.54219063258154],
						[12.592912682184506, 49.54262933694136],
						[12.589644436662281, 49.544426017369794],
						[12.58782385855904, 49.54543675251161],
						[12.587780947974597, 49.54545969562532],
						[12.587802898124117, 49.54557813173138],
						[12.587852482056373, 49.5458450782332],
						[12.588008889807636, 49.546257125119354],
						[12.58764649364857, 49.54655848714239],
						[12.586309431937673, 49.547668444962966],
						[12.584466929020111, 49.54876321531449],
						[12.581704127240688, 49.55171952160185],
						[12.581239706829647, 49.55381019479441],
						[12.580623615328486, 49.554447042712496],
						[12.580411917341605, 49.555633617992214],
						[12.578731547718327, 49.55671322952419],
						[12.57778548658361, 49.55718606483646],
						[12.576285369167463, 49.55770882016777],
						[12.574164398950519, 49.55944452431969],
						[12.574465741318136, 49.56166827674265],
						[12.57424260203145, 49.5626031142716],
						[12.574215896689424, 49.564014523843625],
						[12.574130065022315, 49.56472023153707],
						[12.572426807357258, 49.56732572361263],
						[12.57127666719508, 49.56848910311792],
						[12.571003912605892, 49.568969711861044],
						[12.571059224496347, 49.56975171071884],
						[12.572315228696505, 49.57127013481002],
						[12.57349586538494, 49.57488251328665],
						[12.573515903731275, 49.575016156761514],
						[12.573570247424458, 49.57531352149462],
						[12.573589332116331, 49.57544716519384],
						[12.57383061287223, 49.57684717239715],
						[12.573904041523049, 49.57727818390404],
						[12.573982240078003, 49.57812501509503],
						[12.57408999998845, 49.579326583736744],
						[12.574161538304057, 49.58097467994051],
						[12.57506562357302, 49.58212292707076],
						[12.575510970625729, 49.5826872848217],
						[12.576825138322048, 49.58428950944388],
						[12.576955807188629, 49.585331100355276],
						[12.577077859336237, 49.58629982401066],
						[12.57607174343446, 49.58715443728979],
						[12.57397841365791, 49.588981508322874],
						[12.570605283387598, 49.5915413522459],
						[12.56625557682042, 49.5943489924028],
						[12.565401071244295, 49.595405509093204],
						[12.56419086650942, 49.596237205072455],
						[12.563797963212778, 49.5973969944267],
						[12.563885699971944, 49.597828040471136],
						[12.564033506565702, 49.59836576367541],
						[12.564107892025392, 49.59879681134945],
						[12.563457493772646, 49.59978109127472],
						[12.563545230879205, 49.60021214132986],
						[12.563782690292745, 49.60121534336692],
						[12.563870427608261, 49.6016463958352],
						[12.563720692239352, 49.60585772357976],
						[12.56262205896272, 49.607696402307404],
						[12.562666894672939, 49.60873033539292],
						[12.562449443959283, 49.60914217312963],
						[12.562039370775024, 49.6099128200718],
						[12.56118105954733, 49.61024464864467],
						[12.56046009117955, 49.610519415433366],
						[12.559955607269009, 49.61071789275535],
						[12.559638988592102, 49.61103452642668],
						[12.559475889381952, 49.61148823431911],
						[12.559307103666953, 49.61182409652369],
						[12.558769222108964, 49.61209483341384],
						[12.558562276126334, 49.612411468788416],
						[12.558204639382264, 49.612605915975536],
						[12.557854651631393, 49.61261366905625],
						[12.557728758540108, 49.612617390535064],
						[12.557473171025025, 49.612644061134844],
						[12.557196612621373, 49.6128692107275],
						[12.557093616626172, 49.61333842807709],
						[12.55688477721184, 49.61429609312307],
						[12.557520860752252, 49.616310054559676],
						[12.558687217246414, 49.61756142293766],
						[12.55887316712235, 49.617759595591565],
						[12.559596053199632, 49.618533990047574],
						[12.56066990449439, 49.61963278444169],
						[12.559858329994334, 49.61983499041589],
						[12.556957240847801, 49.62055201656985],
						[12.556395531860169, 49.62068940546115],
						[12.545992851586982, 49.62133789442964],
						[12.536185254355466, 49.61810290914407],
						[12.52816868665882, 49.61818323279691],
						[12.528442395129957, 49.62039198806716],
						[12.526926999073437, 49.62227636105144],
						[12.530232425847599, 49.62273784226591],
						[12.533051489235206, 49.6238937199036],
						[12.533535952968109, 49.62475962361204],
						[12.53360842684782, 49.62488926131075],
						[12.534401895009436, 49.626308457257586],
						[12.53361319313266, 49.626670700841615],
						[12.529715534644044, 49.627201041261074],
						[12.528509141534387, 49.626537340558365],
						[12.527242670210237, 49.62672435511472],
						[12.525169361100824, 49.627166615621526],
						[12.524074546084696, 49.62763585919769],
						[12.52366543354969, 49.62796026735533],
						[12.523383135736784, 49.62841028355966],
						[12.52324582056968, 49.62881098783494],
						[12.523262033577362, 49.62919246385089],
						[12.523478502340915, 49.62969582697729],
						[12.523693071814408, 49.63015732158344],
						[12.523379329548204, 49.63041691266554],
						[12.523036947764249, 49.63077916207143],
						[12.52301693732259, 49.631076901693554],
						[12.52267168909306, 49.631378053268385],
						[12.522692668364757, 49.631862501757354],
						[12.522709854331422, 49.6322861623282],
						[12.522500025567666, 49.6326902843032],
						[12.522488585560218, 49.63319768624503],
						[12.522644030837014, 49.633785107599884],
						[12.523224834023582, 49.63445285906931],
						[12.524058355080479, 49.63494506714522],
						[12.524986260134913, 49.63534919332532],
						[12.525588027290356, 49.63571920350434],
						[12.526055332757238, 49.63634105752695],
						[12.526543629181248, 49.6367799229976],
						[12.526954643323467, 49.63726034973763],
						[12.527788164851597, 49.63775256322239],
						[12.52839564427107, 49.638267418922005],
						[12.52880000102973, 49.638599284290436],
						[12.528859137240097, 49.63923262107803],
						[12.528591149575716, 49.63980858052893],
						[12.527808192030497, 49.64051821894582],
						[12.527112012254987, 49.640976011208615],
						[12.526316639421738, 49.64138790088349],
						[12.5257167753843, 49.64182274296294],
						[12.525143632212195, 49.642109019572075],
						[12.52440738390658, 49.642394986342794],
						[12.523563382364564, 49.64243313594705],
						[12.522646913975564, 49.64229976743673],
						[12.52095699185118, 49.64221571429508],
						[12.51995278493867, 49.64245236583103],
						[12.519441606100097, 49.64267350960086],
						[12.518999103081871, 49.64297870692734],
						[12.518486965098527, 49.64317689928899],
						[12.517916688827567, 49.64352427907332],
						[12.517608651957921, 49.64393245092379],
						[12.517534269127108, 49.644504699031685],
						[12.51756478084618, 49.645221794406304],
						[12.517628676872535, 49.64596184390742],
						[12.518149372571774, 49.64673229168579],
						[12.518302920927106, 49.64727787185305],
						[12.518748274902693, 49.64781942102902],
						[12.519614217565376, 49.6482887025443],
						[12.52050781932734, 49.6487313105539],
						[12.52064418457209, 49.64879985748316],
						[12.521280277981173, 49.6492117597807],
						[12.521327959316213, 49.64957031382784],
						[12.52105331547454, 49.64999772579826],
						[12.520977028593649, 49.650505162129406],
						[12.521508221955639, 49.650749265418305],
						[12.522397993416478, 49.65090559090004],
						[12.522491448263004, 49.650920789215846],
						[12.523381223542183, 49.65120304381726],
						[12.524152750895192, 49.651737157225],
						[12.524599086220855, 49.65227902603492],
						[12.524790765193956, 49.65297319050761],
						[12.524845113366403, 49.65347660050901],
						[12.524962432468643, 49.65358361015675],
						[12.525352472591996, 49.65393441601228],
						[12.525916104787647, 49.65419775335076],
						[12.525994306339646, 49.65449148801719],
						[12.525841704719344, 49.65472784076101],
						[12.525178910185398, 49.65509415692913],
						[12.523819924608794, 49.65564347707985],
						[12.523291575827946, 49.65617356749423],
						[12.523238182993733, 49.656627665717615],
						[12.52341078866343, 49.65724553836904],
						[12.523462293690631, 49.657600381572394],
						[12.523221004710372, 49.65796266954807],
						[12.522993089554841, 49.65863420641194],
						[12.522499083534408, 49.65909575332801],
						[12.522307389407802, 49.65976326082934],
						[12.522446626070733, 49.660453723493944],
						[12.52316666234641, 49.66101080973791],
						[12.524213802409077, 49.66146863876491],
						[12.525007244925309, 49.66202541704306],
						[12.52565766425658, 49.662658811972065],
						[12.526488300293941, 49.663215592849284],
						[12.527348530382842, 49.66360487490913],
						[12.52798746983402, 49.663947939910415],
						[12.528077126001206, 49.66435242220479],
						[12.528322209169662, 49.66492068369028],
						[12.528889659150494, 49.66533664445624],
						[12.52956772739817, 49.665756328154075],
						[12.52984618836196, 49.66624828642099],
						[12.529834750075752, 49.66684726085124],
						[12.529712666809543, 49.667442204221544],
						[12.529448514206958, 49.66811376605532],
						[12.529022226860288, 49.668457147316445],
						[12.528419482335092, 49.66894135600566],
						[12.527973173715077, 49.669666274898276],
						[12.527515417057185, 49.67012411947197],
						[12.526798254728929, 49.67052085672925],
						[12.526638994324593, 49.67107021012026],
						[12.526517863324589, 49.67169184011767],
						[12.52616881436098, 49.67210377939464],
						[12.525825487103452, 49.67265685855272],
						[12.525664340887856, 49.673183572181834],
						[12.525685321913874, 49.673683299723606],
						[12.525298128498632, 49.67406856520163],
						[12.524693484909466, 49.6745109077653],
						[12.52449320795044, 49.674987683183964],
						[12.524372098898604, 49.6755866781597],
						[12.523766509865348, 49.676025300956645],
						[12.523116115976027, 49.67625050644857],
						[12.522807110209616, 49.67675768483525],
						[12.522721289680172, 49.67733000661299],
						[12.52252291831943, 49.67783346471992],
						[12.522322660793982, 49.678314278998286],
						[12.52223588109482, 49.678863649197964],
						[12.522087107723353, 49.679145934741776],
						[12.52203179382795, 49.6792489225126],
						[12.521979337157271, 49.679725706801655],
						[12.52225779827363, 49.6802443697097],
						[12.522570609205191, 49.6806907556781],
						[12.52267360095063, 49.68112938726696],
						[12.522704115635872, 49.68125905360981],
						[12.522736555305285, 49.68202216308996],
						[12.522504815639481, 49.68259821920053],
						[12.522410380150024, 49.682723853581955],
						[12.522087103760887, 49.68315132115156],
						[12.522105207947702, 49.68358220174324],
						[12.522230151237924, 49.68391040357599],
						[12.521992695569072, 49.684368273758615],
						[12.521753299876558, 49.68480287894187],
						[12.521589285260692, 49.685257028191835],
						[12.521606438218967, 49.68566123411438],
						[12.521622647989277, 49.68579090276582],
						[12.52166177096282, 49.686088706617355],
						[12.521637921653822, 49.68676000741085],
						[12.514081947858866, 49.68783179677547],
						[12.511928554097258, 49.68644327978255],
						[12.50924776681364, 49.68640884614642],
						[12.508584983386093, 49.68634804442193],
						[12.507842064186136, 49.68614578572869],
						[12.506835943688065, 49.685783457674006],
						[12.506350524574948, 49.685577476886614],
						[12.505662918539612, 49.68537521880577],
						[12.5050353883686, 49.68529115146057],
						[12.504267693014775, 49.68537521880577],
						[12.503435140840832, 49.68564231118275],
						[12.502570139280811, 49.686023561995036],
						[12.501189239058222, 49.68634804442193],
						[12.50029659511295, 49.686504391742815],
						[12.499314313758061, 49.686271732074],
						[12.498386388933987, 49.68602759475691],
						[12.496704096059714, 49.68573754627924],
						[12.495068553926108, 49.68566898941463],
						[12.493293771309148, 49.685794935524],
						[12.491779338317121, 49.686012394347195],
						[12.490347855075894, 49.68643180190333],
						[12.48647594670141, 49.68776323934666],
						[12.485220897814804, 49.68788515370117],
						[12.485101697807153, 49.6886901621647],
						[12.485099786149746, 49.68996422122742],
						[12.485439296478672, 49.69150538520207],
						[12.48399543437192, 49.693870506852726],
						[12.480921737257692, 49.695030119390715],
						[12.47552393999331, 49.69634236788576],
						[12.470993994379144, 49.697303757074074],
						[12.469069470961717, 49.69782245581602],
						[12.468705183605241, 49.698368145407436],
						[12.46557426524096, 49.699001320528644],
						[12.46304224861748, 49.699508544264575],
						[12.459959027870145, 49.700778934760365],
						[12.45745467210772, 49.702056777173134],
						[12.452816021039725, 49.70121015544396],
						[12.44996928435717, 49.701824103276564],
						[12.445611009709474, 49.702472798631085],
						[12.444459916181575, 49.703159344107114],
						[12.442886351920414, 49.70370101211329],
						[12.441650403793153, 49.7047120667667],
						[12.440278995699172, 49.70577989872491],
						[12.439265246780552, 49.70747751879254],
						[12.435379029727773, 49.712593094936295],
						[12.435064328994203, 49.71405807543715],
						[12.432808872106984, 49.715949966615156],
						[12.432923326000894, 49.716369733820194],
						[12.433180818467854, 49.717582812201265],
						[12.433254236016875, 49.71802895348321],
						[12.429938317681492, 49.71976853967062],
						[12.42897129733649, 49.72092827041904],
						[12.428777692394977, 49.724369022311315],
						[12.427955623541733, 49.72566218621234],
						[12.427807807810387, 49.72647476066334],
						[12.427556043511856, 49.72702795812269],
						[12.42727757594927, 49.72741330445781],
						[12.426884663529599, 49.727684164188645],
						[12.426564205375973, 49.72792803127272],
						[12.426539412625633, 49.72823705402142],
						[12.426441180831793, 49.72852311758419],
						[12.426160820552564, 49.728862857267075],
						[12.426065433679833, 49.72922121331616],
						[12.425931920465777, 49.72955692048122],
						[12.425840365145955, 49.73001083947106],
						[12.425711643348576, 49.73046506954004],
						[12.42520810498906, 49.73073593252984],
						[12.424478543442508, 49.730865624189796],
						[12.424003602314588, 49.73092271336257],
						[12.423305515800715, 49.73093419325214],
						[12.422505386823484, 49.731113527810514],
						[12.421918859634298, 49.73114765723912],
						[12.420998573517442, 49.73111725102069],
						[12.42030333363111, 49.7311743402501],
						[12.419683465217538, 49.73128138258992],
						[12.41899014331947, 49.73141107452885],
						[12.418301571995611, 49.73163974205641],
						[12.417573922308623, 49.731819077113705],
						[12.416692722446843, 49.73183428026456],
						[12.415884963389408, 49.73184576019536],
						[12.415226935669269, 49.73190688307903],
						[12.414498334026295, 49.73205953521835],
						[12.413875573411394, 49.7321166246599],
						[12.413222316526618, 49.732318919958445],
						[12.412790293249538, 49.73251718191837],
						[12.412508021578653, 49.73280728381361],
						[12.412524227468296, 49.73321156540401],
						[12.412578584885138, 49.73366549093566],
						[12.412672036553214, 49.734161303894055],
						[12.41268824262822, 49.73456558764347],
						[12.412600511292373, 49.735675742344796],
						[12.409760474425008, 49.73687743288796],
						[12.408225064192417, 49.73876577092646],
						[12.40725327381701, 49.739139654838915],
						[12.406365389611718, 49.73948282180333],
						[12.404886236293391, 49.74276340973905],
						[12.404621128883843, 49.74444203968491],
						[12.404541967318213, 49.74493787372658],
						[12.40451717330418, 49.74504088817991],
						[12.404411319982225, 49.74547963092914],
						[12.404393193807609, 49.74571606828449],
						[12.404498086932668, 49.74590286015699],
						[12.405672085261235, 49.74748625260881],
						[12.405892374703434, 49.74777606135244],
						[12.405772196077866, 49.747913208646494],
						[12.401527413998247, 49.75289927688425],
						[12.400717740427346, 49.75384908918004],
						[12.400624277711596, 49.754642515642814],
						[12.400494581255225, 49.75574500089081],
						[12.401439662637667, 49.75702280995326],
						[12.401523587965977, 49.758373235867445],
						[12.401655205779171, 49.75943384656661],
						[12.401860024864025, 49.759671227861446],
						[12.43673912278752, 49.76926285971572],
						[12.452655485365215, 49.77970173660627],
						[12.452730991498004, 49.78008902509343],
						[12.452796936938201, 49.780113230643614],
						[12.459872233828051, 49.78274140859876],
						[12.467042915003098, 49.785388854611995],
						[12.468276969306554, 49.78665533109814],
						[12.470018397292547, 49.787090422011154],
						[12.471655855645482, 49.785667534754154],
						[12.47272299710088, 49.78593814650054],
						[12.472566605987627, 49.78746034297766],
						[12.47401428330242, 49.78866196918572],
						[12.474745758379255, 49.78988656624166],
						[12.474832543222538, 49.7906571406222],
						[12.474309930561901, 49.791950332958],
						[12.472616187073925, 49.79191960908918],
						[12.471791266494915, 49.79200743591606],
						[12.47096823419985, 49.79209122832357],
						[12.469879142056186, 49.792442225710644],
						[12.46914290597292, 49.79287329213503],
						[12.468276968050873, 49.79326618701197],
						[12.467083921992177, 49.79378880642182],
						[12.466382036387477, 49.794159047549435],
						[12.465634341758042, 49.79475397931711],
						[12.465293894189077, 49.79541408522038],
						[12.465767864335453, 49.79664616338766],
						[12.466389652125114, 49.79701609835937],
						[12.47056962128469, 49.79953396715336],
						[12.470653523345547, 49.79958331303962],
						[12.470426562883297, 49.80102924489826],
						[12.470351223976612, 49.80252080724605],
						[12.470039373016505, 49.802795471686316],
						[12.469077097260804, 49.803642122826304],
						[12.466735835082252, 49.80587763068227],
						[12.466836927041252, 49.80630872006603],
						[12.467038166348745, 49.80714048568302],
						[12.467111575002741, 49.807571266864805],
						[12.466728210893281, 49.80803680931538],
						[12.46421719222831, 49.81022269779747],
						[12.46546650046835, 49.81149674774861],
						[12.466861725871711, 49.8129654047947],
						[12.468317035442492, 49.81342319799484],
						[12.46933268695237, 49.81374349854535],
						[12.46982478493217, 49.81389992454358],
						[12.473316200688858, 49.81511316043434],
						[12.473176956225668, 49.8166389470956],
						[12.473265650447399, 49.817005186929],
						[12.473879818537153, 49.818054249737735],
						[12.474788656697202, 49.81911076592883],
						[12.474943172475099, 49.819297922461175],
						[12.47453879562319, 49.821670446180974],
						[12.474520672120487, 49.82189547084969],
						[12.474640843607803, 49.82210156258475],
						[12.476117130481818, 49.824821430607905],
						[12.476267801498444, 49.82511505271767],
						[12.476232526029442, 49.825267761180726],
						[12.475539199684325, 49.82699194547862],
						[12.47411988739684, 49.82891199611287],
						[12.482524455778552, 49.82724397844807],
						[12.488934139578086, 49.84074052643803],
						[12.489862501548872, 49.84269513692288],
						[12.49745287910838, 49.85176625569625],
						[12.50214305853216, 49.85737118688131],
						[12.503069876524899, 49.857471453459404],
						[12.503887185155461, 49.85755930315672],
						[12.507397639913746, 49.85760866042063],
						[12.510659228841543, 49.85836423131942],
						[12.512105946216817, 49.85942464196981],
						[12.513180730738311, 49.86088178264508],
						[12.513669004495853, 49.8612555371764],
						[12.514570228579148, 49.8619422039283],
						[12.51573848038092, 49.863899152389706],
						[12.518639551034298, 49.86828216385799],
						[12.518699634786744, 49.868373742575365],
						[12.518741606032398, 49.868713360212304],
						[12.51894188380907, 49.87179570620241],
						[12.519059177681275, 49.8768348289815],
						[12.519071590512734, 49.87713254769543],
						[12.519161233969909, 49.87726604003858],
						[12.520148279137484, 49.87919237350732],
						[12.520469671165685, 49.879482333767136],
						[12.521364199041146, 49.880287021812336],
						[12.521871569812495, 49.88172534603774],
						[12.52371691439591, 49.88292680169551],
						[12.525615693512254, 49.88468553205593],
						[12.525760646999673, 49.88478084224445],
						[12.526519785167451, 49.885292164949526],
						[12.530670175759731, 49.888080708226916],
						[12.532662393979704, 49.889160182711244],
						[12.534509668611832, 49.889953725160595],
						[12.5355186516419, 49.890792908349496],
						[12.537744528174885, 49.89112479474457],
						[12.539959920653354, 49.89120116903804],
						[12.540423401554389, 49.89170846879799],
						[12.540933612340263, 49.892242469655336],
						[12.543429387210194, 49.89473738642214],
						[12.544189454297582, 49.89516831781865],
						[12.545151718958259, 49.89571008780962],
						[12.545708656105584, 49.896312711279826],
						[12.547612178547892, 49.898380146151425],
						[12.548367502291416, 49.899211906189244],
						[12.5496730741746, 49.90109245782922],
						[12.550572399416822, 49.90264515772262],
						[12.550958638583731, 49.903896390600956],
						[12.550879483440552, 49.90470891912334],
						[12.551343907096754, 49.90474307208042],
						[12.55132483693156, 49.90486136554054],
						[12.554712301391808, 49.9030304622674],
						[12.557641996645524, 49.90166870365614],
						[12.557994854560379, 49.90128340120789],
						[12.578387272044266, 49.900112284112],
						[12.584023463810789, 49.89895234956873],
						[12.589097987812643, 49.89686597119882],
						[12.590913783608594, 49.896373874072744],
						[12.595046055475171, 49.895748275652636],
						[12.60190106034883, 49.89553839782315],
						[12.606611247586695, 49.895835828290316],
						[12.611226079767334, 49.896553015942956],
						[12.621322632203237, 49.899452213635236],
						[12.62566089871571, 49.900329617199276],
						[12.64201069706015, 49.902603243081884],
						[12.64778042251986, 49.90264515772262],
						[12.653009404145694, 49.9017866851852],
						[12.659251206207019, 49.89994804251838],
						[12.661771764813412, 49.8986052395806],
						[12.667948729857628, 49.89447410881575],
						[12.671371453079702, 49.891662519940205],
						[12.673419953926057, 49.890396135481375],
						[12.676106466114245, 49.889633327437174],
						[12.679041868039743, 49.88961035319755],
						[12.683253281106548, 49.89047996068286],
						[12.68583201673163, 49.891662519940205],
						[12.687768923556975, 49.89356598947895],
						[12.689705845768366, 49.89665981808949],
						[12.691521643366446, 49.898548112401464],
						[12.694292073352443, 49.899955804406005],
						[12.702277194373433, 49.90285504151067],
						[12.708015448253851, 49.907039713900694],
						[12.711125377341562, 49.908840218831436],
						[12.714686396453066, 49.91032031251795],
						[12.724335675344438, 49.91258626691656],
						[12.727671625985895, 49.91368106122963],
						[12.736810670849852, 49.91869339260941],
						[12.73992824089445, 49.92069239167937],
						[12.742501255335233, 49.92186733118131],
						[12.747099870499726, 49.92300408419741],
						[12.75176716548173, 49.923599321314136],
						[12.754974375998716, 49.92350399633883],
						[12.768464081475893, 49.92228309465923],
						[12.777070035041698, 49.92264545219034],
						[12.815242761398455, 49.92300408419741],
						[12.829834939495237, 49.922626511466625],
						[12.836182594600336, 49.921745303645125],
						[12.844721796601998, 49.91855242620796],
						[12.848860731260762, 49.91787709267818],
						[12.855857843849712, 49.91743463376867],
						[12.87344645525916, 49.91744984813222],
						[12.895296095308899, 49.9181938005891],
						[12.899975771351171, 49.917514742060554],
						[12.904564868836593, 49.916385776408646],
						[12.910553935272933, 49.91352084712831],
						[12.914284711119565, 49.91255956467609],
						[12.920770631327041, 49.912021484089756],
						[12.927333829119549, 49.912403077184784],
						[12.931253424642177, 49.913326168503815],
						[12.936139118631763, 49.915825021437065],
						[12.94524001947718, 49.919742570152486],
						[12.951543819254578, 49.92369092026602],
						[12.955961228054754, 49.927425391555005],
						[12.959299078333057, 49.93196477294665],
						[12.962478638588708, 49.93832016975531],
						[12.963605887784103, 49.943088609110006],
						[12.964408863419795, 49.95105349726345],
						[12.96470546359626, 49.95517345249743],
						[12.965882307546739, 49.95735938237772],
						[12.967984207181836, 49.959133232452004],
						[12.971280102469192, 49.96053319167146],
						[12.975468632620988, 49.96135708439212],
						[12.988170619680325, 49.962810471333505],
						[12.9899663797502, 49.96327195451634],
						[12.995184891189952, 49.96530143478514],
						[12.998983394487913, 49.96614087116779],
						[13.00972556633453, 49.96731944089741],
						[13.01377773294425, 49.96801757916769],
						[13.015583997554822, 49.96854025247245],
						[13.022188186666327, 49.971263885725996],
						[13.029249198609188, 49.97287758260937],
						[13.032528865889867, 49.97396456677626],
						[13.041510577710392, 49.97907252423453],
						[13.045372974232048, 49.982074860802996],
						[13.049804680964609, 49.98490517154403],
						[13.056037900541257, 49.99097058657118],
						[13.065797816946166, 49.99897396809288],
						[13.07071399687876, 50.00389862051333],
						[13.075096130397716, 50.00674819975155],
						[13.078899383559218, 50.00976562515561],
						[13.087936401400508, 50.014869690304366],
						[13.091476440401205, 50.015922546076354],
						[13.097531318676062, 50.01677703869798],
						[13.105044364914248, 50.01747131331409],
						[13.10848712919082, 50.01750183083088],
						[13.125795364339812, 50.016368865532314],
						[13.132195472709459, 50.01541137686892],
						[13.134031295809805, 50.014869690304366],
						[13.140570640552323, 50.01209640490311],
						[13.147628784125788, 50.01043319643851],
						[13.15095996859161, 50.009368896750765],
						[13.1571283340531, 50.00622558601997],
						[13.163474082944257, 50.003894805880925],
						[13.176372520893223, 49.998630446034305],
						[13.180719378545069, 49.995742829569224],
						[13.18532085120425, 49.99320217724328],
						[13.18916894089862, 49.9902344921634],
						[13.193563470072691, 49.98764047557432],
						[13.197351455025306, 49.9846458363433],
						[13.206386553405846, 49.97942719994737],
						[13.21026133261823, 49.97834764567259],
						[13.216862670110773, 49.97777929763447],
						[13.223493588995106, 49.978187700601616],
						[13.22747135468724, 49.97921756231519],
						[13.229986187977635, 49.98058316055247],
						[13.234963411935592, 49.98395914288441],
						[13.236626620606085, 49.985984754279905],
						[13.237232196376878, 49.988433710054025],
						[13.236409185180568, 49.99203870380974],
						[13.235704407895199, 49.993099060851414],
						[13.231469168217984, 49.99725356718],
						[13.230266575587597, 49.99984364631423],
						[13.229538917535228, 50.00275039666088],
						[13.228895187361601, 50.008979797187536],
						[13.228958129870291, 50.01372909532354],
						[13.229846954336237, 50.018363952534294],
						[13.231377601682762, 50.02128601137962],
						[13.233880996725617, 50.02374649071036],
						[13.23541831960176, 50.024806975238555],
						[13.238916397091286, 50.02656936641807],
						[13.247571945125557, 50.0293807976433],
						[13.26081180575566, 50.03438186678277],
						[13.269763946572413, 50.04001236003803],
						[13.276214599706368, 50.04557037457351],
						[13.279215812727111, 50.047386169903845],
						[13.28628063220883, 50.050632478835965],
						[13.29461193100973, 50.05650711233286],
						[13.29555034625575, 50.057598112744564],
						[13.296853065702468, 50.06005859601202],
						[13.299984932026922, 50.06894683924486],
						[13.302437782157323, 50.08313369611946],
						[13.306427002287563, 50.093093875634665],
						[13.309329033215203, 50.10226822237318]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ32",
				"name": " Plzeňský kraj",
				"region": "plzensky"
			},
			"id": 10
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[14.599121093800113, 50.140209198484406],
						[14.601436614813894, 50.1349029523912],
						[14.603182792850275, 50.13263702573481],
						[14.603369712360873, 50.132392878755475],
						[14.606125831368894, 50.13019561539566],
						[14.609541893252834, 50.12840271235875],
						[14.61266708351056, 50.12733077780263],
						[14.612944602813096, 50.12723159641481],
						[14.617353438850417, 50.12609099875966],
						[14.618115424889208, 50.12589263702273],
						[14.61996460004317, 50.1254158062046],
						[14.621581077541641, 50.12499618497184],
						[14.632778167577692, 50.1230468735783],
						[14.63937854738535, 50.122352597357555],
						[14.644143104653475, 50.122192383781076],
						[14.655430794129877, 50.121818546033886],
						[14.659493445898637, 50.12135695974789],
						[14.663112639889617, 50.12037658216836],
						[14.664635658455015, 50.11957550233213],
						[14.665022849782996, 50.11915588133811],
						[14.666730880639422, 50.117305754668465],
						[14.668251991570846, 50.11268616011419],
						[14.669245719723369, 50.10966872988931],
						[14.671113968026829, 50.10745239384701],
						[14.671660423223695, 50.10718154853908],
						[14.674030303574149, 50.10600280393706],
						[14.682225227830768, 50.10366440277832],
						[14.687073707741872, 50.101417543061615],
						[14.690416335691179, 50.10049819590633],
						[14.695817947041697, 50.099426266191536],
						[14.699170112631165, 50.09840393086847],
						[14.708447455858481, 50.09309768193183],
						[14.709835052968055, 50.09167099459861],
						[14.715499877835892, 50.08584213166385],
						[14.716075897354614, 50.085041047470924],
						[14.717371940926654, 50.083244326756024],
						[14.717997551231448, 50.08182144422455],
						[14.718535423184768, 50.07891464142719],
						[14.718161583165282, 50.07603073330859],
						[14.716650963042882, 50.07328415122738],
						[14.715966224545367, 50.0727157580705],
						[14.714371681396205, 50.07139206109024],
						[14.711347580013852, 50.069984436592414],
						[14.707977294942213, 50.06902313251942],
						[14.705410003878034, 50.06843567102912],
						[14.701267242198812, 50.06749343647232],
						[14.68983173370691, 50.06577682498367],
						[14.689107894750705, 50.06566619731221],
						[14.680419922093828, 50.06274414274214],
						[14.677303314019936, 50.06232833679306],
						[14.676477432157455, 50.06222152619446],
						[14.669684410108736, 50.06198120130273],
						[14.66392421730442, 50.061782837690686],
						[14.661479950075746, 50.0616951000833],
						[14.657501220744486, 50.06117248575224],
						[14.655636787570465, 50.06063079985038],
						[14.653990745436584, 50.05981063738117],
						[14.652630806143078, 50.058647157445904],
						[14.651812553547614, 50.057392121735525],
						[14.651305198714848, 50.05477905317372],
						[14.651982307493894, 50.052043915374476],
						[14.652773857350667, 50.0507469199925],
						[14.653850555430097, 50.04956054697304],
						[14.653944969005735, 50.049491880660234],
						[14.656556129561093, 50.04754257304531],
						[14.663658142305433, 50.044136049453094],
						[14.66563987710154, 50.04274368075065],
						[14.665869712758015, 50.042579650185154],
						[14.668606758002765, 50.038650511580855],
						[14.669340133582548, 50.036571501866426],
						[14.669384002594057, 50.03441619784229],
						[14.668176651025409, 50.020130157706575],
						[14.667575836158663, 50.01730728127067],
						[14.666441917471857, 50.014739990743166],
						[14.664612770129962, 50.01276016283291],
						[14.660737037688856, 50.009693146043794],
						[14.657994270351084, 50.00752258326438],
						[14.653660774236632, 50.00474166875639],
						[14.649929046631804, 50.00119400025219],
						[14.647652631606093, 49.999450737740744],
						[14.646681797207727, 49.99894725659569],
						[14.64545725821046, 49.998306181525145],
						[14.643411646758633, 49.99724207510347],
						[14.639536872792577, 49.99611678596775],
						[14.632578851871896, 49.995418568828754],
						[14.625827795111881, 49.995822963035835],
						[14.621865259255951, 49.996791710360746],
						[14.62021542776635, 49.99756633822377],
						[14.618088722851034, 49.99943924556256],
						[14.61511802673211, 50.00334167479201],
						[14.613957405078601, 50.004215240364154],
						[14.612796783461793, 50.0046691895946],
						[14.610577583333527, 50.00553894062921],
						[14.606447219872372, 50.00628662132513],
						[14.592392921425652, 50.00746917702986],
						[14.587444305436287, 50.008045196692805],
						[14.58306980132341, 50.00855636589581],
						[14.55688667296727, 50.006244659361656],
						[14.550347328216676, 50.005149841608436],
						[14.546342849716273, 50.00395584091648],
						[14.536735534668997, 50.00046539307525],
						[14.53329275843608, 49.99864566535595],
						[14.530026444807634, 49.99691781240641],
						[14.518634806650555, 49.992614849209914],
						[14.517058358770093, 49.99211107132575],
						[14.515632633705556, 49.991657299395406],
						[14.51482010008526, 49.9914016842238],
						[14.50562572309782, 49.9894561601099],
						[14.501604088632119, 49.98823555648954],
						[14.498936662252468, 49.98681649584427],
						[14.492717743094442, 49.98349762134465],
						[14.492238033747736, 49.98324574151159],
						[14.486750608285814, 49.97985082379064],
						[14.48617171453738, 49.97949211000558],
						[14.484822277633151, 49.978893323125334],
						[14.480418220824125, 49.97693267886578],
						[14.473947531959144, 49.97363288081866],
						[14.470708840038393, 49.97198097952767],
						[14.464197156835164, 49.96945951418477],
						[14.459098805188052, 49.96837223912768],
						[14.458951952450203, 49.968353294931404],
						[14.45509910691796, 49.96784211273678],
						[14.44314669352571, 49.96625888316874],
						[14.419190402680965, 49.96503062942289],
						[14.414323808706126, 49.96415330902717],
						[14.413597122242072, 49.96390548598487],
						[14.412096983278829, 49.96339803957232],
						[14.409433366699451, 49.96190645123704],
						[14.407212265377213, 49.95964439677441],
						[14.403470028492555, 49.95216740322],
						[14.399673470183522, 49.948051534618415],
						[14.39449119036665, 49.94443506693816],
						[14.38806436953006, 49.94165024244685],
						[14.382820140365313, 49.940567125527515],
						[14.377413738415216, 49.94006717922344],
						[14.369338027949732, 49.93997184796117],
						[14.364180573485237, 49.94030007333984],
						[14.359425529254576, 49.94110092023361],
						[14.357300767044638, 49.94178780608475],
						[14.349770546178346, 49.94618988254808],
						[14.34840011513601, 49.947277060826416],
						[14.346499438033067, 49.94988245736532],
						[14.345197670781534, 49.95436852335199],
						[14.34553145729581, 49.95650475883775],
						[14.347044942699988, 49.96064374779234],
						[14.353281015145726, 49.97243875291786],
						[14.354219421240863, 49.97521957354326],
						[14.354379645093788, 49.978534610720814],
						[14.354037293562675, 49.98015984603747],
						[14.352226263413378, 49.98321157780541],
						[14.349900239911491, 49.984958591523146],
						[14.346327791103759, 49.986343477428946],
						[14.343806265504659, 49.986766802468786],
						[14.333283409746809, 49.98852905986628],
						[14.328228006461833, 49.990005588988105],
						[14.324599262216948, 49.99183650970286],
						[14.323272690620588, 49.99312577171992],
						[14.321750654891591, 49.99609007477777],
						[14.32115555005578, 49.999343891564216],
						[14.321060180665073, 50.00130081177763],
						[14.320560455299994, 50.01142883278696],
						[14.319512367239321, 50.01476287832512],
						[14.317452430671693, 50.01758956856086],
						[14.3146495819681, 50.01972961484228],
						[14.311261177067816, 50.02136611943268],
						[14.307391166601859, 50.022399901496804],
						[14.304183006194078, 50.023258208306736],
						[14.300584792983273, 50.024219511868836],
						[14.297014236405309, 50.02596664383927],
						[14.282986640883585, 50.03691101027719],
						[14.276406288079059, 50.043476104058804],
						[14.274928093024885, 50.04495239325741],
						[14.270726203732602, 50.047828672464824],
						[14.26602363593559, 50.05036926340585],
						[14.26437568671618, 50.0520172126169],
						[14.263648033117907, 50.05274581885082],
						[14.26291656500355, 50.055572510384685],
						[14.263170242508487, 50.057003023221014],
						[14.263878822249131, 50.05837249678642],
						[14.265112877026587, 50.05961227550978],
						[14.268612861514226, 50.061187742954694],
						[14.269424438567569, 50.061378479909195],
						[14.276148796094926, 50.0629768372913],
						[14.281199455292207, 50.06493759185961],
						[14.284049987997644, 50.065555574544696],
						[14.288973808243737, 50.066623687297906],
						[14.292632102724317, 50.067996976355474],
						[14.294025421207763, 50.069084168126885],
						[14.294812202672116, 50.07030105807736],
						[14.295598983762082, 50.07151794430929],
						[14.295881271165152, 50.07337951464309],
						[14.2955980301412, 50.07439422657986],
						[14.294947624337995, 50.07535171639204],
						[14.292895316905064, 50.07680892772951],
						[14.289207458728338, 50.07793426744353],
						[14.283411979533755, 50.079082487606726],
						[14.280006408457192, 50.08037185436058],
						[14.272068023700587, 50.08434677142732],
						[14.267813682990548, 50.08711624577472],
						[14.25423240635555, 50.09467315414527],
						[14.252302169370058, 50.0962638812206],
						[14.251880645279392, 50.097049708433026],
						[14.250999450758595, 50.09869766309864],
						[14.250945091333897, 50.10022354211821],
						[14.25143814050428, 50.10173797244349],
						[14.253856659160968, 50.104209902144504],
						[14.254037856628479, 50.10439300112172],
						[14.263867377968374, 50.109073636267354],
						[14.266012192253498, 50.10966110707301],
						[14.270770072591421, 50.110324856186764],
						[14.28661537191631, 50.11111068936103],
						[14.294398307399167, 50.11218642790824],
						[14.307941437192161, 50.11661148491652],
						[14.312869071881217, 50.11868286054269],
						[14.316626548840995, 50.11959457470644],
						[14.317807197942154, 50.11964416871315],
						[14.318773269801216, 50.11968231347386],
						[14.322808265726781, 50.11920547525649],
						[14.329489707712968, 50.11741256482616],
						[14.33229160259894, 50.11665725224014],
						[14.341879844534226, 50.11515045036219],
						[14.349233627151214, 50.11546325517573],
						[14.35619258906685, 50.116497042367506],
						[14.360293388259986, 50.11807250871215],
						[14.363040923833754, 50.12051009896466],
						[14.365784645441453, 50.1249427830986],
						[14.36779975852916, 50.131191249898094],
						[14.369406700188199, 50.134281158977366],
						[14.37048912062877, 50.135513307095586],
						[14.37311172457284, 50.137523648357934],
						[14.373330116047935, 50.137691495596],
						[14.376969337871293, 50.13937759801042],
						[14.37934207918777, 50.140045166262915],
						[14.384358405591234, 50.140815730182126],
						[14.388525963055857, 50.14099121316399],
						[14.392245292560633, 50.141147612513464],
						[14.403082847798789, 50.140846254441875],
						[14.404286384878864, 50.140739443828885],
						[14.412468910353768, 50.14001083508061],
						[14.41676235218709, 50.13962936595179],
						[14.423128127898973, 50.14263534396032],
						[14.428146362361622, 50.14500808771599],
						[14.432450294627637, 50.14788818489843],
						[14.435072898516436, 50.149246212406624],
						[14.441907882702974, 50.15279388440072],
						[14.443210602012506, 50.15319442950661],
						[14.443771361905545, 50.153366084957305],
						[14.44798946371217, 50.154079436334555],
						[14.461960792306277, 50.15494537123321],
						[14.468392372002125, 50.15589141719311],
						[14.471503258121373, 50.15704727534457],
						[14.481556892845425, 50.16244125806093],
						[14.48283100103001, 50.163127896711465],
						[14.482919693954951, 50.16316224083525],
						[14.485938073191093, 50.16431809434512],
						[14.492429732844094, 50.165321345879015],
						[14.51218223640152, 50.166568762764406],
						[14.520151137860045, 50.168117518853435],
						[14.534048080306453, 50.17082595691087],
						[14.537263869355778, 50.17113875483625],
						[14.539070128451616, 50.171314230334346],
						[14.542033196175385, 50.17126465504529],
						[14.544919012987302, 50.170562734521326],
						[14.54715442719473, 50.16920853263555],
						[14.548569679027976, 50.16736984027092],
						[14.548776627377329, 50.16709900670347],
						[14.55171966558343, 50.16115570122809],
						[14.55405139889893, 50.15892409955658],
						[14.555353164288324, 50.15814208610725],
						[14.557189941541596, 50.157043458346386],
						[14.55901622783531, 50.15628433337461],
						[14.563048363156078, 50.15520096237245],
						[14.570320129033341, 50.153976436923394],
						[14.571561813242917, 50.1537666309957],
						[14.575736999985013, 50.152801518265115],
						[14.588747978261717, 50.14867401172768],
						[14.590907096452643, 50.14762115080693],
						[14.59377193431291, 50.14622497368175],
						[14.596516608724984, 50.14403152012997],
						[14.597597122097119, 50.142814635305584],
						[14.599121093800113, 50.140209198484406]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ10",
				"name": " Praha",
				"region": "praha"
			},
			"id": 11
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[13.4225826264778, 50.084728242392956],
						[13.428676605599476, 50.087570194390885],
						[13.434942245797966, 50.091667178613584],
						[13.438255310126742, 50.092830658677144],
						[13.445343970806956, 50.09452819354151],
						[13.45337676976581, 50.09788894385925],
						[13.462204932755421, 50.09992217584578],
						[13.465021133620544, 50.10113525598686],
						[13.472863197424836, 50.10562133892418],
						[13.480675696935748, 50.11153792924045],
						[13.485760688330707, 50.11919402602323],
						[13.489791869815258, 50.122035977052725],
						[13.493374824893884, 50.12514877707682],
						[13.497321128997159, 50.12810135047072],
						[13.498866081136017, 50.130512236481025],
						[13.500694275105136, 50.1374588033959],
						[13.501704215579867, 50.14009093794286],
						[13.502478599970278, 50.14126587356303],
						[13.506609916915549, 50.14555359126053],
						[13.509025573831002, 50.15013504133487],
						[13.510693550402966, 50.152267459122704],
						[13.519082069822502, 50.1580276533777],
						[13.526641845517211, 50.16130828663046],
						[13.530299186180551, 50.16320037291951],
						[13.553735733090516, 50.177639008174864],
						[13.557647704840479, 50.17950439205377],
						[13.561545372157, 50.180847169507906],
						[13.572394370252137, 50.18325804851504],
						[13.577090263609847, 50.183792116787814],
						[13.581920624090337, 50.184024814025825],
						[13.601597786337022, 50.18406677648331],
						[13.60879039790885, 50.184364321596014],
						[13.61510562955327, 50.18531799924299],
						[13.621610640575707, 50.18717955605723],
						[13.624537467336499, 50.18850325895319],
						[13.625757216835263, 50.189338678152346],
						[13.631249428459505, 50.194400794232614],
						[13.639543533206378, 50.201282499989745],
						[13.645655632744164, 50.207370765555225],
						[13.653324126682113, 50.212268824020356],
						[13.656128883788192, 50.21354294263661],
						[13.664791106616999, 50.21568679230514],
						[13.671026229032021, 50.21831893068184],
						[13.672719002414832, 50.218746191955425],
						[13.676425933483852, 50.219131466073726],
						[13.68198585508867, 50.21869277939797],
						[13.683629990031502, 50.218265537647426],
						[13.688394546953669, 50.21615982514064],
						[13.690135002865182, 50.21563339984502],
						[13.694229125998238, 50.214931488259246],
						[13.698816299836869, 50.21455383711041],
						[13.708682060329862, 50.21427154631739],
						[13.744264602396301, 50.21404647555152],
						[13.751273155816017, 50.214370733732856],
						[13.755513191756148, 50.215065007907604],
						[13.757414818513272, 50.21567917591272],
						[13.759072304708582, 50.21655655867518],
						[13.76030922023067, 50.21765519080788],
						[13.761675834600386, 50.2201194757512],
						[13.76345157636761, 50.22665786881111],
						[13.765200615694493, 50.22904969045575],
						[13.76763534454826, 50.23060606977489],
						[13.777731894896684, 50.234680170152224],
						[13.781752585686277, 50.23572158119415],
						[13.789752006025607, 50.23714827974866],
						[13.793170928146829, 50.238197318401575],
						[13.807876586728028, 50.24668502617725],
						[13.81410026503986, 50.24848937515958],
						[13.819331169159168, 50.249328613594756],
						[13.823185921040876, 50.24935150478265],
						[13.826878546829494, 50.2489128027305],
						[13.833790779681497, 50.2473335323922],
						[13.837226867386114, 50.24624252024315],
						[13.842229843067008, 50.2436904899837],
						[13.849356650486286, 50.238571158648405],
						[13.853082657402496, 50.23735809877773],
						[13.857387542508535, 50.23670196313356],
						[13.861993788970512, 50.23639296771171],
						[13.877500533429966, 50.23623656588912],
						[13.876221656423983, 50.246070858004146],
						[13.876420974741473, 50.25247955332321],
						[13.877169608631846, 50.25509261640385],
						[13.879059791907776, 50.25835037579241],
						[13.880725859722684, 50.260383597101466],
						[13.883131027768199, 50.26215363103027],
						[13.88698291868232, 50.26342392876735],
						[13.891267776752175, 50.26396942405074],
						[13.912224769470528, 50.26432037230243],
						[13.9165611267834, 50.26473236159146],
						[13.9203605646087, 50.2655906618897],
						[13.925391198086265, 50.26777649816911],
						[13.935813904084347, 50.2703437833026],
						[13.942267417954826, 50.273178101061475],
						[13.952564239064754, 50.27578353440828],
						[13.955353736952498, 50.27706146315842],
						[13.962300299971423, 50.28215789163408],
						[13.963712691626636, 50.28452681856235],
						[13.964996338499628, 50.28981781619133],
						[13.96599101992899, 50.29240035735216],
						[13.968165398419204, 50.294693000966156],
						[13.969827652722104, 50.29552460466077],
						[13.973749161589277, 50.29647065036743],
						[13.978096007593724, 50.296821587127404],
						[13.994240761587049, 50.296768196350456],
						[13.998592377264545, 50.29703903756247],
						[14.002603531778144, 50.29791642133245],
						[14.00437164295352, 50.29876327401215],
						[14.0057611469636, 50.299915317918405],
						[14.007225989452673, 50.30255126107431],
						[14.007416725629545, 50.306747441246706],
						[14.005969047231003, 50.31073379200092],
						[14.005096434661017, 50.31187819545823],
						[14.001467705607535, 50.315010079174215],
						[13.99993801151683, 50.31731415143408],
						[13.998702049163414, 50.32141876128451],
						[13.998354911474868, 50.32723998692992],
						[13.999187468659203, 50.33138655790703],
						[14.000720024904922, 50.33381653630108],
						[14.002792359713931, 50.33544160254049],
						[14.008098601279228, 50.33877943928622],
						[14.011193276923967, 50.33999253793852],
						[14.01308822571206, 50.34040068972985],
						[14.019354819603755, 50.34098815269597],
						[14.030858994299033, 50.34104157262856],
						[14.052475927988077, 50.340438830068514],
						[14.060528756855009, 50.339893357701236],
						[14.063939093291957, 50.33913801851741],
						[14.069033624086106, 50.3370475903148],
						[14.070816992289778, 50.33655546675785],
						[14.074857712957566, 50.33589173525521],
						[14.083523749363396, 50.33498000160033],
						[14.087554931982472, 50.33426666600246],
						[14.090637207429769, 50.3331832925442],
						[14.094234465992386, 50.33144759573668],
						[14.097529412440013, 50.33045579122207],
						[14.10460090737142, 50.32882309954754],
						[14.111059188982756, 50.32602310319896],
						[14.112831114762807, 50.32548903463883],
						[14.11689186119722, 50.32479858632432],
						[14.12137985245472, 50.32444381872642],
						[14.130987167159951, 50.32419967454054],
						[14.148264885783728, 50.32423783177251],
						[14.155424118709302, 50.324455267850716],
						[14.162015915681735, 50.32510376734746],
						[14.1657619468084, 50.326030723039146],
						[14.172218322324829, 50.32883452943967],
						[14.180935860366834, 50.33105850899366],
						[14.182495117107473, 50.33166503826981],
						[14.188445089469877, 50.33492277294223],
						[14.196334837649927, 50.33781050432377],
						[14.19989108866137, 50.338947279027394],
						[14.203468322934155, 50.33951568781547],
						[14.206732750330552, 50.33941650777304],
						[14.208216668921558, 50.33914567764807],
						[14.213019371264577, 50.33731460800124],
						[14.21662235356466, 50.336471567138986],
						[14.230148316720804, 50.3350258000878],
						[14.234759331394526, 50.33423233668248],
						[14.244792939185094, 50.33111954674086],
						[14.252777098150956, 50.328968033729794],
						[14.256963730763214, 50.3275108426508],
						[14.259943960243243, 50.331268292296045],
						[14.262216568105911, 50.333503724253525],
						[14.27117252355518, 50.33987426813453],
						[14.28157806258793, 50.34576796132759],
						[14.291310310326368, 50.34835815392907],
						[14.296257017687438, 50.34900663953164],
						[14.304076194179913, 50.34940337562779],
						[14.325693129174702, 50.349342333281434],
						[14.341745378119787, 50.34874726841075],
						[14.354429243124772, 50.34723661502198],
						[14.360736846321403, 50.34699248679029],
						[14.364722252414198, 50.34745026144644],
						[14.366567610251561, 50.34793470881309],
						[14.369602204179952, 50.34955979185036],
						[14.37144756137207, 50.35160825880711],
						[14.374160766668819, 50.35569000309696],
						[14.377390860228775, 50.35898970306908],
						[14.378215791001155, 50.360294353803276],
						[14.379527092193479, 50.36478424280383],
						[14.37990665559281, 50.3697319151112],
						[14.379715919349549, 50.37822341777535],
						[14.378734588625532, 50.38467788698765],
						[14.376782418559953, 50.38877869882098],
						[14.37269687660877, 50.39341354450755],
						[14.371527671973015, 50.39626312410668],
						[14.37082195179835, 50.39940642315578],
						[14.370116235558232, 50.40606691140172],
						[14.370024682226257, 50.41270829352],
						[14.370421410875798, 50.41585923476251],
						[14.371526718527795, 50.41880035778162],
						[14.37255001034678, 50.42015456827969],
						[14.374040603825849, 50.42136764709354],
						[14.37593078528638, 50.422286979070286],
						[14.38021564330052, 50.42329786714479],
						[14.384860038199479, 50.42365264350328],
						[14.389740944352026, 50.4236869855091],
						[14.411480902798646, 50.42306136282636],
						[14.416048049706697, 50.42346572662407],
						[14.418772697379556, 50.424472808167074],
						[14.42095565727731, 50.42600249583183],
						[14.430500984349695, 50.43625641021966],
						[14.432691575971418, 50.43799974349299],
						[14.43554019951033, 50.43935394510264],
						[14.441970826512316, 50.44128419242906],
						[14.445817948821247, 50.442035688914444],
						[14.459107399909017, 50.44340516027667],
						[14.47238826881711, 50.44543839755787],
						[14.476029394933377, 50.446548451069546],
						[14.47762870713832, 50.447422020376514],
						[14.479890824815593, 50.449844374350384],
						[14.481163979780495, 50.45404435364935],
						[14.481199263562326, 50.45848464036405],
						[14.480294229155913, 50.46463014194935],
						[14.480137825865928, 50.471839913011685],
						[14.479349135363798, 50.474403371818944],
						[14.477843284344472, 50.476661679599694],
						[14.46761703305674, 50.48461912274006],
						[14.466004371292742, 50.48656463285386],
						[14.46521663850109, 50.489063280708876],
						[14.465262413019541, 50.491744995065545],
						[14.466083527643715, 50.49443055194175],
						[14.468014718374594, 50.497543347221466],
						[14.481082914347736, 50.499259930326744],
						[14.487488746692229, 50.499515533919556],
						[14.49329471437979, 50.498817429407794],
						[14.496133802678886, 50.49781034797586],
						[14.500424383576048, 50.49567030423261],
						[14.50440692901765, 50.494869232191355],
						[14.510724066874369, 50.495094291498845],
						[14.523010253613025, 50.49621581749851],
						[14.53678417056437, 50.49524687288138],
						[14.543886183197799, 50.49524687288138],
						[14.548420905549333, 50.4955825756067],
						[14.552533149776329, 50.49628067071272],
						[14.554317472581216, 50.49681089599893],
						[14.559274673446357, 50.49900817856095],
						[14.56454467895945, 50.50029755810877],
						[14.571990965964048, 50.50099562802001],
						[14.576504706845927, 50.50062179096336],
						[14.577972411309082, 50.50011443326671],
						[14.580298422925592, 50.498588553966776],
						[14.581905364090398, 50.496013632755265],
						[14.582475663759007, 50.49316789180096],
						[14.583005903403103, 50.48416136023196],
						[14.583885191159375, 50.48139189036691],
						[14.584689141455561, 50.480140696898225],
						[14.592082975877739, 50.47404478625319],
						[14.59607314866809, 50.47254179028027],
						[14.599124906540007, 50.472240429767766],
						[14.62811184133024, 50.47290422474134],
						[14.635886191730958, 50.47336577805763],
						[14.64089870440979, 50.47396469002771],
						[14.659269332196118, 50.47728728591695],
						[14.675325392894845, 50.478973381239264],
						[14.679433823556732, 50.479702004638554],
						[14.688124657915274, 50.48301316483115],
						[14.703851698653825, 50.48704146224128],
						[14.704345701896353, 50.48864363458827],
						[14.707703589276733, 50.49217604532596],
						[14.70983505229574, 50.49671172911453],
						[14.711396216034784, 50.49888609597311],
						[14.715443612423872, 50.501770031642685],
						[14.71914863779509, 50.50483323971531],
						[14.723761560347992, 50.50728990365213],
						[14.726956367108773, 50.50928496951222],
						[14.729995725848864, 50.51049803088944],
						[14.733974455760663, 50.51120375616355],
						[14.740646361698307, 50.511596673957506],
						[14.77677917456397, 50.51134872209522],
						[14.783599852711548, 50.5116004868079],
						[14.787798881050618, 50.51207732701881],
						[14.791480065249463, 50.51302338453847],
						[14.796310423155747, 50.51554106113699],
						[14.803885458657257, 50.51865385793843],
						[14.809084893362773, 50.521465311760565],
						[14.820622445940135, 50.52910234222617],
						[14.824904441740989, 50.53251647862258],
						[14.82985973189777, 50.5373840174034],
						[14.834292413377476, 50.5401344446878],
						[14.837948799279847, 50.54320907730112],
						[14.841923714398472, 50.546115881939585],
						[14.842740059425779, 50.54715729253444],
						[14.843788147575456, 50.54950714676032],
						[14.8452024453202, 50.55589293811838],
						[14.846131324090134, 50.55827330907986],
						[14.847657202365307, 50.560203539988464],
						[14.85025310515207, 50.56255340565395],
						[14.853603361259934, 50.56816099411336],
						[14.85558223751239, 50.57032013190732],
						[14.85815525151118, 50.57177735274584],
						[14.866310121061026, 50.57520676997469],
						[14.875894546768984, 50.57876205687208],
						[14.880727769459174, 50.58125306589682],
						[14.88407230235286, 50.58221052752771],
						[14.889470102157313, 50.58330156055435],
						[14.892778398339724, 50.584369675587325],
						[14.899124147461382, 50.58843995961208],
						[14.90115165748801, 50.589992526765776],
						[14.901990890275462, 50.59103774812484],
						[14.903046608195375, 50.59338760584799],
						[14.904527664357886, 50.59972381753246],
						[14.905559540991247, 50.602096568755435],
						[14.907258988503001, 50.60401917505737],
						[14.910776138029366, 50.606689450552864],
						[14.912732122863474, 50.60871504374175],
						[14.917695999009206, 50.61594390742473],
						[14.92686367168047, 50.612197888348504],
						[14.938461305319207, 50.6083526760696],
						[14.951148988146956, 50.60208512587511],
						[14.955018995442739, 50.60056303307866],
						[14.958662984883407, 50.599552137172225],
						[14.967670438711437, 50.597621899525144],
						[14.972209931448667, 50.59709168434156],
						[14.991041183049045, 50.59658813085275],
						[14.99799442454727, 50.59614183031497],
						[15.00382614041106, 50.59514998514054],
						[15.01292705426125, 50.592929829937574],
						[15.016974449007977, 50.59128951887809],
						[15.022555352051853, 50.588268287372735],
						[15.043670654146057, 50.574565886057194],
						[15.052590371555052, 50.56930924733033],
						[15.06201744094399, 50.565181733544215],
						[15.068056104508216, 50.561767559127865],
						[15.074391365456105, 50.5593223609114],
						[15.086388588421103, 50.55418777898471],
						[15.10112190077576, 50.54874037139603],
						[15.101792334557517, 50.54593276099946],
						[15.104312896482979, 50.54288863909578],
						[15.105452535519138, 50.54054639865215],
						[15.107496260293404, 50.53234862080491],
						[15.10814666679802, 50.53107070294],
						[15.110019684672606, 50.52902985388128],
						[15.116378784944901, 50.524864203824215],
						[15.119397163807907, 50.52360916521513],
						[15.1232357029938, 50.52280426466543],
						[15.131691930690932, 50.52170560915368],
						[15.139350889498592, 50.520385727335274],
						[15.129677770448215, 50.51554868696315],
						[15.120759965242565, 50.51188279352847],
						[15.117844582935144, 50.510360730039544],
						[15.115898132370413, 50.508491516538484],
						[15.114609719213409, 50.50645829068079],
						[15.113797186763684, 50.50443266861895],
						[15.113697051960695, 50.50223922691442],
						[15.11479282444127, 50.49899674061033],
						[15.116029740083965, 50.49669647865965],
						[15.119347571780068, 50.49313353988163],
						[15.125628473236988, 50.48892976570528],
						[15.136444093704643, 50.48345567553786],
						[15.138714789507537, 50.481441490092976],
						[15.139518738717317, 50.480144509249136],
						[15.140434266310402, 50.47732163557098],
						[15.140724180841788, 50.47434614902682],
						[15.13968277062656, 50.46401215384322],
						[15.141394615759937, 50.451332097695875],
						[15.142493248743863, 50.44865036710012],
						[15.143330573433891, 50.447471613101065],
						[15.147669792876943, 50.44325638464467],
						[15.151060103057683, 50.437595355326955],
						[15.15551376494327, 50.43338395562656],
						[15.156385422242725, 50.432197575316714],
						[15.1575584406279, 50.429504389604425],
						[15.158223153200145, 50.42658616071014],
						[15.158810615437792, 50.418403624548255],
						[15.158343315923346, 50.416439063767],
						[15.156966209167148, 50.414688108094325],
						[15.150643346858836, 50.410835249167945],
						[15.14480018711783, 50.40653992586698],
						[15.142957688581909, 50.40460206190707],
						[15.141765595305053, 50.4020233230327],
						[15.139710424332502, 50.39495466292017],
						[15.138083457550369, 50.39230346312938],
						[15.134881018999966, 50.389816278698376],
						[15.127823830958794, 50.386558544821966],
						[15.12521171441613, 50.384651172209004],
						[15.124200822245504, 50.383552563518165],
						[15.123476027877558, 50.38234710170105],
						[15.12301921779287, 50.38026046149016],
						[15.123224259490717, 50.37493516003986],
						[15.1242551819368, 50.3690414574922],
						[15.125466345297639, 50.366332994438636],
						[15.126383782710104, 50.365131390008344],
						[15.131195070123157, 50.36106111253353],
						[15.14228439321333, 50.34956741242953],
						[15.144501684685642, 50.34790037755932],
						[15.15012931630156, 50.34441373939768],
						[15.154809951927483, 50.340492249880185],
						[15.15990257303239, 50.34111023319965],
						[15.16745185981516, 50.34149552589273],
						[15.174752233765455, 50.341289505031504],
						[15.179179192366806, 50.34068299058457],
						[15.181146621161005, 50.340171808944625],
						[15.187814712326267, 50.33760833557134],
						[15.19470882353352, 50.33600234408684],
						[15.19798374066839, 50.33488463347035],
						[15.20434474996322, 50.330776219331845],
						[15.206342697800192, 50.32913971553399],
						[15.207302093446545, 50.327861785340914],
						[15.208414078347888, 50.32498169489221],
						[15.208930014924372, 50.32018660908385],
						[15.20874214178055, 50.30673599295646],
						[15.209150315199828, 50.30359268991262],
						[15.210230826309141, 50.300712576000045],
						[15.212146758910182, 50.29854965096212],
						[15.217329025180447, 50.29509353556229],
						[15.219834327694711, 50.29378509518673],
						[15.223667145427365, 50.29274368888227],
						[15.22796821662907, 50.29219818749223],
						[15.239580155018114, 50.291389470860175],
						[15.252466202614528, 50.28999710850402],
						[15.276020049687888, 50.28943633700853],
						[15.283732413936516, 50.28902053548643],
						[15.30300903388253, 50.286312109515414],
						[15.308067321530496, 50.28609847795543],
						[15.317543029598133, 50.28692245311611],
						[15.323348046025332, 50.28796387339391],
						[15.326354027368211, 50.289070134658466],
						[15.329964637391498, 50.290824886789295],
						[15.340069769985343, 50.29367827610503],
						[15.344983100283057, 50.29588698783597],
						[15.347964287821858, 50.296852121137285],
						[15.353586196399016, 50.29734420318157],
						[15.357370377031371, 50.29695511271119],
						[15.359145163916303, 50.29650878381231],
						[15.370956421254, 50.29088974324257],
						[15.37381363014054, 50.28881836843282],
						[15.376092911330877, 50.28635407010315],
						[15.377993583851014, 50.28213882603455],
						[15.380106925511347, 50.272731776860454],
						[15.383940697546173, 50.26051331325877],
						[15.385017395718348, 50.256233221729005],
						[15.384766579300537, 50.25256348229499],
						[15.38377189718848, 50.25035477441108],
						[15.379812240689152, 50.24583435139729],
						[15.378788947926, 50.24326324340933],
						[15.378088951477762, 50.23899841644876],
						[15.378343582509489, 50.233196261810036],
						[15.379151344790724, 50.23050308677999],
						[15.380743980352992, 50.22817230174444],
						[15.392594336767567, 50.21957015353599],
						[15.393531798442963, 50.21843337212309],
						[15.394709587097406, 50.21579742431741],
						[15.395284653718535, 50.21286011666513],
						[15.395593642785938, 50.20816039670008],
						[15.395680426580968, 50.191802969614066],
						[15.39541912129769, 50.185478215120284],
						[15.394429207218304, 50.18114090305571],
						[15.392821311996002, 50.17869567912641],
						[15.384918212826632, 50.1729202264617],
						[15.379283905815571, 50.16983414418922],
						[15.37643718747719, 50.16763305923735],
						[15.37325000851825, 50.16559983117353],
						[15.37128829993522, 50.16363144265455],
						[15.370083808639949, 50.16104125738224],
						[15.369347572234036, 50.156749724489394],
						[15.369382858173495, 50.15234374905247],
						[15.370331763798127, 50.14817046729663],
						[15.370998382326645, 50.14690017477661],
						[15.372967720498885, 50.1448745770538],
						[15.379455566459152, 50.140861511717254],
						[15.382581711170621, 50.13968658774015],
						[15.388699531513474, 50.138893127058324],
						[15.404763221219008, 50.138462061855],
						[15.411567688275811, 50.137626650589745],
						[15.415678977540585, 50.13649749364875],
						[15.424410820504535, 50.133506779465975],
						[15.428430556844088, 50.13156127556129],
						[15.434501648131603, 50.12725830245383],
						[15.436361312847014, 50.12526321393419],
						[15.436994553072578, 50.12401581232899],
						[15.43772792781537, 50.12129592577645],
						[15.438025474612973, 50.1183815008368],
						[15.43779373206799, 50.10592270245007],
						[15.427124023443575, 50.10689163213589],
						[15.423579216369932, 50.107723239452476],
						[15.418516158964566, 50.10971832189851],
						[15.416776657500902, 50.11013031370289],
						[15.412875175552328, 50.11054611276225],
						[15.406598091349558, 50.11026764122048],
						[15.40288162195196, 50.109546658040685],
						[15.399709702052668, 50.1086387681636],
						[15.402018547373835, 50.105453494117036],
						[15.405806541472915, 50.09773635891856],
						[15.410075187355153, 50.09335708316298],
						[15.411991119139516, 50.089523313172236],
						[15.412785530596606, 50.085083012473326],
						[15.412999153317907, 50.07887268232748],
						[15.412589073018118, 50.0743141159305],
						[15.41180038440696, 50.071475981610995],
						[15.411144256777801, 50.0701637285193],
						[15.40930271134762, 50.06806182732997],
						[15.40627002740188, 50.06576538308301],
						[15.402439117439545, 50.06224823005337],
						[15.399612426949627, 50.06031036553783],
						[15.39449024204231, 50.05801773106218],
						[15.387025832899795, 50.05626296784557],
						[15.38361072524133, 50.05517959445568],
						[15.38212585429347, 50.054378507685826],
						[15.38085079194291, 50.05328369151436],
						[15.379257202280462, 50.05071258666914],
						[15.376599311758893, 50.04208755428653],
						[15.375045776283647, 50.03975677412967],
						[15.373277664139913, 50.03791809040668],
						[15.382326126175517, 50.0311889655551],
						[15.38969707494239, 50.02511596727933],
						[15.392505645751053, 50.02374267577284],
						[15.402902603128732, 50.01979064922183],
						[15.406908988900083, 50.01873016308775],
						[15.416749954205207, 50.016872405835194],
						[15.423664093019546, 50.0142974853692],
						[15.425576210083054, 50.01381301936139],
						[15.432171821586408, 50.01304626457657],
						[15.44632720948354, 50.012401580909675],
						[15.45062637335234, 50.0117454534448],
						[15.453913688624242, 50.01058578458573],
						[15.461779594433553, 50.00622177135182],
						[15.46342086792247, 50.00457000734659],
						[15.463925361619685, 50.0036239622764],
						[15.464182853702766, 50.00167465213733],
						[15.462838164682237, 49.989715500327875],
						[15.463603015786852, 49.987808191345756],
						[15.466340054481526, 49.9854735358639],
						[15.472969064113789, 49.98173912652908],
						[15.475851049816944, 49.9805449597266],
						[15.484672551510512, 49.978542375053095],
						[15.4926471672406, 49.975349391481416],
						[15.501719484106168, 49.97330864890528],
						[15.50996209738025, 49.97003188053976],
						[15.518718734242125, 49.96802534317192],
						[15.52157688915031, 49.96678931674782],
						[15.527854916495416, 49.962661716169414],
						[15.529774658070536, 49.9606055500259],
						[15.530427944750768, 49.9592934758327],
						[15.531279556581927, 49.9549865049873],
						[15.531190869863737, 49.9504585052092],
						[15.53025722156301, 49.94420620585831],
						[15.530824667219036, 49.93529134513457],
						[15.530323015833094, 49.9263609668445],
						[15.531348212563763, 49.91992172875858],
						[15.531368257657075, 49.914348621090106],
						[15.530196173804613, 49.91035446624111],
						[15.528219212509343, 49.907833002543015],
						[15.5251894145566, 49.905704634976246],
						[15.521464342886846, 49.904167129655015],
						[15.51731109200071, 49.903301200384604],
						[15.508919709554192, 49.90221017723708],
						[15.505114541883916, 49.90121447528854],
						[15.50059796792071, 49.89896787328249],
						[15.498535153361493, 49.897098514593665],
						[15.497935311777418, 49.89605346813575],
						[15.49774454953099, 49.894946953110974],
						[15.498510359051664, 49.893188461178426],
						[15.502889619344469, 49.89010988815305],
						[15.504482277749405, 49.887989122311325],
						[15.505431191204785, 49.88535705054045],
						[15.505960480818821, 49.882450254640816],
						[15.506286612969598, 49.87470237857799],
						[15.505741114025827, 49.868423412402166],
						[15.504444138977885, 49.863849793889145],
						[15.501938816382374, 49.859401670497256],
						[15.491477962642602, 49.8586616176952],
						[15.48531055314256, 49.857471453459404],
						[15.482437121718412, 49.856075175116935],
						[15.47869682131733, 49.85292814492373],
						[15.47553443609897, 49.850803347563],
						[15.472332970282528, 49.84967437196588],
						[15.470321646383331, 49.84938041077171],
						[15.468229297003468, 49.84929659930097],
						[15.46402359548473, 49.849704792468124],
						[15.45344354105581, 49.85288251358635],
						[15.447153098377475, 49.853809421154196],
						[15.444082257423084, 49.853641484867595],
						[15.442570700050851, 49.85322583528066],
						[15.440107360048207, 49.851852551318444],
						[15.439063079663418, 49.85077292692775],
						[15.437773706707528, 49.84837343332129],
						[15.431119915990246, 49.82977673757104],
						[15.430855744448028, 49.82679360936603],
						[15.43107222856248, 49.82381051651289],
						[15.433737755158113, 49.81457901313791],
						[15.433973316154974, 49.81165317235219],
						[15.433663382063072, 49.808765540157545],
						[15.43211840046283, 49.80518708226942],
						[15.429828657277811, 49.80217755470503],
						[15.427441580776257, 49.80039581461782],
						[15.42555619200854, 49.79961403784161],
						[15.42134762918478, 49.7987366755239],
						[15.416796697889128, 49.79840863528544],
						[15.392360675999722, 49.798522844137466],
						[15.38776971258698, 49.79822552880992],
						[15.38358783519378, 49.79751203552311],
						[15.380427369596113, 49.79629143598373],
						[15.373770725955595, 49.7922898474747],
						[15.371706016394873, 49.79071051920043],
						[15.367819790030664, 49.786911047777856],
						[15.36506654016255, 49.78492366428032],
						[15.36194895922109, 49.78319542298144],
						[15.356376662411082, 49.78077329827077],
						[15.351445200747799, 49.77824785844032],
						[15.347654347858612, 49.77725606076044],
						[15.333041179970744, 49.775333300126476],
						[15.331261643251683, 49.77485664642833],
						[15.326100333998834, 49.77278122726242],
						[15.32230089935721, 49.77188099467246],
						[15.306479462486639, 49.770050128215786],
						[15.294013991463025, 49.76691068857458],
						[15.28669833798546, 49.76594158801579],
						[15.273846614073504, 49.76556766452149],
						[15.247887596129488, 49.765907143587825],
						[15.240518557604474, 49.76578891545176],
						[15.233765594990928, 49.76498024889532],
						[15.229931828976714, 49.76353452337868],
						[15.228585231936973, 49.76252354444308],
						[15.226806645919199, 49.76021580932055],
						[15.224404326371834, 49.75515357420801],
						[15.2204370555155, 49.7485924301636],
						[15.219183930014346, 49.743831712131296],
						[15.218035684548973, 49.73272692400403],
						[15.216968546527557, 49.72992334442828],
						[15.216090217548961, 49.72867980112569],
						[15.207291587460503, 49.72082123244739],
						[15.202825540490513, 49.71806711442205],
						[15.196969019094125, 49.71555315849108],
						[15.194534313858066, 49.7142144398017],
						[15.188352569808833, 49.70993027717748],
						[15.186447133244446, 49.707904717734024],
						[15.185293195092086, 49.70523450345695],
						[15.184622755757122, 49.700794136052586],
						[15.184910767294161, 49.683208399604176],
						[15.18773268801588, 49.68232337481932],
						[15.190274224346243, 49.68110643198829],
						[15.19236944656737, 49.679092269443956],
						[15.19459628283849, 49.67564003251898],
						[15.200770389928895, 49.67324840332214],
						[15.206291183086819, 49.671516269814994],
						[15.211595548143427, 49.66903317274751],
						[15.214604383875072, 49.66793447593299],
						[15.226614012036208, 49.665729652007855],
						[15.232399946190228, 49.66386418982229],
						[15.240329750192407, 49.660614087282404],
						[15.242756829655558, 49.65865312733765],
						[15.24361610615718, 49.65743257541557],
						[15.245107655253543, 49.65349583122501],
						[15.246211065385468, 49.647567876566704],
						[15.244083417896332, 49.638984806937394],
						[15.2420005813201, 49.63538362006705],
						[15.237375243307916, 49.63132842991544],
						[15.233648305043788, 49.626167343671554],
						[15.23078059370953, 49.62284080727415],
						[15.214094167114641, 49.61662297361244],
						[15.207992542320444, 49.61342991470616],
						[15.204660402884643, 49.61237704513909],
						[15.197549832244153, 49.61075603763331],
						[15.191074384576599, 49.60802853812535],
						[15.18937589063285, 49.60755933050814],
						[15.185594563123392, 49.6069794121693],
						[15.173527723357008, 49.606357629527],
						[15.171062471348543, 49.605598467529866],
						[15.165866842541819, 49.60268774716495],
						[15.164279945920988, 49.60219963258397],
						[15.160691267462326, 49.60171896157386],
						[15.156970035832204, 49.60181819680526],
						[15.1551961862095, 49.602077449028805],
						[15.152310382410228, 49.60295878450673],
						[15.148818003542457, 49.60456454708959],
						[15.147081387528772, 49.60508739895613],
						[15.142983446712687, 49.60578546678349],
						[15.135981553179997, 49.60627358819839],
						[15.123429293551597, 49.606475783618635],
						[15.097846026632618, 49.60643763937837],
						[15.085662837271277, 49.60600657884664],
						[15.079278955138339, 49.60507592473407],
						[15.077505125246466, 49.60454190880633],
						[15.072583208400143, 49.6023636811545],
						[15.070795073623557, 49.60186781443541],
						[15.064552315573797, 49.60113533514685],
						[15.057967173549418, 49.60129535161197],
						[15.053915969012463, 49.60190192656171],
						[15.0521488059494, 49.602397793346825],
						[15.04726599467104, 49.60448825918406],
						[15.045577049984399, 49.60492707000813],
						[15.041727075940825, 49.605392551428444],
						[15.035511031679775, 49.60517516126609],
						[15.031578052807404, 49.604411971301275],
						[15.026184073927134, 49.60292808346621],
						[15.024355883327587, 49.60258479026363],
						[15.021077168650642, 49.60241329889027],
						[15.018039709072758, 49.602821405131785],
						[15.011623390227998, 49.60526664497814],
						[14.999938019277744, 49.60781486713424],
						[14.994352333772406, 49.60963433249866],
						[14.990406993184443, 49.61064532446664],
						[14.986581813420694, 49.61094676210831],
						[14.98270893161609, 49.610519415433366],
						[14.978833191822444, 49.60908883266254],
						[14.97589778710197, 49.60695646355616],
						[14.974179277004053, 49.60429009680394],
						[14.973793978592497, 49.60152049122631],
						[14.974375714002724, 49.59888829278366],
						[14.974996562468176, 49.597682911218385],
						[14.976759901976921, 49.59579840913186],
						[14.979623808801119, 49.59365095573408],
						[14.981852538756742, 49.59030158454757],
						[14.98271369766177, 49.58781431480346],
						[14.983323083814772, 49.58445726762287],
						[14.982873917571355, 49.582443246455085],
						[14.982123386344615, 49.58146678522426],
						[14.979743961020931, 49.57992938571127],
						[14.97786331670316, 49.57932286274129],
						[14.973727219404326, 49.57874672926403],
						[14.969264989075114, 49.578628587951926],
						[14.952935221790279, 49.57890704184017],
						[14.948568336413729, 49.57862083589923],
						[14.946503637917788, 49.578277575240456],
						[14.944551483314687, 49.57772842115755],
						[14.942784318538594, 49.57688531223514],
						[14.941416751802526, 49.5757867011232],
						[14.94048023306771, 49.574554451409035],
						[14.939865124082111, 49.57323848718358],
						[14.939250937656398, 49.570434488829655],
						[14.939106929745419, 49.5659369307241],
						[14.939673428537061, 49.556427048311754],
						[14.94103240320418, 49.54351418885828],
						[14.929289826146363, 49.54839333061624],
						[14.918251031010445, 49.55209344173449],
						[14.915451994174077, 49.55340185642853],
						[14.911952971621805, 49.555473319940496],
						[14.904676442334452, 49.55866627752879],
						[14.900244716986707, 49.56152347800002],
						[14.89517690048927, 49.566116459455905],
						[14.890684113378473, 49.56883607153317],
						[14.886912347842243, 49.57188035964091],
						[14.883788113156484, 49.57390980173854],
						[14.88281439254053, 49.57469925749804],
						[14.881340982939024, 49.57657244169928],
						[14.879660607233161, 49.580612190892815],
						[14.879517543340112, 49.58263767090374],
						[14.880083093417735, 49.58729180826758],
						[14.879466060697826, 49.59125141103901],
						[14.877799998425937, 49.59367762435909],
						[14.876626968230484, 49.59455489962865],
						[14.873910894056271, 49.595912837117446],
						[14.867369646277806, 49.598392432791016],
						[14.86360263663905, 49.59923933370879],
						[14.861875546989108, 49.59937298987647],
						[14.858613967072198, 49.599163047389105],
						[14.857164369565355, 49.59883867573057],
						[14.85101126461919, 49.59634388066554],
						[14.845387463399991, 49.59548954685667],
						[14.841185557463064, 49.59530627634524],
						[14.836855893857413, 49.595413261653256],
						[14.830446232544661, 49.59626759520785],
						[14.826396933855555, 49.59746924885696],
						[14.816262240154467, 49.601203869318326],
						[14.810191162256416, 49.60444267251965],
						[14.80689715963633, 49.605499230833814],
						[14.799816147156516, 49.60717788674705],
						[14.791870104123774, 49.61070238670902],
						[14.783082963135103, 49.61285401467438],
						[14.778183941098186, 49.61511234413885],
						[14.775195112654826, 49.616107851371325],
						[14.773358344388088, 49.61640929544676],
						[14.76950646281985, 49.61655815684958],
						[14.765740401362892, 49.61608893359652],
						[14.76274489229873, 49.614978679755495],
						[14.75515840889631, 49.610576477647655],
						[14.751376161829876, 49.607547856175344],
						[14.746975907404728, 49.604721154446544],
						[14.738998410623836, 49.596099829301444],
						[14.736559862730788, 49.59241862020466],
						[14.733196250515448, 49.58512489044638],
						[14.73251914217535, 49.57931511066761],
						[14.73313331638226, 49.573482516797945],
						[14.736435897657854, 49.5643425722579],
						[14.737726199961886, 49.55750263243977],
						[14.737503996695597, 49.55450812314588],
						[14.736151699906056, 49.55269245919948],
						[14.734037395149434, 49.5512504169307],
						[14.725916877597275, 49.54713454845267],
						[14.724267014410911, 49.546634757833836],
						[14.720615389706827, 49.54600909079731],
						[14.710841189992943, 49.54513942234455],
						[14.707183853153207, 49.54451003845269],
						[14.7041911999768, 49.54346458250353],
						[14.700583451946287, 49.54156869679887],
						[14.692818655655664, 49.53843702803734],
						[14.685507769665959, 49.534381820070315],
						[14.676649089464137, 49.52856822657927],
						[14.666755674953212, 49.52132032996624],
						[14.65992164897757, 49.515167264697936],
						[14.657140730922835, 49.513881674529486],
						[14.655527111528258, 49.51350780986687],
						[14.65216921685712, 49.51324833694942],
						[14.648881913435183, 49.51361848119065],
						[14.647365567800804, 49.5140571369046],
						[14.646016128694102, 49.51469047647054],
						[14.64483928382349, 49.51559445281807],
						[14.641492831085152, 49.52059924065901],
						[14.639157297668014, 49.522232079909855],
						[14.629347791569316, 49.5252150531281],
						[14.62446974446349, 49.52755724762954],
						[14.622804654873585, 49.5281106348797],
						[14.610919000388561, 49.53067018263209],
						[14.60708808508479, 49.532100638638155],
						[14.598074923063493, 49.53654489973636],
						[14.594241147561908, 49.53813939592305],
						[14.592164986136574, 49.53878395590486],
						[14.587453852968983, 49.53964244161908],
						[14.580114378939518, 49.5400048728866],
						[14.572820667331843, 49.53956989341982],
						[14.56820392840178, 49.53878023549628],
						[14.558377260560965, 49.53591150646082],
						[14.55415534941301, 49.53532027880332],
						[14.54994582419932, 49.535247731821926],
						[14.546029079987216, 49.535713086959305],
						[14.544297203717838, 49.53617844293765],
						[14.538004869662728, 49.53892130102541],
						[14.531036383277462, 49.5406227744192],
						[14.527804387869171, 49.54164899649887],
						[14.52429199774115, 49.54343419861598],
						[14.521246917296802, 49.54456336550109],
						[14.5151271878201, 49.545505581858905],
						[14.505986204605607, 49.545787720366796],
						[14.49897195273049, 49.545452254615256],
						[14.49218941228739, 49.54433827582545],
						[14.486244196099527, 49.54213327552969],
						[14.476574908482961, 49.53724681167674],
						[14.466569897423822, 49.54062649485441],
						[14.45687197137556, 49.54438385181826],
						[14.449283591460475, 49.54677954819237],
						[14.443927775812874, 49.54913341059108],
						[14.43527888167034, 49.55369175489792],
						[14.42956160081327, 49.55193314588965],
						[14.421336182988455, 49.55036553840627],
						[14.417689320518315, 49.54928967408384],
						[14.411451335035903, 49.54615016028866],
						[14.393760684096737, 49.539131194274376],
						[14.388852105385592, 49.536617137051806],
						[14.385670667003415, 49.53543095949383],
						[14.381530753175532, 49.53467169711371],
						[14.37464619955712, 49.534149298613585],
						[14.365052221269897, 49.53404233881398],
						[14.358046521765571, 49.534358877943916],
						[14.353721616849144, 49.53491972051151],
						[14.349951729535489, 49.53600296550128],
						[14.34094144286325, 49.54143538074991],
						[14.335888875733394, 49.54596723502904],
						[14.332891463961856, 49.54784393035289],
						[14.32936953987942, 49.549365945584995],
						[14.327436444077241, 49.549930541425056],
						[14.319680222585248, 49.55155953603954],
						[14.31629467948145, 49.5526276585886],
						[14.30718134670258, 49.557754398529944],
						[14.303372391902364, 49.560703366746985],
						[14.294578550108916, 49.565681435819485],
						[14.291074765933766, 49.566494121342785],
						[14.287280089617111, 49.56663520207514],
						[14.283604614133452, 49.56620017756027],
						[14.281947122820535, 49.56576143298319],
						[14.277200695273294, 49.56362911400165],
						[14.271863926683311, 49.56238545030441],
						[14.258644117255347, 49.561142102687235],
						[14.249364850424174, 49.561538671012016],
						[14.244955072378966, 49.56142053761593],
						[14.240577701830341, 49.56089405400711],
						[14.236506461227926, 49.559738150314814],
						[14.234711645029623, 49.558933237616664],
						[14.23162555482862, 49.55703351721772],
						[14.22685433559053, 49.55233776131882],
						[14.223133095709086, 49.5492096820459],
						[14.219836246793204, 49.54372036537264],
						[14.217849736325261, 49.541614582338674],
						[14.216602321623995, 49.540840109932034],
						[14.213682175989428, 49.539646162040114],
						[14.207206733483812, 49.53788764902827],
						[14.199981702408124, 49.53708280469604],
						[14.17966078838294, 49.53646460162841],
						[14.164311413733044, 49.53472905250324],
						[14.14151762940759, 49.53374471177927],
						[14.131340033194238, 49.532672947275536],
						[14.127471909304166, 49.532493441883496],
						[14.12359524539763, 49.532634813995266],
						[14.1133737493199, 49.533580707029046],
						[14.09607028640565, 49.53416821035088],
						[14.089468941227587, 49.535125580113075],
						[14.086274148770716, 49.536422747412196],
						[14.081158652855208, 49.539878998496334],
						[14.079275122589054, 49.54146948484889],
						[14.077910424931583, 49.54384996212339],
						[14.07588101131424, 49.55172355224715],
						[14.075049406632454, 49.552955692470896],
						[14.073787682927229, 49.5540923424116],
						[14.07204818031051, 49.555023121691434],
						[14.070053088444238, 49.5556791959865],
						[14.065624229734246, 49.55641929692906],
						[14.058385840212331, 49.55670919880068],
						[14.050876607407847, 49.55640782488309],
						[14.04592608165477, 49.55580507810787],
						[14.041425717862344, 49.554725780442624],
						[14.032422052696582, 49.551254137519535],
						[14.028168686221075, 49.54912193887015],
						[14.026052467838827, 49.547256395816504],
						[14.020255086598583, 49.54041287995403],
						[14.016966812674717, 49.53401939671782],
						[14.01537131658089, 49.531738218495576],
						[14.012797351724235, 49.529983479764056],
						[14.00324630479705, 49.52688977428104],
						[13.995963095331463, 49.5221710071335],
						[13.99414730230148, 49.52048112605068],
						[13.991409298223406, 49.51626964709529],
						[13.989185329131548, 49.51432033069102],
						[13.985565173254399, 49.51301180451727],
						[13.981321344041964, 49.512428379445474],
						[13.974510201887085, 49.51229104844346],
						[13.962930686604876, 49.51282890278531],
						[13.956584929112342, 49.51197050638917],
						[13.952054016286548, 49.51071159217454],
						[13.945637706638701, 49.507560768550476],
						[13.93671417421614, 49.50451662090888],
						[13.92668342083259, 49.507015175293645],
						[13.915163980680422, 49.51077638224152],
						[13.907084459456193, 49.512496889972645],
						[13.903432859415737, 49.5135385002292],
						[13.90067671565092, 49.51501071189929],
						[13.896595942294807, 49.518573629121526],
						[13.892626751058561, 49.52127444804137],
						[13.88952541103917, 49.522747013893905],
						[13.887812626418656, 49.523304111000165],
						[13.88430976704334, 49.52382276731833],
						[13.87501334428187, 49.523261948906615],
						[13.869224553559677, 49.52215581644519],
						[13.866310130552085, 49.52092754375212],
						[13.861652361715535, 49.518348562155225],
						[13.853811261566957, 49.51573178557879],
						[13.850197799093424, 49.514915540244374],
						[13.846370696604787, 49.51488112965468],
						[13.835602773627652, 49.51725020097705],
						[13.827144616269445, 49.51842110437909],
						[13.823797240405758, 49.5183374018149],
						[13.813888557032833, 49.517402725026926],
						[13.810035713751285, 49.516639795672376],
						[13.808320058622632, 49.51607527280399],
						[13.80214978498885, 49.51298917429596],
						[13.79296303229259, 49.5096703033301],
						[13.789081586451989, 49.51426328984763],
						[13.783439644694605, 49.51916512836627],
						[13.781866085365477, 49.52182782180148],
						[13.78089523572543, 49.52642443508275],
						[13.780236252493825, 49.53776177567321],
						[13.778807647480553, 49.542102891799296],
						[13.776931771932063, 49.544185735826616],
						[13.771128664174736, 49.54853068086542],
						[13.765606894334994, 49.5516702237145],
						[13.758716587172698, 49.556678813348526],
						[13.75679207744147, 49.55872735896462],
						[13.756088262910302, 49.56006247255356],
						[13.754978191539715, 49.564529541437565],
						[13.753720284916952, 49.58057405050099],
						[13.75585174548886, 49.591075895986464],
						[13.758482944067277, 49.5988541810586],
						[13.758962641319512, 49.60331355235317],
						[13.758232118631488, 49.60775377400989],
						[13.755290017913, 49.61349473067669],
						[13.753527651639757, 49.6157570974466],
						[13.750713355043407, 49.6180191740888],
						[13.74720669951362, 49.619808319066586],
						[13.745229719709783, 49.62048719881154],
						[13.740776065252959, 49.62138751584355],
						[13.727557193081918, 49.62264263068372],
						[13.725597383261638, 49.623027819127074],
						[13.722483636123913, 49.62413407611894],
						[13.714388859684869, 49.62840284014252],
						[13.707431782031042, 49.633529545028246],
						[13.70544338658198, 49.635395095648654],
						[13.702033057587544, 49.64052597287297],
						[13.706782347650446, 49.642543862879464],
						[13.710457795611255, 49.64450066692672],
						[13.718488702612092, 49.650837043405176],
						[13.719284999498546, 49.65196978536535],
						[13.720203408328253, 49.654464813049366],
						[13.720504758427031, 49.65708920900254],
						[13.720339770046726, 49.66274256166421],
						[13.720946323748203, 49.664718752198546],
						[13.723202694452684, 49.66855609828061],
						[13.724968906379484, 49.67005153430177],
						[13.727955825787637, 49.671917041778414],
						[13.729459776694673, 49.673439174476755],
						[13.729924212125317, 49.67435084543058],
						[13.730075832037079, 49.676254228855065],
						[13.729149818044739, 49.67913817964023],
						[13.727730736568631, 49.68103012121181],
						[13.725633629570739, 49.68252190797689],
						[13.720309256761833, 49.685581199429485],
						[13.717165945806848, 49.68659590460416],
						[13.713389400226834, 49.6869278328859],
						[13.709650996281008, 49.68664553871222],
						[13.706380831065367, 49.6858175810133],
						[13.702054980308365, 49.6836281127492],
						[13.700506205603274, 49.68314356592803],
						[13.696974746821095, 49.68260566419916],
						[13.693204892195826, 49.68271268607887],
						[13.691329964798339, 49.68308648748997],
						[13.689555167998636, 49.68375778036484],
						[13.687309268207146, 49.68548968693301],
						[13.686044678639313, 49.687423554621226],
						[13.685336118426061, 49.68938070324611],
						[13.685373319281647, 49.69149793994302],
						[13.686130509372484, 49.69345077681194],
						[13.687233927040683, 49.69544985203803],
						[13.688738828026308, 49.69732671381419],
						[13.693222054209714, 49.70116051849348],
						[13.695926666864327, 49.70572281520629],
						[13.697731968105515, 49.707992515426845],
						[13.705032363144781, 49.713077697885325],
						[13.70902822947129, 49.7150381465261],
						[13.719564450625008, 49.71883405743311],
						[13.723616608935863, 49.7198945026789],
						[13.733535762714034, 49.721759755330254],
						[13.740266812334276, 49.724453102585336],
						[13.742120744178166, 49.724948897535306],
						[13.746312150248624, 49.725540253730074],
						[13.750861164527272, 49.72576519283337],
						[13.767222393063847, 49.725238680514124],
						[13.771946901199332, 49.72585671983594],
						[13.7766113153796, 49.72699724213566],
						[13.779184330573134, 49.72819889155314],
						[13.782254226237525, 49.730247572663686],
						[13.786882402791152, 49.732643151256696],
						[13.791148175403269, 49.73530186354166],
						[13.794509885122583, 49.73641202146723],
						[13.800029747640826, 49.73764412249838],
						[13.802955641983694, 49.73856750407968],
						[13.807701099537674, 49.74119556079731],
						[13.814916598563416, 49.74419008934223],
						[13.819228162611845, 49.74653615389265],
						[13.825997362411423, 49.75096522058825],
						[13.818469050367412, 49.75342181283861],
						[13.815135958582962, 49.7551880171721],
						[13.807868969194699, 49.76052487145624],
						[13.806909570923036, 49.76176081346939],
						[13.805746088372869, 49.76455698776841],
						[13.805213925794993, 49.76762006136649],
						[13.804959295724927, 49.77416990671074],
						[13.805134770114279, 49.78772350855893],
						[13.805615429520536, 49.79429249586774],
						[13.80622006023223, 49.797351895506374],
						[13.807315816513533, 49.80010594553446],
						[13.812132841954057, 49.805702277760076],
						[13.813043591121852, 49.80832668751559],
						[13.813318264296768, 49.811138275064934],
						[13.813018790015365, 49.813953308041384],
						[13.812076558247057, 49.81657780371765],
						[13.810521131312102, 49.8185921289017],
						[13.807974819463388, 49.820995373381294],
						[13.807122223655156, 49.822208333068055],
						[13.805973058645788, 49.8250275247379],
						[13.805050856024403, 49.83141714724553],
						[13.805197706181922, 49.83800496640059],
						[13.805723192121478, 49.8411483953085],
						[13.806778919809936, 49.844017153804074],
						[13.811568245604937, 49.84979232903596],
						[13.814061158265483, 49.857883384991375],
						[13.815301902464869, 49.860454635290644],
						[13.816262244346493, 49.861595145181525],
						[13.818330756337188, 49.86313238935692],
						[13.824848180729724, 49.867015897493566],
						[13.828022969517276, 49.867965829494736],
						[13.834782602113545, 49.869426745008816],
						[13.837521561253876, 49.87068184772714],
						[13.839246740752927, 49.87234487626207],
						[13.83991814979695, 49.874256270632706],
						[13.83994768614749, 49.87803253582163],
						[13.83859444125522, 49.89257435797118],
						[13.836066240390341, 49.900905550793176],
						[13.833955768021838, 49.913547549471396],
						[13.831675540728856, 49.91849529447318],
						[13.828693387985506, 49.92312238629707],
						[13.82616615186543, 49.925434101297036],
						[13.823170649615099, 49.927390924989524],
						[13.816143023980022, 49.930667754055996],
						[13.811808593220338, 49.93348319720633],
						[13.806982041383911, 49.93593598424499],
						[13.802433001287396, 49.93878160761223],
						[13.792344106835076, 49.94281782787832],
						[13.784706117688373, 49.941066762306626],
						[13.776288996487455, 49.94054042029586],
						[13.77087879815017, 49.94107825179066],
						[13.766081804952979, 49.942665047771804],
						[13.763118757112357, 49.94497694373773],
						[13.76108933303018, 49.94768914020705],
						[13.759632117582358, 49.950843883512405],
						[13.757889755417386, 49.95743950348483],
						[13.756112099011338, 49.96052170129092],
						[13.754546167214361, 49.96190645123704],
						[13.75009346479928, 49.96382908945762],
						[13.741963394611576, 49.96498497763051],
						[13.729966161798627, 49.96490858077217],
						[13.720686903108554, 49.963996789182296],
						[13.708579051809911, 49.961616395329635],
						[13.704237937892556, 49.968677520390955],
						[13.702103615535867, 49.97108841700725],
						[13.697752947092278, 49.97466272368198],
						[13.692548744927509, 49.98235313858349],
						[13.68487645448075, 49.98824704814963],
						[13.675662042972734, 49.99324038001379],
						[13.671600332190453, 49.99430074218249],
						[13.664500224278864, 49.9949377691993],
						[13.654195794011217, 49.99506387030411],
						[13.60349274270419, 49.9946861883686],
						[13.593547806776089, 49.995155184937175],
						[13.589121811802354, 49.99584190932433],
						[13.58717347559983, 49.996387625172595],
						[13.582122802039585, 49.998573295936836],
						[13.57363796233883, 50.000793457004676],
						[13.570426940911172, 50.001911163258036],
						[13.556798934909844, 50.00949478121336],
						[13.553526878402005, 50.01054382371558],
						[13.546423912094735, 50.01213455249009],
						[13.539936065629572, 50.014839171897975],
						[13.533760070834006, 50.016536712995304],
						[13.53087234498153, 50.017669677846975],
						[13.529001236012814, 50.019439697800976],
						[13.528586387582662, 50.021400451116676],
						[13.529390335179633, 50.02348709208047],
						[13.533571243322658, 50.0287323001885],
						[13.533847808798239, 50.030025481760404],
						[13.533587455861705, 50.03137588618885],
						[13.532852172742544, 50.032661436841984],
						[13.530353546233876, 50.034976960188004],
						[13.526827812191407, 50.03687286373237],
						[13.524729728608737, 50.03760909939433],
						[13.519883155853162, 50.03854370149102],
						[13.512147903365234, 50.03898620524154],
						[13.464110374445259, 50.0388946532624],
						[13.46033763893627, 50.03824997034108],
						[13.458305358898077, 50.037597656368824],
						[13.44661331171907, 50.03227233835477],
						[13.442217826809854, 50.03096771204885],
						[13.437673568771721, 50.03025436450085],
						[13.433154106075627, 50.029994963915826],
						[13.428818702619687, 50.030212401516735],
						[13.424807548422837, 50.0311698902955],
						[13.423063278285584, 50.03211212250747],
						[13.42197704307923, 50.03312683028567],
						[13.421299934311477, 50.034210204275695],
						[13.420882224932523, 50.03644180187423],
						[13.424249649083022, 50.049736023322076],
						[13.425681114075843, 50.052577971130994],
						[13.427689552229346, 50.05479812539759],
						[13.429978370631577, 50.056346892940994],
						[13.435237884661687, 50.05888366847394],
						[13.438255310060706, 50.06135177614421],
						[13.439534187323362, 50.06384658820196],
						[13.439753532211657, 50.066452024274774],
						[13.438976287730252, 50.068958281292744],
						[13.438178062533181, 50.07010269264524],
						[13.431099891506458, 50.07562637164078],
						[13.4225826264778, 50.084728242392956]
					],
					[
						[14.599121093800113, 50.140209198484406],
						[14.597597122097119, 50.142814635305584],
						[14.596516608724984, 50.14403152012997],
						[14.59377193431291, 50.14622497368175],
						[14.590907096452643, 50.14762115080693],
						[14.588747978261717, 50.14867401172768],
						[14.575736999985013, 50.152801518265115],
						[14.571561813242917, 50.1537666309957],
						[14.570320129033341, 50.153976436923394],
						[14.563048363156078, 50.15520096237245],
						[14.55901622783531, 50.15628433337461],
						[14.557189941541596, 50.157043458346386],
						[14.555353164288324, 50.15814208610725],
						[14.55405139889893, 50.15892409955658],
						[14.55171966558343, 50.16115570122809],
						[14.548776627377329, 50.16709900670347],
						[14.548569679027976, 50.16736984027092],
						[14.54715442719473, 50.16920853263555],
						[14.544919012987302, 50.170562734521326],
						[14.542033196175385, 50.17126465504529],
						[14.539070128451616, 50.171314230334346],
						[14.537263869355778, 50.17113875483625],
						[14.534048080306453, 50.17082595691087],
						[14.520151137860045, 50.168117518853435],
						[14.51218223640152, 50.166568762764406],
						[14.492429732844094, 50.165321345879015],
						[14.485938073191093, 50.16431809434512],
						[14.482919693954951, 50.16316224083525],
						[14.48283100103001, 50.163127896711465],
						[14.481556892845425, 50.16244125806093],
						[14.471503258121373, 50.15704727534457],
						[14.468392372002125, 50.15589141719311],
						[14.461960792306277, 50.15494537123321],
						[14.44798946371217, 50.154079436334555],
						[14.443771361905545, 50.153366084957305],
						[14.443210602012506, 50.15319442950661],
						[14.441907882702974, 50.15279388440072],
						[14.435072898516436, 50.149246212406624],
						[14.432450294627637, 50.14788818489843],
						[14.428146362361622, 50.14500808771599],
						[14.423128127898973, 50.14263534396032],
						[14.41676235218709, 50.13962936595179],
						[14.412468910353768, 50.14001083508061],
						[14.404286384878864, 50.140739443828885],
						[14.403082847798789, 50.140846254441875],
						[14.392245292560633, 50.141147612513464],
						[14.388525963055857, 50.14099121316399],
						[14.384358405591234, 50.140815730182126],
						[14.37934207918777, 50.140045166262915],
						[14.376969337871293, 50.13937759801042],
						[14.373330116047935, 50.137691495596],
						[14.37311172457284, 50.137523648357934],
						[14.37048912062877, 50.135513307095586],
						[14.369406700188199, 50.134281158977366],
						[14.36779975852916, 50.131191249898094],
						[14.365784645441453, 50.1249427830986],
						[14.363040923833754, 50.12051009896466],
						[14.360293388259986, 50.11807250871215],
						[14.35619258906685, 50.116497042367506],
						[14.349233627151214, 50.11546325517573],
						[14.341879844534226, 50.11515045036219],
						[14.33229160259894, 50.11665725224014],
						[14.329489707712968, 50.11741256482616],
						[14.322808265726781, 50.11920547525649],
						[14.318773269801216, 50.11968231347386],
						[14.317807197942154, 50.11964416871315],
						[14.316626548840995, 50.11959457470644],
						[14.312869071881217, 50.11868286054269],
						[14.307941437192161, 50.11661148491652],
						[14.294398307399167, 50.11218642790824],
						[14.28661537191631, 50.11111068936103],
						[14.270770072591421, 50.110324856186764],
						[14.266012192253498, 50.10966110707301],
						[14.263867377968374, 50.109073636267354],
						[14.254037856628479, 50.10439300112172],
						[14.253856659160968, 50.104209902144504],
						[14.25143814050428, 50.10173797244349],
						[14.250945091333897, 50.10022354211821],
						[14.250999450758595, 50.09869766309864],
						[14.251880645279392, 50.097049708433026],
						[14.252302169370058, 50.0962638812206],
						[14.25423240635555, 50.09467315414527],
						[14.267813682990548, 50.08711624577472],
						[14.272068023700587, 50.08434677142732],
						[14.280006408457192, 50.08037185436058],
						[14.283411979533755, 50.079082487606726],
						[14.289207458728338, 50.07793426744353],
						[14.292895316905064, 50.07680892772951],
						[14.294947624337995, 50.07535171639204],
						[14.2955980301412, 50.07439422657986],
						[14.295881271165152, 50.07337951464309],
						[14.295598983762082, 50.07151794430929],
						[14.294812202672116, 50.07030105807736],
						[14.294025421207763, 50.069084168126885],
						[14.292632102724317, 50.067996976355474],
						[14.288973808243737, 50.066623687297906],
						[14.284049987997644, 50.065555574544696],
						[14.281199455292207, 50.06493759185961],
						[14.276148796094926, 50.0629768372913],
						[14.269424438567569, 50.061378479909195],
						[14.268612861514226, 50.061187742954694],
						[14.265112877026587, 50.05961227550978],
						[14.263878822249131, 50.05837249678642],
						[14.263170242508487, 50.057003023221014],
						[14.26291656500355, 50.055572510384685],
						[14.263648033117907, 50.05274581885082],
						[14.26437568671618, 50.0520172126169],
						[14.26602363593559, 50.05036926340585],
						[14.270726203732602, 50.047828672464824],
						[14.274928093024885, 50.04495239325741],
						[14.276406288079059, 50.043476104058804],
						[14.282986640883585, 50.03691101027719],
						[14.297014236405309, 50.02596664383927],
						[14.300584792983273, 50.024219511868836],
						[14.304183006194078, 50.023258208306736],
						[14.307391166601859, 50.022399901496804],
						[14.311261177067816, 50.02136611943268],
						[14.3146495819681, 50.01972961484228],
						[14.317452430671693, 50.01758956856086],
						[14.319512367239321, 50.01476287832512],
						[14.320560455299994, 50.01142883278696],
						[14.321060180665073, 50.00130081177763],
						[14.32115555005578, 49.999343891564216],
						[14.321750654891591, 49.99609007477777],
						[14.323272690620588, 49.99312577171992],
						[14.324599262216948, 49.99183650970286],
						[14.328228006461833, 49.990005588988105],
						[14.333283409746809, 49.98852905986628],
						[14.343806265504659, 49.986766802468786],
						[14.346327791103759, 49.986343477428946],
						[14.349900239911491, 49.984958591523146],
						[14.352226263413378, 49.98321157780541],
						[14.354037293562675, 49.98015984603747],
						[14.354379645093788, 49.978534610720814],
						[14.354219421240863, 49.97521957354326],
						[14.353281015145726, 49.97243875291786],
						[14.347044942699988, 49.96064374779234],
						[14.34553145729581, 49.95650475883775],
						[14.345197670781534, 49.95436852335199],
						[14.346499438033067, 49.94988245736532],
						[14.34840011513601, 49.947277060826416],
						[14.349770546178346, 49.94618988254808],
						[14.357300767044638, 49.94178780608475],
						[14.359425529254576, 49.94110092023361],
						[14.364180573485237, 49.94030007333984],
						[14.369338027949732, 49.93997184796117],
						[14.377413738415216, 49.94006717922344],
						[14.382820140365313, 49.940567125527515],
						[14.38806436953006, 49.94165024244685],
						[14.39449119036665, 49.94443506693816],
						[14.399673470183522, 49.948051534618415],
						[14.403470028492555, 49.95216740322],
						[14.407212265377213, 49.95964439677441],
						[14.409433366699451, 49.96190645123704],
						[14.412096983278829, 49.96339803957232],
						[14.413597122242072, 49.96390548598487],
						[14.414323808706126, 49.96415330902717],
						[14.419190402680965, 49.96503062942289],
						[14.44314669352571, 49.96625888316874],
						[14.45509910691796, 49.96784211273678],
						[14.458951952450203, 49.968353294931404],
						[14.459098805188052, 49.96837223912768],
						[14.464197156835164, 49.96945951418477],
						[14.470708840038393, 49.97198097952767],
						[14.473947531959144, 49.97363288081866],
						[14.480418220824125, 49.97693267886578],
						[14.484822277633151, 49.978893323125334],
						[14.48617171453738, 49.97949211000558],
						[14.486750608285814, 49.97985082379064],
						[14.492238033747736, 49.98324574151159],
						[14.492717743094442, 49.98349762134465],
						[14.498936662252468, 49.98681649584427],
						[14.501604088632119, 49.98823555648954],
						[14.50562572309782, 49.9894561601099],
						[14.51482010008526, 49.9914016842238],
						[14.515632633705556, 49.991657299395406],
						[14.517058358770093, 49.99211107132575],
						[14.518634806650555, 49.992614849209914],
						[14.530026444807634, 49.99691781240641],
						[14.53329275843608, 49.99864566535595],
						[14.536735534668997, 50.00046539307525],
						[14.546342849716273, 50.00395584091648],
						[14.550347328216676, 50.005149841608436],
						[14.55688667296727, 50.006244659361656],
						[14.58306980132341, 50.00855636589581],
						[14.587444305436287, 50.008045196692805],
						[14.592392921425652, 50.00746917702986],
						[14.606447219872372, 50.00628662132513],
						[14.610577583333527, 50.00553894062921],
						[14.612796783461793, 50.0046691895946],
						[14.613957405078601, 50.004215240364154],
						[14.61511802673211, 50.00334167479201],
						[14.618088722851034, 49.99943924556256],
						[14.62021542776635, 49.99756633822377],
						[14.621865259255951, 49.996791710360746],
						[14.625827795111881, 49.995822963035835],
						[14.632578851871896, 49.995418568828754],
						[14.639536872792577, 49.99611678596775],
						[14.643411646758633, 49.99724207510347],
						[14.64545725821046, 49.998306181525145],
						[14.646681797207727, 49.99894725659569],
						[14.647652631606093, 49.999450737740744],
						[14.649929046631804, 50.00119400025219],
						[14.653660774236632, 50.00474166875639],
						[14.657994270351084, 50.00752258326438],
						[14.660737037688856, 50.009693146043794],
						[14.664612770129962, 50.01276016283291],
						[14.666441917471857, 50.014739990743166],
						[14.667575836158663, 50.01730728127067],
						[14.668176651025409, 50.020130157706575],
						[14.669384002594057, 50.03441619784229],
						[14.669340133582548, 50.036571501866426],
						[14.668606758002765, 50.038650511580855],
						[14.665869712758015, 50.042579650185154],
						[14.66563987710154, 50.04274368075065],
						[14.663658142305433, 50.044136049453094],
						[14.656556129561093, 50.04754257304531],
						[14.653944969005735, 50.049491880660234],
						[14.653850555430097, 50.04956054697304],
						[14.652773857350667, 50.0507469199925],
						[14.651982307493894, 50.052043915374476],
						[14.651305198714848, 50.05477905317372],
						[14.651812553547614, 50.057392121735525],
						[14.652630806143078, 50.058647157445904],
						[14.653990745436584, 50.05981063738117],
						[14.655636787570465, 50.06063079985038],
						[14.657501220744486, 50.06117248575224],
						[14.661479950075746, 50.0616951000833],
						[14.66392421730442, 50.061782837690686],
						[14.669684410108736, 50.06198120130273],
						[14.676477432157455, 50.06222152619446],
						[14.677303314019936, 50.06232833679306],
						[14.680419922093828, 50.06274414274214],
						[14.689107894750705, 50.06566619731221],
						[14.68983173370691, 50.06577682498367],
						[14.701267242198812, 50.06749343647232],
						[14.705410003878034, 50.06843567102912],
						[14.707977294942213, 50.06902313251942],
						[14.711347580013852, 50.069984436592414],
						[14.714371681396205, 50.07139206109024],
						[14.715966224545367, 50.0727157580705],
						[14.716650963042882, 50.07328415122738],
						[14.718161583165282, 50.07603073330859],
						[14.718535423184768, 50.07891464142719],
						[14.717997551231448, 50.08182144422455],
						[14.717371940926654, 50.083244326756024],
						[14.716075897354614, 50.085041047470924],
						[14.715499877835892, 50.08584213166385],
						[14.709835052968055, 50.09167099459861],
						[14.708447455858481, 50.09309768193183],
						[14.699170112631165, 50.09840393086847],
						[14.695817947041697, 50.099426266191536],
						[14.690416335691179, 50.10049819590633],
						[14.687073707741872, 50.101417543061615],
						[14.682225227830768, 50.10366440277832],
						[14.674030303574149, 50.10600280393706],
						[14.671660423223695, 50.10718154853908],
						[14.671113968026829, 50.10745239384701],
						[14.669245719723369, 50.10966872988931],
						[14.668251991570846, 50.11268616011419],
						[14.666730880639422, 50.117305754668465],
						[14.665022849782996, 50.11915588133811],
						[14.664635658455015, 50.11957550233213],
						[14.663112639889617, 50.12037658216836],
						[14.659493445898637, 50.12135695974789],
						[14.655430794129877, 50.121818546033886],
						[14.644143104653475, 50.122192383781076],
						[14.63937854738535, 50.122352597357555],
						[14.632778167577692, 50.1230468735783],
						[14.621581077541641, 50.12499618497184],
						[14.61996460004317, 50.1254158062046],
						[14.618115424889208, 50.12589263702273],
						[14.617353438850417, 50.12609099875966],
						[14.612944602813096, 50.12723159641481],
						[14.61266708351056, 50.12733077780263],
						[14.609541893252834, 50.12840271235875],
						[14.606125831368894, 50.13019561539566],
						[14.603369712360873, 50.132392878755475],
						[14.603182792850275, 50.13263702573481],
						[14.601436614813894, 50.1349029523912],
						[14.599121093800113, 50.140209198484406]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ20",
				"name": " Středočeský kraj",
				"region": "stredocesky"
			},
			"id": 12
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[15.591567028005255, 48.951175580052634],
						[15.587309830339395, 48.95751564970305],
						[15.582797998779462, 48.96770090697875],
						[15.58173179698466, 48.968990332801766],
						[15.579462037430664, 48.970771656263544],
						[15.576540953967804, 48.97217185035599],
						[15.569961544822197, 48.97405621496134],
						[15.554735171741617, 48.97680652615045],
						[15.55165385605295, 48.97791284597359],
						[15.542466152041982, 48.98225773212134],
						[15.53944778964851, 48.984066059503505],
						[15.536869992115907, 48.98619832358379],
						[15.53493310485382, 48.988571307099726],
						[15.53203105675475, 48.99335477334371],
						[15.529904374354413, 48.99542244762344],
						[15.527276048068638, 48.99676522231701],
						[15.522804252129564, 48.99821845861377],
						[15.512375816651062, 49.00027070029995],
						[15.509019860327106, 49.001281821066556],
						[15.506547922116356, 49.0030478881269],
						[15.50586033738776, 49.004074180150795],
						[15.505315792559614, 49.00627529118566],
						[15.505615224211025, 49.008323572080016],
						[15.507206912039608, 49.01301951609767],
						[15.508599274787736, 49.015445646776506],
						[15.510867122007058, 49.017566711263925],
						[15.51402281203468, 49.01896653018038],
						[15.520765318593728, 49.02071012562382],
						[15.52360437738182, 49.02180084548091],
						[15.534256933362693, 49.02686308135908],
						[15.538192755791846, 49.02994162347481],
						[15.540200236100866, 49.03336336750229],
						[15.541168218391133, 49.03949742798793],
						[15.542936312832456, 49.043464543844784],
						[15.544220922081037, 49.045349099184236],
						[15.548371315346348, 49.04973221153096],
						[15.55192470988322, 49.057502788306266],
						[15.556086528947642, 49.063991439229994],
						[15.55904961637849, 49.07063684500935],
						[15.561999326408383, 49.07404332555727],
						[15.564684884049507, 49.07558456569426],
						[15.57060909395712, 49.077217113889866],
						[15.586670860651399, 49.07948289067701],
						[15.600920691191734, 49.08025754872621],
						[15.600837702881874, 49.08965297113015],
						[15.600213994033101, 49.0928343731898],
						[15.59881020635473, 49.095878700048154],
						[15.596527112684509, 49.09847271927143],
						[15.592073428375928, 49.10182941326655],
						[15.58707904420713, 49.104705773059706],
						[15.579492579716657, 49.10819254588478],
						[15.577303872365606, 49.10984788907078],
						[15.575839982665794, 49.11181246172967],
						[15.574474329453617, 49.11482233772072],
						[15.574269300124564, 49.116867116565544],
						[15.574797619319856, 49.122821703543046],
						[15.573900214081835, 49.12664023728573],
						[15.572280892403095, 49.12865074704044],
						[15.566860192335225, 49.13304513350698],
						[15.564605717968105, 49.13443379454028],
						[15.561785694536816, 49.13533398260665],
						[15.558691964454988, 49.13558565196131],
						[15.541708938936743, 49.13504021388271],
						[15.532755842323667, 49.134391695035454],
						[15.527025216500496, 49.133174836493055],
						[15.521971710419104, 49.130939558319575],
						[15.520203575359021, 49.13041672695849],
						[15.516183851393011, 49.1296806168139],
						[15.505526534734711, 49.128326340435336],
						[15.501928329591777, 49.12739181636722],
						[15.498449330335047, 49.12576298498052],
						[15.495764728913029, 49.12488171149442],
						[15.490846631769616, 49.1243743692131],
						[15.485896104248443, 49.12484735210254],
						[15.4831752929697, 49.125759270439154],
						[15.479739192146079, 49.12742617608772],
						[15.476485252063988, 49.12828826602194],
						[15.464790343455164, 49.12969207015209],
						[15.461161615548011, 49.13036348427245],
						[15.459570873292787, 49.13084019242229],
						[15.454625114608646, 49.133071755117086],
						[15.451080336178048, 49.13391126586398],
						[15.444824225764174, 49.1344567016266],
						[15.424650189097859, 49.134838073948245],
						[15.420563689494376, 49.13527671470562],
						[15.416979805614297, 49.13617721518322],
						[15.412184725970784, 49.13870630984085],
						[15.403015127506109, 49.14261236892479],
						[15.38610077733065, 49.1525879701599],
						[15.381615637662897, 49.15489958689683],
						[15.374723442757505, 49.157951434763],
						[15.356961239694087, 49.168578999603625],
						[15.349671374747844, 49.17445765497275],
						[15.348427785418941, 49.17710507389898],
						[15.348417272608506, 49.17990484649075],
						[15.349508290412498, 49.18251423765599],
						[15.35252855920551, 49.18570696860443],
						[15.354165083452468, 49.18830496107196],
						[15.356543535827262, 49.19542689170371],
						[15.35698223974709, 49.198757254230735],
						[15.355843558937865, 49.20587172529524],
						[15.35464094620196, 49.20917497082929],
						[15.352486623910838, 49.21219647960401],
						[15.349506362612173, 49.21470245688281],
						[15.345856651778819, 49.21680436249547],
						[15.341592782299513, 49.21841424523915],
						[15.338950148254167, 49.21902457265316],
						[15.333483692914932, 49.219703644843165],
						[15.32217310857838, 49.22000493917394],
						[15.292801844320818, 49.2198027344104],
						[15.27869319293624, 49.2176017161574],
						[15.265778536009147, 49.21515268687783],
						[15.260983457404718, 49.21456899820779],
						[15.251056685041975, 49.214130535842905],
						[15.225789065347696, 49.213970138069214],
						[15.216066356331494, 49.21324153705268],
						[15.202388752228279, 49.21105946179484],
						[15.198605522135386, 49.210189671245224],
						[15.195668215889466, 49.20898051541169],
						[15.190841671147467, 49.2063674572052],
						[15.180995002406325, 49.202556754915065],
						[15.177028651983521, 49.20133586792661],
						[15.174847605401332, 49.20091631511444],
						[15.170343399313468, 49.200511934952694],
						[15.165800099870628, 49.20065312734322],
						[15.163564688366181, 49.20095068436039],
						[15.159386631890598, 49.20211026198706],
						[15.155935278597633, 49.20386496495662],
						[15.15320588515862, 49.20595563737705],
						[15.149789808675997, 49.20965956178391],
						[15.14706612533658, 49.212066737945484],
						[15.145522122572332, 49.214145708610346],
						[15.14500904426689, 49.21541217328956],
						[15.143865586879597, 49.22072984297548],
						[15.142912873044503, 49.22328575632546],
						[15.142029764003945, 49.224472062776115],
						[15.140696527773786, 49.22553636782776],
						[15.139028558390633, 49.22629937531251],
						[15.135208121844949, 49.22703544428249],
						[15.133190165443008, 49.22710047361286],
						[15.129125597238621, 49.22676851453235],
						[15.125293721698322, 49.2258757572483],
						[15.118040096315394, 49.22366725653932],
						[15.114404686688433, 49.22328575632546],
						[15.110665309025018, 49.223556398465796],
						[15.10851192322777, 49.224090561399144],
						[15.106573108523701, 49.224842107252144],
						[15.10340214679596, 49.226825802217014],
						[15.101449981362187, 49.2293244863573],
						[15.101156220362752, 49.23073563866695],
						[15.101452820820615, 49.232097561088324],
						[15.103150366685435, 49.23446654248913],
						[15.106506357098471, 49.237876984060236],
						[15.108156214400466, 49.24041757957272],
						[15.10888863382194, 49.24308021435916],
						[15.108755096565774, 49.24572739177447],
						[15.10830496475529, 49.246986265890556],
						[15.10661315767139, 49.249046310997976],
						[15.101492870859381, 49.252399338287944],
						[15.098974238833259, 49.253700362772705],
						[15.09704875309105, 49.254295287084034],
						[15.092734330953526, 49.25494379018092],
						[15.075649273364032, 49.25556194457189],
						[15.068313591111199, 49.25645820907691],
						[15.049144749290448, 49.26227192425001],
						[15.037404057806453, 49.26691815737931],
						[15.031222331912211, 49.27002704789941],
						[15.027317045440718, 49.271022780218054],
						[15.022882469462504, 49.27147682301828],
						[15.015813825991193, 49.27140806614552],
						[15.008812896601658, 49.27036277806395],
						[15.004845604480415, 49.26907715684961],
						[14.995027555832545, 49.265167370790806],
						[14.99055576037086, 49.2626113609808],
						[14.987640383819594, 49.26155093235467],
						[14.985843671864174, 49.2612344150589],
						[14.982082365130566, 49.261119824742366],
						[14.978411686400756, 49.261776087257665],
						[14.976777065520372, 49.26247013542647],
						[14.97549437974828, 49.26338190876126],
						[14.97457599016429, 49.26439279158632],
						[14.971347805842694, 49.269626588033],
						[14.966830265777391, 49.273727536523616],
						[14.961745264481152, 49.281131767309176],
						[14.95770262888436, 49.288532180172346],
						[14.948513997223825, 49.291809205228155],
						[14.940413469444719, 49.29342264402729],
						[14.93774222195005, 49.297195323273264],
						[14.925867095720132, 49.30600371832571],
						[14.924114222740025, 49.30810542397066],
						[14.921454423053902, 49.312587673423224],
						[14.918207177895606, 49.3158417664006],
						[14.916834837474694, 49.317794861124405],
						[14.91628074583529, 49.32018660884906],
						[14.916986465909545, 49.32375336141012],
						[14.918359757105623, 49.32562256484251],
						[14.920807826763971, 49.32793415041948],
						[14.922640795866032, 49.331733658331174],
						[14.92307567525708, 49.33619307777125],
						[14.922669415984394, 49.33926778254663],
						[14.92153741283345, 49.34227003041971],
						[14.919705391361394, 49.34486771053275],
						[14.913949976179271, 49.351356602078816],
						[14.909057602953396, 49.355388501556845],
						[14.907405847661462, 49.35766596052389],
						[14.90287589398946, 49.36935037168817],
						[14.902042392578782, 49.37756351251966],
						[14.902645100379257, 49.385845079275946],
						[14.905376437435022, 49.39578250119312],
						[14.906562813026511, 49.40729911869958],
						[14.907670033276407, 49.41211712413398],
						[14.909111024072114, 49.41501237062016],
						[14.912630095267122, 49.42017759769898],
						[14.916379928991207, 49.42787170803857],
						[14.920699105507698, 49.43224320962485],
						[14.922211639508014, 49.4345359066183],
						[14.929717062190594, 49.45163725133014],
						[14.930455197510833, 49.45417775570833],
						[14.930621139872512, 49.456962514321674],
						[14.930148135951535, 49.45960628057674],
						[14.928968437934712, 49.461937032407974],
						[14.925024024306696, 49.4663695479864],
						[14.923927298042045, 49.469074160531065],
						[14.923277851348344, 49.472087825237175],
						[14.922670363174984, 49.47855757490741],
						[14.922442450502375, 49.486869951407606],
						[14.922645571060977, 49.4917412020146],
						[14.923578248311305, 49.496318680404265],
						[14.925073633834861, 49.49903879554237],
						[14.927456855471345, 49.501037594705075],
						[14.942714705713588, 49.507606648035996],
						[14.945247652059509, 49.50910951569337],
						[14.947321889109523, 49.511646244716246],
						[14.94834041653491, 49.51456833450467],
						[14.948718055886289, 49.519286962498704],
						[14.947794912300344, 49.52573774353026],
						[14.946581838455934, 49.52884290599792],
						[14.943174374027867, 49.5340996940633],
						[14.941899289333378, 49.53676595218609],
						[14.941249847098767, 49.53950881653287],
						[14.94103240320418, 49.54351418885828],
						[14.939673428537061, 49.556427048311754],
						[14.939106929745419, 49.5659369307241],
						[14.939250937656398, 49.570434488829655],
						[14.939865124082111, 49.57323848718358],
						[14.94048023306771, 49.574554451409035],
						[14.941416751802526, 49.5757867011232],
						[14.942784318538594, 49.57688531223514],
						[14.944551483314687, 49.57772842115755],
						[14.946503637917788, 49.578277575240456],
						[14.948568336413729, 49.57862083589923],
						[14.952935221790279, 49.57890704184017],
						[14.969264989075114, 49.578628587951926],
						[14.973727219404326, 49.57874672926403],
						[14.97786331670316, 49.57932286274129],
						[14.979743961020931, 49.57992938571127],
						[14.982123386344615, 49.58146678522426],
						[14.982873917571355, 49.582443246455085],
						[14.983323083814772, 49.58445726762287],
						[14.98271369766177, 49.58781431480346],
						[14.981852538756742, 49.59030158454757],
						[14.979623808801119, 49.59365095573408],
						[14.976759901976921, 49.59579840913186],
						[14.974996562468176, 49.597682911218385],
						[14.974375714002724, 49.59888829278366],
						[14.973793978592497, 49.60152049122631],
						[14.974179277004053, 49.60429009680394],
						[14.97589778710197, 49.60695646355616],
						[14.978833191822444, 49.60908883266254],
						[14.98270893161609, 49.610519415433366],
						[14.986581813420694, 49.61094676210831],
						[14.990406993184443, 49.61064532446664],
						[14.994352333772406, 49.60963433249866],
						[14.999938019277744, 49.60781486713424],
						[15.011623390227998, 49.60526664497814],
						[15.018039709072758, 49.602821405131785],
						[15.021077168650642, 49.60241329889027],
						[15.024355883327587, 49.60258479026363],
						[15.026184073927134, 49.60292808346621],
						[15.031578052807404, 49.604411971301275],
						[15.035511031679775, 49.60517516126609],
						[15.041727075940825, 49.605392551428444],
						[15.045577049984399, 49.60492707000813],
						[15.04726599467104, 49.60448825918406],
						[15.0521488059494, 49.602397793346825],
						[15.053915969012463, 49.60190192656171],
						[15.057967173549418, 49.60129535161197],
						[15.064552315573797, 49.60113533514685],
						[15.070795073623557, 49.60186781443541],
						[15.072583208400143, 49.6023636811545],
						[15.077505125246466, 49.60454190880633],
						[15.079278955138339, 49.60507592473407],
						[15.085662837271277, 49.60600657884664],
						[15.097846026632618, 49.60643763937837],
						[15.123429293551597, 49.606475783618635],
						[15.135981553179997, 49.60627358819839],
						[15.142983446712687, 49.60578546678349],
						[15.147081387528772, 49.60508739895613],
						[15.148818003542457, 49.60456454708959],
						[15.152310382410228, 49.60295878450673],
						[15.1551961862095, 49.602077449028805],
						[15.156970035832204, 49.60181819680526],
						[15.160691267462326, 49.60171896157386],
						[15.164279945920988, 49.60219963258397],
						[15.165866842541819, 49.60268774716495],
						[15.171062471348543, 49.605598467529866],
						[15.173527723357008, 49.606357629527],
						[15.185594563123392, 49.6069794121693],
						[15.18937589063285, 49.60755933050814],
						[15.191074384576599, 49.60802853812535],
						[15.197549832244153, 49.61075603763331],
						[15.204660402884643, 49.61237704513909],
						[15.207992542320444, 49.61342991470616],
						[15.214094167114641, 49.61662297361244],
						[15.23078059370953, 49.62284080727415],
						[15.233648305043788, 49.626167343671554],
						[15.237375243307916, 49.63132842991544],
						[15.2420005813201, 49.63538362006705],
						[15.244083417896332, 49.638984806937394],
						[15.246211065385468, 49.647567876566704],
						[15.245107655253543, 49.65349583122501],
						[15.24361610615718, 49.65743257541557],
						[15.242756829655558, 49.65865312733765],
						[15.240329750192407, 49.660614087282404],
						[15.232399946190228, 49.66386418982229],
						[15.226614012036208, 49.665729652007855],
						[15.214604383875072, 49.66793447593299],
						[15.211595548143427, 49.66903317274751],
						[15.206291183086819, 49.671516269814994],
						[15.200770389928895, 49.67324840332214],
						[15.19459628283849, 49.67564003251898],
						[15.19236944656737, 49.679092269443956],
						[15.190274224346243, 49.68110643198829],
						[15.18773268801588, 49.68232337481932],
						[15.184910767294161, 49.683208399604176],
						[15.184622755757122, 49.700794136052586],
						[15.185293195092086, 49.70523450345695],
						[15.186447133244446, 49.707904717734024],
						[15.188352569808833, 49.70993027717748],
						[15.194534313858066, 49.7142144398017],
						[15.196969019094125, 49.71555315849108],
						[15.202825540490513, 49.71806711442205],
						[15.207291587460503, 49.72082123244739],
						[15.216090217548961, 49.72867980112569],
						[15.216968546527557, 49.72992334442828],
						[15.218035684548973, 49.73272692400403],
						[15.219183930014346, 49.743831712131296],
						[15.2204370555155, 49.7485924301636],
						[15.224404326371834, 49.75515357420801],
						[15.226806645919199, 49.76021580932055],
						[15.228585231936973, 49.76252354444308],
						[15.229931828976714, 49.76353452337868],
						[15.233765594990928, 49.76498024889532],
						[15.240518557604474, 49.76578891545176],
						[15.247887596129488, 49.765907143587825],
						[15.273846614073504, 49.76556766452149],
						[15.28669833798546, 49.76594158801579],
						[15.294013991463025, 49.76691068857458],
						[15.306479462486639, 49.770050128215786],
						[15.32230089935721, 49.77188099467246],
						[15.326100333998834, 49.77278122726242],
						[15.331261643251683, 49.77485664642833],
						[15.333041179970744, 49.775333300126476],
						[15.347654347858612, 49.77725606076044],
						[15.351445200747799, 49.77824785844032],
						[15.356376662411082, 49.78077329827077],
						[15.36194895922109, 49.78319542298144],
						[15.36506654016255, 49.78492366428032],
						[15.367819790030664, 49.786911047777856],
						[15.371706016394873, 49.79071051920043],
						[15.373770725955595, 49.7922898474747],
						[15.380427369596113, 49.79629143598373],
						[15.38358783519378, 49.79751203552311],
						[15.38776971258698, 49.79822552880992],
						[15.392360675999722, 49.798522844137466],
						[15.416796697889128, 49.79840863528544],
						[15.42134762918478, 49.7987366755239],
						[15.42555619200854, 49.79961403784161],
						[15.427441580776257, 49.80039581461782],
						[15.429828657277811, 49.80217755470503],
						[15.43211840046283, 49.80518708226942],
						[15.433663382063072, 49.808765540157545],
						[15.433973316154974, 49.81165317235219],
						[15.433737755158113, 49.81457901313791],
						[15.43107222856248, 49.82381051651289],
						[15.430855744448028, 49.82679360936603],
						[15.431119915990246, 49.82977673757104],
						[15.437773706707528, 49.84837343332129],
						[15.439063079663418, 49.85077292692775],
						[15.440107360048207, 49.851852551318444],
						[15.442570700050851, 49.85322583528066],
						[15.444082257423084, 49.853641484867595],
						[15.447153098377475, 49.853809421154196],
						[15.45344354105581, 49.85288251358635],
						[15.46402359548473, 49.849704792468124],
						[15.468229297003468, 49.84929659930097],
						[15.470321646383331, 49.84938041077171],
						[15.472332970282528, 49.84967437196588],
						[15.47553443609897, 49.850803347563],
						[15.47869682131733, 49.85292814492373],
						[15.482437121718412, 49.856075175116935],
						[15.48531055314256, 49.857471453459404],
						[15.491477962642602, 49.8586616176952],
						[15.501938816382374, 49.859401670497256],
						[15.508492479275294, 49.8526993674856],
						[15.516434685543539, 49.84682479430896],
						[15.556209574094423, 49.82109841885942],
						[15.580190664293989, 49.80524449858222],
						[15.585516937664671, 49.80219276208621],
						[15.58936690369284, 49.800537025052094],
						[15.59361552279949, 49.79950324236112],
						[15.59578799544829, 49.79926675469163],
						[15.600033759103459, 49.79925154748686],
						[15.603919982556471, 49.79980086954635],
						[15.605606082222883, 49.80029681218466],
						[15.610301030914323, 49.80257046407188],
						[15.613801966160379, 49.8035012210098],
						[15.617930395736087, 49.80403503447497],
						[15.622360215110106, 49.80428300983532],
						[15.6313390850816, 49.80414210766071],
						[15.63744355755538, 49.803302903388264],
						[15.639174468062635, 49.802795471686316],
						[15.644124016277726, 49.80055223233435],
						[15.64749337742805, 49.799690384335484],
						[15.664107327820453, 49.79792790348325],
						[15.66828727649764, 49.79702758124889],
						[15.676326759112689, 49.79469687573761],
						[15.686550141855115, 49.79284287849709],
						[15.688376410714865, 49.792365881409864],
						[15.691264157731132, 49.79110341071079],
						[15.694417942166325, 49.7890585815707],
						[15.698998448114063, 49.78661343579301],
						[15.70276070561888, 49.78364571419715],
						[15.707277311830408, 49.78111279775957],
						[15.711476337771622, 49.77817927656057],
						[15.714275369436548, 49.77695473626637],
						[15.723009118046596, 49.773853380221034],
						[15.727061286600176, 49.7726785118342],
						[15.731258387676972, 49.77199550184566],
						[15.743871685334426, 49.770992246994126],
						[15.747627257970471, 49.77033996280204],
						[15.750647547499026, 49.769245171803576],
						[15.754191395255607, 49.76733395364056],
						[15.761522277845506, 49.764228681604905],
						[15.765925415612779, 49.761306837582],
						[15.770584120768186, 49.75646985730395],
						[15.77439595166993, 49.75334175678516],
						[15.775836932152131, 49.75115573983694],
						[15.778163920854176, 49.74630747292449],
						[15.780200002657766, 49.74422453081518],
						[15.782923682440916, 49.742751929313755],
						[15.78478812278358, 49.74215308622916],
						[15.788812653854023, 49.74144378480033],
						[15.803941731574119, 49.74046330140506],
						[15.82193373733079, 49.737903512952286],
						[15.82548238311128, 49.736988200932],
						[15.83048917126109, 49.73481380515363],
						[15.834093092642407, 49.73401640726588],
						[15.838209157083645, 49.73363880766251],
						[15.851187717392476, 49.733196362170595],
						[15.855212210282017, 49.732631671289774],
						[15.857078556282685, 49.73208621832529],
						[15.858766539002106, 49.73126586920455],
						[15.860093101410083, 49.73017869352063],
						[15.860989554270816, 49.72895035194402],
						[15.861928947536963, 49.72626502374792],
						[15.86222744018696, 49.721874239846684],
						[15.861713397287447, 49.707866558322266],
						[15.862034805816064, 49.70485694666759],
						[15.862885487331196, 49.702060810189224],
						[15.864492430576608, 49.69962705172974],
						[15.868059173188838, 49.696628705750534],
						[15.870955473768863, 49.6949082016119],
						[15.878511420836745, 49.691287921684136],
						[15.88389111228839, 49.69331365894429],
						[15.891395578368323, 49.695678797410366],
						[15.897809977357454, 49.698604538874314],
						[15.901326173748288, 49.699325509282914],
						[15.905101787978976, 49.69944773940858],
						[15.908742889088124, 49.69902024445415],
						[15.910376550174131, 49.698589337713024],
						[15.916834821138753, 49.69593038937839],
						[15.920849788113376, 49.69519795032178],
						[15.927686689764348, 49.694641099506896],
						[15.937314986290373, 49.69443511154782],
						[15.94437026186215, 49.69465630043218],
						[15.950790403757457, 49.695541368117404],
						[15.954054835825772, 49.6966972655688],
						[15.957601532111669, 49.69860826160784],
						[15.96445558878991, 49.70173630771495],
						[15.96799088408359, 49.70438011527096],
						[15.969734183851163, 49.706447528655616],
						[15.971071250202138, 49.709522309778386],
						[15.971605302251426, 49.71276093746633],
						[15.97183895181923, 49.72780609770138],
						[15.972701065470075, 49.73102944532877],
						[15.974579808398213, 49.73391339729365],
						[15.977322584312065, 49.736240440005716],
						[15.980789176869859, 49.73807137222721],
						[15.985911380876372, 49.739566907088815],
						[15.990728387437626, 49.74040993343038],
						[15.99419497312239, 49.74048222842202],
						[15.995945921789723, 49.740260999607],
						[15.999129299888672, 49.73921970640389],
						[16.00036431287549, 49.73841484802164],
						[16.002040869350385, 49.73660284004637],
						[16.003803249377857, 49.73374554077193],
						[16.006795883029078, 49.72670745714816],
						[16.008914944318146, 49.72460171686479],
						[16.01263619237719, 49.72309882407043],
						[16.01940347483128, 49.72219101163692],
						[16.03419877612365, 49.72181715271008],
						[16.04118921061896, 49.721286925516786],
						[16.045202265174595, 49.720462888262226],
						[16.05228423151714, 49.717990792550154],
						[16.058652877778986, 49.71710967991811],
						[16.091262825154537, 49.71575171759997],
						[16.091493614870696, 49.71149452022822],
						[16.092138286129973, 49.708843192876685],
						[16.09297181106343, 49.70731743571407],
						[16.096675883138882, 49.7032204600844],
						[16.099775297182198, 49.69736083870198],
						[16.10178946296721, 49.695442096439585],
						[16.10695076607778, 49.69213109795895],
						[16.109371168811002, 49.69087967398426],
						[16.112960828383063, 49.69009792489804],
						[16.11486433470392, 49.689979421873204],
						[16.11862946421689, 49.690189439051835],
						[16.121978763344867, 49.690975221259556],
						[16.126428591054264, 49.693115117366496],
						[16.128000249794074, 49.693576726773614],
						[16.129751194773952, 49.69388570773194],
						[16.13349915472112, 49.6940842499113],
						[16.137201310675334, 49.693714155004926],
						[16.140180572045246, 49.69279465917801],
						[16.14515878463905, 49.690597685644036],
						[16.152242661614903, 49.68894578002848],
						[16.1555709741042, 49.68793478806071],
						[16.159187314506593, 49.68617246401338],
						[16.162277228256965, 49.68507772600044],
						[16.166322709736164, 49.684360518497996],
						[16.175012594532923, 49.683460289450025],
						[16.1790656965561, 49.68278496464915],
						[16.18772316373645, 49.679611241266315],
						[16.191770565532018, 49.67892848178418],
						[16.202543263477246, 49.677738232580246],
						[16.20630838048056, 49.67684950439428],
						[16.21141243232896, 49.67471315721583],
						[16.21320535366102, 49.67422118260525],
						[16.21725082610604, 49.673572559271314],
						[16.227983476249435, 49.67239381234239],
						[16.2317256766366, 49.67137513123187],
						[16.240976328767122, 49.66638942216465],
						[16.244869242119176, 49.66347893977136],
						[16.24933624232317, 49.66094970389336],
						[16.25708009129242, 49.65494930534169],
						[16.258705144388077, 49.65269093394817],
						[16.261613832074662, 49.64611041236003],
						[16.268224720464566, 49.637905158899855],
						[16.27005576177856, 49.63606254117407],
						[16.27441980146343, 49.63321319365521],
						[16.279373161190865, 49.629505088522556],
						[16.28738784922705, 49.625125896801],
						[16.29125787013139, 49.62416850135023],
						[16.295589434565734, 49.62382114787781],
						[16.30002974214824, 49.62389744154649],
						[16.304264052486104, 49.62434372895063],
						[16.307888014882682, 49.62522110930774],
						[16.31253050616256, 49.6271780908342],
						[16.315542234653982, 49.6276398910365],
						[16.318895342882104, 49.62749102318374],
						[16.322610850161325, 49.626628831907986],
						[16.33240701351615, 49.62322630615211],
						[16.337274552969543, 49.62065125910246],
						[16.33984756152955, 49.61956021362489],
						[16.347566588963886, 49.61770997488135],
						[16.350423811045943, 49.61671446141573],
						[16.35890578551845, 49.61115640413423],
						[16.36054421527471, 49.60903177077981],
						[16.36230277875903, 49.60558699328492],
						[16.363874428300054, 49.60348504432922],
						[16.367891294407073, 49.60065063471998],
						[16.37156486177791, 49.597568482442426],
						[16.3759880172931, 49.594791507081815],
						[16.382349027648175, 49.588390468645095],
						[16.393678663097088, 49.57847974858101],
						[16.38363456366194, 49.574127165395545],
						[16.381059651407558, 49.5726738401341],
						[16.379892346150847, 49.57165524604364],
						[16.376001368111552, 49.56614312521951],
						[16.372627268552584, 49.562969298655226],
						[16.371164327618313, 49.56098180120035],
						[16.37053678861209, 49.55854783539512],
						[16.37082670610803, 49.55605684253554],
						[16.371353142875233, 49.554859103379236],
						[16.37313841939518, 49.55289833301894],
						[16.379457474372195, 49.54896164487721],
						[16.382322324292957, 49.547763938764525],
						[16.389345157998555, 49.54621495926774],
						[16.39263533699457, 49.545234605165646],
						[16.40202140691478, 49.54037474552748],
						[16.41020775692449, 49.534652785339446],
						[16.412399284906336, 49.531738218495576],
						[16.413896544877765, 49.52759538015821],
						[16.41377831922903, 49.52544415632334],
						[16.412681563599552, 49.52041230339048],
						[16.41176032674275, 49.51780697619706],
						[16.410274512546618, 49.51545340005865],
						[16.406738277180278, 49.51223369804666],
						[16.402988447365566, 49.5069085367464],
						[16.40078161733906, 49.50495898107088],
						[16.397666944839752, 49.503639342661735],
						[16.38922309993874, 49.501461039565875],
						[16.38430215502502, 49.4993363825268],
						[16.37780952205838, 49.49777219477556],
						[16.374599455570642, 49.496749867115554],
						[16.373176567285455, 49.49592965203364],
						[16.372087478300955, 49.49488067327519],
						[16.371391288818202, 49.493724755693194],
						[16.37096787274, 49.49129111506693],
						[16.371637327813808, 49.48892197196999],
						[16.37237359043374, 49.48784264432008],
						[16.377042773492278, 49.48410036942331],
						[16.383947356052406, 49.47646317217821],
						[16.385641091890708, 49.473590796302865],
						[16.386621465784213, 49.470352088940125],
						[16.387239461861927, 49.46361165335392],
						[16.38685228149436, 49.45510879465707],
						[16.38603210026895, 49.45015331323855],
						[16.384052285878212, 49.443607412838524],
						[16.383718505537765, 49.43918241452911],
						[16.38403510796445, 49.43623731285405],
						[16.38626862557185, 49.42812737656456],
						[16.386831291830525, 49.4232102176556],
						[16.38728333383878, 49.39461525044828],
						[16.387762063526274, 49.39134592268108],
						[16.38869667481282, 49.388179817246915],
						[16.39224051085643, 49.381118654524045],
						[16.395004258040952, 49.37705599315116],
						[16.39171790428605, 49.36293786937232],
						[16.39010430649137, 49.358013266241564],
						[16.38627815302296, 49.35167694589685],
						[16.381814955705536, 49.34758376217251],
						[16.3788108831151, 49.34346771729272],
						[16.376918804229675, 49.341419322899995],
						[16.375595080088768, 49.340515023221464],
						[16.372007376389995, 49.33920675279041],
						[16.367862710456933, 49.33851250159174],
						[16.356611264807608, 49.33730709257576],
						[16.35234832482333, 49.33637616497316],
						[16.341815941432966, 49.33290093771614],
						[16.33881187495587, 49.3316345265638],
						[16.334405901303526, 49.328681966043796],
						[16.329788200171848, 49.326171804648745],
						[16.325990688437184, 49.323215588416204],
						[16.32148931972409, 49.32071291399309],
						[16.3176918159917, 49.31769573463389],
						[16.31324005613322, 49.3149223764931],
						[16.301521292499764, 49.302406232086064],
						[16.295181270316444, 49.29767604951598],
						[16.28825759394768, 49.28987117138557],
						[16.28671073505275, 49.287166558645936],
						[16.28594970358985, 49.284366576631484],
						[16.285802841414256, 49.28014373984686],
						[16.28631210631367, 49.27745440366138],
						[16.28744887205746, 49.2750128707545],
						[16.288328171449816, 49.27394867550757],
						[16.293426527346675, 49.27012646610459],
						[16.30018234605933, 49.262657197361236],
						[16.30089759509026, 49.26134869572161],
						[16.301343901367545, 49.258876651917035],
						[16.30066107236564, 49.25641237377599],
						[16.299753185309903, 49.25512310435631],
						[16.29857445147106, 49.253967319793546],
						[16.295677187099393, 49.25201036387472],
						[16.28854753258215, 49.248932035674486],
						[16.2842883970353, 49.24610892445078],
						[16.279598223109048, 49.2436751146885],
						[16.275728236566675, 49.24075327198599],
						[16.271095290104984, 49.238330969711555],
						[16.26668357426818, 49.23564144128859],
						[16.2631912357185, 49.234569663339244],
						[16.25292395278753, 49.23274600956875],
						[16.247909535776525, 49.23129644761653],
						[16.250093462499933, 49.22808458610203],
						[16.25316237423704, 49.22153464025768],
						[16.25478554486635, 49.21924597538691],
						[16.25864790374121, 49.21599183836631],
						[16.270334234131653, 49.20367422907772],
						[16.276086815471636, 49.1984596996812],
						[16.277481080355837, 49.19597245398409],
						[16.280609145841094, 49.1882783339194],
						[16.281831755027746, 49.18402112012943],
						[16.281848917963913, 49.177806949309485],
						[16.280992516342806, 49.17485054005363],
						[16.279201501713466, 49.17217249332444],
						[16.275711065347434, 49.16981893054797],
						[16.265893931518704, 49.16679759585654],
						[16.263202673185912, 49.16493230496644],
						[16.262247097806675, 49.16367351192201],
						[16.26063727996999, 49.159294097958146],
						[16.259159085276373, 49.149799320961655],
						[16.256832117331566, 49.14157099520619],
						[16.256513598731555, 49.13652422907246],
						[16.257158264275365, 49.13333116117849],
						[16.257860181775182, 49.13183973455724],
						[16.260408396103614, 49.129257153196235],
						[16.26228523827704, 49.12835698569886],
						[16.26649093338944, 49.127357456651225],
						[16.277854928418805, 49.12593849711923],
						[16.281570443060055, 49.12475975115054],
						[16.284194963244225, 49.12328354015231],
						[16.28693580880025, 49.12073137668721],
						[16.28972055190959, 49.11713424520673],
						[16.29088973321419, 49.11466973829422],
						[16.290864935921658, 49.112022322403845],
						[16.288881289984552, 49.10847080872666],
						[16.284582133291792, 49.10368342834463],
						[16.275648133490275, 49.09806075724886],
						[16.266551973561295, 49.09393312480995],
						[16.259220107716764, 49.08950410014647],
						[16.255956651141698, 49.087211621284524],
						[16.246757515677167, 49.078666763153215],
						[16.245401394654312, 49.076194874487115],
						[16.243637081668883, 49.067577332033046],
						[16.24226952443122, 49.06468589853285],
						[16.24119375766356, 49.06340777295769],
						[16.23831558024503, 49.0611839109122],
						[16.23459052979555, 49.059513086563676],
						[16.232347498698083, 49.058937166753594],
						[16.22770880328784, 49.058349488440385],
						[16.22304726130339, 49.05827335959062],
						[16.21853637861988, 49.05860139462614],
						[16.214418411490332, 49.05933761811838],
						[16.212623607068263, 49.0598946611992],
						[16.207704534546277, 49.062179478372855],
						[16.203834540575716, 49.06319052316469],
						[16.196910855349824, 49.06395337399952],
						[16.18943977165912, 49.06415174652037],
						[16.181905745574504, 49.06380080365844],
						[16.177045831676736, 49.06304940373557],
						[16.171087271955624, 49.06114584608131],
						[16.164716721790036, 49.058403026221676],
						[16.16221429539262, 49.056739955867364],
						[16.161151887623912, 49.05551911902497],
						[16.159973160351047, 49.05281844347099],
						[16.15952490310321, 49.04844270753082],
						[16.159671799037152, 49.039470815708626],
						[16.158630381533584, 49.035350895410915],
						[16.157764428580258, 49.03409952161378],
						[16.156467432627426, 49.03297038147765],
						[16.154773709189797, 49.03208539143697],
						[16.152870168219817, 49.03147116055617],
						[16.146499617608512, 49.03063568504241],
						[16.124975217772388, 49.030311706904776],
						[16.11253355402153, 49.029228069406976],
						[16.106702819627113, 49.029159684663234],
						[16.103006362100487, 49.02953719342096],
						[16.08931733155836, 49.031650633413605],
						[16.08592033420537, 49.03261947948265],
						[16.08244513526992, 49.03426352427631],
						[16.07952881053345, 49.035179156079536],
						[16.077741638387106, 49.03545393906255],
						[16.073984134256186, 49.03557957191662],
						[16.070314417460626, 49.035118196379365],
						[16.068651186446132, 49.03464877620848],
						[16.062755571967436, 49.03164661074479],
						[16.052890779691847, 49.02791978873643],
						[16.048912050707276, 49.02671053214603],
						[16.042224890764725, 49.025825562763444],
						[16.03533935381647, 49.025886520351044],
						[16.02528570859263, 49.027122384277355],
						[16.00827406608587, 49.028331642724716],
						[16.003633484238435, 49.02899537568959],
						[16.000255573246246, 49.029785049869766],
						[15.995413787405147, 49.03112799640972],
						[15.992533678091437, 49.03226084202757],
						[15.980446803364726, 49.03958500097227],
						[15.977719304327014, 49.04086301279887],
						[15.969133381114796, 49.04314426359054],
						[15.964240084519188, 49.04537973492245],
						[15.961212143350064, 49.046367507268684],
						[15.95744992140495, 49.046802598624666],
						[15.953587520351265, 49.04663456539272],
						[15.951732650282363, 49.04629911815115],
						[15.948713311153817, 49.04513557746983],
						[15.9427089849959, 49.0410081433409],
						[15.94091129225044, 49.03915023078407],
						[15.93862723837102, 49.034587816628914],
						[15.937063220760422, 49.032455477825856],
						[15.929757107747516, 49.02764501347469],
						[15.926801676096, 49.02653879834868],
						[15.924997330574751, 49.026187904769536],
						[15.911289202784067, 49.025401954326476],
						[15.909895910779124, 49.02499784054627],
						[15.907469762467251, 49.023731353140164],
						[15.905559529734028, 49.0219382300837],
						[15.900214186427586, 49.015121377562956],
						[15.89649105712384, 49.00759893678207],
						[15.894274726559969, 49.00545134211239],
						[15.892551406134396, 49.0046041901983],
						[15.888504020336509, 49.00360481427396],
						[15.884012221319026, 49.00318526313593],
						[15.85952852686047, 49.003108840543426],
						[15.85488415618352, 49.00283440007653],
						[15.850648866240272, 49.00220476601711],
						[15.848787319727222, 49.00168620855792],
						[15.842223162572065, 48.99896998627791],
						[15.835268036372453, 48.99729552734949],
						[15.832055081727107, 48.996181392956984],
						[15.827759755767568, 48.99349987820246],
						[15.8231058143324, 48.99105074143867],
						[15.818795219042897, 48.988201281174305],
						[15.816014291429122, 48.987003341200406],
						[15.805394156623962, 48.98329910445617],
						[15.801292419753157, 48.98229980769317],
						[15.790616984784155, 48.98049922660438],
						[15.788565649045582, 48.97992718884433],
						[15.784864430766607, 48.97834782643294],
						[15.781759270182427, 48.97630317688503],
						[15.779495225337731, 48.974059927398436],
						[15.772012711984754, 48.964355482083185],
						[15.769148825653371, 48.95969008506912],
						[15.76603030028423, 48.95599736036921],
						[15.760852810238099, 48.95098873663928],
						[15.757659907972672, 48.94944759275588],
						[15.75342369578364, 48.94854741041555],
						[15.746413240088215, 48.94806298363559],
						[15.700346962350237, 48.94853225273173],
						[15.68826293811083, 48.9480895868717],
						[15.684006680329436, 48.947402853011745],
						[15.68051146826304, 48.946079193892004],
						[15.678444865628842, 48.9442482304517],
						[15.675461760361898, 48.940345681109726],
						[15.674276344760104, 48.93946068628424],
						[15.670796406273366, 48.93812190898955],
						[15.666558259843695, 48.937404577027266],
						[15.661911976949838, 48.937053799607106],
						[15.649536132936365, 48.93688583491899],
						[15.63729001601277, 48.93732848241595],
						[15.630794538498378, 48.93827069606455],
						[15.628952012709103, 48.93881975510653],
						[15.62244987971945, 48.941593216314125],
						[15.615434648869643, 48.94326021445179],
						[15.612124435955074, 48.94428627872934],
						[15.60565377266792, 48.947315310037105],
						[15.591567028005255, 48.951175580052634]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ63",
				"name": " Kraj Vysočina",
				"region": "vysocina"
			},
			"id": 13
		},
		{
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					[
						[17.686552047187224, 48.85998534698213],
						[17.68699456979542, 48.86027541368797],
						[17.68820190697566, 48.861450217935186],
						[17.689863190502567, 48.86389910891502],
						[17.690691002147638, 48.866336889078134],
						[17.691232694233925, 48.869815935808724],
						[17.685091022606954, 48.87371066550589],
						[17.681020734492833, 48.87705991793479],
						[17.676424008722687, 48.879707186388124],
						[17.672527315316714, 48.8826751885024],
						[17.667982096247023, 48.88517375373699],
						[17.664112088924714, 48.888092022937975],
						[17.659593578642, 48.890590638055784],
						[17.65575982939236, 48.893585357104136],
						[17.651298519177303, 48.89635464341498],
						[17.64631842616172, 48.901222148646454],
						[17.64354515513049, 48.903492010845156],
						[17.622404101035695, 48.91799928893473],
						[17.618080139301345, 48.92134475827492],
						[17.61266326730152, 48.92612455802074],
						[17.60520362537987, 48.92964551158739],
						[17.599830623008295, 48.93255992951916],
						[17.573343273276627, 48.94950482094429],
						[17.56968496435657, 48.95160278377349],
						[17.56581117151961, 48.95346844386434],
						[17.561922063335825, 48.954822455294476],
						[17.554670332100056, 48.956569656690064],
						[17.551101696643418, 48.95729075178295],
						[17.546546933285192, 48.957778907341535],
						[17.541931163466852, 48.95786676306185],
						[17.53738022381815, 48.95756916739252],
						[17.533433918538854, 48.95689014316004],
						[17.52854919886794, 48.95561222109616],
						[17.524045954728464, 48.9539414345193],
						[17.515880594243193, 48.948017201328426],
						[17.514381422302662, 48.9458314145348],
						[17.512851705158504, 48.94229880473207],
						[17.511404049019852, 48.940097907012806],
						[17.50440979888197, 48.934059218315966],
						[17.501968370247265, 48.93290698923537],
						[17.500453944664073, 48.93257137444031],
						[17.497377379143998, 48.93256364138543],
						[17.49451637271333, 48.93307495145057],
						[17.491664870955837, 48.9340437521213],
						[17.48926352330895, 48.93576421704464],
						[17.485418334636293, 48.94234860740376],
						[17.481599804396577, 48.945491762302275],
						[17.47014426379241, 48.958125999473786],
						[17.46620749999552, 48.96129223041073],
						[17.46435929630381, 48.96322261318997],
						[17.460742941999786, 48.97105781995291],
						[17.457284924009073, 48.97629544257669],
						[17.456018460166987, 48.97900401094464],
						[17.453939442415106, 48.98967365323653],
						[17.452407845564096, 48.991939618335465],
						[17.450069415096664, 48.99342717106729],
						[17.447086323652584, 48.994167237803936],
						[17.44407463415726, 48.99422076277647],
						[17.416511526136443, 48.99246589177043],
						[17.411771763100123, 48.99311437591418],
						[17.40723611236293, 48.994495503843694],
						[17.404769899920726, 48.99622347070632],
						[17.400743467325533, 49.00277313831951],
						[17.39732931754049, 49.005924114685115],
						[17.395921699148687, 49.0081137927449],
						[17.394310006382792, 49.0116692342674],
						[17.392801281175895, 49.01388928188937],
						[17.38892555431718, 49.016998307656145],
						[17.38536263815698, 49.02065288229277],
						[17.382602706837066, 49.02274335477785],
						[17.379144672822143, 49.0245247249569],
						[17.374986641156603, 49.02577203149233],
						[17.37046049700418, 49.02638996247996],
						[17.365806565749477, 49.026622653936904],
						[17.358829515569163, 49.02651992310923],
						[17.354345323158032, 49.02619935367097],
						[17.348325717786604, 49.02519216164484],
						[17.346670149217204, 49.02465437525452],
						[17.341924654867107, 49.02241505421694],
						[17.340238560739387, 49.02194967880374],
						[17.336391439629153, 49.021461406797755],
						[17.33224867030449, 49.021545260798945],
						[17.328138356713573, 49.02228169189834],
						[17.32455445588828, 49.023697006753345],
						[17.321582797665815, 49.02550128100732],
						[17.317277902314196, 49.02895731543321],
						[17.31438829059604, 49.03033460506019],
						[17.31252669545577, 49.03083031966099],
						[17.30626488725196, 49.03163918427944],
						[17.295234695907595, 49.032219068067],
						[17.291095735196425, 49.03264237783513],
						[17.287450772685595, 49.033428040060784],
						[17.282316225112954, 49.0354653883596],
						[17.2806968725517, 49.03588870325415],
						[17.277032849666856, 49.03644941085424],
						[17.26477050212331, 49.03750986932951],
						[17.260723119909986, 49.03839116395429],
						[17.2587718818533, 49.03911959575827],
						[17.255416864992828, 49.04103846913573],
						[17.254045497791367, 49.042198278640726],
						[17.25209807706447, 49.04486078455748],
						[17.250955575211073, 49.0492095392547],
						[17.250341403297377, 49.057998553191226],
						[17.249160765224904, 49.06194304237056],
						[17.247575768658738, 49.06394966031878],
						[17.244070050927427, 49.06723783533094],
						[17.240520470160526, 49.07264321872963],
						[17.23772430622508, 49.076210039378516],
						[17.227239608986125, 49.07533264350579],
						[17.223230372166782, 49.07479104255354],
						[17.219747540573422, 49.07391736515995],
						[17.214712143965787, 49.07171631738329],
						[17.210992823428125, 49.07080087006048],
						[17.20670509287115, 49.07028960740304],
						[17.19975088973205, 49.069965271793215],
						[17.190204615258896, 49.070045427217416],
						[17.181194294648325, 49.070842650042415],
						[17.177410117401408, 49.07175438371917],
						[17.172359461416388, 49.073883012334626],
						[17.170555119620833, 49.07437137994204],
						[17.166425715442017, 49.0749665211418],
						[17.159519195458127, 49.075157164677016],
						[17.149261482660044, 49.074417183793855],
						[17.144037261449512, 49.081733830974436],
						[17.142332085883524, 49.08474739095442],
						[17.141141895351918, 49.08787921435222],
						[17.140554410570438, 49.09105285764424],
						[17.140525813784418, 49.094158137319766],
						[17.14118004018078, 49.09711457791293],
						[17.14289475827746, 49.099800225565716],
						[17.144340501838325, 49.1009482189679],
						[17.146305075503015, 49.101886673973326],
						[17.148456566774403, 49.10249704292005],
						[17.153064713477548, 49.10313403188111],
						[17.16295814860293, 49.10378649834254],
						[17.16722870187481, 49.104362514890376],
						[17.17540169737254, 49.10617073827764],
						[17.177705755173697, 49.10694114050025],
						[17.18122864548869, 49.10871130977076],
						[17.184062942857047, 49.1109770445493],
						[17.18606565614739, 49.11386093184048],
						[17.187068923814582, 49.11716829406786],
						[17.1878776518808, 49.125671359641935],
						[17.18854333483994, 49.128967415319934],
						[17.190067308771592, 49.13204589639398],
						[17.191886906792956, 49.133926434039765],
						[17.194623957688396, 49.13573083402211],
						[17.202621451477945, 49.13996498452231],
						[17.214548105755217, 49.14302439990284],
						[17.219562540239338, 49.145088279189075],
						[17.228927601817603, 49.14796820234172],
						[17.23064611547307, 49.14895233028937],
						[17.232837661271393, 49.15130601755187],
						[17.234348304895487, 49.155441350795435],
						[17.234720236391805, 49.162063652493345],
						[17.234365446331942, 49.16537842562723],
						[17.23352050880792, 49.16858673947916],
						[17.230556486062667, 49.174438459656685],
						[17.22850226142703, 49.17676915271282],
						[17.22693254173811, 49.17774595697463],
						[17.225013744511504, 49.1784363786409],
						[17.222969061454773, 49.17880635870468],
						[17.218784315341907, 49.17881378927195],
						[17.214851371837554, 49.178062374214505],
						[17.20533943867244, 49.17525488102088],
						[17.20066642069549, 49.174606263918314],
						[17.195947638610754, 49.17438118331863],
						[17.19140626119599, 49.17465982507956],
						[17.189271936066664, 49.1750641657558],
						[17.186052335162554, 49.17635737893654],
						[17.18470191425136, 49.177455856569146],
						[17.183788289939738, 49.17866889324829],
						[17.18281364813815, 49.18126681667439],
						[17.18195151504451, 49.18958275792538],
						[17.181354533368975, 49.192218872013626],
						[17.18018915005338, 49.19453826542616],
						[17.176328643714704, 49.19903932758307],
						[17.175361637277494, 49.201690707946334],
						[17.174709332840848, 49.20612346162053],
						[17.173969266737107, 49.21872327944094],
						[17.172901157724283, 49.22333530177664],
						[17.167144773308735, 49.236766797339484],
						[17.164508813766506, 49.24712748314074],
						[17.16307068183846, 49.249488857366046],
						[17.15986444214345, 49.252594135403456],
						[17.158788681872373, 49.25483322865175],
						[17.158788693784803, 49.258518328275784],
						[17.159955990093906, 49.26081476698068],
						[17.164482126242284, 49.264736257253674],
						[17.175430281212165, 49.27619538379712],
						[17.189058297551487, 49.28575510380467],
						[17.19653320282868, 49.29410934195174],
						[17.204002397718277, 49.296085505677965],
						[17.210527426938363, 49.2990265480543],
						[17.216037757466157, 49.30030828910531],
						[17.227544771563878, 49.30153644946687],
						[17.239725125132505, 49.301612958007546],
						[17.24858856092897, 49.302524557437316],
						[17.257997499004762, 49.30308520969627],
						[17.264284150892525, 49.30424895414974],
						[17.271730410619426, 49.30485142702255],
						[17.27832413862963, 49.30596933536676],
						[17.283550263202866, 49.307304388705006],
						[17.28712081756771, 49.308891283452],
						[17.29014204812882, 49.3108443263811],
						[17.29500008814423, 49.31557474649266],
						[17.29887580923184, 49.318706516825685],
						[17.300392157255896, 49.32090001743034],
						[17.30210686503369, 49.324394291610865],
						[17.303688058036542, 49.326530530423376],
						[17.31144333220279, 49.332435636233186],
						[17.320522320024047, 49.33749018055732],
						[17.32381056615402, 49.33853139907875],
						[17.329189311560313, 49.33967981122241],
						[17.332550031420666, 49.34068665094333],
						[17.337387087642057, 49.34322359443267],
						[17.344831467541923, 49.34632874267427],
						[17.349399580780734, 49.34917461880258],
						[17.35439491548069, 49.35380937998692],
						[17.35820008003012, 49.356868801153965],
						[17.358945834728768, 49.35800923860793],
						[17.359609593156357, 49.360473542361],
						[17.359304416655277, 49.36297597770463],
						[17.35877226015051, 49.364162295969535],
						[17.357017527039606, 49.36605843351201],
						[17.353967666928835, 49.36800384776888],
						[17.350217828981698, 49.370933615097876],
						[17.346965798927915, 49.37290199354169],
						[17.344951627067182, 49.3746299526729],
						[17.341373442282478, 49.38018416243967],
						[17.337057096266836, 49.38425430894349],
						[17.33629035154747, 49.38540261238078],
						[17.335777295156095, 49.386657819795055],
						[17.335416794278075, 49.38936996843604],
						[17.335933681221427, 49.392215694339306],
						[17.33658407479088, 49.39364228727423],
						[17.338735563152184, 49.39636597359603],
						[17.341564162077297, 49.398856978557674],
						[17.348070158176363, 49.40353786415956],
						[17.354892714368383, 49.40784822054985],
						[17.35838889776017, 49.40967557292169],
						[17.36215592416728, 49.41099938106537],
						[17.36599730706383, 49.41136163217411],
						[17.370647446171354, 49.410640849027764],
						[17.373554230438423, 49.40952683085475],
						[17.37479972484674, 49.40867993233194],
						[17.375808702039873, 49.40752780770404],
						[17.376373289261867, 49.4063072057105],
						[17.37665557135555, 49.40377801513534],
						[17.376235958510918, 49.40122220038008],
						[17.3747329773439, 49.39698415210375],
						[17.374628055075267, 49.39474477257175],
						[17.374938977843268, 49.39360820264295],
						[17.37556268592379, 49.39249053906895],
						[17.377618803834363, 49.39064037794411],
						[17.381013861869366, 49.38921349159592],
						[17.385395055765077, 49.38847355882103],
						[17.390075695449635, 49.38821421102169],
						[17.415149682233096, 49.388416235808506],
						[17.425064072221957, 49.38791644164453],
						[17.45578955047295, 49.382282126638636],
						[17.45919989507569, 49.381313237514746],
						[17.462768548945164, 49.37963480907419],
						[17.46583555564502, 49.37864671955533],
						[17.46977044449524, 49.3781357898179],
						[17.476179130491968, 49.37834555284546],
						[17.47831917597171, 49.378700322308674],
						[17.482282648205107, 49.3798256728308],
						[17.49075127350788, 49.38297277605736],
						[17.493537896837722, 49.38425059075387],
						[17.502077108954463, 49.39020162117946],
						[17.507598884113385, 49.396308958709845],
						[17.513948455622646, 49.40237057863779],
						[17.516998280948055, 49.40387717431258],
						[17.518947585189018, 49.40440736667958],
						[17.533449167247984, 49.4064559459364],
						[17.536497123998156, 49.4074593249323],
						[17.54024314798384, 49.409133904303694],
						[17.543811813393642, 49.41008771284333],
						[17.559539789696682, 49.41257853929414],
						[17.566400545657054, 49.41306319652942],
						[17.5710353936198, 49.41296775245001],
						[17.575571041973514, 49.41252121097249],
						[17.591154098242672, 49.4099082924513],
						[17.594516757113645, 49.40898516254648],
						[17.59796334363808, 49.407470790372464],
						[17.6007270817937, 49.40676117354131],
						[17.60397912029859, 49.40663536394708],
						[17.60567091397708, 49.406803006794256],
						[17.609344492896607, 49.40769204247899],
						[17.61905859079943, 49.41109451454123],
						[17.624042524907708, 49.4135934076214],
						[17.62694547791692, 49.41471085195561],
						[17.63664054930762, 49.41658783457122],
						[17.640693661399876, 49.41781995071947],
						[17.64433858924079, 49.41964706328556],
						[17.64723013033683, 49.4219129982063],
						[17.64826773167474, 49.423217655148434],
						[17.648906713063127, 49.42464069935939],
						[17.64894485513776, 49.42686081264675],
						[17.647853837085304, 49.430194737007454],
						[17.645528807030583, 49.43373882177726],
						[17.638067263275868, 49.441108850797455],
						[17.63400460284841, 49.443916403143135],
						[17.632263174022604, 49.445789257972045],
						[17.631481179752978, 49.448169783523625],
						[17.631523132681348, 49.44940948781714],
						[17.632669448520723, 49.451847073671445],
						[17.633932119004466, 49.45293430943919],
						[17.635692583262248, 49.45376957490691],
						[17.639678972950346, 49.45455184452442],
						[17.646215456077055, 49.45470061238927],
						[17.658254630837604, 49.45430761746483],
						[17.661897641216765, 49.45486053793923],
						[17.665618887209828, 49.45630638096633],
						[17.668846117952693, 49.45825185064918],
						[17.675390240969513, 49.46387479577516],
						[17.67967986578484, 49.46554942925158],
						[17.684246050624683, 49.466457263031295],
						[17.687511425727173, 49.466483918492514],
						[17.692131037735223, 49.46564861202926],
						[17.69516181992905, 49.464679721896786],
						[17.697721467286424, 49.46323383213536],
						[17.701793672514505, 49.459560409607526],
						[17.704519255491203, 49.457584246374765],
						[17.70758437933501, 49.45583342049451],
						[17.7130527620211, 49.45326624578328],
						[17.718988422907106, 49.44968036399437],
						[17.731033337928082, 49.44521342262979],
						[17.735412599312692, 49.44419099262944],
						[17.740150452380668, 49.44367218610158],
						[17.74489973420477, 49.443553796704805],
						[17.749494557978302, 49.44379429459363],
						[17.753732668559334, 49.4444922356057],
						[17.755613343888246, 49.44507612730908],
						[17.760446541264717, 49.44764322091845],
						[17.768299120678705, 49.451210168861785],
						[17.771596906261294, 49.453308086529105],
						[17.777862539745914, 49.4580649584714],
						[17.781135541977815, 49.46038422865677],
						[17.785305040988664, 49.46410384457858],
						[17.789793010998753, 49.4667892167035],
						[17.793643962849945, 49.46979913539312],
						[17.797977465734057, 49.47261443753323],
						[17.800521853377013, 49.475475334123544],
						[17.803987515623362, 49.48082743439721],
						[17.807197587787513, 49.487915177972646],
						[17.808021562897313, 49.491089010163684],
						[17.8085003003445, 49.497680749292485],
						[17.808050141492497, 49.51269901163405],
						[17.80820845298638, 49.51745976656466],
						[17.809375748506376, 49.52181232111975],
						[17.811485294663072, 49.524246249581],
						[17.81459234429761, 49.525729993071735],
						[17.822790150829306, 49.52793888319139],
						[17.82642555483806, 49.52956773864638],
						[17.82960511129737, 49.53060538756544],
						[17.83365820792958, 49.531288061765935],
						[17.842187884827958, 49.532260922131606],
						[17.846044521722984, 49.533019867377384],
						[17.84884260685632, 49.534133797190584],
						[17.853120812684136, 49.53644568972248],
						[17.855827334643205, 49.53712465901955],
						[17.858821877056332, 49.53718573534089],
						[17.865451821411522, 49.536270212103965],
						[17.876859661216475, 49.53285214276578],
						[17.88382530261506, 49.53181076448846],
						[17.888574594300685, 49.53161234814625],
						[17.893177026349687, 49.53178782259106],
						[17.897415179287403, 49.53244414767857],
						[17.899288162066462, 49.5330313383807],
						[17.908458709350395, 49.5380287140683],
						[17.915084821317354, 49.54317841603124],
						[17.91690446829245, 49.54520050056771],
						[17.917976360637503, 49.547824707565816],
						[17.918569567944274, 49.55221560149764],
						[17.91812514673695, 49.5644607069974],
						[17.96894454424048, 49.56483836645021],
						[17.97577665614732, 49.564552176189956],
						[17.980005272926373, 49.5639649135339],
						[17.981956474937004, 49.56345361783715],
						[17.983728411787666, 49.56273272053909],
						[17.986116416722957, 49.561069548423546],
						[17.992471681266558, 49.55471027778007],
						[17.99670030092429, 49.54964839837368],
						[18.000474945955308, 49.5464822164736],
						[18.00192449564256, 49.54429611028828],
						[18.003553377085613, 49.54076756139523],
						[18.00514413005403, 49.538589564629284],
						[18.012138370987866, 49.53371432903884],
						[18.015146253636544, 49.53255079678791],
						[18.01700592550608, 49.53222278891232],
						[18.01893043540312, 49.53207397640328],
						[18.02279661921557, 49.5322531714768],
						[18.026353825511332, 49.53309241373122],
						[18.032306683248105, 49.536281683252035],
						[18.043943424007747, 49.54092040940476],
						[18.060848248340534, 49.546383002629256],
						[18.065093982645436, 49.547420409280306],
						[18.08637999684059, 49.55047219494161],
						[18.093957910289575, 49.5509568006287],
						[18.10425186467517, 49.551021600818586],
						[18.11437415063765, 49.55042258724525],
						[18.130496959780267, 49.547824707565816],
						[18.135862361842566, 49.54650888020074],
						[18.140750888647265, 49.54450228742915],
						[18.142402640552945, 49.54411690683238],
						[18.146011342487633, 49.54376594125601],
						[18.151407257415496, 49.54419720732746],
						[18.15420915019101, 49.54505168055694],
						[18.157718656612936, 49.546550736057135],
						[18.16123006826886, 49.5473097234341],
						[18.16740036778785, 49.54752737463912],
						[18.171674736150035, 49.54701239110259],
						[18.177532180263977, 49.54529940391414],
						[18.186965953589823, 49.541587919118584],
						[18.191244141466107, 49.53865064129813],
						[18.195728308915584, 49.53604512968002],
						[18.199550641646507, 49.533084973078594],
						[18.209762555635518, 49.52710709820515],
						[18.2192382755112, 49.524211837745966],
						[18.230157863372888, 49.521991819071154],
						[18.234466554407156, 49.521331800448735],
						[18.242166536036898, 49.52080167868305],
						[18.250026695229725, 49.520671783516114],
						[18.257894526256653, 49.52077873776575],
						[18.265634549460056, 49.52119074455084],
						[18.273023601750722, 49.522209138865286],
						[18.281171783563106, 49.52440249797076],
						[18.285421382799342, 49.525295347729504],
						[18.289926544770044, 49.52584469988203],
						[18.299224850229155, 49.526401493665],
						[18.301576597370207, 49.52247606114552],
						[18.305141437108148, 49.51930990328329],
						[18.30595779549162, 49.518230448577945],
						[18.30870057247085, 49.5117417251665],
						[18.310310374780773, 49.50909432577431],
						[18.31651117293912, 49.50240340836638],
						[18.31878089331982, 49.50074000576012],
						[18.32038881170169, 49.50003447334025],
						[18.32910919313171, 49.4978332617772],
						[18.33183860484236, 49.4966506724094],
						[18.33502961625296, 49.4946519071968],
						[18.33974264926319, 49.49225607516612],
						[18.343645085302107, 49.48933020821513],
						[18.34820555946677, 49.48682779526469],
						[18.352069862025324, 49.483875332503814],
						[18.356632235106925, 49.48136522322567],
						[18.360488885627767, 49.47834773092154],
						[18.36495400712132, 49.47555933275709],
						[18.377613050701935, 49.462131365987936],
						[18.38208198783435, 49.459362048753],
						[18.385925274058728, 49.456371157402224],
						[18.390478125832622, 49.45389168815445],
						[18.394334789374156, 49.45092007551094],
						[18.39885519472952, 49.4481772217317],
						[18.403841014194242, 49.44329067491435],
						[18.413890856562446, 49.435379170500696],
						[18.419977174014075, 49.429244883403584],
						[18.42296791869943, 49.42694479552914],
						[18.4246387312648, 49.42502962068195],
						[18.425220491700163, 49.42387773348433],
						[18.427095426188455, 49.41631327427355],
						[18.428104382487156, 49.41394791523168],
						[18.42888640341111, 49.412887492683105],
						[18.432775501066022, 49.40975955025123],
						[18.43789290843513, 49.404735522519886],
						[18.443853371621508, 49.40092844442433],
						[18.43692780796302, 49.398197273592274],
						[18.433969514744664, 49.39703001202144],
						[18.41649817442807, 49.394302290559374],
						[18.415395726716056, 49.39413062757216],
						[18.39895249968593, 49.39190304719225],
						[18.400317984204104, 49.3878857661505],
						[18.38764206390097, 49.38975140049359],
						[18.387008653577684, 49.37762424139913],
						[18.385504586573905, 49.3488276346418],
						[18.379688254708835, 49.344188624581626],
						[18.361970887314804, 49.33300006996323],
						[18.340074553491995, 49.322887535041126],
						[18.334627149472382, 49.32085417088037],
						[18.33193968392959, 49.319850814948325],
						[18.33087541085147, 49.319454306099516],
						[18.31131172178319, 49.31214904770265],
						[18.29805754903405, 49.309970798641295],
						[18.273702621393355, 49.305973052443186],
						[18.2387084913758, 49.29838939684574],
						[18.23000337354192, 49.29722227117723],
						[18.207485202782802, 49.2942047426174],
						[18.188081731806708, 49.288532180172346],
						[18.184816350895588, 49.28757850542125],
						[18.177761067971545, 49.28551475148676],
						[18.15795707317023, 49.27223965385356],
						[18.149129858382228, 49.25404350479343],
						[18.14780424443163, 49.250347009229806],
						[18.146165850557544, 49.24578096735236],
						[18.14476397993079, 49.2418699787913],
						[18.136494592606976, 49.23306837638359],
						[18.117787732924842, 49.20257935825254],
						[18.105075323051956, 49.16976475117208],
						[18.10145795365374, 49.142944532090056],
						[18.101629670085476, 49.136928202101096],
						[18.10290490245962, 49.09225002487566],
						[18.096290306270117, 49.070287441037934],
						[18.07583381179948, 49.0475412652981],
						[18.07551639386069, 49.04718817804162],
						[18.046060837906243, 49.02915318656631],
						[18.012884578771096, 49.019128048217446],
						[17.959244425147183, 49.02186675295052],
						[17.93505986990802, 49.01938641539456],
						[17.914079205281123, 49.010497799114326],
						[17.90085007482318, 48.99303145896129],
						[17.89464889447689, 48.97820025474743],
						[17.88689742313488, 48.947246018091455],
						[17.882007022367453, 48.93904370965023],
						[17.879460058777617, 48.93477190152692],
						[17.868320482846382, 48.92729964759109],
						[17.851043688490403, 48.92636860752721],
						[17.850214016494288, 48.92636118396483],
						[17.83102799563992, 48.92620095879312],
						[17.827493666106786, 48.92617033661858],
						[17.80338668864173, 48.924243930427664],
						[17.77821348428038, 48.9200094730689],
						[17.775598520284248, 48.91957087491846],
						[17.768438337996894, 48.91582487976288],
						[17.76189422310334, 48.912403081754015],
						[17.75027083557185, 48.9035071660048],
						[17.745794302740723, 48.89844136913222],
						[17.73965452879392, 48.89149464818057],
						[17.73167611127839, 48.88398369281341],
						[17.728006345538883, 48.88052735002959],
						[17.713748931565537, 48.86922836034584],
						[17.69691468846597, 48.86034406491524],
						[17.686552047187224, 48.85998534698213]
					]
				]
			},
			"type": "Feature",
			"properties": {
				"source": "https://simplemaps.com",
				"id": "CZ72",
				"name": " Zlínský kraj",
				"region": "zlinsky"
			},
			"id": 14
		}
	]
}
